// /*! jQuery v3.2.1 | (c) JS Foundation and other contributors | jquery.org/license */
// !function(a,b){"use strict";"object"==typeof module&&"object"==typeof module.exports?module.exports=a.document?b(a,!0):function(a){if(!a.document)throw new Error("jQuery requires a window with a document");return b(a)}:b(a)}("undefined"!=typeof window?window:this,function(a,b){"use strict";var c=[],d=a.document,e=Object.getPrototypeOf,f=c.slice,g=c.concat,h=c.push,i=c.indexOf,j={},k=j.toString,l=j.hasOwnProperty,m=l.toString,n=m.call(Object),o={};function p(a,b){b=b||d;var c=b.createElement("script");c.text=a,b.head.appendChild(c).parentNode.removeChild(c)}var q="3.2.1",r=function(a,b){return new r.fn.init(a,b)},s=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,t=/^-ms-/,u=/-([a-z])/g,v=function(a,b){return b.toUpperCase()};r.fn=r.prototype={jquery:q,constructor:r,length:0,toArray:function(){return f.call(this)},get:function(a){return null==a?f.call(this):a<0?this[a+this.length]:this[a]},pushStack:function(a){var b=r.merge(this.constructor(),a);return b.prevObject=this,b},each:function(a){return r.each(this,a)},map:function(a){return this.pushStack(r.map(this,function(b,c){return a.call(b,c,b)}))},slice:function(){return this.pushStack(f.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},eq:function(a){var b=this.length,c=+a+(a<0?b:0);return this.pushStack(c>=0&&c<b?[this[c]]:[])},end:function(){return this.prevObject||this.constructor()},push:h,sort:c.sort,splice:c.splice},r.extend=r.fn.extend=function(){var a,b,c,d,e,f,g=arguments[0]||{},h=1,i=arguments.length,j=!1;for("boolean"==typeof g&&(j=g,g=arguments[h]||{},h++),"object"==typeof g||r.isFunction(g)||(g={}),h===i&&(g=this,h--);h<i;h++)if(null!=(a=arguments[h]))for(b in a)c=g[b],d=a[b],g!==d&&(j&&d&&(r.isPlainObject(d)||(e=Array.isArray(d)))?(e?(e=!1,f=c&&Array.isArray(c)?c:[]):f=c&&r.isPlainObject(c)?c:{},g[b]=r.extend(j,f,d)):void 0!==d&&(g[b]=d));return g},r.extend({expando:"jQuery"+(q+Math.random()).replace(/\D/g,""),isReady:!0,error:function(a){throw new Error(a)},noop:function(){},isFunction:function(a){return"function"===r.type(a)},isWindow:function(a){return null!=a&&a===a.window},isNumeric:function(a){var b=r.type(a);return("number"===b||"string"===b)&&!isNaN(a-parseFloat(a))},isPlainObject:function(a){var b,c;return!(!a||"[object Object]"!==k.call(a))&&(!(b=e(a))||(c=l.call(b,"constructor")&&b.constructor,"function"==typeof c&&m.call(c)===n))},isEmptyObject:function(a){var b;for(b in a)return!1;return!0},type:function(a){return null==a?a+"":"object"==typeof a||"function"==typeof a?j[k.call(a)]||"object":typeof a},globalEval:function(a){p(a)},camelCase:function(a){return a.replace(t,"ms-").replace(u,v)},each:function(a,b){var c,d=0;if(w(a)){for(c=a.length;d<c;d++)if(b.call(a[d],d,a[d])===!1)break}else for(d in a)if(b.call(a[d],d,a[d])===!1)break;return a},trim:function(a){return null==a?"":(a+"").replace(s,"")},makeArray:function(a,b){var c=b||[];return null!=a&&(w(Object(a))?r.merge(c,"string"==typeof a?[a]:a):h.call(c,a)),c},inArray:function(a,b,c){return null==b?-1:i.call(b,a,c)},merge:function(a,b){for(var c=+b.length,d=0,e=a.length;d<c;d++)a[e++]=b[d];return a.length=e,a},grep:function(a,b,c){for(var d,e=[],f=0,g=a.length,h=!c;f<g;f++)d=!b(a[f],f),d!==h&&e.push(a[f]);return e},map:function(a,b,c){var d,e,f=0,h=[];if(w(a))for(d=a.length;f<d;f++)e=b(a[f],f,c),null!=e&&h.push(e);else for(f in a)e=b(a[f],f,c),null!=e&&h.push(e);return g.apply([],h)},guid:1,proxy:function(a,b){var c,d,e;if("string"==typeof b&&(c=a[b],b=a,a=c),r.isFunction(a))return d=f.call(arguments,2),e=function(){return a.apply(b||this,d.concat(f.call(arguments)))},e.guid=a.guid=a.guid||r.guid++,e},now:Date.now,support:o}),"function"==typeof Symbol&&(r.fn[Symbol.iterator]=c[Symbol.iterator]),r.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(a,b){j["[object "+b+"]"]=b.toLowerCase()});function w(a){var b=!!a&&"length"in a&&a.length,c=r.type(a);return"function"!==c&&!r.isWindow(a)&&("array"===c||0===b||"number"==typeof b&&b>0&&b-1 in a)}var x=function(a){var b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u="sizzle"+1*new Date,v=a.document,w=0,x=0,y=ha(),z=ha(),A=ha(),B=function(a,b){return a===b&&(l=!0),0},C={}.hasOwnProperty,D=[],E=D.pop,F=D.push,G=D.push,H=D.slice,I=function(a,b){for(var c=0,d=a.length;c<d;c++)if(a[c]===b)return c;return-1},J="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",K="[\\x20\\t\\r\\n\\f]",L="(?:\\\\.|[\\w-]|[^\0-\\xa0])+",M="\\["+K+"*("+L+")(?:"+K+"*([*^$|!~]?=)"+K+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+L+"))|)"+K+"*\\]",N=":("+L+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+M+")*)|.*)\\)|)",O=new RegExp(K+"+","g"),P=new RegExp("^"+K+"+|((?:^|[^\\\\])(?:\\\\.)*)"+K+"+$","g"),Q=new RegExp("^"+K+"*,"+K+"*"),R=new RegExp("^"+K+"*([>+~]|"+K+")"+K+"*"),S=new RegExp("="+K+"*([^\\]'\"]*?)"+K+"*\\]","g"),T=new RegExp(N),U=new RegExp("^"+L+"$"),V={ID:new RegExp("^#("+L+")"),CLASS:new RegExp("^\\.("+L+")"),TAG:new RegExp("^("+L+"|[*])"),ATTR:new RegExp("^"+M),PSEUDO:new RegExp("^"+N),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+K+"*(even|odd|(([+-]|)(\\d*)n|)"+K+"*(?:([+-]|)"+K+"*(\\d+)|))"+K+"*\\)|)","i"),bool:new RegExp("^(?:"+J+")$","i"),needsContext:new RegExp("^"+K+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+K+"*((?:-\\d)?\\d*)"+K+"*\\)|)(?=[^-]|$)","i")},W=/^(?:input|select|textarea|button)$/i,X=/^h\d$/i,Y=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,$=/[+~]/,_=new RegExp("\\\\([\\da-f]{1,6}"+K+"?|("+K+")|.)","ig"),aa=function(a,b,c){var d="0x"+b-65536;return d!==d||c?b:d<0?String.fromCharCode(d+65536):String.fromCharCode(d>>10|55296,1023&d|56320)},ba=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ca=function(a,b){return b?"\0"===a?"\ufffd":a.slice(0,-1)+"\\"+a.charCodeAt(a.length-1).toString(16)+" ":"\\"+a},da=function(){m()},ea=ta(function(a){return a.disabled===!0&&("form"in a||"label"in a)},{dir:"parentNode",next:"legend"});try{G.apply(D=H.call(v.childNodes),v.childNodes),D[v.childNodes.length].nodeType}catch(fa){G={apply:D.length?function(a,b){F.apply(a,H.call(b))}:function(a,b){var c=a.length,d=0;while(a[c++]=b[d++]);a.length=c-1}}}function ga(a,b,d,e){var f,h,j,k,l,o,r,s=b&&b.ownerDocument,w=b?b.nodeType:9;if(d=d||[],"string"!=typeof a||!a||1!==w&&9!==w&&11!==w)return d;if(!e&&((b?b.ownerDocument||b:v)!==n&&m(b),b=b||n,p)){if(11!==w&&(l=Z.exec(a)))if(f=l[1]){if(9===w){if(!(j=b.getElementById(f)))return d;if(j.id===f)return d.push(j),d}else if(s&&(j=s.getElementById(f))&&t(b,j)&&j.id===f)return d.push(j),d}else{if(l[2])return G.apply(d,b.getElementsByTagName(a)),d;if((f=l[3])&&c.getElementsByClassName&&b.getElementsByClassName)return G.apply(d,b.getElementsByClassName(f)),d}if(c.qsa&&!A[a+" "]&&(!q||!q.test(a))){if(1!==w)s=b,r=a;else if("object"!==b.nodeName.toLowerCase()){(k=b.getAttribute("id"))?k=k.replace(ba,ca):b.setAttribute("id",k=u),o=g(a),h=o.length;while(h--)o[h]="#"+k+" "+sa(o[h]);r=o.join(","),s=$.test(a)&&qa(b.parentNode)||b}if(r)try{return G.apply(d,s.querySelectorAll(r)),d}catch(x){}finally{k===u&&b.removeAttribute("id")}}}return i(a.replace(P,"$1"),b,d,e)}function ha(){var a=[];function b(c,e){return a.push(c+" ")>d.cacheLength&&delete b[a.shift()],b[c+" "]=e}return b}function ia(a){return a[u]=!0,a}function ja(a){var b=n.createElement("fieldset");try{return!!a(b)}catch(c){return!1}finally{b.parentNode&&b.parentNode.removeChild(b),b=null}}function ka(a,b){var c=a.split("|"),e=c.length;while(e--)d.attrHandle[c[e]]=b}function la(a,b){var c=b&&a,d=c&&1===a.nodeType&&1===b.nodeType&&a.sourceIndex-b.sourceIndex;if(d)return d;if(c)while(c=c.nextSibling)if(c===b)return-1;return a?1:-1}function ma(a){return function(b){var c=b.nodeName.toLowerCase();return"input"===c&&b.type===a}}function na(a){return function(b){var c=b.nodeName.toLowerCase();return("input"===c||"button"===c)&&b.type===a}}function oa(a){return function(b){return"form"in b?b.parentNode&&b.disabled===!1?"label"in b?"label"in b.parentNode?b.parentNode.disabled===a:b.disabled===a:b.isDisabled===a||b.isDisabled!==!a&&ea(b)===a:b.disabled===a:"label"in b&&b.disabled===a}}function pa(a){return ia(function(b){return b=+b,ia(function(c,d){var e,f=a([],c.length,b),g=f.length;while(g--)c[e=f[g]]&&(c[e]=!(d[e]=c[e]))})})}function qa(a){return a&&"undefined"!=typeof a.getElementsByTagName&&a}c=ga.support={},f=ga.isXML=function(a){var b=a&&(a.ownerDocument||a).documentElement;return!!b&&"HTML"!==b.nodeName},m=ga.setDocument=function(a){var b,e,g=a?a.ownerDocument||a:v;return g!==n&&9===g.nodeType&&g.documentElement?(n=g,o=n.documentElement,p=!f(n),v!==n&&(e=n.defaultView)&&e.top!==e&&(e.addEventListener?e.addEventListener("unload",da,!1):e.attachEvent&&e.attachEvent("onunload",da)),c.attributes=ja(function(a){return a.className="i",!a.getAttribute("className")}),c.getElementsByTagName=ja(function(a){return a.appendChild(n.createComment("")),!a.getElementsByTagName("*").length}),c.getElementsByClassName=Y.test(n.getElementsByClassName),c.getById=ja(function(a){return o.appendChild(a).id=u,!n.getElementsByName||!n.getElementsByName(u).length}),c.getById?(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){return a.getAttribute("id")===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c=b.getElementById(a);return c?[c]:[]}}):(d.filter.ID=function(a){var b=a.replace(_,aa);return function(a){var c="undefined"!=typeof a.getAttributeNode&&a.getAttributeNode("id");return c&&c.value===b}},d.find.ID=function(a,b){if("undefined"!=typeof b.getElementById&&p){var c,d,e,f=b.getElementById(a);if(f){if(c=f.getAttributeNode("id"),c&&c.value===a)return[f];e=b.getElementsByName(a),d=0;while(f=e[d++])if(c=f.getAttributeNode("id"),c&&c.value===a)return[f]}return[]}}),d.find.TAG=c.getElementsByTagName?function(a,b){return"undefined"!=typeof b.getElementsByTagName?b.getElementsByTagName(a):c.qsa?b.querySelectorAll(a):void 0}:function(a,b){var c,d=[],e=0,f=b.getElementsByTagName(a);if("*"===a){while(c=f[e++])1===c.nodeType&&d.push(c);return d}return f},d.find.CLASS=c.getElementsByClassName&&function(a,b){if("undefined"!=typeof b.getElementsByClassName&&p)return b.getElementsByClassName(a)},r=[],q=[],(c.qsa=Y.test(n.querySelectorAll))&&(ja(function(a){o.appendChild(a).innerHTML="<a id='"+u+"'></a><select id='"+u+"-\r\\' msallowcapture=''><option selected=''></option></select>",a.querySelectorAll("[msallowcapture^='']").length&&q.push("[*^$]="+K+"*(?:''|\"\")"),a.querySelectorAll("[selected]").length||q.push("\\["+K+"*(?:value|"+J+")"),a.querySelectorAll("[id~="+u+"-]").length||q.push("~="),a.querySelectorAll(":checked").length||q.push(":checked"),a.querySelectorAll("a#"+u+"+*").length||q.push(".#.+[+~]")}),ja(function(a){a.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var b=n.createElement("input");b.setAttribute("type","hidden"),a.appendChild(b).setAttribute("name","D"),a.querySelectorAll("[name=d]").length&&q.push("name"+K+"*[*^$|!~]?="),2!==a.querySelectorAll(":enabled").length&&q.push(":enabled",":disabled"),o.appendChild(a).disabled=!0,2!==a.querySelectorAll(":disabled").length&&q.push(":enabled",":disabled"),a.querySelectorAll("*,:x"),q.push(",.*:")})),(c.matchesSelector=Y.test(s=o.matches||o.webkitMatchesSelector||o.mozMatchesSelector||o.oMatchesSelector||o.msMatchesSelector))&&ja(function(a){c.disconnectedMatch=s.call(a,"*"),s.call(a,"[s!='']:x"),r.push("!=",N)}),q=q.length&&new RegExp(q.join("|")),r=r.length&&new RegExp(r.join("|")),b=Y.test(o.compareDocumentPosition),t=b||Y.test(o.contains)?function(a,b){var c=9===a.nodeType?a.documentElement:a,d=b&&b.parentNode;return a===d||!(!d||1!==d.nodeType||!(c.contains?c.contains(d):a.compareDocumentPosition&&16&a.compareDocumentPosition(d)))}:function(a,b){if(b)while(b=b.parentNode)if(b===a)return!0;return!1},B=b?function(a,b){if(a===b)return l=!0,0;var d=!a.compareDocumentPosition-!b.compareDocumentPosition;return d?d:(d=(a.ownerDocument||a)===(b.ownerDocument||b)?a.compareDocumentPosition(b):1,1&d||!c.sortDetached&&b.compareDocumentPosition(a)===d?a===n||a.ownerDocument===v&&t(v,a)?-1:b===n||b.ownerDocument===v&&t(v,b)?1:k?I(k,a)-I(k,b):0:4&d?-1:1)}:function(a,b){if(a===b)return l=!0,0;var c,d=0,e=a.parentNode,f=b.parentNode,g=[a],h=[b];if(!e||!f)return a===n?-1:b===n?1:e?-1:f?1:k?I(k,a)-I(k,b):0;if(e===f)return la(a,b);c=a;while(c=c.parentNode)g.unshift(c);c=b;while(c=c.parentNode)h.unshift(c);while(g[d]===h[d])d++;return d?la(g[d],h[d]):g[d]===v?-1:h[d]===v?1:0},n):n},ga.matches=function(a,b){return ga(a,null,null,b)},ga.matchesSelector=function(a,b){if((a.ownerDocument||a)!==n&&m(a),b=b.replace(S,"='$1']"),c.matchesSelector&&p&&!A[b+" "]&&(!r||!r.test(b))&&(!q||!q.test(b)))try{var d=s.call(a,b);if(d||c.disconnectedMatch||a.document&&11!==a.document.nodeType)return d}catch(e){}return ga(b,n,null,[a]).length>0},ga.contains=function(a,b){return(a.ownerDocument||a)!==n&&m(a),t(a,b)},ga.attr=function(a,b){(a.ownerDocument||a)!==n&&m(a);var e=d.attrHandle[b.toLowerCase()],f=e&&C.call(d.attrHandle,b.toLowerCase())?e(a,b,!p):void 0;return void 0!==f?f:c.attributes||!p?a.getAttribute(b):(f=a.getAttributeNode(b))&&f.specified?f.value:null},ga.escape=function(a){return(a+"").replace(ba,ca)},ga.error=function(a){throw new Error("Syntax error, unrecognized expression: "+a)},ga.uniqueSort=function(a){var b,d=[],e=0,f=0;if(l=!c.detectDuplicates,k=!c.sortStable&&a.slice(0),a.sort(B),l){while(b=a[f++])b===a[f]&&(e=d.push(f));while(e--)a.splice(d[e],1)}return k=null,a},e=ga.getText=function(a){var b,c="",d=0,f=a.nodeType;if(f){if(1===f||9===f||11===f){if("string"==typeof a.textContent)return a.textContent;for(a=a.firstChild;a;a=a.nextSibling)c+=e(a)}else if(3===f||4===f)return a.nodeValue}else while(b=a[d++])c+=e(b);return c},d=ga.selectors={cacheLength:50,createPseudo:ia,match:V,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(a){return a[1]=a[1].replace(_,aa),a[3]=(a[3]||a[4]||a[5]||"").replace(_,aa),"~="===a[2]&&(a[3]=" "+a[3]+" "),a.slice(0,4)},CHILD:function(a){return a[1]=a[1].toLowerCase(),"nth"===a[1].slice(0,3)?(a[3]||ga.error(a[0]),a[4]=+(a[4]?a[5]+(a[6]||1):2*("even"===a[3]||"odd"===a[3])),a[5]=+(a[7]+a[8]||"odd"===a[3])):a[3]&&ga.error(a[0]),a},PSEUDO:function(a){var b,c=!a[6]&&a[2];return V.CHILD.test(a[0])?null:(a[3]?a[2]=a[4]||a[5]||"":c&&T.test(c)&&(b=g(c,!0))&&(b=c.indexOf(")",c.length-b)-c.length)&&(a[0]=a[0].slice(0,b),a[2]=c.slice(0,b)),a.slice(0,3))}},filter:{TAG:function(a){var b=a.replace(_,aa).toLowerCase();return"*"===a?function(){return!0}:function(a){return a.nodeName&&a.nodeName.toLowerCase()===b}},CLASS:function(a){var b=y[a+" "];return b||(b=new RegExp("(^|"+K+")"+a+"("+K+"|$)"))&&y(a,function(a){return b.test("string"==typeof a.className&&a.className||"undefined"!=typeof a.getAttribute&&a.getAttribute("class")||"")})},ATTR:function(a,b,c){return function(d){var e=ga.attr(d,a);return null==e?"!="===b:!b||(e+="","="===b?e===c:"!="===b?e!==c:"^="===b?c&&0===e.indexOf(c):"*="===b?c&&e.indexOf(c)>-1:"$="===b?c&&e.slice(-c.length)===c:"~="===b?(" "+e.replace(O," ")+" ").indexOf(c)>-1:"|="===b&&(e===c||e.slice(0,c.length+1)===c+"-"))}},CHILD:function(a,b,c,d,e){var f="nth"!==a.slice(0,3),g="last"!==a.slice(-4),h="of-type"===b;return 1===d&&0===e?function(a){return!!a.parentNode}:function(b,c,i){var j,k,l,m,n,o,p=f!==g?"nextSibling":"previousSibling",q=b.parentNode,r=h&&b.nodeName.toLowerCase(),s=!i&&!h,t=!1;if(q){if(f){while(p){m=b;while(m=m[p])if(h?m.nodeName.toLowerCase()===r:1===m.nodeType)return!1;o=p="only"===a&&!o&&"nextSibling"}return!0}if(o=[g?q.firstChild:q.lastChild],g&&s){m=q,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n&&j[2],m=n&&q.childNodes[n];while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if(1===m.nodeType&&++t&&m===b){k[a]=[w,n,t];break}}else if(s&&(m=b,l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),j=k[a]||[],n=j[0]===w&&j[1],t=n),t===!1)while(m=++n&&m&&m[p]||(t=n=0)||o.pop())if((h?m.nodeName.toLowerCase()===r:1===m.nodeType)&&++t&&(s&&(l=m[u]||(m[u]={}),k=l[m.uniqueID]||(l[m.uniqueID]={}),k[a]=[w,t]),m===b))break;return t-=e,t===d||t%d===0&&t/d>=0}}},PSEUDO:function(a,b){var c,e=d.pseudos[a]||d.setFilters[a.toLowerCase()]||ga.error("unsupported pseudo: "+a);return e[u]?e(b):e.length>1?(c=[a,a,"",b],d.setFilters.hasOwnProperty(a.toLowerCase())?ia(function(a,c){var d,f=e(a,b),g=f.length;while(g--)d=I(a,f[g]),a[d]=!(c[d]=f[g])}):function(a){return e(a,0,c)}):e}},pseudos:{not:ia(function(a){var b=[],c=[],d=h(a.replace(P,"$1"));return d[u]?ia(function(a,b,c,e){var f,g=d(a,null,e,[]),h=a.length;while(h--)(f=g[h])&&(a[h]=!(b[h]=f))}):function(a,e,f){return b[0]=a,d(b,null,f,c),b[0]=null,!c.pop()}}),has:ia(function(a){return function(b){return ga(a,b).length>0}}),contains:ia(function(a){return a=a.replace(_,aa),function(b){return(b.textContent||b.innerText||e(b)).indexOf(a)>-1}}),lang:ia(function(a){return U.test(a||"")||ga.error("unsupported lang: "+a),a=a.replace(_,aa).toLowerCase(),function(b){var c;do if(c=p?b.lang:b.getAttribute("xml:lang")||b.getAttribute("lang"))return c=c.toLowerCase(),c===a||0===c.indexOf(a+"-");while((b=b.parentNode)&&1===b.nodeType);return!1}}),target:function(b){var c=a.location&&a.location.hash;return c&&c.slice(1)===b.id},root:function(a){return a===o},focus:function(a){return a===n.activeElement&&(!n.hasFocus||n.hasFocus())&&!!(a.type||a.href||~a.tabIndex)},enabled:oa(!1),disabled:oa(!0),checked:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&!!a.checked||"option"===b&&!!a.selected},selected:function(a){return a.parentNode&&a.parentNode.selectedIndex,a.selected===!0},empty:function(a){for(a=a.firstChild;a;a=a.nextSibling)if(a.nodeType<6)return!1;return!0},parent:function(a){return!d.pseudos.empty(a)},header:function(a){return X.test(a.nodeName)},input:function(a){return W.test(a.nodeName)},button:function(a){var b=a.nodeName.toLowerCase();return"input"===b&&"button"===a.type||"button"===b},text:function(a){var b;return"input"===a.nodeName.toLowerCase()&&"text"===a.type&&(null==(b=a.getAttribute("type"))||"text"===b.toLowerCase())},first:pa(function(){return[0]}),last:pa(function(a,b){return[b-1]}),eq:pa(function(a,b,c){return[c<0?c+b:c]}),even:pa(function(a,b){for(var c=0;c<b;c+=2)a.push(c);return a}),odd:pa(function(a,b){for(var c=1;c<b;c+=2)a.push(c);return a}),lt:pa(function(a,b,c){for(var d=c<0?c+b:c;--d>=0;)a.push(d);return a}),gt:pa(function(a,b,c){for(var d=c<0?c+b:c;++d<b;)a.push(d);return a})}},d.pseudos.nth=d.pseudos.eq;for(b in{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})d.pseudos[b]=ma(b);for(b in{submit:!0,reset:!0})d.pseudos[b]=na(b);function ra(){}ra.prototype=d.filters=d.pseudos,d.setFilters=new ra,g=ga.tokenize=function(a,b){var c,e,f,g,h,i,j,k=z[a+" "];if(k)return b?0:k.slice(0);h=a,i=[],j=d.preFilter;while(h){c&&!(e=Q.exec(h))||(e&&(h=h.slice(e[0].length)||h),i.push(f=[])),c=!1,(e=R.exec(h))&&(c=e.shift(),f.push({value:c,type:e[0].replace(P," ")}),h=h.slice(c.length));for(g in d.filter)!(e=V[g].exec(h))||j[g]&&!(e=j[g](e))||(c=e.shift(),f.push({value:c,type:g,matches:e}),h=h.slice(c.length));if(!c)break}return b?h.length:h?ga.error(a):z(a,i).slice(0)};function sa(a){for(var b=0,c=a.length,d="";b<c;b++)d+=a[b].value;return d}function ta(a,b,c){var d=b.dir,e=b.next,f=e||d,g=c&&"parentNode"===f,h=x++;return b.first?function(b,c,e){while(b=b[d])if(1===b.nodeType||g)return a(b,c,e);return!1}:function(b,c,i){var j,k,l,m=[w,h];if(i){while(b=b[d])if((1===b.nodeType||g)&&a(b,c,i))return!0}else while(b=b[d])if(1===b.nodeType||g)if(l=b[u]||(b[u]={}),k=l[b.uniqueID]||(l[b.uniqueID]={}),e&&e===b.nodeName.toLowerCase())b=b[d]||b;else{if((j=k[f])&&j[0]===w&&j[1]===h)return m[2]=j[2];if(k[f]=m,m[2]=a(b,c,i))return!0}return!1}}function ua(a){return a.length>1?function(b,c,d){var e=a.length;while(e--)if(!a[e](b,c,d))return!1;return!0}:a[0]}function va(a,b,c){for(var d=0,e=b.length;d<e;d++)ga(a,b[d],c);return c}function wa(a,b,c,d,e){for(var f,g=[],h=0,i=a.length,j=null!=b;h<i;h++)(f=a[h])&&(c&&!c(f,d,e)||(g.push(f),j&&b.push(h)));return g}function xa(a,b,c,d,e,f){return d&&!d[u]&&(d=xa(d)),e&&!e[u]&&(e=xa(e,f)),ia(function(f,g,h,i){var j,k,l,m=[],n=[],o=g.length,p=f||va(b||"*",h.nodeType?[h]:h,[]),q=!a||!f&&b?p:wa(p,m,a,h,i),r=c?e||(f?a:o||d)?[]:g:q;if(c&&c(q,r,h,i),d){j=wa(r,n),d(j,[],h,i),k=j.length;while(k--)(l=j[k])&&(r[n[k]]=!(q[n[k]]=l))}if(f){if(e||a){if(e){j=[],k=r.length;while(k--)(l=r[k])&&j.push(q[k]=l);e(null,r=[],j,i)}k=r.length;while(k--)(l=r[k])&&(j=e?I(f,l):m[k])>-1&&(f[j]=!(g[j]=l))}}else r=wa(r===g?r.splice(o,r.length):r),e?e(null,g,r,i):G.apply(g,r)})}function ya(a){for(var b,c,e,f=a.length,g=d.relative[a[0].type],h=g||d.relative[" "],i=g?1:0,k=ta(function(a){return a===b},h,!0),l=ta(function(a){return I(b,a)>-1},h,!0),m=[function(a,c,d){var e=!g&&(d||c!==j)||((b=c).nodeType?k(a,c,d):l(a,c,d));return b=null,e}];i<f;i++)if(c=d.relative[a[i].type])m=[ta(ua(m),c)];else{if(c=d.filter[a[i].type].apply(null,a[i].matches),c[u]){for(e=++i;e<f;e++)if(d.relative[a[e].type])break;return xa(i>1&&ua(m),i>1&&sa(a.slice(0,i-1).concat({value:" "===a[i-2].type?"*":""})).replace(P,"$1"),c,i<e&&ya(a.slice(i,e)),e<f&&ya(a=a.slice(e)),e<f&&sa(a))}m.push(c)}return ua(m)}function za(a,b){var c=b.length>0,e=a.length>0,f=function(f,g,h,i,k){var l,o,q,r=0,s="0",t=f&&[],u=[],v=j,x=f||e&&d.find.TAG("*",k),y=w+=null==v?1:Math.random()||.1,z=x.length;for(k&&(j=g===n||g||k);s!==z&&null!=(l=x[s]);s++){if(e&&l){o=0,g||l.ownerDocument===n||(m(l),h=!p);while(q=a[o++])if(q(l,g||n,h)){i.push(l);break}k&&(w=y)}c&&((l=!q&&l)&&r--,f&&t.push(l))}if(r+=s,c&&s!==r){o=0;while(q=b[o++])q(t,u,g,h);if(f){if(r>0)while(s--)t[s]||u[s]||(u[s]=E.call(i));u=wa(u)}G.apply(i,u),k&&!f&&u.length>0&&r+b.length>1&&ga.uniqueSort(i)}return k&&(w=y,j=v),t};return c?ia(f):f}return h=ga.compile=function(a,b){var c,d=[],e=[],f=A[a+" "];if(!f){b||(b=g(a)),c=b.length;while(c--)f=ya(b[c]),f[u]?d.push(f):e.push(f);f=A(a,za(e,d)),f.selector=a}return f},i=ga.select=function(a,b,c,e){var f,i,j,k,l,m="function"==typeof a&&a,n=!e&&g(a=m.selector||a);if(c=c||[],1===n.length){if(i=n[0]=n[0].slice(0),i.length>2&&"ID"===(j=i[0]).type&&9===b.nodeType&&p&&d.relative[i[1].type]){if(b=(d.find.ID(j.matches[0].replace(_,aa),b)||[])[0],!b)return c;m&&(b=b.parentNode),a=a.slice(i.shift().value.length)}f=V.needsContext.test(a)?0:i.length;while(f--){if(j=i[f],d.relative[k=j.type])break;if((l=d.find[k])&&(e=l(j.matches[0].replace(_,aa),$.test(i[0].type)&&qa(b.parentNode)||b))){if(i.splice(f,1),a=e.length&&sa(i),!a)return G.apply(c,e),c;break}}}return(m||h(a,n))(e,b,!p,c,!b||$.test(a)&&qa(b.parentNode)||b),c},c.sortStable=u.split("").sort(B).join("")===u,c.detectDuplicates=!!l,m(),c.sortDetached=ja(function(a){return 1&a.compareDocumentPosition(n.createElement("fieldset"))}),ja(function(a){return a.innerHTML="<a href='#'></a>","#"===a.firstChild.getAttribute("href")})||ka("type|href|height|width",function(a,b,c){if(!c)return a.getAttribute(b,"type"===b.toLowerCase()?1:2)}),c.attributes&&ja(function(a){return a.innerHTML="<input/>",a.firstChild.setAttribute("value",""),""===a.firstChild.getAttribute("value")})||ka("value",function(a,b,c){if(!c&&"input"===a.nodeName.toLowerCase())return a.defaultValue}),ja(function(a){return null==a.getAttribute("disabled")})||ka(J,function(a,b,c){var d;if(!c)return a[b]===!0?b.toLowerCase():(d=a.getAttributeNode(b))&&d.specified?d.value:null}),ga}(a);r.find=x,r.expr=x.selectors,r.expr[":"]=r.expr.pseudos,r.uniqueSort=r.unique=x.uniqueSort,r.text=x.getText,r.isXMLDoc=x.isXML,r.contains=x.contains,r.escapeSelector=x.escape;var y=function(a,b,c){var d=[],e=void 0!==c;while((a=a[b])&&9!==a.nodeType)if(1===a.nodeType){if(e&&r(a).is(c))break;d.push(a)}return d},z=function(a,b){for(var c=[];a;a=a.nextSibling)1===a.nodeType&&a!==b&&c.push(a);return c},A=r.expr.match.needsContext;function B(a,b){return a.nodeName&&a.nodeName.toLowerCase()===b.toLowerCase()}var C=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i,D=/^.[^:#\[\.,]*$/;function E(a,b,c){return r.isFunction(b)?r.grep(a,function(a,d){return!!b.call(a,d,a)!==c}):b.nodeType?r.grep(a,function(a){return a===b!==c}):"string"!=typeof b?r.grep(a,function(a){return i.call(b,a)>-1!==c}):D.test(b)?r.filter(b,a,c):(b=r.filter(b,a),r.grep(a,function(a){return i.call(b,a)>-1!==c&&1===a.nodeType}))}r.filter=function(a,b,c){var d=b[0];return c&&(a=":not("+a+")"),1===b.length&&1===d.nodeType?r.find.matchesSelector(d,a)?[d]:[]:r.find.matches(a,r.grep(b,function(a){return 1===a.nodeType}))},r.fn.extend({find:function(a){var b,c,d=this.length,e=this;if("string"!=typeof a)return this.pushStack(r(a).filter(function(){for(b=0;b<d;b++)if(r.contains(e[b],this))return!0}));for(c=this.pushStack([]),b=0;b<d;b++)r.find(a,e[b],c);return d>1?r.uniqueSort(c):c},filter:function(a){return this.pushStack(E(this,a||[],!1))},not:function(a){return this.pushStack(E(this,a||[],!0))},is:function(a){return!!E(this,"string"==typeof a&&A.test(a)?r(a):a||[],!1).length}});var F,G=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,H=r.fn.init=function(a,b,c){var e,f;if(!a)return this;if(c=c||F,"string"==typeof a){if(e="<"===a[0]&&">"===a[a.length-1]&&a.length>=3?[null,a,null]:G.exec(a),!e||!e[1]&&b)return!b||b.jquery?(b||c).find(a):this.constructor(b).find(a);if(e[1]){if(b=b instanceof r?b[0]:b,r.merge(this,r.parseHTML(e[1],b&&b.nodeType?b.ownerDocument||b:d,!0)),C.test(e[1])&&r.isPlainObject(b))for(e in b)r.isFunction(this[e])?this[e](b[e]):this.attr(e,b[e]);return this}return f=d.getElementById(e[2]),f&&(this[0]=f,this.length=1),this}return a.nodeType?(this[0]=a,this.length=1,this):r.isFunction(a)?void 0!==c.ready?c.ready(a):a(r):r.makeArray(a,this)};H.prototype=r.fn,F=r(d);var I=/^(?:parents|prev(?:Until|All))/,J={children:!0,contents:!0,next:!0,prev:!0};r.fn.extend({has:function(a){var b=r(a,this),c=b.length;return this.filter(function(){for(var a=0;a<c;a++)if(r.contains(this,b[a]))return!0})},closest:function(a,b){var c,d=0,e=this.length,f=[],g="string"!=typeof a&&r(a);if(!A.test(a))for(;d<e;d++)for(c=this[d];c&&c!==b;c=c.parentNode)if(c.nodeType<11&&(g?g.index(c)>-1:1===c.nodeType&&r.find.matchesSelector(c,a))){f.push(c);break}return this.pushStack(f.length>1?r.uniqueSort(f):f)},index:function(a){return a?"string"==typeof a?i.call(r(a),this[0]):i.call(this,a.jquery?a[0]:a):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(a,b){return this.pushStack(r.uniqueSort(r.merge(this.get(),r(a,b))))},addBack:function(a){return this.add(null==a?this.prevObject:this.prevObject.filter(a))}});function K(a,b){while((a=a[b])&&1!==a.nodeType);return a}r.each({parent:function(a){var b=a.parentNode;return b&&11!==b.nodeType?b:null},parents:function(a){return y(a,"parentNode")},parentsUntil:function(a,b,c){return y(a,"parentNode",c)},next:function(a){return K(a,"nextSibling")},prev:function(a){return K(a,"previousSibling")},nextAll:function(a){return y(a,"nextSibling")},prevAll:function(a){return y(a,"previousSibling")},nextUntil:function(a,b,c){return y(a,"nextSibling",c)},prevUntil:function(a,b,c){return y(a,"previousSibling",c)},siblings:function(a){return z((a.parentNode||{}).firstChild,a)},children:function(a){return z(a.firstChild)},contents:function(a){return B(a,"iframe")?a.contentDocument:(B(a,"template")&&(a=a.content||a),r.merge([],a.childNodes))}},function(a,b){r.fn[a]=function(c,d){var e=r.map(this,b,c);return"Until"!==a.slice(-5)&&(d=c),d&&"string"==typeof d&&(e=r.filter(d,e)),this.length>1&&(J[a]||r.uniqueSort(e),I.test(a)&&e.reverse()),this.pushStack(e)}});var L=/[^\x20\t\r\n\f]+/g;function M(a){var b={};return r.each(a.match(L)||[],function(a,c){b[c]=!0}),b}r.Callbacks=function(a){a="string"==typeof a?M(a):r.extend({},a);var b,c,d,e,f=[],g=[],h=-1,i=function(){for(e=e||a.once,d=b=!0;g.length;h=-1){c=g.shift();while(++h<f.length)f[h].apply(c[0],c[1])===!1&&a.stopOnFalse&&(h=f.length,c=!1)}a.memory||(c=!1),b=!1,e&&(f=c?[]:"")},j={add:function(){return f&&(c&&!b&&(h=f.length-1,g.push(c)),function d(b){r.each(b,function(b,c){r.isFunction(c)?a.unique&&j.has(c)||f.push(c):c&&c.length&&"string"!==r.type(c)&&d(c)})}(arguments),c&&!b&&i()),this},remove:function(){return r.each(arguments,function(a,b){var c;while((c=r.inArray(b,f,c))>-1)f.splice(c,1),c<=h&&h--}),this},has:function(a){return a?r.inArray(a,f)>-1:f.length>0},empty:function(){return f&&(f=[]),this},disable:function(){return e=g=[],f=c="",this},disabled:function(){return!f},lock:function(){return e=g=[],c||b||(f=c=""),this},locked:function(){return!!e},fireWith:function(a,c){return e||(c=c||[],c=[a,c.slice?c.slice():c],g.push(c),b||i()),this},fire:function(){return j.fireWith(this,arguments),this},fired:function(){return!!d}};return j};function N(a){return a}function O(a){throw a}function P(a,b,c,d){var e;try{a&&r.isFunction(e=a.promise)?e.call(a).done(b).fail(c):a&&r.isFunction(e=a.then)?e.call(a,b,c):b.apply(void 0,[a].slice(d))}catch(a){c.apply(void 0,[a])}}r.extend({Deferred:function(b){var c=[["notify","progress",r.Callbacks("memory"),r.Callbacks("memory"),2],["resolve","done",r.Callbacks("once memory"),r.Callbacks("once memory"),0,"resolved"],["reject","fail",r.Callbacks("once memory"),r.Callbacks("once memory"),1,"rejected"]],d="pending",e={state:function(){return d},always:function(){return f.done(arguments).fail(arguments),this},"catch":function(a){return e.then(null,a)},pipe:function(){var a=arguments;return r.Deferred(function(b){r.each(c,function(c,d){var e=r.isFunction(a[d[4]])&&a[d[4]];f[d[1]](function(){var a=e&&e.apply(this,arguments);a&&r.isFunction(a.promise)?a.promise().progress(b.notify).done(b.resolve).fail(b.reject):b[d[0]+"With"](this,e?[a]:arguments)})}),a=null}).promise()},then:function(b,d,e){var f=0;function g(b,c,d,e){return function(){var h=this,i=arguments,j=function(){var a,j;if(!(b<f)){if(a=d.apply(h,i),a===c.promise())throw new TypeError("Thenable self-resolution");j=a&&("object"==typeof a||"function"==typeof a)&&a.then,r.isFunction(j)?e?j.call(a,g(f,c,N,e),g(f,c,O,e)):(f++,j.call(a,g(f,c,N,e),g(f,c,O,e),g(f,c,N,c.notifyWith))):(d!==N&&(h=void 0,i=[a]),(e||c.resolveWith)(h,i))}},k=e?j:function(){try{j()}catch(a){r.Deferred.exceptionHook&&r.Deferred.exceptionHook(a,k.stackTrace),b+1>=f&&(d!==O&&(h=void 0,i=[a]),c.rejectWith(h,i))}};b?k():(r.Deferred.getStackHook&&(k.stackTrace=r.Deferred.getStackHook()),a.setTimeout(k))}}return r.Deferred(function(a){c[0][3].add(g(0,a,r.isFunction(e)?e:N,a.notifyWith)),c[1][3].add(g(0,a,r.isFunction(b)?b:N)),c[2][3].add(g(0,a,r.isFunction(d)?d:O))}).promise()},promise:function(a){return null!=a?r.extend(a,e):e}},f={};return r.each(c,function(a,b){var g=b[2],h=b[5];e[b[1]]=g.add,h&&g.add(function(){d=h},c[3-a][2].disable,c[0][2].lock),g.add(b[3].fire),f[b[0]]=function(){return f[b[0]+"With"](this===f?void 0:this,arguments),this},f[b[0]+"With"]=g.fireWith}),e.promise(f),b&&b.call(f,f),f},when:function(a){var b=arguments.length,c=b,d=Array(c),e=f.call(arguments),g=r.Deferred(),h=function(a){return function(c){d[a]=this,e[a]=arguments.length>1?f.call(arguments):c,--b||g.resolveWith(d,e)}};if(b<=1&&(P(a,g.done(h(c)).resolve,g.reject,!b),"pending"===g.state()||r.isFunction(e[c]&&e[c].then)))return g.then();while(c--)P(e[c],h(c),g.reject);return g.promise()}});var Q=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;r.Deferred.exceptionHook=function(b,c){a.console&&a.console.warn&&b&&Q.test(b.name)&&a.console.warn("jQuery.Deferred exception: "+b.message,b.stack,c)},r.readyException=function(b){a.setTimeout(function(){throw b})};var R=r.Deferred();r.fn.ready=function(a){return R.then(a)["catch"](function(a){r.readyException(a)}),this},r.extend({isReady:!1,readyWait:1,ready:function(a){(a===!0?--r.readyWait:r.isReady)||(r.isReady=!0,a!==!0&&--r.readyWait>0||R.resolveWith(d,[r]))}}),r.ready.then=R.then;function S(){d.removeEventListener("DOMContentLoaded",S),
// a.removeEventListener("load",S),r.ready()}"complete"===d.readyState||"loading"!==d.readyState&&!d.documentElement.doScroll?a.setTimeout(r.ready):(d.addEventListener("DOMContentLoaded",S),a.addEventListener("load",S));var T=function(a,b,c,d,e,f,g){var h=0,i=a.length,j=null==c;if("object"===r.type(c)){e=!0;for(h in c)T(a,b,h,c[h],!0,f,g)}else if(void 0!==d&&(e=!0,r.isFunction(d)||(g=!0),j&&(g?(b.call(a,d),b=null):(j=b,b=function(a,b,c){return j.call(r(a),c)})),b))for(;h<i;h++)b(a[h],c,g?d:d.call(a[h],h,b(a[h],c)));return e?a:j?b.call(a):i?b(a[0],c):f},U=function(a){return 1===a.nodeType||9===a.nodeType||!+a.nodeType};function V(){this.expando=r.expando+V.uid++}V.uid=1,V.prototype={cache:function(a){var b=a[this.expando];return b||(b={},U(a)&&(a.nodeType?a[this.expando]=b:Object.defineProperty(a,this.expando,{value:b,configurable:!0}))),b},set:function(a,b,c){var d,e=this.cache(a);if("string"==typeof b)e[r.camelCase(b)]=c;else for(d in b)e[r.camelCase(d)]=b[d];return e},get:function(a,b){return void 0===b?this.cache(a):a[this.expando]&&a[this.expando][r.camelCase(b)]},access:function(a,b,c){return void 0===b||b&&"string"==typeof b&&void 0===c?this.get(a,b):(this.set(a,b,c),void 0!==c?c:b)},remove:function(a,b){var c,d=a[this.expando];if(void 0!==d){if(void 0!==b){Array.isArray(b)?b=b.map(r.camelCase):(b=r.camelCase(b),b=b in d?[b]:b.match(L)||[]),c=b.length;while(c--)delete d[b[c]]}(void 0===b||r.isEmptyObject(d))&&(a.nodeType?a[this.expando]=void 0:delete a[this.expando])}},hasData:function(a){var b=a[this.expando];return void 0!==b&&!r.isEmptyObject(b)}};var W=new V,X=new V,Y=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,Z=/[A-Z]/g;function $(a){return"true"===a||"false"!==a&&("null"===a?null:a===+a+""?+a:Y.test(a)?JSON.parse(a):a)}function _(a,b,c){var d;if(void 0===c&&1===a.nodeType)if(d="data-"+b.replace(Z,"-$&").toLowerCase(),c=a.getAttribute(d),"string"==typeof c){try{c=$(c)}catch(e){}X.set(a,b,c)}else c=void 0;return c}r.extend({hasData:function(a){return X.hasData(a)||W.hasData(a)},data:function(a,b,c){return X.access(a,b,c)},removeData:function(a,b){X.remove(a,b)},_data:function(a,b,c){return W.access(a,b,c)},_removeData:function(a,b){W.remove(a,b)}}),r.fn.extend({data:function(a,b){var c,d,e,f=this[0],g=f&&f.attributes;if(void 0===a){if(this.length&&(e=X.get(f),1===f.nodeType&&!W.get(f,"hasDataAttrs"))){c=g.length;while(c--)g[c]&&(d=g[c].name,0===d.indexOf("data-")&&(d=r.camelCase(d.slice(5)),_(f,d,e[d])));W.set(f,"hasDataAttrs",!0)}return e}return"object"==typeof a?this.each(function(){X.set(this,a)}):T(this,function(b){var c;if(f&&void 0===b){if(c=X.get(f,a),void 0!==c)return c;if(c=_(f,a),void 0!==c)return c}else this.each(function(){X.set(this,a,b)})},null,b,arguments.length>1,null,!0)},removeData:function(a){return this.each(function(){X.remove(this,a)})}}),r.extend({queue:function(a,b,c){var d;if(a)return b=(b||"fx")+"queue",d=W.get(a,b),c&&(!d||Array.isArray(c)?d=W.access(a,b,r.makeArray(c)):d.push(c)),d||[]},dequeue:function(a,b){b=b||"fx";var c=r.queue(a,b),d=c.length,e=c.shift(),f=r._queueHooks(a,b),g=function(){r.dequeue(a,b)};"inprogress"===e&&(e=c.shift(),d--),e&&("fx"===b&&c.unshift("inprogress"),delete f.stop,e.call(a,g,f)),!d&&f&&f.empty.fire()},_queueHooks:function(a,b){var c=b+"queueHooks";return W.get(a,c)||W.access(a,c,{empty:r.Callbacks("once memory").add(function(){W.remove(a,[b+"queue",c])})})}}),r.fn.extend({queue:function(a,b){var c=2;return"string"!=typeof a&&(b=a,a="fx",c--),arguments.length<c?r.queue(this[0],a):void 0===b?this:this.each(function(){var c=r.queue(this,a,b);r._queueHooks(this,a),"fx"===a&&"inprogress"!==c[0]&&r.dequeue(this,a)})},dequeue:function(a){return this.each(function(){r.dequeue(this,a)})},clearQueue:function(a){return this.queue(a||"fx",[])},promise:function(a,b){var c,d=1,e=r.Deferred(),f=this,g=this.length,h=function(){--d||e.resolveWith(f,[f])};"string"!=typeof a&&(b=a,a=void 0),a=a||"fx";while(g--)c=W.get(f[g],a+"queueHooks"),c&&c.empty&&(d++,c.empty.add(h));return h(),e.promise(b)}});var aa=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,ba=new RegExp("^(?:([+-])=|)("+aa+")([a-z%]*)$","i"),ca=["Top","Right","Bottom","Left"],da=function(a,b){return a=b||a,"none"===a.style.display||""===a.style.display&&r.contains(a.ownerDocument,a)&&"none"===r.css(a,"display")},ea=function(a,b,c,d){var e,f,g={};for(f in b)g[f]=a.style[f],a.style[f]=b[f];e=c.apply(a,d||[]);for(f in b)a.style[f]=g[f];return e};function fa(a,b,c,d){var e,f=1,g=20,h=d?function(){return d.cur()}:function(){return r.css(a,b,"")},i=h(),j=c&&c[3]||(r.cssNumber[b]?"":"px"),k=(r.cssNumber[b]||"px"!==j&&+i)&&ba.exec(r.css(a,b));if(k&&k[3]!==j){j=j||k[3],c=c||[],k=+i||1;do f=f||".5",k/=f,r.style(a,b,k+j);while(f!==(f=h()/i)&&1!==f&&--g)}return c&&(k=+k||+i||0,e=c[1]?k+(c[1]+1)*c[2]:+c[2],d&&(d.unit=j,d.start=k,d.end=e)),e}var ga={};function ha(a){var b,c=a.ownerDocument,d=a.nodeName,e=ga[d];return e?e:(b=c.body.appendChild(c.createElement(d)),e=r.css(b,"display"),b.parentNode.removeChild(b),"none"===e&&(e="block"),ga[d]=e,e)}function ia(a,b){for(var c,d,e=[],f=0,g=a.length;f<g;f++)d=a[f],d.style&&(c=d.style.display,b?("none"===c&&(e[f]=W.get(d,"display")||null,e[f]||(d.style.display="")),""===d.style.display&&da(d)&&(e[f]=ha(d))):"none"!==c&&(e[f]="none",W.set(d,"display",c)));for(f=0;f<g;f++)null!=e[f]&&(a[f].style.display=e[f]);return a}r.fn.extend({show:function(){return ia(this,!0)},hide:function(){return ia(this)},toggle:function(a){return"boolean"==typeof a?a?this.show():this.hide():this.each(function(){da(this)?r(this).show():r(this).hide()})}});var ja=/^(?:checkbox|radio)$/i,ka=/<([a-z][^\/\0>\x20\t\r\n\f]+)/i,la=/^$|\/(?:java|ecma)script/i,ma={option:[1,"<select multiple='multiple'>","</select>"],thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};ma.optgroup=ma.option,ma.tbody=ma.tfoot=ma.colgroup=ma.caption=ma.thead,ma.th=ma.td;function na(a,b){var c;return c="undefined"!=typeof a.getElementsByTagName?a.getElementsByTagName(b||"*"):"undefined"!=typeof a.querySelectorAll?a.querySelectorAll(b||"*"):[],void 0===b||b&&B(a,b)?r.merge([a],c):c}function oa(a,b){for(var c=0,d=a.length;c<d;c++)W.set(a[c],"globalEval",!b||W.get(b[c],"globalEval"))}var pa=/<|&#?\w+;/;function qa(a,b,c,d,e){for(var f,g,h,i,j,k,l=b.createDocumentFragment(),m=[],n=0,o=a.length;n<o;n++)if(f=a[n],f||0===f)if("object"===r.type(f))r.merge(m,f.nodeType?[f]:f);else if(pa.test(f)){g=g||l.appendChild(b.createElement("div")),h=(ka.exec(f)||["",""])[1].toLowerCase(),i=ma[h]||ma._default,g.innerHTML=i[1]+r.htmlPrefilter(f)+i[2],k=i[0];while(k--)g=g.lastChild;r.merge(m,g.childNodes),g=l.firstChild,g.textContent=""}else m.push(b.createTextNode(f));l.textContent="",n=0;while(f=m[n++])if(d&&r.inArray(f,d)>-1)e&&e.push(f);else if(j=r.contains(f.ownerDocument,f),g=na(l.appendChild(f),"script"),j&&oa(g),c){k=0;while(f=g[k++])la.test(f.type||"")&&c.push(f)}return l}!function(){var a=d.createDocumentFragment(),b=a.appendChild(d.createElement("div")),c=d.createElement("input");c.setAttribute("type","radio"),c.setAttribute("checked","checked"),c.setAttribute("name","t"),b.appendChild(c),o.checkClone=b.cloneNode(!0).cloneNode(!0).lastChild.checked,b.innerHTML="<textarea>x</textarea>",o.noCloneChecked=!!b.cloneNode(!0).lastChild.defaultValue}();var ra=d.documentElement,sa=/^key/,ta=/^(?:mouse|pointer|contextmenu|drag|drop)|click/,ua=/^([^.]*)(?:\.(.+)|)/;function va(){return!0}function wa(){return!1}function xa(){try{return d.activeElement}catch(a){}}function ya(a,b,c,d,e,f){var g,h;if("object"==typeof b){"string"!=typeof c&&(d=d||c,c=void 0);for(h in b)ya(a,h,c,d,b[h],f);return a}if(null==d&&null==e?(e=c,d=c=void 0):null==e&&("string"==typeof c?(e=d,d=void 0):(e=d,d=c,c=void 0)),e===!1)e=wa;else if(!e)return a;return 1===f&&(g=e,e=function(a){return r().off(a),g.apply(this,arguments)},e.guid=g.guid||(g.guid=r.guid++)),a.each(function(){r.event.add(this,b,e,d,c)})}r.event={global:{},add:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.get(a);if(q){c.handler&&(f=c,c=f.handler,e=f.selector),e&&r.find.matchesSelector(ra,e),c.guid||(c.guid=r.guid++),(i=q.events)||(i=q.events={}),(g=q.handle)||(g=q.handle=function(b){return"undefined"!=typeof r&&r.event.triggered!==b.type?r.event.dispatch.apply(a,arguments):void 0}),b=(b||"").match(L)||[""],j=b.length;while(j--)h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n&&(l=r.event.special[n]||{},n=(e?l.delegateType:l.bindType)||n,l=r.event.special[n]||{},k=r.extend({type:n,origType:p,data:d,handler:c,guid:c.guid,selector:e,needsContext:e&&r.expr.match.needsContext.test(e),namespace:o.join(".")},f),(m=i[n])||(m=i[n]=[],m.delegateCount=0,l.setup&&l.setup.call(a,d,o,g)!==!1||a.addEventListener&&a.addEventListener(n,g)),l.add&&(l.add.call(a,k),k.handler.guid||(k.handler.guid=c.guid)),e?m.splice(m.delegateCount++,0,k):m.push(k),r.event.global[n]=!0)}},remove:function(a,b,c,d,e){var f,g,h,i,j,k,l,m,n,o,p,q=W.hasData(a)&&W.get(a);if(q&&(i=q.events)){b=(b||"").match(L)||[""],j=b.length;while(j--)if(h=ua.exec(b[j])||[],n=p=h[1],o=(h[2]||"").split(".").sort(),n){l=r.event.special[n]||{},n=(d?l.delegateType:l.bindType)||n,m=i[n]||[],h=h[2]&&new RegExp("(^|\\.)"+o.join("\\.(?:.*\\.|)")+"(\\.|$)"),g=f=m.length;while(f--)k=m[f],!e&&p!==k.origType||c&&c.guid!==k.guid||h&&!h.test(k.namespace)||d&&d!==k.selector&&("**"!==d||!k.selector)||(m.splice(f,1),k.selector&&m.delegateCount--,l.remove&&l.remove.call(a,k));g&&!m.length&&(l.teardown&&l.teardown.call(a,o,q.handle)!==!1||r.removeEvent(a,n,q.handle),delete i[n])}else for(n in i)r.event.remove(a,n+b[j],c,d,!0);r.isEmptyObject(i)&&W.remove(a,"handle events")}},dispatch:function(a){var b=r.event.fix(a),c,d,e,f,g,h,i=new Array(arguments.length),j=(W.get(this,"events")||{})[b.type]||[],k=r.event.special[b.type]||{};for(i[0]=b,c=1;c<arguments.length;c++)i[c]=arguments[c];if(b.delegateTarget=this,!k.preDispatch||k.preDispatch.call(this,b)!==!1){h=r.event.handlers.call(this,b,j),c=0;while((f=h[c++])&&!b.isPropagationStopped()){b.currentTarget=f.elem,d=0;while((g=f.handlers[d++])&&!b.isImmediatePropagationStopped())b.rnamespace&&!b.rnamespace.test(g.namespace)||(b.handleObj=g,b.data=g.data,e=((r.event.special[g.origType]||{}).handle||g.handler).apply(f.elem,i),void 0!==e&&(b.result=e)===!1&&(b.preventDefault(),b.stopPropagation()))}return k.postDispatch&&k.postDispatch.call(this,b),b.result}},handlers:function(a,b){var c,d,e,f,g,h=[],i=b.delegateCount,j=a.target;if(i&&j.nodeType&&!("click"===a.type&&a.button>=1))for(;j!==this;j=j.parentNode||this)if(1===j.nodeType&&("click"!==a.type||j.disabled!==!0)){for(f=[],g={},c=0;c<i;c++)d=b[c],e=d.selector+" ",void 0===g[e]&&(g[e]=d.needsContext?r(e,this).index(j)>-1:r.find(e,this,null,[j]).length),g[e]&&f.push(d);f.length&&h.push({elem:j,handlers:f})}return j=this,i<b.length&&h.push({elem:j,handlers:b.slice(i)}),h},addProp:function(a,b){Object.defineProperty(r.Event.prototype,a,{enumerable:!0,configurable:!0,get:r.isFunction(b)?function(){if(this.originalEvent)return b(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[a]},set:function(b){Object.defineProperty(this,a,{enumerable:!0,configurable:!0,writable:!0,value:b})}})},fix:function(a){return a[r.expando]?a:new r.Event(a)},special:{load:{noBubble:!0},focus:{trigger:function(){if(this!==xa()&&this.focus)return this.focus(),!1},delegateType:"focusin"},blur:{trigger:function(){if(this===xa()&&this.blur)return this.blur(),!1},delegateType:"focusout"},click:{trigger:function(){if("checkbox"===this.type&&this.click&&B(this,"input"))return this.click(),!1},_default:function(a){return B(a.target,"a")}},beforeunload:{postDispatch:function(a){void 0!==a.result&&a.originalEvent&&(a.originalEvent.returnValue=a.result)}}}},r.removeEvent=function(a,b,c){a.removeEventListener&&a.removeEventListener(b,c)},r.Event=function(a,b){return this instanceof r.Event?(a&&a.type?(this.originalEvent=a,this.type=a.type,this.isDefaultPrevented=a.defaultPrevented||void 0===a.defaultPrevented&&a.returnValue===!1?va:wa,this.target=a.target&&3===a.target.nodeType?a.target.parentNode:a.target,this.currentTarget=a.currentTarget,this.relatedTarget=a.relatedTarget):this.type=a,b&&r.extend(this,b),this.timeStamp=a&&a.timeStamp||r.now(),void(this[r.expando]=!0)):new r.Event(a,b)},r.Event.prototype={constructor:r.Event,isDefaultPrevented:wa,isPropagationStopped:wa,isImmediatePropagationStopped:wa,isSimulated:!1,preventDefault:function(){var a=this.originalEvent;this.isDefaultPrevented=va,a&&!this.isSimulated&&a.preventDefault()},stopPropagation:function(){var a=this.originalEvent;this.isPropagationStopped=va,a&&!this.isSimulated&&a.stopPropagation()},stopImmediatePropagation:function(){var a=this.originalEvent;this.isImmediatePropagationStopped=va,a&&!this.isSimulated&&a.stopImmediatePropagation(),this.stopPropagation()}},r.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:function(a){var b=a.button;return null==a.which&&sa.test(a.type)?null!=a.charCode?a.charCode:a.keyCode:!a.which&&void 0!==b&&ta.test(a.type)?1&b?1:2&b?3:4&b?2:0:a.which}},r.event.addProp),r.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(a,b){r.event.special[a]={delegateType:b,bindType:b,handle:function(a){var c,d=this,e=a.relatedTarget,f=a.handleObj;return e&&(e===d||r.contains(d,e))||(a.type=f.origType,c=f.handler.apply(this,arguments),a.type=b),c}}}),r.fn.extend({on:function(a,b,c,d){return ya(this,a,b,c,d)},one:function(a,b,c,d){return ya(this,a,b,c,d,1)},off:function(a,b,c){var d,e;if(a&&a.preventDefault&&a.handleObj)return d=a.handleObj,r(a.delegateTarget).off(d.namespace?d.origType+"."+d.namespace:d.origType,d.selector,d.handler),this;if("object"==typeof a){for(e in a)this.off(e,b,a[e]);return this}return b!==!1&&"function"!=typeof b||(c=b,b=void 0),c===!1&&(c=wa),this.each(function(){r.event.remove(this,a,c,b)})}});var za=/<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,Aa=/<script|<style|<link/i,Ba=/checked\s*(?:[^=]|=\s*.checked.)/i,Ca=/^true\/(.*)/,Da=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function Ea(a,b){return B(a,"table")&&B(11!==b.nodeType?b:b.firstChild,"tr")?r(">tbody",a)[0]||a:a}function Fa(a){return a.type=(null!==a.getAttribute("type"))+"/"+a.type,a}function Ga(a){var b=Ca.exec(a.type);return b?a.type=b[1]:a.removeAttribute("type"),a}function Ha(a,b){var c,d,e,f,g,h,i,j;if(1===b.nodeType){if(W.hasData(a)&&(f=W.access(a),g=W.set(b,f),j=f.events)){delete g.handle,g.events={};for(e in j)for(c=0,d=j[e].length;c<d;c++)r.event.add(b,e,j[e][c])}X.hasData(a)&&(h=X.access(a),i=r.extend({},h),X.set(b,i))}}function Ia(a,b){var c=b.nodeName.toLowerCase();"input"===c&&ja.test(a.type)?b.checked=a.checked:"input"!==c&&"textarea"!==c||(b.defaultValue=a.defaultValue)}function Ja(a,b,c,d){b=g.apply([],b);var e,f,h,i,j,k,l=0,m=a.length,n=m-1,q=b[0],s=r.isFunction(q);if(s||m>1&&"string"==typeof q&&!o.checkClone&&Ba.test(q))return a.each(function(e){var f=a.eq(e);s&&(b[0]=q.call(this,e,f.html())),Ja(f,b,c,d)});if(m&&(e=qa(b,a[0].ownerDocument,!1,a,d),f=e.firstChild,1===e.childNodes.length&&(e=f),f||d)){for(h=r.map(na(e,"script"),Fa),i=h.length;l<m;l++)j=e,l!==n&&(j=r.clone(j,!0,!0),i&&r.merge(h,na(j,"script"))),c.call(a[l],j,l);if(i)for(k=h[h.length-1].ownerDocument,r.map(h,Ga),l=0;l<i;l++)j=h[l],la.test(j.type||"")&&!W.access(j,"globalEval")&&r.contains(k,j)&&(j.src?r._evalUrl&&r._evalUrl(j.src):p(j.textContent.replace(Da,""),k))}return a}function Ka(a,b,c){for(var d,e=b?r.filter(b,a):a,f=0;null!=(d=e[f]);f++)c||1!==d.nodeType||r.cleanData(na(d)),d.parentNode&&(c&&r.contains(d.ownerDocument,d)&&oa(na(d,"script")),d.parentNode.removeChild(d));return a}r.extend({htmlPrefilter:function(a){return a.replace(za,"<$1></$2>")},clone:function(a,b,c){var d,e,f,g,h=a.cloneNode(!0),i=r.contains(a.ownerDocument,a);if(!(o.noCloneChecked||1!==a.nodeType&&11!==a.nodeType||r.isXMLDoc(a)))for(g=na(h),f=na(a),d=0,e=f.length;d<e;d++)Ia(f[d],g[d]);if(b)if(c)for(f=f||na(a),g=g||na(h),d=0,e=f.length;d<e;d++)Ha(f[d],g[d]);else Ha(a,h);return g=na(h,"script"),g.length>0&&oa(g,!i&&na(a,"script")),h},cleanData:function(a){for(var b,c,d,e=r.event.special,f=0;void 0!==(c=a[f]);f++)if(U(c)){if(b=c[W.expando]){if(b.events)for(d in b.events)e[d]?r.event.remove(c,d):r.removeEvent(c,d,b.handle);c[W.expando]=void 0}c[X.expando]&&(c[X.expando]=void 0)}}}),r.fn.extend({detach:function(a){return Ka(this,a,!0)},remove:function(a){return Ka(this,a)},text:function(a){return T(this,function(a){return void 0===a?r.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=a)})},null,a,arguments.length)},append:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.appendChild(a)}})},prepend:function(){return Ja(this,arguments,function(a){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var b=Ea(this,a);b.insertBefore(a,b.firstChild)}})},before:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this)})},after:function(){return Ja(this,arguments,function(a){this.parentNode&&this.parentNode.insertBefore(a,this.nextSibling)})},empty:function(){for(var a,b=0;null!=(a=this[b]);b++)1===a.nodeType&&(r.cleanData(na(a,!1)),a.textContent="");return this},clone:function(a,b){return a=null!=a&&a,b=null==b?a:b,this.map(function(){return r.clone(this,a,b)})},html:function(a){return T(this,function(a){var b=this[0]||{},c=0,d=this.length;if(void 0===a&&1===b.nodeType)return b.innerHTML;if("string"==typeof a&&!Aa.test(a)&&!ma[(ka.exec(a)||["",""])[1].toLowerCase()]){a=r.htmlPrefilter(a);try{for(;c<d;c++)b=this[c]||{},1===b.nodeType&&(r.cleanData(na(b,!1)),b.innerHTML=a);b=0}catch(e){}}b&&this.empty().append(a)},null,a,arguments.length)},replaceWith:function(){var a=[];return Ja(this,arguments,function(b){var c=this.parentNode;r.inArray(this,a)<0&&(r.cleanData(na(this)),c&&c.replaceChild(b,this))},a)}}),r.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(a,b){r.fn[a]=function(a){for(var c,d=[],e=r(a),f=e.length-1,g=0;g<=f;g++)c=g===f?this:this.clone(!0),r(e[g])[b](c),h.apply(d,c.get());return this.pushStack(d)}});var La=/^margin/,Ma=new RegExp("^("+aa+")(?!px)[a-z%]+$","i"),Na=function(b){var c=b.ownerDocument.defaultView;return c&&c.opener||(c=a),c.getComputedStyle(b)};!function(){function b(){if(i){i.style.cssText="box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%",i.innerHTML="",ra.appendChild(h);var b=a.getComputedStyle(i);c="1%"!==b.top,g="2px"===b.marginLeft,e="4px"===b.width,i.style.marginRight="50%",f="4px"===b.marginRight,ra.removeChild(h),i=null}}var c,e,f,g,h=d.createElement("div"),i=d.createElement("div");i.style&&(i.style.backgroundClip="content-box",i.cloneNode(!0).style.backgroundClip="",o.clearCloneStyle="content-box"===i.style.backgroundClip,h.style.cssText="border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute",h.appendChild(i),r.extend(o,{pixelPosition:function(){return b(),c},boxSizingReliable:function(){return b(),e},pixelMarginRight:function(){return b(),f},reliableMarginLeft:function(){return b(),g}}))}();function Oa(a,b,c){var d,e,f,g,h=a.style;return c=c||Na(a),c&&(g=c.getPropertyValue(b)||c[b],""!==g||r.contains(a.ownerDocument,a)||(g=r.style(a,b)),!o.pixelMarginRight()&&Ma.test(g)&&La.test(b)&&(d=h.width,e=h.minWidth,f=h.maxWidth,h.minWidth=h.maxWidth=h.width=g,g=c.width,h.width=d,h.minWidth=e,h.maxWidth=f)),void 0!==g?g+"":g}function Pa(a,b){return{get:function(){return a()?void delete this.get:(this.get=b).apply(this,arguments)}}}var Qa=/^(none|table(?!-c[ea]).+)/,Ra=/^--/,Sa={position:"absolute",visibility:"hidden",display:"block"},Ta={letterSpacing:"0",fontWeight:"400"},Ua=["Webkit","Moz","ms"],Va=d.createElement("div").style;function Wa(a){if(a in Va)return a;var b=a[0].toUpperCase()+a.slice(1),c=Ua.length;while(c--)if(a=Ua[c]+b,a in Va)return a}function Xa(a){var b=r.cssProps[a];return b||(b=r.cssProps[a]=Wa(a)||a),b}function Ya(a,b,c){var d=ba.exec(b);return d?Math.max(0,d[2]-(c||0))+(d[3]||"px"):b}function Za(a,b,c,d,e){var f,g=0;for(f=c===(d?"border":"content")?4:"width"===b?1:0;f<4;f+=2)"margin"===c&&(g+=r.css(a,c+ca[f],!0,e)),d?("content"===c&&(g-=r.css(a,"padding"+ca[f],!0,e)),"margin"!==c&&(g-=r.css(a,"border"+ca[f]+"Width",!0,e))):(g+=r.css(a,"padding"+ca[f],!0,e),"padding"!==c&&(g+=r.css(a,"border"+ca[f]+"Width",!0,e)));return g}function $a(a,b,c){var d,e=Na(a),f=Oa(a,b,e),g="border-box"===r.css(a,"boxSizing",!1,e);return Ma.test(f)?f:(d=g&&(o.boxSizingReliable()||f===a.style[b]),"auto"===f&&(f=a["offset"+b[0].toUpperCase()+b.slice(1)]),f=parseFloat(f)||0,f+Za(a,b,c||(g?"border":"content"),d,e)+"px")}r.extend({cssHooks:{opacity:{get:function(a,b){if(b){var c=Oa(a,"opacity");return""===c?"1":c}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{"float":"cssFloat"},style:function(a,b,c,d){if(a&&3!==a.nodeType&&8!==a.nodeType&&a.style){var e,f,g,h=r.camelCase(b),i=Ra.test(b),j=a.style;return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],void 0===c?g&&"get"in g&&void 0!==(e=g.get(a,!1,d))?e:j[b]:(f=typeof c,"string"===f&&(e=ba.exec(c))&&e[1]&&(c=fa(a,b,e),f="number"),null!=c&&c===c&&("number"===f&&(c+=e&&e[3]||(r.cssNumber[h]?"":"px")),o.clearCloneStyle||""!==c||0!==b.indexOf("background")||(j[b]="inherit"),g&&"set"in g&&void 0===(c=g.set(a,c,d))||(i?j.setProperty(b,c):j[b]=c)),void 0)}},css:function(a,b,c,d){var e,f,g,h=r.camelCase(b),i=Ra.test(b);return i||(b=Xa(h)),g=r.cssHooks[b]||r.cssHooks[h],g&&"get"in g&&(e=g.get(a,!0,c)),void 0===e&&(e=Oa(a,b,d)),"normal"===e&&b in Ta&&(e=Ta[b]),""===c||c?(f=parseFloat(e),c===!0||isFinite(f)?f||0:e):e}}),r.each(["height","width"],function(a,b){r.cssHooks[b]={get:function(a,c,d){if(c)return!Qa.test(r.css(a,"display"))||a.getClientRects().length&&a.getBoundingClientRect().width?$a(a,b,d):ea(a,Sa,function(){return $a(a,b,d)})},set:function(a,c,d){var e,f=d&&Na(a),g=d&&Za(a,b,d,"border-box"===r.css(a,"boxSizing",!1,f),f);return g&&(e=ba.exec(c))&&"px"!==(e[3]||"px")&&(a.style[b]=c,c=r.css(a,b)),Ya(a,c,g)}}}),r.cssHooks.marginLeft=Pa(o.reliableMarginLeft,function(a,b){if(b)return(parseFloat(Oa(a,"marginLeft"))||a.getBoundingClientRect().left-ea(a,{marginLeft:0},function(){return a.getBoundingClientRect().left}))+"px"}),r.each({margin:"",padding:"",border:"Width"},function(a,b){r.cssHooks[a+b]={expand:function(c){for(var d=0,e={},f="string"==typeof c?c.split(" "):[c];d<4;d++)e[a+ca[d]+b]=f[d]||f[d-2]||f[0];return e}},La.test(a)||(r.cssHooks[a+b].set=Ya)}),r.fn.extend({css:function(a,b){return T(this,function(a,b,c){var d,e,f={},g=0;if(Array.isArray(b)){for(d=Na(a),e=b.length;g<e;g++)f[b[g]]=r.css(a,b[g],!1,d);return f}return void 0!==c?r.style(a,b,c):r.css(a,b)},a,b,arguments.length>1)}});function _a(a,b,c,d,e){return new _a.prototype.init(a,b,c,d,e)}r.Tween=_a,_a.prototype={constructor:_a,init:function(a,b,c,d,e,f){this.elem=a,this.prop=c,this.easing=e||r.easing._default,this.options=b,this.start=this.now=this.cur(),this.end=d,this.unit=f||(r.cssNumber[c]?"":"px")},cur:function(){var a=_a.propHooks[this.prop];return a&&a.get?a.get(this):_a.propHooks._default.get(this)},run:function(a){var b,c=_a.propHooks[this.prop];return this.options.duration?this.pos=b=r.easing[this.easing](a,this.options.duration*a,0,1,this.options.duration):this.pos=b=a,this.now=(this.end-this.start)*b+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),c&&c.set?c.set(this):_a.propHooks._default.set(this),this}},_a.prototype.init.prototype=_a.prototype,_a.propHooks={_default:{get:function(a){var b;return 1!==a.elem.nodeType||null!=a.elem[a.prop]&&null==a.elem.style[a.prop]?a.elem[a.prop]:(b=r.css(a.elem,a.prop,""),b&&"auto"!==b?b:0)},set:function(a){r.fx.step[a.prop]?r.fx.step[a.prop](a):1!==a.elem.nodeType||null==a.elem.style[r.cssProps[a.prop]]&&!r.cssHooks[a.prop]?a.elem[a.prop]=a.now:r.style(a.elem,a.prop,a.now+a.unit)}}},_a.propHooks.scrollTop=_a.propHooks.scrollLeft={set:function(a){a.elem.nodeType&&a.elem.parentNode&&(a.elem[a.prop]=a.now)}},r.easing={linear:function(a){return a},swing:function(a){return.5-Math.cos(a*Math.PI)/2},_default:"swing"},r.fx=_a.prototype.init,r.fx.step={};var ab,bb,cb=/^(?:toggle|show|hide)$/,db=/queueHooks$/;function eb(){bb&&(d.hidden===!1&&a.requestAnimationFrame?a.requestAnimationFrame(eb):a.setTimeout(eb,r.fx.interval),r.fx.tick())}function fb(){return a.setTimeout(function(){ab=void 0}),ab=r.now()}function gb(a,b){var c,d=0,e={height:a};for(b=b?1:0;d<4;d+=2-b)c=ca[d],e["margin"+c]=e["padding"+c]=a;return b&&(e.opacity=e.width=a),e}function hb(a,b,c){for(var d,e=(kb.tweeners[b]||[]).concat(kb.tweeners["*"]),f=0,g=e.length;f<g;f++)if(d=e[f].call(c,b,a))return d}function ib(a,b,c){var d,e,f,g,h,i,j,k,l="width"in b||"height"in b,m=this,n={},o=a.style,p=a.nodeType&&da(a),q=W.get(a,"fxshow");c.queue||(g=r._queueHooks(a,"fx"),null==g.unqueued&&(g.unqueued=0,h=g.empty.fire,g.empty.fire=function(){g.unqueued||h()}),g.unqueued++,m.always(function(){m.always(function(){g.unqueued--,r.queue(a,"fx").length||g.empty.fire()})}));for(d in b)if(e=b[d],cb.test(e)){if(delete b[d],f=f||"toggle"===e,e===(p?"hide":"show")){if("show"!==e||!q||void 0===q[d])continue;p=!0}n[d]=q&&q[d]||r.style(a,d)}if(i=!r.isEmptyObject(b),i||!r.isEmptyObject(n)){l&&1===a.nodeType&&(c.overflow=[o.overflow,o.overflowX,o.overflowY],j=q&&q.display,null==j&&(j=W.get(a,"display")),k=r.css(a,"display"),"none"===k&&(j?k=j:(ia([a],!0),j=a.style.display||j,k=r.css(a,"display"),ia([a]))),("inline"===k||"inline-block"===k&&null!=j)&&"none"===r.css(a,"float")&&(i||(m.done(function(){o.display=j}),null==j&&(k=o.display,j="none"===k?"":k)),o.display="inline-block")),c.overflow&&(o.overflow="hidden",m.always(function(){o.overflow=c.overflow[0],o.overflowX=c.overflow[1],o.overflowY=c.overflow[2]})),i=!1;for(d in n)i||(q?"hidden"in q&&(p=q.hidden):q=W.access(a,"fxshow",{display:j}),f&&(q.hidden=!p),p&&ia([a],!0),m.done(function(){p||ia([a]),W.remove(a,"fxshow");for(d in n)r.style(a,d,n[d])})),i=hb(p?q[d]:0,d,m),d in q||(q[d]=i.start,p&&(i.end=i.start,i.start=0))}}function jb(a,b){var c,d,e,f,g;for(c in a)if(d=r.camelCase(c),e=b[d],f=a[c],Array.isArray(f)&&(e=f[1],f=a[c]=f[0]),c!==d&&(a[d]=f,delete a[c]),g=r.cssHooks[d],g&&"expand"in g){f=g.expand(f),delete a[d];for(c in f)c in a||(a[c]=f[c],b[c]=e)}else b[d]=e}function kb(a,b,c){var d,e,f=0,g=kb.prefilters.length,h=r.Deferred().always(function(){delete i.elem}),i=function(){if(e)return!1;for(var b=ab||fb(),c=Math.max(0,j.startTime+j.duration-b),d=c/j.duration||0,f=1-d,g=0,i=j.tweens.length;g<i;g++)j.tweens[g].run(f);return h.notifyWith(a,[j,f,c]),f<1&&i?c:(i||h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j]),!1)},j=h.promise({elem:a,props:r.extend({},b),opts:r.extend(!0,{specialEasing:{},easing:r.easing._default},c),originalProperties:b,originalOptions:c,startTime:ab||fb(),duration:c.duration,tweens:[],createTween:function(b,c){var d=r.Tween(a,j.opts,b,c,j.opts.specialEasing[b]||j.opts.easing);return j.tweens.push(d),d},stop:function(b){var c=0,d=b?j.tweens.length:0;if(e)return this;for(e=!0;c<d;c++)j.tweens[c].run(1);return b?(h.notifyWith(a,[j,1,0]),h.resolveWith(a,[j,b])):h.rejectWith(a,[j,b]),this}}),k=j.props;for(jb(k,j.opts.specialEasing);f<g;f++)if(d=kb.prefilters[f].call(j,a,k,j.opts))return r.isFunction(d.stop)&&(r._queueHooks(j.elem,j.opts.queue).stop=r.proxy(d.stop,d)),d;return r.map(k,hb,j),r.isFunction(j.opts.start)&&j.opts.start.call(a,j),j.progress(j.opts.progress).done(j.opts.done,j.opts.complete).fail(j.opts.fail).always(j.opts.always),r.fx.timer(r.extend(i,{elem:a,anim:j,queue:j.opts.queue})),j}r.Animation=r.extend(kb,{tweeners:{"*":[function(a,b){var c=this.createTween(a,b);return fa(c.elem,a,ba.exec(b),c),c}]},tweener:function(a,b){r.isFunction(a)?(b=a,a=["*"]):a=a.match(L);for(var c,d=0,e=a.length;d<e;d++)c=a[d],kb.tweeners[c]=kb.tweeners[c]||[],kb.tweeners[c].unshift(b)},prefilters:[ib],prefilter:function(a,b){b?kb.prefilters.unshift(a):kb.prefilters.push(a)}}),r.speed=function(a,b,c){var d=a&&"object"==typeof a?r.extend({},a):{complete:c||!c&&b||r.isFunction(a)&&a,duration:a,easing:c&&b||b&&!r.isFunction(b)&&b};return r.fx.off?d.duration=0:"number"!=typeof d.duration&&(d.duration in r.fx.speeds?d.duration=r.fx.speeds[d.duration]:d.duration=r.fx.speeds._default),null!=d.queue&&d.queue!==!0||(d.queue="fx"),d.old=d.complete,d.complete=function(){r.isFunction(d.old)&&d.old.call(this),d.queue&&r.dequeue(this,d.queue)},d},r.fn.extend({fadeTo:function(a,b,c,d){return this.filter(da).css("opacity",0).show().end().animate({opacity:b},a,c,d)},animate:function(a,b,c,d){var e=r.isEmptyObject(a),f=r.speed(b,c,d),g=function(){var b=kb(this,r.extend({},a),f);(e||W.get(this,"finish"))&&b.stop(!0)};return g.finish=g,e||f.queue===!1?this.each(g):this.queue(f.queue,g)},stop:function(a,b,c){var d=function(a){var b=a.stop;delete a.stop,b(c)};return"string"!=typeof a&&(c=b,b=a,a=void 0),b&&a!==!1&&this.queue(a||"fx",[]),this.each(function(){var b=!0,e=null!=a&&a+"queueHooks",f=r.timers,g=W.get(this);if(e)g[e]&&g[e].stop&&d(g[e]);else for(e in g)g[e]&&g[e].stop&&db.test(e)&&d(g[e]);for(e=f.length;e--;)f[e].elem!==this||null!=a&&f[e].queue!==a||(f[e].anim.stop(c),b=!1,f.splice(e,1));!b&&c||r.dequeue(this,a)})},finish:function(a){return a!==!1&&(a=a||"fx"),this.each(function(){var b,c=W.get(this),d=c[a+"queue"],e=c[a+"queueHooks"],f=r.timers,g=d?d.length:0;for(c.finish=!0,r.queue(this,a,[]),e&&e.stop&&e.stop.call(this,!0),b=f.length;b--;)f[b].elem===this&&f[b].queue===a&&(f[b].anim.stop(!0),f.splice(b,1));for(b=0;b<g;b++)d[b]&&d[b].finish&&d[b].finish.call(this);delete c.finish})}}),r.each(["toggle","show","hide"],function(a,b){var c=r.fn[b];r.fn[b]=function(a,d,e){return null==a||"boolean"==typeof a?c.apply(this,arguments):this.animate(gb(b,!0),a,d,e)}}),r.each({slideDown:gb("show"),slideUp:gb("hide"),slideToggle:gb("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(a,b){r.fn[a]=function(a,c,d){return this.animate(b,a,c,d)}}),r.timers=[],r.fx.tick=function(){var a,b=0,c=r.timers;for(ab=r.now();b<c.length;b++)a=c[b],a()||c[b]!==a||c.splice(b--,1);c.length||r.fx.stop(),ab=void 0},r.fx.timer=function(a){r.timers.push(a),r.fx.start()},r.fx.interval=13,r.fx.start=function(){bb||(bb=!0,eb())},r.fx.stop=function(){bb=null},r.fx.speeds={slow:600,fast:200,_default:400},r.fn.delay=function(b,c){return b=r.fx?r.fx.speeds[b]||b:b,c=c||"fx",this.queue(c,function(c,d){var e=a.setTimeout(c,b);d.stop=function(){a.clearTimeout(e)}})},function(){var a=d.createElement("input"),b=d.createElement("select"),c=b.appendChild(d.createElement("option"));a.type="checkbox",o.checkOn=""!==a.value,o.optSelected=c.selected,a=d.createElement("input"),a.value="t",a.type="radio",o.radioValue="t"===a.value}();var lb,mb=r.expr.attrHandle;r.fn.extend({attr:function(a,b){return T(this,r.attr,a,b,arguments.length>1)},removeAttr:function(a){return this.each(function(){r.removeAttr(this,a)})}}),r.extend({attr:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return"undefined"==typeof a.getAttribute?r.prop(a,b,c):(1===f&&r.isXMLDoc(a)||(e=r.attrHooks[b.toLowerCase()]||(r.expr.match.bool.test(b)?lb:void 0)),void 0!==c?null===c?void r.removeAttr(a,b):e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:(a.setAttribute(b,c+""),c):e&&"get"in e&&null!==(d=e.get(a,b))?d:(d=r.find.attr(a,b),
// null==d?void 0:d))},attrHooks:{type:{set:function(a,b){if(!o.radioValue&&"radio"===b&&B(a,"input")){var c=a.value;return a.setAttribute("type",b),c&&(a.value=c),b}}}},removeAttr:function(a,b){var c,d=0,e=b&&b.match(L);if(e&&1===a.nodeType)while(c=e[d++])a.removeAttribute(c)}}),lb={set:function(a,b,c){return b===!1?r.removeAttr(a,c):a.setAttribute(c,c),c}},r.each(r.expr.match.bool.source.match(/\w+/g),function(a,b){var c=mb[b]||r.find.attr;mb[b]=function(a,b,d){var e,f,g=b.toLowerCase();return d||(f=mb[g],mb[g]=e,e=null!=c(a,b,d)?g:null,mb[g]=f),e}});var nb=/^(?:input|select|textarea|button)$/i,ob=/^(?:a|area)$/i;r.fn.extend({prop:function(a,b){return T(this,r.prop,a,b,arguments.length>1)},removeProp:function(a){return this.each(function(){delete this[r.propFix[a]||a]})}}),r.extend({prop:function(a,b,c){var d,e,f=a.nodeType;if(3!==f&&8!==f&&2!==f)return 1===f&&r.isXMLDoc(a)||(b=r.propFix[b]||b,e=r.propHooks[b]),void 0!==c?e&&"set"in e&&void 0!==(d=e.set(a,c,b))?d:a[b]=c:e&&"get"in e&&null!==(d=e.get(a,b))?d:a[b]},propHooks:{tabIndex:{get:function(a){var b=r.find.attr(a,"tabindex");return b?parseInt(b,10):nb.test(a.nodeName)||ob.test(a.nodeName)&&a.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),o.optSelected||(r.propHooks.selected={get:function(a){var b=a.parentNode;return b&&b.parentNode&&b.parentNode.selectedIndex,null},set:function(a){var b=a.parentNode;b&&(b.selectedIndex,b.parentNode&&b.parentNode.selectedIndex)}}),r.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){r.propFix[this.toLowerCase()]=this});function pb(a){var b=a.match(L)||[];return b.join(" ")}function qb(a){return a.getAttribute&&a.getAttribute("class")||""}r.fn.extend({addClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).addClass(a.call(this,b,qb(this)))});if("string"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&" "+pb(e)+" "){g=0;while(f=b[g++])d.indexOf(" "+f+" ")<0&&(d+=f+" ");h=pb(d),e!==h&&c.setAttribute("class",h)}}return this},removeClass:function(a){var b,c,d,e,f,g,h,i=0;if(r.isFunction(a))return this.each(function(b){r(this).removeClass(a.call(this,b,qb(this)))});if(!arguments.length)return this.attr("class","");if("string"==typeof a&&a){b=a.match(L)||[];while(c=this[i++])if(e=qb(c),d=1===c.nodeType&&" "+pb(e)+" "){g=0;while(f=b[g++])while(d.indexOf(" "+f+" ")>-1)d=d.replace(" "+f+" "," ");h=pb(d),e!==h&&c.setAttribute("class",h)}}return this},toggleClass:function(a,b){var c=typeof a;return"boolean"==typeof b&&"string"===c?b?this.addClass(a):this.removeClass(a):r.isFunction(a)?this.each(function(c){r(this).toggleClass(a.call(this,c,qb(this),b),b)}):this.each(function(){var b,d,e,f;if("string"===c){d=0,e=r(this),f=a.match(L)||[];while(b=f[d++])e.hasClass(b)?e.removeClass(b):e.addClass(b)}else void 0!==a&&"boolean"!==c||(b=qb(this),b&&W.set(this,"__className__",b),this.setAttribute&&this.setAttribute("class",b||a===!1?"":W.get(this,"__className__")||""))})},hasClass:function(a){var b,c,d=0;b=" "+a+" ";while(c=this[d++])if(1===c.nodeType&&(" "+pb(qb(c))+" ").indexOf(b)>-1)return!0;return!1}});var rb=/\r/g;r.fn.extend({val:function(a){var b,c,d,e=this[0];{if(arguments.length)return d=r.isFunction(a),this.each(function(c){var e;1===this.nodeType&&(e=d?a.call(this,c,r(this).val()):a,null==e?e="":"number"==typeof e?e+="":Array.isArray(e)&&(e=r.map(e,function(a){return null==a?"":a+""})),b=r.valHooks[this.type]||r.valHooks[this.nodeName.toLowerCase()],b&&"set"in b&&void 0!==b.set(this,e,"value")||(this.value=e))});if(e)return b=r.valHooks[e.type]||r.valHooks[e.nodeName.toLowerCase()],b&&"get"in b&&void 0!==(c=b.get(e,"value"))?c:(c=e.value,"string"==typeof c?c.replace(rb,""):null==c?"":c)}}}),r.extend({valHooks:{option:{get:function(a){var b=r.find.attr(a,"value");return null!=b?b:pb(r.text(a))}},select:{get:function(a){var b,c,d,e=a.options,f=a.selectedIndex,g="select-one"===a.type,h=g?null:[],i=g?f+1:e.length;for(d=f<0?i:g?f:0;d<i;d++)if(c=e[d],(c.selected||d===f)&&!c.disabled&&(!c.parentNode.disabled||!B(c.parentNode,"optgroup"))){if(b=r(c).val(),g)return b;h.push(b)}return h},set:function(a,b){var c,d,e=a.options,f=r.makeArray(b),g=e.length;while(g--)d=e[g],(d.selected=r.inArray(r.valHooks.option.get(d),f)>-1)&&(c=!0);return c||(a.selectedIndex=-1),f}}}}),r.each(["radio","checkbox"],function(){r.valHooks[this]={set:function(a,b){if(Array.isArray(b))return a.checked=r.inArray(r(a).val(),b)>-1}},o.checkOn||(r.valHooks[this].get=function(a){return null===a.getAttribute("value")?"on":a.value})});var sb=/^(?:focusinfocus|focusoutblur)$/;r.extend(r.event,{trigger:function(b,c,e,f){var g,h,i,j,k,m,n,o=[e||d],p=l.call(b,"type")?b.type:b,q=l.call(b,"namespace")?b.namespace.split("."):[];if(h=i=e=e||d,3!==e.nodeType&&8!==e.nodeType&&!sb.test(p+r.event.triggered)&&(p.indexOf(".")>-1&&(q=p.split("."),p=q.shift(),q.sort()),k=p.indexOf(":")<0&&"on"+p,b=b[r.expando]?b:new r.Event(p,"object"==typeof b&&b),b.isTrigger=f?2:3,b.namespace=q.join("."),b.rnamespace=b.namespace?new RegExp("(^|\\.)"+q.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,b.result=void 0,b.target||(b.target=e),c=null==c?[b]:r.makeArray(c,[b]),n=r.event.special[p]||{},f||!n.trigger||n.trigger.apply(e,c)!==!1)){if(!f&&!n.noBubble&&!r.isWindow(e)){for(j=n.delegateType||p,sb.test(j+p)||(h=h.parentNode);h;h=h.parentNode)o.push(h),i=h;i===(e.ownerDocument||d)&&o.push(i.defaultView||i.parentWindow||a)}g=0;while((h=o[g++])&&!b.isPropagationStopped())b.type=g>1?j:n.bindType||p,m=(W.get(h,"events")||{})[b.type]&&W.get(h,"handle"),m&&m.apply(h,c),m=k&&h[k],m&&m.apply&&U(h)&&(b.result=m.apply(h,c),b.result===!1&&b.preventDefault());return b.type=p,f||b.isDefaultPrevented()||n._default&&n._default.apply(o.pop(),c)!==!1||!U(e)||k&&r.isFunction(e[p])&&!r.isWindow(e)&&(i=e[k],i&&(e[k]=null),r.event.triggered=p,e[p](),r.event.triggered=void 0,i&&(e[k]=i)),b.result}},simulate:function(a,b,c){var d=r.extend(new r.Event,c,{type:a,isSimulated:!0});r.event.trigger(d,null,b)}}),r.fn.extend({trigger:function(a,b){return this.each(function(){r.event.trigger(a,b,this)})},triggerHandler:function(a,b){var c=this[0];if(c)return r.event.trigger(a,b,c,!0)}}),r.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(a,b){r.fn[b]=function(a,c){return arguments.length>0?this.on(b,null,a,c):this.trigger(b)}}),r.fn.extend({hover:function(a,b){return this.mouseenter(a).mouseleave(b||a)}}),o.focusin="onfocusin"in a,o.focusin||r.each({focus:"focusin",blur:"focusout"},function(a,b){var c=function(a){r.event.simulate(b,a.target,r.event.fix(a))};r.event.special[b]={setup:function(){var d=this.ownerDocument||this,e=W.access(d,b);e||d.addEventListener(a,c,!0),W.access(d,b,(e||0)+1)},teardown:function(){var d=this.ownerDocument||this,e=W.access(d,b)-1;e?W.access(d,b,e):(d.removeEventListener(a,c,!0),W.remove(d,b))}}});var tb=a.location,ub=r.now(),vb=/\?/;r.parseXML=function(b){var c;if(!b||"string"!=typeof b)return null;try{c=(new a.DOMParser).parseFromString(b,"text/xml")}catch(d){c=void 0}return c&&!c.getElementsByTagName("parsererror").length||r.error("Invalid XML: "+b),c};var wb=/\[\]$/,xb=/\r?\n/g,yb=/^(?:submit|button|image|reset|file)$/i,zb=/^(?:input|select|textarea|keygen)/i;function Ab(a,b,c,d){var e;if(Array.isArray(b))r.each(b,function(b,e){c||wb.test(a)?d(a,e):Ab(a+"["+("object"==typeof e&&null!=e?b:"")+"]",e,c,d)});else if(c||"object"!==r.type(b))d(a,b);else for(e in b)Ab(a+"["+e+"]",b[e],c,d)}r.param=function(a,b){var c,d=[],e=function(a,b){var c=r.isFunction(b)?b():b;d[d.length]=encodeURIComponent(a)+"="+encodeURIComponent(null==c?"":c)};if(Array.isArray(a)||a.jquery&&!r.isPlainObject(a))r.each(a,function(){e(this.name,this.value)});else for(c in a)Ab(c,a[c],b,e);return d.join("&")},r.fn.extend({serialize:function(){return r.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var a=r.prop(this,"elements");return a?r.makeArray(a):this}).filter(function(){var a=this.type;return this.name&&!r(this).is(":disabled")&&zb.test(this.nodeName)&&!yb.test(a)&&(this.checked||!ja.test(a))}).map(function(a,b){var c=r(this).val();return null==c?null:Array.isArray(c)?r.map(c,function(a){return{name:b.name,value:a.replace(xb,"\r\n")}}):{name:b.name,value:c.replace(xb,"\r\n")}}).get()}});var Bb=/%20/g,Cb=/#.*$/,Db=/([?&])_=[^&]*/,Eb=/^(.*?):[ \t]*([^\r\n]*)$/gm,Fb=/^(?:about|app|app-storage|.+-extension|file|res|widget):$/,Gb=/^(?:GET|HEAD)$/,Hb=/^\/\//,Ib={},Jb={},Kb="*/".concat("*"),Lb=d.createElement("a");Lb.href=tb.href;function Mb(a){return function(b,c){"string"!=typeof b&&(c=b,b="*");var d,e=0,f=b.toLowerCase().match(L)||[];if(r.isFunction(c))while(d=f[e++])"+"===d[0]?(d=d.slice(1)||"*",(a[d]=a[d]||[]).unshift(c)):(a[d]=a[d]||[]).push(c)}}function Nb(a,b,c,d){var e={},f=a===Jb;function g(h){var i;return e[h]=!0,r.each(a[h]||[],function(a,h){var j=h(b,c,d);return"string"!=typeof j||f||e[j]?f?!(i=j):void 0:(b.dataTypes.unshift(j),g(j),!1)}),i}return g(b.dataTypes[0])||!e["*"]&&g("*")}function Ob(a,b){var c,d,e=r.ajaxSettings.flatOptions||{};for(c in b)void 0!==b[c]&&((e[c]?a:d||(d={}))[c]=b[c]);return d&&r.extend(!0,a,d),a}function Pb(a,b,c){var d,e,f,g,h=a.contents,i=a.dataTypes;while("*"===i[0])i.shift(),void 0===d&&(d=a.mimeType||b.getResponseHeader("Content-Type"));if(d)for(e in h)if(h[e]&&h[e].test(d)){i.unshift(e);break}if(i[0]in c)f=i[0];else{for(e in c){if(!i[0]||a.converters[e+" "+i[0]]){f=e;break}g||(g=e)}f=f||g}if(f)return f!==i[0]&&i.unshift(f),c[f]}function Qb(a,b,c,d){var e,f,g,h,i,j={},k=a.dataTypes.slice();if(k[1])for(g in a.converters)j[g.toLowerCase()]=a.converters[g];f=k.shift();while(f)if(a.responseFields[f]&&(c[a.responseFields[f]]=b),!i&&d&&a.dataFilter&&(b=a.dataFilter(b,a.dataType)),i=f,f=k.shift())if("*"===f)f=i;else if("*"!==i&&i!==f){if(g=j[i+" "+f]||j["* "+f],!g)for(e in j)if(h=e.split(" "),h[1]===f&&(g=j[i+" "+h[0]]||j["* "+h[0]])){g===!0?g=j[e]:j[e]!==!0&&(f=h[0],k.unshift(h[1]));break}if(g!==!0)if(g&&a["throws"])b=g(b);else try{b=g(b)}catch(l){return{state:"parsererror",error:g?l:"No conversion from "+i+" to "+f}}}return{state:"success",data:b}}r.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:tb.href,type:"GET",isLocal:Fb.test(tb.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Kb,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":r.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(a,b){return b?Ob(Ob(a,r.ajaxSettings),b):Ob(r.ajaxSettings,a)},ajaxPrefilter:Mb(Ib),ajaxTransport:Mb(Jb),ajax:function(b,c){"object"==typeof b&&(c=b,b=void 0),c=c||{};var e,f,g,h,i,j,k,l,m,n,o=r.ajaxSetup({},c),p=o.context||o,q=o.context&&(p.nodeType||p.jquery)?r(p):r.event,s=r.Deferred(),t=r.Callbacks("once memory"),u=o.statusCode||{},v={},w={},x="canceled",y={readyState:0,getResponseHeader:function(a){var b;if(k){if(!h){h={};while(b=Eb.exec(g))h[b[1].toLowerCase()]=b[2]}b=h[a.toLowerCase()]}return null==b?null:b},getAllResponseHeaders:function(){return k?g:null},setRequestHeader:function(a,b){return null==k&&(a=w[a.toLowerCase()]=w[a.toLowerCase()]||a,v[a]=b),this},overrideMimeType:function(a){return null==k&&(o.mimeType=a),this},statusCode:function(a){var b;if(a)if(k)y.always(a[y.status]);else for(b in a)u[b]=[u[b],a[b]];return this},abort:function(a){var b=a||x;return e&&e.abort(b),A(0,b),this}};if(s.promise(y),o.url=((b||o.url||tb.href)+"").replace(Hb,tb.protocol+"//"),o.type=c.method||c.type||o.method||o.type,o.dataTypes=(o.dataType||"*").toLowerCase().match(L)||[""],null==o.crossDomain){j=d.createElement("a");try{j.href=o.url,j.href=j.href,o.crossDomain=Lb.protocol+"//"+Lb.host!=j.protocol+"//"+j.host}catch(z){o.crossDomain=!0}}if(o.data&&o.processData&&"string"!=typeof o.data&&(o.data=r.param(o.data,o.traditional)),Nb(Ib,o,c,y),k)return y;l=r.event&&o.global,l&&0===r.active++&&r.event.trigger("ajaxStart"),o.type=o.type.toUpperCase(),o.hasContent=!Gb.test(o.type),f=o.url.replace(Cb,""),o.hasContent?o.data&&o.processData&&0===(o.contentType||"").indexOf("application/x-www-form-urlencoded")&&(o.data=o.data.replace(Bb,"+")):(n=o.url.slice(f.length),o.data&&(f+=(vb.test(f)?"&":"?")+o.data,delete o.data),o.cache===!1&&(f=f.replace(Db,"$1"),n=(vb.test(f)?"&":"?")+"_="+ub++ +n),o.url=f+n),o.ifModified&&(r.lastModified[f]&&y.setRequestHeader("If-Modified-Since",r.lastModified[f]),r.etag[f]&&y.setRequestHeader("If-None-Match",r.etag[f])),(o.data&&o.hasContent&&o.contentType!==!1||c.contentType)&&y.setRequestHeader("Content-Type",o.contentType),y.setRequestHeader("Accept",o.dataTypes[0]&&o.accepts[o.dataTypes[0]]?o.accepts[o.dataTypes[0]]+("*"!==o.dataTypes[0]?", "+Kb+"; q=0.01":""):o.accepts["*"]);for(m in o.headers)y.setRequestHeader(m,o.headers[m]);if(o.beforeSend&&(o.beforeSend.call(p,y,o)===!1||k))return y.abort();if(x="abort",t.add(o.complete),y.done(o.success),y.fail(o.error),e=Nb(Jb,o,c,y)){if(y.readyState=1,l&&q.trigger("ajaxSend",[y,o]),k)return y;o.async&&o.timeout>0&&(i=a.setTimeout(function(){y.abort("timeout")},o.timeout));try{k=!1,e.send(v,A)}catch(z){if(k)throw z;A(-1,z)}}else A(-1,"No Transport");function A(b,c,d,h){var j,m,n,v,w,x=c;k||(k=!0,i&&a.clearTimeout(i),e=void 0,g=h||"",y.readyState=b>0?4:0,j=b>=200&&b<300||304===b,d&&(v=Pb(o,y,d)),v=Qb(o,v,y,j),j?(o.ifModified&&(w=y.getResponseHeader("Last-Modified"),w&&(r.lastModified[f]=w),w=y.getResponseHeader("etag"),w&&(r.etag[f]=w)),204===b||"HEAD"===o.type?x="nocontent":304===b?x="notmodified":(x=v.state,m=v.data,n=v.error,j=!n)):(n=x,!b&&x||(x="error",b<0&&(b=0))),y.status=b,y.statusText=(c||x)+"",j?s.resolveWith(p,[m,x,y]):s.rejectWith(p,[y,x,n]),y.statusCode(u),u=void 0,l&&q.trigger(j?"ajaxSuccess":"ajaxError",[y,o,j?m:n]),t.fireWith(p,[y,x]),l&&(q.trigger("ajaxComplete",[y,o]),--r.active||r.event.trigger("ajaxStop")))}return y},getJSON:function(a,b,c){return r.get(a,b,c,"json")},getScript:function(a,b){return r.get(a,void 0,b,"script")}}),r.each(["get","post"],function(a,b){r[b]=function(a,c,d,e){return r.isFunction(c)&&(e=e||d,d=c,c=void 0),r.ajax(r.extend({url:a,type:b,dataType:e,data:c,success:d},r.isPlainObject(a)&&a))}}),r._evalUrl=function(a){return r.ajax({url:a,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,"throws":!0})},r.fn.extend({wrapAll:function(a){var b;return this[0]&&(r.isFunction(a)&&(a=a.call(this[0])),b=r(a,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&b.insertBefore(this[0]),b.map(function(){var a=this;while(a.firstElementChild)a=a.firstElementChild;return a}).append(this)),this},wrapInner:function(a){return r.isFunction(a)?this.each(function(b){r(this).wrapInner(a.call(this,b))}):this.each(function(){var b=r(this),c=b.contents();c.length?c.wrapAll(a):b.append(a)})},wrap:function(a){var b=r.isFunction(a);return this.each(function(c){r(this).wrapAll(b?a.call(this,c):a)})},unwrap:function(a){return this.parent(a).not("body").each(function(){r(this).replaceWith(this.childNodes)}),this}}),r.expr.pseudos.hidden=function(a){return!r.expr.pseudos.visible(a)},r.expr.pseudos.visible=function(a){return!!(a.offsetWidth||a.offsetHeight||a.getClientRects().length)},r.ajaxSettings.xhr=function(){try{return new a.XMLHttpRequest}catch(b){}};var Rb={0:200,1223:204},Sb=r.ajaxSettings.xhr();o.cors=!!Sb&&"withCredentials"in Sb,o.ajax=Sb=!!Sb,r.ajaxTransport(function(b){var c,d;if(o.cors||Sb&&!b.crossDomain)return{send:function(e,f){var g,h=b.xhr();if(h.open(b.type,b.url,b.async,b.username,b.password),b.xhrFields)for(g in b.xhrFields)h[g]=b.xhrFields[g];b.mimeType&&h.overrideMimeType&&h.overrideMimeType(b.mimeType),b.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest");for(g in e)h.setRequestHeader(g,e[g]);c=function(a){return function(){c&&(c=d=h.onload=h.onerror=h.onabort=h.onreadystatechange=null,"abort"===a?h.abort():"error"===a?"number"!=typeof h.status?f(0,"error"):f(h.status,h.statusText):f(Rb[h.status]||h.status,h.statusText,"text"!==(h.responseType||"text")||"string"!=typeof h.responseText?{binary:h.response}:{text:h.responseText},h.getAllResponseHeaders()))}},h.onload=c(),d=h.onerror=c("error"),void 0!==h.onabort?h.onabort=d:h.onreadystatechange=function(){4===h.readyState&&a.setTimeout(function(){c&&d()})},c=c("abort");try{h.send(b.hasContent&&b.data||null)}catch(i){if(c)throw i}},abort:function(){c&&c()}}}),r.ajaxPrefilter(function(a){a.crossDomain&&(a.contents.script=!1)}),r.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(a){return r.globalEval(a),a}}}),r.ajaxPrefilter("script",function(a){void 0===a.cache&&(a.cache=!1),a.crossDomain&&(a.type="GET")}),r.ajaxTransport("script",function(a){if(a.crossDomain){var b,c;return{send:function(e,f){b=r("<script>").prop({charset:a.scriptCharset,src:a.url}).on("load error",c=function(a){b.remove(),c=null,a&&f("error"===a.type?404:200,a.type)}),d.head.appendChild(b[0])},abort:function(){c&&c()}}}});var Tb=[],Ub=/(=)\?(?=&|$)|\?\?/;r.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var a=Tb.pop()||r.expando+"_"+ub++;return this[a]=!0,a}}),r.ajaxPrefilter("json jsonp",function(b,c,d){var e,f,g,h=b.jsonp!==!1&&(Ub.test(b.url)?"url":"string"==typeof b.data&&0===(b.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ub.test(b.data)&&"data");if(h||"jsonp"===b.dataTypes[0])return e=b.jsonpCallback=r.isFunction(b.jsonpCallback)?b.jsonpCallback():b.jsonpCallback,h?b[h]=b[h].replace(Ub,"$1"+e):b.jsonp!==!1&&(b.url+=(vb.test(b.url)?"&":"?")+b.jsonp+"="+e),b.converters["script json"]=function(){return g||r.error(e+" was not called"),g[0]},b.dataTypes[0]="json",f=a[e],a[e]=function(){g=arguments},d.always(function(){void 0===f?r(a).removeProp(e):a[e]=f,b[e]&&(b.jsonpCallback=c.jsonpCallback,Tb.push(e)),g&&r.isFunction(f)&&f(g[0]),g=f=void 0}),"script"}),o.createHTMLDocument=function(){var a=d.implementation.createHTMLDocument("").body;return a.innerHTML="<form></form><form></form>",2===a.childNodes.length}(),r.parseHTML=function(a,b,c){if("string"!=typeof a)return[];"boolean"==typeof b&&(c=b,b=!1);var e,f,g;return b||(o.createHTMLDocument?(b=d.implementation.createHTMLDocument(""),e=b.createElement("base"),e.href=d.location.href,b.head.appendChild(e)):b=d),f=C.exec(a),g=!c&&[],f?[b.createElement(f[1])]:(f=qa([a],b,g),g&&g.length&&r(g).remove(),r.merge([],f.childNodes))},r.fn.load=function(a,b,c){var d,e,f,g=this,h=a.indexOf(" ");return h>-1&&(d=pb(a.slice(h)),a=a.slice(0,h)),r.isFunction(b)?(c=b,b=void 0):b&&"object"==typeof b&&(e="POST"),g.length>0&&r.ajax({url:a,type:e||"GET",dataType:"html",data:b}).done(function(a){f=arguments,g.html(d?r("<div>").append(r.parseHTML(a)).find(d):a)}).always(c&&function(a,b){g.each(function(){c.apply(this,f||[a.responseText,b,a])})}),this},r.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(a,b){r.fn[b]=function(a){return this.on(b,a)}}),r.expr.pseudos.animated=function(a){return r.grep(r.timers,function(b){return a===b.elem}).length},r.offset={setOffset:function(a,b,c){var d,e,f,g,h,i,j,k=r.css(a,"position"),l=r(a),m={};"static"===k&&(a.style.position="relative"),h=l.offset(),f=r.css(a,"top"),i=r.css(a,"left"),j=("absolute"===k||"fixed"===k)&&(f+i).indexOf("auto")>-1,j?(d=l.position(),g=d.top,e=d.left):(g=parseFloat(f)||0,e=parseFloat(i)||0),r.isFunction(b)&&(b=b.call(a,c,r.extend({},h))),null!=b.top&&(m.top=b.top-h.top+g),null!=b.left&&(m.left=b.left-h.left+e),"using"in b?b.using.call(a,m):l.css(m)}},r.fn.extend({offset:function(a){if(arguments.length)return void 0===a?this:this.each(function(b){r.offset.setOffset(this,a,b)});var b,c,d,e,f=this[0];if(f)return f.getClientRects().length?(d=f.getBoundingClientRect(),b=f.ownerDocument,c=b.documentElement,e=b.defaultView,{top:d.top+e.pageYOffset-c.clientTop,left:d.left+e.pageXOffset-c.clientLeft}):{top:0,left:0}},position:function(){if(this[0]){var a,b,c=this[0],d={top:0,left:0};return"fixed"===r.css(c,"position")?b=c.getBoundingClientRect():(a=this.offsetParent(),b=this.offset(),B(a[0],"html")||(d=a.offset()),d={top:d.top+r.css(a[0],"borderTopWidth",!0),left:d.left+r.css(a[0],"borderLeftWidth",!0)}),{top:b.top-d.top-r.css(c,"marginTop",!0),left:b.left-d.left-r.css(c,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var a=this.offsetParent;while(a&&"static"===r.css(a,"position"))a=a.offsetParent;return a||ra})}}),r.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(a,b){var c="pageYOffset"===b;r.fn[a]=function(d){return T(this,function(a,d,e){var f;return r.isWindow(a)?f=a:9===a.nodeType&&(f=a.defaultView),void 0===e?f?f[b]:a[d]:void(f?f.scrollTo(c?f.pageXOffset:e,c?e:f.pageYOffset):a[d]=e)},a,d,arguments.length)}}),r.each(["top","left"],function(a,b){r.cssHooks[b]=Pa(o.pixelPosition,function(a,c){if(c)return c=Oa(a,b),Ma.test(c)?r(a).position()[b]+"px":c})}),r.each({Height:"height",Width:"width"},function(a,b){r.each({padding:"inner"+a,content:b,"":"outer"+a},function(c,d){r.fn[d]=function(e,f){var g=arguments.length&&(c||"boolean"!=typeof e),h=c||(e===!0||f===!0?"margin":"border");return T(this,function(b,c,e){var f;return r.isWindow(b)?0===d.indexOf("outer")?b["inner"+a]:b.document.documentElement["client"+a]:9===b.nodeType?(f=b.documentElement,Math.max(b.body["scroll"+a],f["scroll"+a],b.body["offset"+a],f["offset"+a],f["client"+a])):void 0===e?r.css(b,c,h):r.style(b,c,e,h)},b,g?e:void 0,g)}})}),r.fn.extend({bind:function(a,b,c){return this.on(a,null,b,c)},unbind:function(a,b){return this.off(a,null,b)},delegate:function(a,b,c,d){return this.on(b,a,c,d)},undelegate:function(a,b,c){return 1===arguments.length?this.off(a,"**"):this.off(b,a||"**",c)}}),r.holdReady=function(a){a?r.readyWait++:r.ready(!0)},r.isArray=Array.isArray,r.parseJSON=JSON.parse,r.nodeName=B,"function"==typeof define&&define.amd&&define("jquery",[],function(){return r});var Vb=a.jQuery,Wb=a.$;return r.noConflict=function(b){return a.$===r&&(a.$=Wb),b&&a.jQuery===r&&(a.jQuery=Vb),r},b||(a.jQuery=a.$=r),r});

function deferDebounce(method) {
  if (_.debounce) {
    method();
  } else {
    setTimeout(function() { deferDebounce(method) }, 50);
  }
}

/*
 * jquery-match-height 0.7.2 by @liabru
 * http://brm.io/jquery-match-height/
 * License MIT
 */
!(function (t) {
  "use strict";
  "function" == typeof define && define.amd
    ? define(["jquery"], t)
    : "undefined" != typeof module && module.exports
    ? (module.exports = t(require("jquery")))
    : t(jQuery);
})(function (t) {
  var e = -1,
    o = -1,
    n = function (t) {
      return parseFloat(t) || 0;
    },
    a = function (e) {
      var o = 1,
        a = t(e),
        i = null,
        r = [];
      return (
        a.each(function () {
          var e = t(this),
            a = e.offset().top - n(e.css("margin-top")),
            s = r.length > 0 ? r[r.length - 1] : null;
          null === s
            ? r.push(e)
            : Math.floor(Math.abs(i - a)) <= o
            ? (r[r.length - 1] = s.add(e))
            : r.push(e),
            (i = a);
        }),
        r
      );
    },
    i = function (e) {
      var o = {
        byRow: !0,
        property: "height",
        target: null,
        remove: !1,
      };
      return "object" == typeof e
        ? t.extend(o, e)
        : ("boolean" == typeof e
            ? (o.byRow = e)
            : "remove" === e && (o.remove = !0),
          o);
    },
    r = (t.fn.matchHeight = function (e) {
      var o = i(e);
      if (o.remove) {
        var n = this;
        return (
          this.css(o.property, ""),
          t.each(r._groups, function (t, e) {
            e.elements = e.elements.not(n);
          }),
          this
        );
      }
      return this.length <= 1 && !o.target
        ? this
        : (r._groups.push({ elements: this, options: o }),
          r._apply(this, o),
          this);
    });
  (r.version = "0.7.2"),
    (r._groups = []),
    (r._throttle = 80),
    (r._maintainScroll = !1),
    (r._beforeUpdate = null),
    (r._afterUpdate = null),
    (r._rows = a),
    (r._parse = n),
    (r._parseOptions = i),
    (r._apply = function (e, o) {
      var s = i(o),
        h = t(e),
        l = [h],
        c = t(window).scrollTop(),
        p = t("html").outerHeight(!0),
        u = h.parents().filter(":hidden");
      return (
        u.each(function () {
          var e = t(this);
          e.data("style-cache", e.attr("style"));
        }),
        u.css("display", "block"),
        s.byRow &&
          !s.target &&
          (h.each(function () {
            var e = t(this),
              o = e.css("display");
            "inline-block" !== o &&
              "flex" !== o &&
              "inline-flex" !== o &&
              (o = "block"),
              e.data("style-cache", e.attr("style")),
              e.css({
                display: o,
                "padding-top": "0",
                "padding-bottom": "0",
                "margin-top": "0",
                "margin-bottom": "0",
                "border-top-width": "0",
                "border-bottom-width": "0",
                height: "100px",
                overflow: "hidden",
              });
          }),
          (l = a(h)),
          h.each(function () {
            var e = t(this);
            e.attr("style", e.data("style-cache") || "");
          })),
        t.each(l, function (e, o) {
          var a = t(o),
            i = 0;
          if (s.target) i = s.target.outerHeight(!1);
          else {
            if (s.byRow && a.length <= 1) return void a.css(s.property, "");
            a.each(function () {
              var e = t(this),
                o = e.attr("style"),
                n = e.css("display");
              "inline-block" !== n &&
                "flex" !== n &&
                "inline-flex" !== n &&
                (n = "block");
              var a = {
                display: n,
              };
              (a[s.property] = ""),
                e.css(a),
                e.outerHeight(!1) > i && (i = e.outerHeight(!1)),
                o ? e.attr("style", o) : e.css("display", "");
            });
          }
          a.each(function () {
            var e = t(this),
              o = 0;
            (s.target && e.is(s.target)) ||
              ("border-box" !== e.css("box-sizing") &&
                ((o +=
                  n(e.css("border-top-width")) +
                  n(e.css("border-bottom-width"))),
                (o += n(e.css("padding-top")) + n(e.css("padding-bottom")))),
              e.css(s.property, i - o + "px"));
          });
        }),
        u.each(function () {
          var e = t(this);
          e.attr("style", e.data("style-cache") || null);
        }),
        r._maintainScroll &&
          t(window).scrollTop((c / p) * t("html").outerHeight(!0)),
        this
      );
    }),
    (r._applyDataApi = function () {
      var e = {};
      t("[data-match-height], [data-mh]").each(function () {
        var o = t(this),
          n = o.attr("data-mh") || o.attr("data-match-height");
        n in e ? (e[n] = e[n].add(o)) : (e[n] = o);
      }),
        t.each(e, function () {
          this.matchHeight(!0);
        });
    });
  var s = function (e) {
    r._beforeUpdate && r._beforeUpdate(e, r._groups),
      t.each(r._groups, function () {
        r._apply(this.elements, this.options);
      }),
      r._afterUpdate && r._afterUpdate(e, r._groups);
  };
  (r._update = function (n, a) {
    if (a && "resize" === a.type) {
      var i = t(window).width();
      if (i === e) return;
      e = i;
    }
    n
      ? o === -1 &&
        (o = setTimeout(function () {
          s(a), (o = -1);
        }, r._throttle))
      : s(a);
  }),
    t(r._applyDataApi);
  var h = t.fn.on ? "on" : "bind";
  t(window)[h]("load", function (t) {
    r._update(!1, t);
  }),
    t(window)[h]("resize orientationchange", function (t) {
      r._update(!0, t);
    });
});

/**!
 handlebars v4.7.3
*/
!(function (a, b) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = b())
    : "function" == typeof define && define.amd
    ? define([], b)
    : "object" == typeof exports
    ? (exports.Handlebars = b())
    : (a.Handlebars = b());
})(this, function () {
  return (function (a) {
    function b(d) {
      if (c[d]) return c[d].exports;
      var e = (c[d] = { exports: {}, id: d, loaded: !1 });
      return a[d].call(e.exports, e, e.exports, b), (e.loaded = !0), e.exports;
    }
    var c = {};
    return (b.m = a), (b.c = c), (b.p = ""), b(0);
  })([
    function (a, b, c) {
      "use strict";
      function d() {
        var a = r();
        return (
          (a.compile = function (b, c) {
            return k.compile(b, c, a);
          }),
          (a.precompile = function (b, c) {
            return k.precompile(b, c, a);
          }),
          (a.AST = i["default"]),
          (a.Compiler = k.Compiler),
          (a.JavaScriptCompiler = m["default"]),
          (a.Parser = j.parser),
          (a.parse = j.parse),
          (a.parseWithoutProcessing = j.parseWithoutProcessing),
          a
        );
      }
      var e = c(1)["default"];
      b.__esModule = !0;
      var f = c(2),
        g = e(f),
        h = c(45),
        i = e(h),
        j = c(46),
        k = c(51),
        l = c(52),
        m = e(l),
        n = c(49),
        o = e(n),
        p = c(44),
        q = e(p),
        r = g["default"].create,
        s = d();
      (s.create = d),
        q["default"](s),
        (s.Visitor = o["default"]),
        (s["default"] = s),
        (b["default"] = s),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b["default"] = function (a) {
        return a && a.__esModule ? a : { default: a };
      }),
        (b.__esModule = !0);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        var a = new h.HandlebarsEnvironment();
        return (
          n.extend(a, h),
          (a.SafeString = j["default"]),
          (a.Exception = l["default"]),
          (a.Utils = n),
          (a.escapeExpression = n.escapeExpression),
          (a.VM = p),
          (a.template = function (b) {
            return p.template(b, a);
          }),
          a
        );
      }
      var e = c(3)["default"],
        f = c(1)["default"];
      b.__esModule = !0;
      var g = c(4),
        h = e(g),
        i = c(37),
        j = f(i),
        k = c(6),
        l = f(k),
        m = c(5),
        n = e(m),
        o = c(38),
        p = e(o),
        q = c(44),
        r = f(q),
        s = d();
      (s.create = d),
        r["default"](s),
        (s["default"] = s),
        (b["default"] = s),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b["default"] = function (a) {
        if (a && a.__esModule) return a;
        var b = {};
        if (null != a)
          for (var c in a)
            Object.prototype.hasOwnProperty.call(a, c) && (b[c] = a[c]);
        return (b["default"] = a), b;
      }),
        (b.__esModule = !0);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b, c) {
        (this.helpers = a || {}),
          (this.partials = b || {}),
          (this.decorators = c || {}),
          i.registerDefaultHelpers(this),
          j.registerDefaultDecorators(this);
      }
      var e = c(1)["default"];
      (b.__esModule = !0), (b.HandlebarsEnvironment = d);
      var f = c(5),
        g = c(6),
        h = e(g),
        i = c(10),
        j = c(30),
        k = c(32),
        l = e(k),
        m = c(33),
        n = "4.7.3";
      b.VERSION = n;
      var o = 8;
      b.COMPILER_REVISION = o;
      var p = 7;
      b.LAST_COMPATIBLE_COMPILER_REVISION = p;
      var q = {
        1: "<= 1.0.rc.2",
        2: "== 1.0.0-rc.3",
        3: "== 1.0.0-rc.4",
        4: "== 1.x.x",
        5: "== 2.0.0-alpha.x",
        6: ">= 2.0.0-beta.1",
        7: ">= 4.0.0 <4.3.0",
        8: ">= 4.3.0",
      };
      b.REVISION_CHANGES = q;
      var r = "[object Object]";
      d.prototype = {
        constructor: d,
        logger: l["default"],
        log: l["default"].log,
        registerHelper: function (a, b) {
          if (f.toString.call(a) === r) {
            if (b)
              throw new h["default"]("Arg not supported with multiple helpers");
            f.extend(this.helpers, a);
          } else this.helpers[a] = b;
        },
        unregisterHelper: function (a) {
          delete this.helpers[a];
        },
        registerPartial: function (a, b) {
          if (f.toString.call(a) === r) f.extend(this.partials, a);
          else {
            if ("undefined" == typeof b)
              throw new h["default"](
                'Attempting to register a partial called "' +
                  a +
                  '" as undefined'
              );
            this.partials[a] = b;
          }
        },
        unregisterPartial: function (a) {
          delete this.partials[a];
        },
        registerDecorator: function (a, b) {
          if (f.toString.call(a) === r) {
            if (b)
              throw new h["default"](
                "Arg not supported with multiple decorators"
              );
            f.extend(this.decorators, a);
          } else this.decorators[a] = b;
        },
        unregisterDecorator: function (a) {
          delete this.decorators[a];
        },
        resetLoggedPropertyAccesses: function () {
          m.resetLoggedProperties();
        },
      };
      var s = l["default"].log;
      (b.log = s), (b.createFrame = f.createFrame), (b.logger = l["default"]);
    },
    function (a, b) {
      "use strict";
      function c(a) {
        return k[a];
      }
      function d(a) {
        for (var b = 1; b < arguments.length; b++)
          for (var c in arguments[b])
            Object.prototype.hasOwnProperty.call(arguments[b], c) &&
              (a[c] = arguments[b][c]);
        return a;
      }
      function e(a, b) {
        for (var c = 0, d = a.length; c < d; c++) if (a[c] === b) return c;
        return -1;
      }
      function f(a) {
        if ("string" != typeof a) {
          if (a && a.toHTML) return a.toHTML();
          if (null == a) return "";
          if (!a) return a + "";
          a = "" + a;
        }
        return m.test(a) ? a.replace(l, c) : a;
      }
      function g(a) {
        return (!a && 0 !== a) || !(!p(a) || 0 !== a.length);
      }
      function h(a) {
        var b = d({}, a);
        return (b._parent = a), b;
      }
      function i(a, b) {
        return (a.path = b), a;
      }
      function j(a, b) {
        return (a ? a + "." : "") + b;
      }
      (b.__esModule = !0),
        (b.extend = d),
        (b.indexOf = e),
        (b.escapeExpression = f),
        (b.isEmpty = g),
        (b.createFrame = h),
        (b.blockParams = i),
        (b.appendContextPath = j);
      var k = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#x27;",
          "`": "&#x60;",
          "=": "&#x3D;",
        },
        l = /[&<>"'`=]/g,
        m = /[&<>"'`=]/,
        n = Object.prototype.toString;
      b.toString = n;
      var o = function (a) {
        return "function" == typeof a;
      };
      o(/x/) &&
        (b.isFunction = o =
          function (a) {
            return "function" == typeof a && "[object Function]" === n.call(a);
          }),
        (b.isFunction = o);
      var p =
        Array.isArray ||
        function (a) {
          return (
            !(!a || "object" != typeof a) && "[object Array]" === n.call(a)
          );
        };
      b.isArray = p;
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        var c = b && b.loc,
          g = void 0,
          h = void 0,
          i = void 0,
          j = void 0;
        c &&
          ((g = c.start.line),
          (h = c.end.line),
          (i = c.start.column),
          (j = c.end.column),
          (a += " - " + g + ":" + i));
        for (
          var k = Error.prototype.constructor.call(this, a), l = 0;
          l < f.length;
          l++
        )
          this[f[l]] = k[f[l]];
        Error.captureStackTrace && Error.captureStackTrace(this, d);
        try {
          c &&
            ((this.lineNumber = g),
            (this.endLineNumber = h),
            e
              ? (Object.defineProperty(this, "column", {
                  value: i,
                  enumerable: !0,
                }),
                Object.defineProperty(this, "endColumn", {
                  value: j,
                  enumerable: !0,
                }))
              : ((this.column = i), (this.endColumn = j)));
        } catch (m) {}
      }
      var e = c(7)["default"];
      b.__esModule = !0;
      var f = [
        "description",
        "fileName",
        "lineNumber",
        "endLineNumber",
        "message",
        "name",
        "number",
        "stack",
      ];
      (d.prototype = new Error()),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      a.exports = { default: c(8), __esModule: !0 };
    },
    function (a, b, c) {
      var d = c(9);
      a.exports = function (a, b, c) {
        return d.setDesc(a, b, c);
      };
    },
    function (a, b) {
      var c = Object;
      a.exports = {
        create: c.create,
        getProto: c.getPrototypeOf,
        isEnum: {}.propertyIsEnumerable,
        getDesc: c.getOwnPropertyDescriptor,
        setDesc: c.defineProperty,
        setDescs: c.defineProperties,
        getKeys: c.keys,
        getNames: c.getOwnPropertyNames,
        getSymbols: c.getOwnPropertySymbols,
        each: [].forEach,
      };
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        h["default"](a),
          j["default"](a),
          l["default"](a),
          n["default"](a),
          p["default"](a),
          r["default"](a),
          t["default"](a);
      }
      function e(a, b, c) {
        a.helpers[b] && ((a.hooks[b] = a.helpers[b]), c || delete a.helpers[b]);
      }
      var f = c(1)["default"];
      (b.__esModule = !0),
        (b.registerDefaultHelpers = d),
        (b.moveHelperToHooks = e);
      var g = c(11),
        h = f(g),
        i = c(12),
        j = f(i),
        k = c(25),
        l = f(k),
        m = c(26),
        n = f(m),
        o = c(27),
        p = f(o),
        q = c(28),
        r = f(q),
        s = c(29),
        t = f(s);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerHelper("blockHelperMissing", function (b, c) {
          var e = c.inverse,
            f = c.fn;
          if (b === !0) return f(this);
          if (b === !1 || null == b) return e(this);
          if (d.isArray(b))
            return b.length > 0
              ? (c.ids && (c.ids = [c.name]), a.helpers.each(b, c))
              : e(this);
          if (c.data && c.ids) {
            var g = d.createFrame(c.data);
            (g.contextPath = d.appendContextPath(c.data.contextPath, c.name)),
              (c = { data: g });
          }
          return f(b, c);
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      (function (d) {
        "use strict";
        var e = c(13)["default"],
          f = c(1)["default"];
        b.__esModule = !0;
        var g = c(5),
          h = c(6),
          i = f(h);
        (b["default"] = function (a) {
          a.registerHelper("each", function (a, b) {
            function c(b, c, d) {
              l &&
                ((l.key = b),
                (l.index = c),
                (l.first = 0 === c),
                (l.last = !!d),
                m && (l.contextPath = m + b)),
                (k += f(a[b], {
                  data: l,
                  blockParams: g.blockParams([a[b], b], [m + b, null]),
                }));
            }
            if (!b) throw new i["default"]("Must pass iterator to #each");
            var f = b.fn,
              h = b.inverse,
              j = 0,
              k = "",
              l = void 0,
              m = void 0;
            if (
              (b.data &&
                b.ids &&
                (m = g.appendContextPath(b.data.contextPath, b.ids[0]) + "."),
              g.isFunction(a) && (a = a.call(this)),
              b.data && (l = g.createFrame(b.data)),
              a && "object" == typeof a)
            )
              if (g.isArray(a))
                for (var n = a.length; j < n; j++)
                  j in a && c(j, j, j === a.length - 1);
              else if (d.Symbol && a[d.Symbol.iterator]) {
                for (
                  var o = [], p = a[d.Symbol.iterator](), q = p.next();
                  !q.done;
                  q = p.next()
                )
                  o.push(q.value);
                a = o;
                for (var n = a.length; j < n; j++) c(j, j, j === a.length - 1);
              } else
                !(function () {
                  var b = void 0;
                  e(a).forEach(function (a) {
                    void 0 !== b && c(b, j - 1), (b = a), j++;
                  }),
                    void 0 !== b && c(b, j - 1, !0);
                })();
            return 0 === j && (k = h(this)), k;
          });
        }),
          (a.exports = b["default"]);
      }.call(
        b,
        (function () {
          return this;
        })()
      ));
    },
    function (a, b, c) {
      a.exports = { default: c(14), __esModule: !0 };
    },
    function (a, b, c) {
      c(15), (a.exports = c(21).Object.keys);
    },
    function (a, b, c) {
      var d = c(16);
      c(18)("keys", function (a) {
        return function (b) {
          return a(d(b));
        };
      });
    },
    function (a, b, c) {
      var d = c(17);
      a.exports = function (a) {
        return Object(d(a));
      };
    },
    function (a, b) {
      a.exports = function (a) {
        if (void 0 == a) throw TypeError("Can't call method on  " + a);
        return a;
      };
    },
    function (a, b, c) {
      var d = c(19),
        e = c(21),
        f = c(24);
      a.exports = function (a, b) {
        var c = (e.Object || {})[a] || Object[a],
          g = {};
        (g[a] = b(c)),
          d(
            d.S +
              d.F *
                f(function () {
                  c(1);
                }),
            "Object",
            g
          );
      };
    },
    function (a, b, c) {
      var d = c(20),
        e = c(21),
        f = c(22),
        g = "prototype",
        h = function (a, b, c) {
          var i,
            j,
            k,
            l = a & h.F,
            m = a & h.G,
            n = a & h.S,
            o = a & h.P,
            p = a & h.B,
            q = a & h.W,
            r = m ? e : e[b] || (e[b] = {}),
            s = m ? d : n ? d[b] : (d[b] || {})[g];
          m && (c = b);
          for (i in c)
            (j = !l && s && i in s),
              (j && i in r) ||
                ((k = j ? s[i] : c[i]),
                (r[i] =
                  m && "function" != typeof s[i]
                    ? c[i]
                    : p && j
                    ? f(k, d)
                    : q && s[i] == k
                    ? (function (a) {
                        var b = function (b) {
                          return this instanceof a ? new a(b) : a(b);
                        };
                        return (b[g] = a[g]), b;
                      })(k)
                    : o && "function" == typeof k
                    ? f(Function.call, k)
                    : k),
                o && ((r[g] || (r[g] = {}))[i] = k));
        };
      (h.F = 1),
        (h.G = 2),
        (h.S = 4),
        (h.P = 8),
        (h.B = 16),
        (h.W = 32),
        (a.exports = h);
    },
    function (a, b) {
      var c = (a.exports =
        "undefined" != typeof window && window.Math == Math
          ? window
          : "undefined" != typeof self && self.Math == Math
          ? self
          : Function("return this")());
      "number" == typeof __g && (__g = c);
    },
    function (a, b) {
      var c = (a.exports = { version: "1.2.6" });
      "number" == typeof __e && (__e = c);
    },
    function (a, b, c) {
      var d = c(23);
      a.exports = function (a, b, c) {
        if ((d(a), void 0 === b)) return a;
        switch (c) {
          case 1:
            return function (c) {
              return a.call(b, c);
            };
          case 2:
            return function (c, d) {
              return a.call(b, c, d);
            };
          case 3:
            return function (c, d, e) {
              return a.call(b, c, d, e);
            };
        }
        return function () {
          return a.apply(b, arguments);
        };
      };
    },
    function (a, b) {
      a.exports = function (a) {
        if ("function" != typeof a) throw TypeError(a + " is not a function!");
        return a;
      };
    },
    function (a, b) {
      a.exports = function (a) {
        try {
          return !!a();
        } catch (b) {
          return !0;
        }
      };
    },
    function (a, b, c) {
      "use strict";
      var d = c(1)["default"];
      b.__esModule = !0;
      var e = c(6),
        f = d(e);
      (b["default"] = function (a) {
        a.registerHelper("helperMissing", function () {
          if (1 !== arguments.length)
            throw new f["default"](
              'Missing helper: "' + arguments[arguments.length - 1].name + '"'
            );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      var d = c(1)["default"];
      b.__esModule = !0;
      var e = c(5),
        f = c(6),
        g = d(f);
      (b["default"] = function (a) {
        a.registerHelper("if", function (a, b) {
          if (2 != arguments.length)
            throw new g["default"]("#if requires exactly one argument");
          return (
            e.isFunction(a) && (a = a.call(this)),
            (!b.hash.includeZero && !a) || e.isEmpty(a)
              ? b.inverse(this)
              : b.fn(this)
          );
        }),
          a.registerHelper("unless", function (b, c) {
            if (2 != arguments.length)
              throw new g["default"]("#unless requires exactly one argument");
            return a.helpers["if"].call(this, b, {
              fn: c.inverse,
              inverse: c.fn,
              hash: c.hash,
            });
          });
      }),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b.__esModule = !0),
        (b["default"] = function (a) {
          a.registerHelper("log", function () {
            for (
              var b = [void 0], c = arguments[arguments.length - 1], d = 0;
              d < arguments.length - 1;
              d++
            )
              b.push(arguments[d]);
            var e = 1;
            null != c.hash.level
              ? (e = c.hash.level)
              : c.data && null != c.data.level && (e = c.data.level),
              (b[0] = e),
              a.log.apply(a, b);
          });
        }),
        (a.exports = b["default"]);
    },
    function (a, b) {
      "use strict";
      (b.__esModule = !0),
        (b["default"] = function (a) {
          a.registerHelper("lookup", function (a, b, c) {
            return a ? c.lookupProperty(a, b) : a;
          });
        }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      var d = c(1)["default"];
      b.__esModule = !0;
      var e = c(5),
        f = c(6),
        g = d(f);
      (b["default"] = function (a) {
        a.registerHelper("with", function (a, b) {
          if (2 != arguments.length)
            throw new g["default"]("#with requires exactly one argument");
          e.isFunction(a) && (a = a.call(this));
          var c = b.fn;
          if (e.isEmpty(a)) return b.inverse(this);
          var d = b.data;
          return (
            b.data &&
              b.ids &&
              ((d = e.createFrame(b.data)),
              (d.contextPath = e.appendContextPath(
                b.data.contextPath,
                b.ids[0]
              ))),
            c(a, {
              data: d,
              blockParams: e.blockParams([a], [d && d.contextPath]),
            })
          );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        g["default"](a);
      }
      var e = c(1)["default"];
      (b.__esModule = !0), (b.registerDefaultDecorators = d);
      var f = c(31),
        g = e(f);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5);
      (b["default"] = function (a) {
        a.registerDecorator("inline", function (a, b, c, e) {
          var f = a;
          return (
            b.partials ||
              ((b.partials = {}),
              (f = function (e, f) {
                var g = c.partials;
                c.partials = d.extend({}, g, b.partials);
                var h = a(e, f);
                return (c.partials = g), h;
              })),
            (b.partials[e.args[0]] = e.fn),
            f
          );
        });
      }),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      b.__esModule = !0;
      var d = c(5),
        e = {
          methodMap: ["debug", "info", "warn", "error"],
          level: "info",
          lookupLevel: function (a) {
            if ("string" == typeof a) {
              var b = d.indexOf(e.methodMap, a.toLowerCase());
              a = b >= 0 ? b : parseInt(a, 10);
            }
            return a;
          },
          log: function (a) {
            if (
              ((a = e.lookupLevel(a)),
              "undefined" != typeof console && e.lookupLevel(e.level) <= a)
            ) {
              var b = e.methodMap[a];
              console[b] || (b = "log");
              for (
                var c = arguments.length, d = Array(c > 1 ? c - 1 : 0), f = 1;
                f < c;
                f++
              )
                d[f - 1] = arguments[f];
              console[b].apply(console, d);
            }
          },
        };
      (b["default"] = e), (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        var b = i(null);
        (b.constructor = !1),
          (b.__defineGetter__ = !1),
          (b.__defineSetter__ = !1),
          (b.__lookupGetter__ = !1);
        var c = i(null);
        return (
          (c.__proto__ = !1),
          {
            properties: {
              whitelist: l.createNewLookupObject(c, a.allowedProtoProperties),
              defaultValue: a.allowProtoPropertiesByDefault,
            },
            methods: {
              whitelist: l.createNewLookupObject(b, a.allowedProtoMethods),
              defaultValue: a.allowProtoMethodsByDefault,
            },
          }
        );
      }
      function e(a, b, c) {
        return "function" == typeof a ? f(b.methods, c) : f(b.properties, c);
      }
      function f(a, b) {
        return void 0 !== a.whitelist[b]
          ? a.whitelist[b] === !0
          : void 0 !== a.defaultValue
          ? a.defaultValue
          : (g(b), !1);
      }
      function g(a) {
        o[a] !== !0 &&
          ((o[a] = !0),
          n.log(
            "error",
            'Handlebars: Access has been denied to resolve the property "' +
              a +
              '" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'
          ));
      }
      function h() {
        j(o).forEach(function (a) {
          delete o[a];
        });
      }
      var i = c(34)["default"],
        j = c(13)["default"],
        k = c(3)["default"];
      (b.__esModule = !0),
        (b.createProtoAccessControl = d),
        (b.resultIsAllowed = e),
        (b.resetLoggedProperties = h);
      var l = c(36),
        m = c(32),
        n = k(m),
        o = i(null);
    },
    function (a, b, c) {
      a.exports = { default: c(35), __esModule: !0 };
    },
    function (a, b, c) {
      var d = c(9);
      a.exports = function (a, b) {
        return d.create(a, b);
      };
    },
    function (a, b, c) {
      "use strict";
      function d() {
        for (var a = arguments.length, b = Array(a), c = 0; c < a; c++)
          b[c] = arguments[c];
        return f.extend.apply(void 0, [e(null)].concat(b));
      }
      var e = c(34)["default"];
      (b.__esModule = !0), (b.createNewLookupObject = d);
      var f = c(5);
    },
    function (a, b) {
      "use strict";
      function c(a) {
        this.string = a;
      }
      (b.__esModule = !0),
        (c.prototype.toString = c.prototype.toHTML =
          function () {
            return "" + this.string;
          }),
        (b["default"] = c),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        var b = (a && a[0]) || 1,
          c = v.COMPILER_REVISION;
        if (
          !(
            b >= v.LAST_COMPATIBLE_COMPILER_REVISION && b <= v.COMPILER_REVISION
          )
        ) {
          if (b < v.LAST_COMPATIBLE_COMPILER_REVISION) {
            var d = v.REVISION_CHANGES[c],
              e = v.REVISION_CHANGES[b];
            throw new u["default"](
              "Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" +
                d +
                ") or downgrade your runtime to an older version (" +
                e +
                ")."
            );
          }
          throw new u["default"](
            "Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" +
              a[1] +
              ")."
          );
        }
      }
      function e(a, b) {
        function c(c, d, e) {
          e.hash && ((d = s.extend({}, d, e.hash)), e.ids && (e.ids[0] = !0)),
            (c = b.VM.resolvePartial.call(this, c, d, e));
          var f = s.extend({}, e, {
              hooks: this.hooks,
              protoAccessControl: this.protoAccessControl,
            }),
            g = b.VM.invokePartial.call(this, c, d, f);
          if (
            (null == g &&
              b.compile &&
              ((e.partials[e.name] = b.compile(c, a.compilerOptions, b)),
              (g = e.partials[e.name](d, f))),
            null != g)
          ) {
            if (e.indent) {
              for (
                var h = g.split("\n"), i = 0, j = h.length;
                i < j && (h[i] || i + 1 !== j);
                i++
              )
                h[i] = e.indent + h[i];
              g = h.join("\n");
            }
            return g;
          }
          throw new u["default"](
            "The partial " +
              e.name +
              " could not be compiled when running in runtime-only mode"
          );
        }
        function d(b) {
          function c(b) {
            return "" + a.main(g, b, g.helpers, g.partials, f, i, h);
          }
          var e =
              arguments.length <= 1 || void 0 === arguments[1]
                ? {}
                : arguments[1],
            f = e.data;
          d._setup(e), !e.partial && a.useData && (f = j(b, f));
          var h = void 0,
            i = a.useBlockParams ? [] : void 0;
          return (
            a.useDepths &&
              (h = e.depths
                ? b != e.depths[0]
                  ? [b].concat(e.depths)
                  : e.depths
                : [b]),
            (c = k(a.main, c, g, e.depths || [], f, i))(b, e)
          );
        }
        if (!b) throw new u["default"]("No environment passed to template");
        if (!a || !a.main)
          throw new u["default"]("Unknown template object: " + typeof a);
        (a.main.decorator = a.main_d), b.VM.checkRevision(a.compiler);
        var e = a.compiler && 7 === a.compiler[0],
          g = {
            strict: function (a, b, c) {
              if (!(a && b in a))
                throw new u["default"]('"' + b + '" not defined in ' + a, {
                  loc: c,
                });
              return a[b];
            },
            lookupProperty: function (a, b) {
              var c = a[b];
              return null == c
                ? c
                : Object.prototype.hasOwnProperty.call(a, b)
                ? c
                : y.resultIsAllowed(c, g.protoAccessControl, b)
                ? c
                : void 0;
            },
            lookup: function (a, b) {
              for (var c = a.length, d = 0; d < c; d++) {
                var e = a[d] && g.lookupProperty(a[d], b);
                if (null != e) return a[d][b];
              }
            },
            lambda: function (a, b) {
              return "function" == typeof a ? a.call(b) : a;
            },
            escapeExpression: s.escapeExpression,
            invokePartial: c,
            fn: function (b) {
              var c = a[b];
              return (c.decorator = a[b + "_d"]), c;
            },
            programs: [],
            program: function (a, b, c, d, e) {
              var g = this.programs[a],
                h = this.fn(a);
              return (
                b || e || d || c
                  ? (g = f(this, a, h, b, c, d, e))
                  : g || (g = this.programs[a] = f(this, a, h)),
                g
              );
            },
            data: function (a, b) {
              for (; a && b--; ) a = a._parent;
              return a;
            },
            mergeIfNeeded: function (a, b) {
              var c = a || b;
              return a && b && a !== b && (c = s.extend({}, b, a)), c;
            },
            nullContext: n({}),
            noop: b.VM.noop,
            compilerInfo: a.compiler,
          };
        return (
          (d.isTop = !0),
          (d._setup = function (c) {
            if (c.partial)
              (g.protoAccessControl = c.protoAccessControl),
                (g.helpers = c.helpers),
                (g.partials = c.partials),
                (g.decorators = c.decorators),
                (g.hooks = c.hooks);
            else {
              var d = s.extend({}, b.helpers, c.helpers);
              l(d, g),
                (g.helpers = d),
                a.usePartial &&
                  (g.partials = g.mergeIfNeeded(c.partials, b.partials)),
                (a.usePartial || a.useDecorators) &&
                  (g.decorators = s.extend({}, b.decorators, c.decorators)),
                (g.hooks = {}),
                (g.protoAccessControl = y.createProtoAccessControl(c));
              var f = c.allowCallsToHelperMissing || e;
              w.moveHelperToHooks(g, "helperMissing", f),
                w.moveHelperToHooks(g, "blockHelperMissing", f);
            }
          }),
          (d._child = function (b, c, d, e) {
            if (a.useBlockParams && !d)
              throw new u["default"]("must pass block params");
            if (a.useDepths && !e)
              throw new u["default"]("must pass parent depths");
            return f(g, b, a[b], c, 0, d, e);
          }),
          d
        );
      }
      function f(a, b, c, d, e, f, g) {
        function h(b) {
          var e =
              arguments.length <= 1 || void 0 === arguments[1]
                ? {}
                : arguments[1],
            h = g;
          return (
            !g ||
              b == g[0] ||
              (b === a.nullContext && null === g[0]) ||
              (h = [b].concat(g)),
            c(
              a,
              b,
              a.helpers,
              a.partials,
              e.data || d,
              f && [e.blockParams].concat(f),
              h
            )
          );
        }
        return (
          (h = k(c, h, a, g, d, f)),
          (h.program = b),
          (h.depth = g ? g.length : 0),
          (h.blockParams = e || 0),
          h
        );
      }
      function g(a, b, c) {
        return (
          a
            ? a.call || c.name || ((c.name = a), (a = c.partials[a]))
            : (a =
                "@partial-block" === c.name
                  ? c.data["partial-block"]
                  : c.partials[c.name]),
          a
        );
      }
      function h(a, b, c) {
        var d = c.data && c.data["partial-block"];
        (c.partial = !0),
          c.ids && (c.data.contextPath = c.ids[0] || c.data.contextPath);
        var e = void 0;
        if (
          (c.fn &&
            c.fn !== i &&
            !(function () {
              c.data = v.createFrame(c.data);
              var a = c.fn;
              (e = c.data["partial-block"] =
                function (b) {
                  var c =
                    arguments.length <= 1 || void 0 === arguments[1]
                      ? {}
                      : arguments[1];
                  return (
                    (c.data = v.createFrame(c.data)),
                    (c.data["partial-block"] = d),
                    a(b, c)
                  );
                }),
                a.partials &&
                  (c.partials = s.extend({}, c.partials, a.partials));
            })(),
          void 0 === a && e && (a = e),
          void 0 === a)
        )
          throw new u["default"](
            "The partial " + c.name + " could not be found"
          );
        if (a instanceof Function) return a(b, c);
      }
      function i() {
        return "";
      }
      function j(a, b) {
        return (
          (b && "root" in b) || ((b = b ? v.createFrame(b) : {}), (b.root = a)),
          b
        );
      }
      function k(a, b, c, d, e, f) {
        if (a.decorator) {
          var g = {};
          (b = a.decorator(b, g, c, d && d[0], e, f, d)), s.extend(b, g);
        }
        return b;
      }
      function l(a, b) {
        o(a).forEach(function (c) {
          var d = a[c];
          a[c] = m(d, b);
        });
      }
      function m(a, b) {
        var c = b.lookupProperty;
        return x.wrapHelper(a, function (a) {
          return s.extend({ lookupProperty: c }, a);
        });
      }
      var n = c(39)["default"],
        o = c(13)["default"],
        p = c(3)["default"],
        q = c(1)["default"];
      (b.__esModule = !0),
        (b.checkRevision = d),
        (b.template = e),
        (b.wrapProgram = f),
        (b.resolvePartial = g),
        (b.invokePartial = h),
        (b.noop = i);
      var r = c(5),
        s = p(r),
        t = c(6),
        u = q(t),
        v = c(4),
        w = c(10),
        x = c(43),
        y = c(33);
    },
    function (a, b, c) {
      a.exports = { default: c(40), __esModule: !0 };
    },
    function (a, b, c) {
      c(41), (a.exports = c(21).Object.seal);
    },
    function (a, b, c) {
      var d = c(42);
      c(18)("seal", function (a) {
        return function (b) {
          return a && d(b) ? a(b) : b;
        };
      });
    },
    function (a, b) {
      a.exports = function (a) {
        return "object" == typeof a ? null !== a : "function" == typeof a;
      };
    },
    function (a, b) {
      "use strict";
      function c(a, b) {
        if ("function" != typeof a) return a;
        var c = function () {
          var c = arguments[arguments.length - 1];
          return (
            (arguments[arguments.length - 1] = b(c)), a.apply(this, arguments)
          );
        };
        return c;
      }
      (b.__esModule = !0), (b.wrapHelper = c);
    },
    function (a, b) {
      (function (c) {
        "use strict";
        (b.__esModule = !0),
          (b["default"] = function (a) {
            var b = "undefined" != typeof c ? c : window,
              d = b.Handlebars;
            a.noConflict = function () {
              return b.Handlebars === a && (b.Handlebars = d), a;
            };
          }),
          (a.exports = b["default"]);
      }.call(
        b,
        (function () {
          return this;
        })()
      ));
    },
    function (a, b) {
      "use strict";
      b.__esModule = !0;
      var c = {
        helpers: {
          helperExpression: function (a) {
            return (
              "SubExpression" === a.type ||
              (("MustacheStatement" === a.type ||
                "BlockStatement" === a.type) &&
                !!((a.params && a.params.length) || a.hash))
            );
          },
          scopedId: function (a) {
            return /^\.|this\b/.test(a.original);
          },
          simpleId: function (a) {
            return 1 === a.parts.length && !c.helpers.scopedId(a) && !a.depth;
          },
        },
      };
      (b["default"] = c), (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        if ("Program" === a.type) return a;
        (i["default"].yy = o),
          (o.locInfo = function (a) {
            return new o.SourceLocation(b && b.srcName, a);
          });
        var c = i["default"].parse(a);
        return c;
      }
      function e(a, b) {
        var c = d(a, b),
          e = new k["default"](b);
        return e.accept(c);
      }
      var f = c(1)["default"],
        g = c(3)["default"];
      (b.__esModule = !0), (b.parseWithoutProcessing = d), (b.parse = e);
      var h = c(47),
        i = f(h),
        j = c(48),
        k = f(j),
        l = c(50),
        m = g(l),
        n = c(5);
      b.parser = i["default"];
      var o = {};
      n.extend(o, m);
    },
    function (a, b) {
      "use strict";
      b.__esModule = !0;
      var c = (function () {
        function a() {
          this.yy = {};
        }
        var b = {
            trace: function () {},
            yy: {},
            symbols_: {
              error: 2,
              root: 3,
              program: 4,
              EOF: 5,
              program_repetition0: 6,
              statement: 7,
              mustache: 8,
              block: 9,
              rawBlock: 10,
              partial: 11,
              partialBlock: 12,
              content: 13,
              COMMENT: 14,
              CONTENT: 15,
              openRawBlock: 16,
              rawBlock_repetition0: 17,
              END_RAW_BLOCK: 18,
              OPEN_RAW_BLOCK: 19,
              helperName: 20,
              openRawBlock_repetition0: 21,
              openRawBlock_option0: 22,
              CLOSE_RAW_BLOCK: 23,
              openBlock: 24,
              block_option0: 25,
              closeBlock: 26,
              openInverse: 27,
              block_option1: 28,
              OPEN_BLOCK: 29,
              openBlock_repetition0: 30,
              openBlock_option0: 31,
              openBlock_option1: 32,
              CLOSE: 33,
              OPEN_INVERSE: 34,
              openInverse_repetition0: 35,
              openInverse_option0: 36,
              openInverse_option1: 37,
              openInverseChain: 38,
              OPEN_INVERSE_CHAIN: 39,
              openInverseChain_repetition0: 40,
              openInverseChain_option0: 41,
              openInverseChain_option1: 42,
              inverseAndProgram: 43,
              INVERSE: 44,
              inverseChain: 45,
              inverseChain_option0: 46,
              OPEN_ENDBLOCK: 47,
              OPEN: 48,
              mustache_repetition0: 49,
              mustache_option0: 50,
              OPEN_UNESCAPED: 51,
              mustache_repetition1: 52,
              mustache_option1: 53,
              CLOSE_UNESCAPED: 54,
              OPEN_PARTIAL: 55,
              partialName: 56,
              partial_repetition0: 57,
              partial_option0: 58,
              openPartialBlock: 59,
              OPEN_PARTIAL_BLOCK: 60,
              openPartialBlock_repetition0: 61,
              openPartialBlock_option0: 62,
              param: 63,
              sexpr: 64,
              OPEN_SEXPR: 65,
              sexpr_repetition0: 66,
              sexpr_option0: 67,
              CLOSE_SEXPR: 68,
              hash: 69,
              hash_repetition_plus0: 70,
              hashSegment: 71,
              ID: 72,
              EQUALS: 73,
              blockParams: 74,
              OPEN_BLOCK_PARAMS: 75,
              blockParams_repetition_plus0: 76,
              CLOSE_BLOCK_PARAMS: 77,
              path: 78,
              dataName: 79,
              STRING: 80,
              NUMBER: 81,
              BOOLEAN: 82,
              UNDEFINED: 83,
              NULL: 84,
              DATA: 85,
              pathSegments: 86,
              SEP: 87,
              $accept: 0,
              $end: 1,
            },
            terminals_: {
              2: "error",
              5: "EOF",
              14: "COMMENT",
              15: "CONTENT",
              18: "END_RAW_BLOCK",
              19: "OPEN_RAW_BLOCK",
              23: "CLOSE_RAW_BLOCK",
              29: "OPEN_BLOCK",
              33: "CLOSE",
              34: "OPEN_INVERSE",
              39: "OPEN_INVERSE_CHAIN",
              44: "INVERSE",
              47: "OPEN_ENDBLOCK",
              48: "OPEN",
              51: "OPEN_UNESCAPED",
              54: "CLOSE_UNESCAPED",
              55: "OPEN_PARTIAL",
              60: "OPEN_PARTIAL_BLOCK",
              65: "OPEN_SEXPR",
              68: "CLOSE_SEXPR",
              72: "ID",
              73: "EQUALS",
              75: "OPEN_BLOCK_PARAMS",
              77: "CLOSE_BLOCK_PARAMS",
              80: "STRING",
              81: "NUMBER",
              82: "BOOLEAN",
              83: "UNDEFINED",
              84: "NULL",
              85: "DATA",
              87: "SEP",
            },
            productions_: [
              0,
              [3, 2],
              [4, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [7, 1],
              [13, 1],
              [10, 3],
              [16, 5],
              [9, 4],
              [9, 4],
              [24, 6],
              [27, 6],
              [38, 6],
              [43, 2],
              [45, 3],
              [45, 1],
              [26, 3],
              [8, 5],
              [8, 5],
              [11, 5],
              [12, 3],
              [59, 5],
              [63, 1],
              [63, 1],
              [64, 5],
              [69, 1],
              [71, 3],
              [74, 3],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [20, 1],
              [56, 1],
              [56, 1],
              [79, 2],
              [78, 1],
              [86, 3],
              [86, 1],
              [6, 0],
              [6, 2],
              [17, 0],
              [17, 2],
              [21, 0],
              [21, 2],
              [22, 0],
              [22, 1],
              [25, 0],
              [25, 1],
              [28, 0],
              [28, 1],
              [30, 0],
              [30, 2],
              [31, 0],
              [31, 1],
              [32, 0],
              [32, 1],
              [35, 0],
              [35, 2],
              [36, 0],
              [36, 1],
              [37, 0],
              [37, 1],
              [40, 0],
              [40, 2],
              [41, 0],
              [41, 1],
              [42, 0],
              [42, 1],
              [46, 0],
              [46, 1],
              [49, 0],
              [49, 2],
              [50, 0],
              [50, 1],
              [52, 0],
              [52, 2],
              [53, 0],
              [53, 1],
              [57, 0],
              [57, 2],
              [58, 0],
              [58, 1],
              [61, 0],
              [61, 2],
              [62, 0],
              [62, 1],
              [66, 0],
              [66, 2],
              [67, 0],
              [67, 1],
              [70, 1],
              [70, 2],
              [76, 1],
              [76, 2],
            ],
            performAction: function (a, b, c, d, e, f, g) {
              var h = f.length - 1;
              switch (e) {
                case 1:
                  return f[h - 1];
                case 2:
                  this.$ = d.prepareProgram(f[h]);
                  break;
                case 3:
                  this.$ = f[h];
                  break;
                case 4:
                  this.$ = f[h];
                  break;
                case 5:
                  this.$ = f[h];
                  break;
                case 6:
                  this.$ = f[h];
                  break;
                case 7:
                  this.$ = f[h];
                  break;
                case 8:
                  this.$ = f[h];
                  break;
                case 9:
                  this.$ = {
                    type: "CommentStatement",
                    value: d.stripComment(f[h]),
                    strip: d.stripFlags(f[h], f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 10:
                  this.$ = {
                    type: "ContentStatement",
                    original: f[h],
                    value: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 11:
                  this.$ = d.prepareRawBlock(f[h - 2], f[h - 1], f[h], this._$);
                  break;
                case 12:
                  this.$ = { path: f[h - 3], params: f[h - 2], hash: f[h - 1] };
                  break;
                case 13:
                  this.$ = d.prepareBlock(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    !1,
                    this._$
                  );
                  break;
                case 14:
                  this.$ = d.prepareBlock(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    !0,
                    this._$
                  );
                  break;
                case 15:
                  this.$ = {
                    open: f[h - 5],
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 16:
                  this.$ = {
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 17:
                  this.$ = {
                    path: f[h - 4],
                    params: f[h - 3],
                    hash: f[h - 2],
                    blockParams: f[h - 1],
                    strip: d.stripFlags(f[h - 5], f[h]),
                  };
                  break;
                case 18:
                  this.$ = {
                    strip: d.stripFlags(f[h - 1], f[h - 1]),
                    program: f[h],
                  };
                  break;
                case 19:
                  var i = d.prepareBlock(
                      f[h - 2],
                      f[h - 1],
                      f[h],
                      f[h],
                      !1,
                      this._$
                    ),
                    j = d.prepareProgram([i], f[h - 1].loc);
                  (j.chained = !0),
                    (this.$ = { strip: f[h - 2].strip, program: j, chain: !0 });
                  break;
                case 20:
                  this.$ = f[h];
                  break;
                case 21:
                  this.$ = {
                    path: f[h - 1],
                    strip: d.stripFlags(f[h - 2], f[h]),
                  };
                  break;
                case 22:
                  this.$ = d.prepareMustache(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h - 4],
                    d.stripFlags(f[h - 4], f[h]),
                    this._$
                  );
                  break;
                case 23:
                  this.$ = d.prepareMustache(
                    f[h - 3],
                    f[h - 2],
                    f[h - 1],
                    f[h - 4],
                    d.stripFlags(f[h - 4], f[h]),
                    this._$
                  );
                  break;
                case 24:
                  this.$ = {
                    type: "PartialStatement",
                    name: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    indent: "",
                    strip: d.stripFlags(f[h - 4], f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 25:
                  this.$ = d.preparePartialBlock(
                    f[h - 2],
                    f[h - 1],
                    f[h],
                    this._$
                  );
                  break;
                case 26:
                  this.$ = {
                    path: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    strip: d.stripFlags(f[h - 4], f[h]),
                  };
                  break;
                case 27:
                  this.$ = f[h];
                  break;
                case 28:
                  this.$ = f[h];
                  break;
                case 29:
                  this.$ = {
                    type: "SubExpression",
                    path: f[h - 3],
                    params: f[h - 2],
                    hash: f[h - 1],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 30:
                  this.$ = {
                    type: "Hash",
                    pairs: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 31:
                  this.$ = {
                    type: "HashPair",
                    key: d.id(f[h - 2]),
                    value: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 32:
                  this.$ = d.id(f[h - 1]);
                  break;
                case 33:
                  this.$ = f[h];
                  break;
                case 34:
                  this.$ = f[h];
                  break;
                case 35:
                  this.$ = {
                    type: "StringLiteral",
                    value: f[h],
                    original: f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 36:
                  this.$ = {
                    type: "NumberLiteral",
                    value: Number(f[h]),
                    original: Number(f[h]),
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 37:
                  this.$ = {
                    type: "BooleanLiteral",
                    value: "true" === f[h],
                    original: "true" === f[h],
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 38:
                  this.$ = {
                    type: "UndefinedLiteral",
                    original: void 0,
                    value: void 0,
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 39:
                  this.$ = {
                    type: "NullLiteral",
                    original: null,
                    value: null,
                    loc: d.locInfo(this._$),
                  };
                  break;
                case 40:
                  this.$ = f[h];
                  break;
                case 41:
                  this.$ = f[h];
                  break;
                case 42:
                  this.$ = d.preparePath(!0, f[h], this._$);
                  break;
                case 43:
                  this.$ = d.preparePath(!1, f[h], this._$);
                  break;
                case 44:
                  f[h - 2].push({
                    part: d.id(f[h]),
                    original: f[h],
                    separator: f[h - 1],
                  }),
                    (this.$ = f[h - 2]);
                  break;
                case 45:
                  this.$ = [{ part: d.id(f[h]), original: f[h] }];
                  break;
                case 46:
                  this.$ = [];
                  break;
                case 47:
                  f[h - 1].push(f[h]);
                  break;
                case 48:
                  this.$ = [];
                  break;
                case 49:
                  f[h - 1].push(f[h]);
                  break;
                case 50:
                  this.$ = [];
                  break;
                case 51:
                  f[h - 1].push(f[h]);
                  break;
                case 58:
                  this.$ = [];
                  break;
                case 59:
                  f[h - 1].push(f[h]);
                  break;
                case 64:
                  this.$ = [];
                  break;
                case 65:
                  f[h - 1].push(f[h]);
                  break;
                case 70:
                  this.$ = [];
                  break;
                case 71:
                  f[h - 1].push(f[h]);
                  break;
                case 78:
                  this.$ = [];
                  break;
                case 79:
                  f[h - 1].push(f[h]);
                  break;
                case 82:
                  this.$ = [];
                  break;
                case 83:
                  f[h - 1].push(f[h]);
                  break;
                case 86:
                  this.$ = [];
                  break;
                case 87:
                  f[h - 1].push(f[h]);
                  break;
                case 90:
                  this.$ = [];
                  break;
                case 91:
                  f[h - 1].push(f[h]);
                  break;
                case 94:
                  this.$ = [];
                  break;
                case 95:
                  f[h - 1].push(f[h]);
                  break;
                case 98:
                  this.$ = [f[h]];
                  break;
                case 99:
                  f[h - 1].push(f[h]);
                  break;
                case 100:
                  this.$ = [f[h]];
                  break;
                case 101:
                  f[h - 1].push(f[h]);
              }
            },
            table: [
              {
                3: 1,
                4: 2,
                5: [2, 46],
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 1: [3] },
              { 5: [1, 4] },
              {
                5: [2, 2],
                7: 5,
                8: 6,
                9: 7,
                10: 8,
                11: 9,
                12: 10,
                13: 11,
                14: [1, 12],
                15: [1, 20],
                16: 17,
                19: [1, 23],
                24: 15,
                27: 16,
                29: [1, 21],
                34: [1, 22],
                39: [2, 2],
                44: [2, 2],
                47: [2, 2],
                48: [1, 13],
                51: [1, 14],
                55: [1, 18],
                59: 19,
                60: [1, 24],
              },
              { 1: [2, 1] },
              {
                5: [2, 47],
                14: [2, 47],
                15: [2, 47],
                19: [2, 47],
                29: [2, 47],
                34: [2, 47],
                39: [2, 47],
                44: [2, 47],
                47: [2, 47],
                48: [2, 47],
                51: [2, 47],
                55: [2, 47],
                60: [2, 47],
              },
              {
                5: [2, 3],
                14: [2, 3],
                15: [2, 3],
                19: [2, 3],
                29: [2, 3],
                34: [2, 3],
                39: [2, 3],
                44: [2, 3],
                47: [2, 3],
                48: [2, 3],
                51: [2, 3],
                55: [2, 3],
                60: [2, 3],
              },
              {
                5: [2, 4],
                14: [2, 4],
                15: [2, 4],
                19: [2, 4],
                29: [2, 4],
                34: [2, 4],
                39: [2, 4],
                44: [2, 4],
                47: [2, 4],
                48: [2, 4],
                51: [2, 4],
                55: [2, 4],
                60: [2, 4],
              },
              {
                5: [2, 5],
                14: [2, 5],
                15: [2, 5],
                19: [2, 5],
                29: [2, 5],
                34: [2, 5],
                39: [2, 5],
                44: [2, 5],
                47: [2, 5],
                48: [2, 5],
                51: [2, 5],
                55: [2, 5],
                60: [2, 5],
              },
              {
                5: [2, 6],
                14: [2, 6],
                15: [2, 6],
                19: [2, 6],
                29: [2, 6],
                34: [2, 6],
                39: [2, 6],
                44: [2, 6],
                47: [2, 6],
                48: [2, 6],
                51: [2, 6],
                55: [2, 6],
                60: [2, 6],
              },
              {
                5: [2, 7],
                14: [2, 7],
                15: [2, 7],
                19: [2, 7],
                29: [2, 7],
                34: [2, 7],
                39: [2, 7],
                44: [2, 7],
                47: [2, 7],
                48: [2, 7],
                51: [2, 7],
                55: [2, 7],
                60: [2, 7],
              },
              {
                5: [2, 8],
                14: [2, 8],
                15: [2, 8],
                19: [2, 8],
                29: [2, 8],
                34: [2, 8],
                39: [2, 8],
                44: [2, 8],
                47: [2, 8],
                48: [2, 8],
                51: [2, 8],
                55: [2, 8],
                60: [2, 8],
              },
              {
                5: [2, 9],
                14: [2, 9],
                15: [2, 9],
                19: [2, 9],
                29: [2, 9],
                34: [2, 9],
                39: [2, 9],
                44: [2, 9],
                47: [2, 9],
                48: [2, 9],
                51: [2, 9],
                55: [2, 9],
                60: [2, 9],
              },
              {
                20: 25,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 36,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 37,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                4: 38,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 15: [2, 48], 17: 39, 18: [2, 48] },
              {
                20: 41,
                56: 40,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 44,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              {
                5: [2, 10],
                14: [2, 10],
                15: [2, 10],
                18: [2, 10],
                19: [2, 10],
                29: [2, 10],
                34: [2, 10],
                39: [2, 10],
                44: [2, 10],
                47: [2, 10],
                48: [2, 10],
                51: [2, 10],
                55: [2, 10],
                60: [2, 10],
              },
              {
                20: 45,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 46,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 47,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 41,
                56: 48,
                64: 42,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                33: [2, 78],
                49: 49,
                65: [2, 78],
                72: [2, 78],
                80: [2, 78],
                81: [2, 78],
                82: [2, 78],
                83: [2, 78],
                84: [2, 78],
                85: [2, 78],
              },
              {
                23: [2, 33],
                33: [2, 33],
                54: [2, 33],
                65: [2, 33],
                68: [2, 33],
                72: [2, 33],
                75: [2, 33],
                80: [2, 33],
                81: [2, 33],
                82: [2, 33],
                83: [2, 33],
                84: [2, 33],
                85: [2, 33],
              },
              {
                23: [2, 34],
                33: [2, 34],
                54: [2, 34],
                65: [2, 34],
                68: [2, 34],
                72: [2, 34],
                75: [2, 34],
                80: [2, 34],
                81: [2, 34],
                82: [2, 34],
                83: [2, 34],
                84: [2, 34],
                85: [2, 34],
              },
              {
                23: [2, 35],
                33: [2, 35],
                54: [2, 35],
                65: [2, 35],
                68: [2, 35],
                72: [2, 35],
                75: [2, 35],
                80: [2, 35],
                81: [2, 35],
                82: [2, 35],
                83: [2, 35],
                84: [2, 35],
                85: [2, 35],
              },
              {
                23: [2, 36],
                33: [2, 36],
                54: [2, 36],
                65: [2, 36],
                68: [2, 36],
                72: [2, 36],
                75: [2, 36],
                80: [2, 36],
                81: [2, 36],
                82: [2, 36],
                83: [2, 36],
                84: [2, 36],
                85: [2, 36],
              },
              {
                23: [2, 37],
                33: [2, 37],
                54: [2, 37],
                65: [2, 37],
                68: [2, 37],
                72: [2, 37],
                75: [2, 37],
                80: [2, 37],
                81: [2, 37],
                82: [2, 37],
                83: [2, 37],
                84: [2, 37],
                85: [2, 37],
              },
              {
                23: [2, 38],
                33: [2, 38],
                54: [2, 38],
                65: [2, 38],
                68: [2, 38],
                72: [2, 38],
                75: [2, 38],
                80: [2, 38],
                81: [2, 38],
                82: [2, 38],
                83: [2, 38],
                84: [2, 38],
                85: [2, 38],
              },
              {
                23: [2, 39],
                33: [2, 39],
                54: [2, 39],
                65: [2, 39],
                68: [2, 39],
                72: [2, 39],
                75: [2, 39],
                80: [2, 39],
                81: [2, 39],
                82: [2, 39],
                83: [2, 39],
                84: [2, 39],
                85: [2, 39],
              },
              {
                23: [2, 43],
                33: [2, 43],
                54: [2, 43],
                65: [2, 43],
                68: [2, 43],
                72: [2, 43],
                75: [2, 43],
                80: [2, 43],
                81: [2, 43],
                82: [2, 43],
                83: [2, 43],
                84: [2, 43],
                85: [2, 43],
                87: [1, 50],
              },
              { 72: [1, 35], 86: 51 },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                52: 52,
                54: [2, 82],
                65: [2, 82],
                72: [2, 82],
                80: [2, 82],
                81: [2, 82],
                82: [2, 82],
                83: [2, 82],
                84: [2, 82],
                85: [2, 82],
              },
              {
                25: 53,
                38: 55,
                39: [1, 57],
                43: 56,
                44: [1, 58],
                45: 54,
                47: [2, 54],
              },
              { 28: 59, 43: 60, 44: [1, 58], 47: [2, 56] },
              { 13: 62, 15: [1, 20], 18: [1, 61] },
              {
                33: [2, 86],
                57: 63,
                65: [2, 86],
                72: [2, 86],
                80: [2, 86],
                81: [2, 86],
                82: [2, 86],
                83: [2, 86],
                84: [2, 86],
                85: [2, 86],
              },
              {
                33: [2, 40],
                65: [2, 40],
                72: [2, 40],
                80: [2, 40],
                81: [2, 40],
                82: [2, 40],
                83: [2, 40],
                84: [2, 40],
                85: [2, 40],
              },
              {
                33: [2, 41],
                65: [2, 41],
                72: [2, 41],
                80: [2, 41],
                81: [2, 41],
                82: [2, 41],
                83: [2, 41],
                84: [2, 41],
                85: [2, 41],
              },
              {
                20: 64,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 65, 47: [1, 66] },
              {
                30: 67,
                33: [2, 58],
                65: [2, 58],
                72: [2, 58],
                75: [2, 58],
                80: [2, 58],
                81: [2, 58],
                82: [2, 58],
                83: [2, 58],
                84: [2, 58],
                85: [2, 58],
              },
              {
                33: [2, 64],
                35: 68,
                65: [2, 64],
                72: [2, 64],
                75: [2, 64],
                80: [2, 64],
                81: [2, 64],
                82: [2, 64],
                83: [2, 64],
                84: [2, 64],
                85: [2, 64],
              },
              {
                21: 69,
                23: [2, 50],
                65: [2, 50],
                72: [2, 50],
                80: [2, 50],
                81: [2, 50],
                82: [2, 50],
                83: [2, 50],
                84: [2, 50],
                85: [2, 50],
              },
              {
                33: [2, 90],
                61: 70,
                65: [2, 90],
                72: [2, 90],
                80: [2, 90],
                81: [2, 90],
                82: [2, 90],
                83: [2, 90],
                84: [2, 90],
                85: [2, 90],
              },
              {
                20: 74,
                33: [2, 80],
                50: 71,
                63: 72,
                64: 75,
                65: [1, 43],
                69: 73,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 72: [1, 79] },
              {
                23: [2, 42],
                33: [2, 42],
                54: [2, 42],
                65: [2, 42],
                68: [2, 42],
                72: [2, 42],
                75: [2, 42],
                80: [2, 42],
                81: [2, 42],
                82: [2, 42],
                83: [2, 42],
                84: [2, 42],
                85: [2, 42],
                87: [1, 50],
              },
              {
                20: 74,
                53: 80,
                54: [2, 84],
                63: 81,
                64: 75,
                65: [1, 43],
                69: 82,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 26: 83, 47: [1, 66] },
              { 47: [2, 55] },
              {
                4: 84,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                39: [2, 46],
                44: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 47: [2, 20] },
              {
                20: 85,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                4: 86,
                6: 3,
                14: [2, 46],
                15: [2, 46],
                19: [2, 46],
                29: [2, 46],
                34: [2, 46],
                47: [2, 46],
                48: [2, 46],
                51: [2, 46],
                55: [2, 46],
                60: [2, 46],
              },
              { 26: 87, 47: [1, 66] },
              { 47: [2, 57] },
              {
                5: [2, 11],
                14: [2, 11],
                15: [2, 11],
                19: [2, 11],
                29: [2, 11],
                34: [2, 11],
                39: [2, 11],
                44: [2, 11],
                47: [2, 11],
                48: [2, 11],
                51: [2, 11],
                55: [2, 11],
                60: [2, 11],
              },
              { 15: [2, 49], 18: [2, 49] },
              {
                20: 74,
                33: [2, 88],
                58: 88,
                63: 89,
                64: 75,
                65: [1, 43],
                69: 90,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                65: [2, 94],
                66: 91,
                68: [2, 94],
                72: [2, 94],
                80: [2, 94],
                81: [2, 94],
                82: [2, 94],
                83: [2, 94],
                84: [2, 94],
                85: [2, 94],
              },
              {
                5: [2, 25],
                14: [2, 25],
                15: [2, 25],
                19: [2, 25],
                29: [2, 25],
                34: [2, 25],
                39: [2, 25],
                44: [2, 25],
                47: [2, 25],
                48: [2, 25],
                51: [2, 25],
                55: [2, 25],
                60: [2, 25],
              },
              {
                20: 92,
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                31: 93,
                33: [2, 60],
                63: 94,
                64: 75,
                65: [1, 43],
                69: 95,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 60],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                33: [2, 66],
                36: 96,
                63: 97,
                64: 75,
                65: [1, 43],
                69: 98,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 66],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                22: 99,
                23: [2, 52],
                63: 100,
                64: 75,
                65: [1, 43],
                69: 101,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                20: 74,
                33: [2, 92],
                62: 102,
                63: 103,
                64: 75,
                65: [1, 43],
                69: 104,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 105] },
              {
                33: [2, 79],
                65: [2, 79],
                72: [2, 79],
                80: [2, 79],
                81: [2, 79],
                82: [2, 79],
                83: [2, 79],
                84: [2, 79],
                85: [2, 79],
              },
              { 33: [2, 81] },
              {
                23: [2, 27],
                33: [2, 27],
                54: [2, 27],
                65: [2, 27],
                68: [2, 27],
                72: [2, 27],
                75: [2, 27],
                80: [2, 27],
                81: [2, 27],
                82: [2, 27],
                83: [2, 27],
                84: [2, 27],
                85: [2, 27],
              },
              {
                23: [2, 28],
                33: [2, 28],
                54: [2, 28],
                65: [2, 28],
                68: [2, 28],
                72: [2, 28],
                75: [2, 28],
                80: [2, 28],
                81: [2, 28],
                82: [2, 28],
                83: [2, 28],
                84: [2, 28],
                85: [2, 28],
              },
              {
                23: [2, 30],
                33: [2, 30],
                54: [2, 30],
                68: [2, 30],
                71: 106,
                72: [1, 107],
                75: [2, 30],
              },
              {
                23: [2, 98],
                33: [2, 98],
                54: [2, 98],
                68: [2, 98],
                72: [2, 98],
                75: [2, 98],
              },
              {
                23: [2, 45],
                33: [2, 45],
                54: [2, 45],
                65: [2, 45],
                68: [2, 45],
                72: [2, 45],
                73: [1, 108],
                75: [2, 45],
                80: [2, 45],
                81: [2, 45],
                82: [2, 45],
                83: [2, 45],
                84: [2, 45],
                85: [2, 45],
                87: [2, 45],
              },
              {
                23: [2, 44],
                33: [2, 44],
                54: [2, 44],
                65: [2, 44],
                68: [2, 44],
                72: [2, 44],
                75: [2, 44],
                80: [2, 44],
                81: [2, 44],
                82: [2, 44],
                83: [2, 44],
                84: [2, 44],
                85: [2, 44],
                87: [2, 44],
              },
              { 54: [1, 109] },
              {
                54: [2, 83],
                65: [2, 83],
                72: [2, 83],
                80: [2, 83],
                81: [2, 83],
                82: [2, 83],
                83: [2, 83],
                84: [2, 83],
                85: [2, 83],
              },
              { 54: [2, 85] },
              {
                5: [2, 13],
                14: [2, 13],
                15: [2, 13],
                19: [2, 13],
                29: [2, 13],
                34: [2, 13],
                39: [2, 13],
                44: [2, 13],
                47: [2, 13],
                48: [2, 13],
                51: [2, 13],
                55: [2, 13],
                60: [2, 13],
              },
              {
                38: 55,
                39: [1, 57],
                43: 56,
                44: [1, 58],
                45: 111,
                46: 110,
                47: [2, 76],
              },
              {
                33: [2, 70],
                40: 112,
                65: [2, 70],
                72: [2, 70],
                75: [2, 70],
                80: [2, 70],
                81: [2, 70],
                82: [2, 70],
                83: [2, 70],
                84: [2, 70],
                85: [2, 70],
              },
              { 47: [2, 18] },
              {
                5: [2, 14],
                14: [2, 14],
                15: [2, 14],
                19: [2, 14],
                29: [2, 14],
                34: [2, 14],
                39: [2, 14],
                44: [2, 14],
                47: [2, 14],
                48: [2, 14],
                51: [2, 14],
                55: [2, 14],
                60: [2, 14],
              },
              { 33: [1, 113] },
              {
                33: [2, 87],
                65: [2, 87],
                72: [2, 87],
                80: [2, 87],
                81: [2, 87],
                82: [2, 87],
                83: [2, 87],
                84: [2, 87],
                85: [2, 87],
              },
              { 33: [2, 89] },
              {
                20: 74,
                63: 115,
                64: 75,
                65: [1, 43],
                67: 114,
                68: [2, 96],
                69: 116,
                70: 76,
                71: 77,
                72: [1, 78],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              { 33: [1, 117] },
              { 32: 118, 33: [2, 62], 74: 119, 75: [1, 120] },
              {
                33: [2, 59],
                65: [2, 59],
                72: [2, 59],
                75: [2, 59],
                80: [2, 59],
                81: [2, 59],
                82: [2, 59],
                83: [2, 59],
                84: [2, 59],
                85: [2, 59],
              },
              { 33: [2, 61], 75: [2, 61] },
              { 33: [2, 68], 37: 121, 74: 122, 75: [1, 120] },
              {
                33: [2, 65],
                65: [2, 65],
                72: [2, 65],
                75: [2, 65],
                80: [2, 65],
                81: [2, 65],
                82: [2, 65],
                83: [2, 65],
                84: [2, 65],
                85: [2, 65],
              },
              { 33: [2, 67], 75: [2, 67] },
              { 23: [1, 123] },
              {
                23: [2, 51],
                65: [2, 51],
                72: [2, 51],
                80: [2, 51],
                81: [2, 51],
                82: [2, 51],
                83: [2, 51],
                84: [2, 51],
                85: [2, 51],
              },
              { 23: [2, 53] },
              { 33: [1, 124] },
              {
                33: [2, 91],
                65: [2, 91],
                72: [2, 91],
                80: [2, 91],
                81: [2, 91],
                82: [2, 91],
                83: [2, 91],
                84: [2, 91],
                85: [2, 91],
              },
              { 33: [2, 93] },
              {
                5: [2, 22],
                14: [2, 22],
                15: [2, 22],
                19: [2, 22],
                29: [2, 22],
                34: [2, 22],
                39: [2, 22],
                44: [2, 22],
                47: [2, 22],
                48: [2, 22],
                51: [2, 22],
                55: [2, 22],
                60: [2, 22],
              },
              {
                23: [2, 99],
                33: [2, 99],
                54: [2, 99],
                68: [2, 99],
                72: [2, 99],
                75: [2, 99],
              },
              { 73: [1, 108] },
              {
                20: 74,
                63: 125,
                64: 75,
                65: [1, 43],
                72: [1, 35],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 23],
                14: [2, 23],
                15: [2, 23],
                19: [2, 23],
                29: [2, 23],
                34: [2, 23],
                39: [2, 23],
                44: [2, 23],
                47: [2, 23],
                48: [2, 23],
                51: [2, 23],
                55: [2, 23],
                60: [2, 23],
              },
              { 47: [2, 19] },
              { 47: [2, 77] },
              {
                20: 74,
                33: [2, 72],
                41: 126,
                63: 127,
                64: 75,
                65: [1, 43],
                69: 128,
                70: 76,
                71: 77,
                72: [1, 78],
                75: [2, 72],
                78: 26,
                79: 27,
                80: [1, 28],
                81: [1, 29],
                82: [1, 30],
                83: [1, 31],
                84: [1, 32],
                85: [1, 34],
                86: 33,
              },
              {
                5: [2, 24],
                14: [2, 24],
                15: [2, 24],
                19: [2, 24],
                29: [2, 24],
                34: [2, 24],
                39: [2, 24],
                44: [2, 24],
                47: [2, 24],
                48: [2, 24],
                51: [2, 24],
                55: [2, 24],
                60: [2, 24],
              },
              { 68: [1, 129] },
              {
                65: [2, 95],
                68: [2, 95],
                72: [2, 95],
                80: [2, 95],
                81: [2, 95],
                82: [2, 95],
                83: [2, 95],
                84: [2, 95],
                85: [2, 95],
              },
              { 68: [2, 97] },
              {
                5: [2, 21],
                14: [2, 21],
                15: [2, 21],
                19: [2, 21],
                29: [2, 21],
                34: [2, 21],
                39: [2, 21],
                44: [2, 21],
                47: [2, 21],
                48: [2, 21],
                51: [2, 21],
                55: [2, 21],
                60: [2, 21],
              },
              { 33: [1, 130] },
              { 33: [2, 63] },
              { 72: [1, 132], 76: 131 },
              { 33: [1, 133] },
              { 33: [2, 69] },
              { 15: [2, 12], 18: [2, 12] },
              {
                14: [2, 26],
                15: [2, 26],
                19: [2, 26],
                29: [2, 26],
                34: [2, 26],
                47: [2, 26],
                48: [2, 26],
                51: [2, 26],
                55: [2, 26],
                60: [2, 26],
              },
              {
                23: [2, 31],
                33: [2, 31],
                54: [2, 31],
                68: [2, 31],
                72: [2, 31],
                75: [2, 31],
              },
              { 33: [2, 74], 42: 134, 74: 135, 75: [1, 120] },
              {
                33: [2, 71],
                65: [2, 71],
                72: [2, 71],
                75: [2, 71],
                80: [2, 71],
                81: [2, 71],
                82: [2, 71],
                83: [2, 71],
                84: [2, 71],
                85: [2, 71],
              },
              { 33: [2, 73], 75: [2, 73] },
              {
                23: [2, 29],
                33: [2, 29],
                54: [2, 29],
                65: [2, 29],
                68: [2, 29],
                72: [2, 29],
                75: [2, 29],
                80: [2, 29],
                81: [2, 29],
                82: [2, 29],
                83: [2, 29],
                84: [2, 29],
                85: [2, 29],
              },
              {
                14: [2, 15],
                15: [2, 15],
                19: [2, 15],
                29: [2, 15],
                34: [2, 15],
                39: [2, 15],
                44: [2, 15],
                47: [2, 15],
                48: [2, 15],
                51: [2, 15],
                55: [2, 15],
                60: [2, 15],
              },
              { 72: [1, 137], 77: [1, 136] },
              { 72: [2, 100], 77: [2, 100] },
              {
                14: [2, 16],
                15: [2, 16],
                19: [2, 16],
                29: [2, 16],
                34: [2, 16],
                44: [2, 16],
                47: [2, 16],
                48: [2, 16],
                51: [2, 16],
                55: [2, 16],
                60: [2, 16],
              },
              { 33: [1, 138] },
              { 33: [2, 75] },
              { 33: [2, 32] },
              { 72: [2, 101], 77: [2, 101] },
              {
                14: [2, 17],
                15: [2, 17],
                19: [2, 17],
                29: [2, 17],
                34: [2, 17],
                39: [2, 17],
                44: [2, 17],
                47: [2, 17],
                48: [2, 17],
                51: [2, 17],
                55: [2, 17],
                60: [2, 17],
              },
            ],
            defaultActions: {
              4: [2, 1],
              54: [2, 55],
              56: [2, 20],
              60: [2, 57],
              73: [2, 81],
              82: [2, 85],
              86: [2, 18],
              90: [2, 89],
              101: [2, 53],
              104: [2, 93],
              110: [2, 19],
              111: [2, 77],
              116: [2, 97],
              119: [2, 63],
              122: [2, 69],
              135: [2, 75],
              136: [2, 32],
            },
            parseError: function (a, b) {
              throw new Error(a);
            },
            parse: function (a) {
              function b() {
                var a;
                return (
                  (a = c.lexer.lex() || 1),
                  "number" != typeof a && (a = c.symbols_[a] || a),
                  a
                );
              }
              var c = this,
                d = [0],
                e = [null],
                f = [],
                g = this.table,
                h = "",
                i = 0,
                j = 0,
                k = 0;
              this.lexer.setInput(a),
                (this.lexer.yy = this.yy),
                (this.yy.lexer = this.lexer),
                (this.yy.parser = this),
                "undefined" == typeof this.lexer.yylloc &&
                  (this.lexer.yylloc = {});
              var l = this.lexer.yylloc;
              f.push(l);
              var m = this.lexer.options && this.lexer.options.ranges;
              "function" == typeof this.yy.parseError &&
                (this.parseError = this.yy.parseError);
              for (var n, o, p, q, r, s, t, u, v, w = {}; ; ) {
                if (
                  ((p = d[d.length - 1]),
                  this.defaultActions[p]
                    ? (q = this.defaultActions[p])
                    : ((null !== n && "undefined" != typeof n) || (n = b()),
                      (q = g[p] && g[p][n])),
                  "undefined" == typeof q || !q.length || !q[0])
                ) {
                  var x = "";
                  if (!k) {
                    v = [];
                    for (s in g[p])
                      this.terminals_[s] &&
                        s > 2 &&
                        v.push("'" + this.terminals_[s] + "'");
                    (x = this.lexer.showPosition
                      ? "Parse error on line " +
                        (i + 1) +
                        ":\n" +
                        this.lexer.showPosition() +
                        "\nExpecting " +
                        v.join(", ") +
                        ", got '" +
                        (this.terminals_[n] || n) +
                        "'"
                      : "Parse error on line " +
                        (i + 1) +
                        ": Unexpected " +
                        (1 == n
                          ? "end of input"
                          : "'" + (this.terminals_[n] || n) + "'")),
                      this.parseError(x, {
                        text: this.lexer.match,
                        token: this.terminals_[n] || n,
                        line: this.lexer.yylineno,
                        loc: l,
                        expected: v,
                      });
                  }
                }
                if (q[0] instanceof Array && q.length > 1)
                  throw new Error(
                    "Parse Error: multiple actions possible at state: " +
                      p +
                      ", token: " +
                      n
                  );
                switch (q[0]) {
                  case 1:
                    d.push(n),
                      e.push(this.lexer.yytext),
                      f.push(this.lexer.yylloc),
                      d.push(q[1]),
                      (n = null),
                      o
                        ? ((n = o), (o = null))
                        : ((j = this.lexer.yyleng),
                          (h = this.lexer.yytext),
                          (i = this.lexer.yylineno),
                          (l = this.lexer.yylloc),
                          k > 0 && k--);
                    break;
                  case 2:
                    if (
                      ((t = this.productions_[q[1]][1]),
                      (w.$ = e[e.length - t]),
                      (w._$ = {
                        first_line: f[f.length - (t || 1)].first_line,
                        last_line: f[f.length - 1].last_line,
                        first_column: f[f.length - (t || 1)].first_column,
                        last_column: f[f.length - 1].last_column,
                      }),
                      m &&
                        (w._$.range = [
                          f[f.length - (t || 1)].range[0],
                          f[f.length - 1].range[1],
                        ]),
                      (r = this.performAction.call(
                        w,
                        h,
                        j,
                        i,
                        this.yy,
                        q[1],
                        e,
                        f
                      )),
                      "undefined" != typeof r)
                    )
                      return r;
                    t &&
                      ((d = d.slice(0, -1 * t * 2)),
                      (e = e.slice(0, -1 * t)),
                      (f = f.slice(0, -1 * t))),
                      d.push(this.productions_[q[1]][0]),
                      e.push(w.$),
                      f.push(w._$),
                      (u = g[d[d.length - 2]][d[d.length - 1]]),
                      d.push(u);
                    break;
                  case 3:
                    return !0;
                }
              }
              return !0;
            },
          },
          c = (function () {
            var a = {
              EOF: 1,
              parseError: function (a, b) {
                if (!this.yy.parser) throw new Error(a);
                this.yy.parser.parseError(a, b);
              },
              setInput: function (a) {
                return (
                  (this._input = a),
                  (this._more = this._less = this.done = !1),
                  (this.yylineno = this.yyleng = 0),
                  (this.yytext = this.matched = this.match = ""),
                  (this.conditionStack = ["INITIAL"]),
                  (this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                  }),
                  this.options.ranges && (this.yylloc.range = [0, 0]),
                  (this.offset = 0),
                  this
                );
              },
              input: function () {
                var a = this._input[0];
                (this.yytext += a),
                  this.yyleng++,
                  this.offset++,
                  (this.match += a),
                  (this.matched += a);
                var b = a.match(/(?:\r\n?|\n).*/g);
                return (
                  b
                    ? (this.yylineno++, this.yylloc.last_line++)
                    : this.yylloc.last_column++,
                  this.options.ranges && this.yylloc.range[1]++,
                  (this._input = this._input.slice(1)),
                  a
                );
              },
              unput: function (a) {
                var b = a.length,
                  c = a.split(/(?:\r\n?|\n)/g);
                (this._input = a + this._input),
                  (this.yytext = this.yytext.substr(
                    0,
                    this.yytext.length - b - 1
                  )),
                  (this.offset -= b);
                var d = this.match.split(/(?:\r\n?|\n)/g);
                (this.match = this.match.substr(0, this.match.length - 1)),
                  (this.matched = this.matched.substr(
                    0,
                    this.matched.length - 1
                  )),
                  c.length - 1 && (this.yylineno -= c.length - 1);
                var e = this.yylloc.range;
                return (
                  (this.yylloc = {
                    first_line: this.yylloc.first_line,
                    last_line: this.yylineno + 1,
                    first_column: this.yylloc.first_column,
                    last_column: c
                      ? (c.length === d.length ? this.yylloc.first_column : 0) +
                        d[d.length - c.length].length -
                        c[0].length
                      : this.yylloc.first_column - b,
                  }),
                  this.options.ranges &&
                    (this.yylloc.range = [e[0], e[0] + this.yyleng - b]),
                  this
                );
              },
              more: function () {
                return (this._more = !0), this;
              },
              less: function (a) {
                this.unput(this.match.slice(a));
              },
              pastInput: function () {
                var a = this.matched.substr(
                  0,
                  this.matched.length - this.match.length
                );
                return (
                  (a.length > 20 ? "..." : "") +
                  a.substr(-20).replace(/\n/g, "")
                );
              },
              upcomingInput: function () {
                var a = this.match;
                return (
                  a.length < 20 && (a += this._input.substr(0, 20 - a.length)),
                  (a.substr(0, 20) + (a.length > 20 ? "..." : "")).replace(
                    /\n/g,
                    ""
                  )
                );
              },
              showPosition: function () {
                var a = this.pastInput(),
                  b = new Array(a.length + 1).join("-");
                return a + this.upcomingInput() + "\n" + b + "^";
              },
              next: function () {
                if (this.done) return this.EOF;
                this._input || (this.done = !0);
                var a, b, c, d, e;
                this._more || ((this.yytext = ""), (this.match = ""));
                for (
                  var f = this._currentRules(), g = 0;
                  g < f.length &&
                  ((c = this._input.match(this.rules[f[g]])),
                  !c ||
                    (b && !(c[0].length > b[0].length)) ||
                    ((b = c), (d = g), this.options.flex));
                  g++
                );
                return b
                  ? ((e = b[0].match(/(?:\r\n?|\n).*/g)),
                    e && (this.yylineno += e.length),
                    (this.yylloc = {
                      first_line: this.yylloc.last_line,
                      last_line: this.yylineno + 1,
                      first_column: this.yylloc.last_column,
                      last_column: e
                        ? e[e.length - 1].length -
                          e[e.length - 1].match(/\r?\n?/)[0].length
                        : this.yylloc.last_column + b[0].length,
                    }),
                    (this.yytext += b[0]),
                    (this.match += b[0]),
                    (this.matches = b),
                    (this.yyleng = this.yytext.length),
                    this.options.ranges &&
                      (this.yylloc.range = [
                        this.offset,
                        (this.offset += this.yyleng),
                      ]),
                    (this._more = !1),
                    (this._input = this._input.slice(b[0].length)),
                    (this.matched += b[0]),
                    (a = this.performAction.call(
                      this,
                      this.yy,
                      this,
                      f[d],
                      this.conditionStack[this.conditionStack.length - 1]
                    )),
                    this.done && this._input && (this.done = !1),
                    a ? a : void 0)
                  : "" === this._input
                  ? this.EOF
                  : this.parseError(
                      "Lexical error on line " +
                        (this.yylineno + 1) +
                        ". Unrecognized text.\n" +
                        this.showPosition(),
                      { text: "", token: null, line: this.yylineno }
                    );
              },
              lex: function () {
                var a = this.next();
                return "undefined" != typeof a ? a : this.lex();
              },
              begin: function (a) {
                this.conditionStack.push(a);
              },
              popState: function () {
                return this.conditionStack.pop();
              },
              _currentRules: function () {
                return this.conditions[
                  this.conditionStack[this.conditionStack.length - 1]
                ].rules;
              },
              topState: function () {
                return this.conditionStack[this.conditionStack.length - 2];
              },
              pushState: function (a) {
                this.begin(a);
              },
            };
            return (
              (a.options = {}),
              (a.performAction = function (a, b, c, d) {
                function e(a, c) {
                  return (b.yytext = b.yytext.substring(a, b.yyleng - c + a));
                }
                switch (c) {
                  case 0:
                    if (
                      ("\\\\" === b.yytext.slice(-2)
                        ? (e(0, 1), this.begin("mu"))
                        : "\\" === b.yytext.slice(-1)
                        ? (e(0, 1), this.begin("emu"))
                        : this.begin("mu"),
                      b.yytext)
                    )
                      return 15;
                    break;
                  case 1:
                    return 15;
                  case 2:
                    return this.popState(), 15;
                  case 3:
                    return this.begin("raw"), 15;
                  case 4:
                    return (
                      this.popState(),
                      "raw" ===
                      this.conditionStack[this.conditionStack.length - 1]
                        ? 15
                        : (e(5, 9), "END_RAW_BLOCK")
                    );
                  case 5:
                    return 15;
                  case 6:
                    return this.popState(), 14;
                  case 7:
                    return 65;
                  case 8:
                    return 68;
                  case 9:
                    return 19;
                  case 10:
                    return this.popState(), this.begin("raw"), 23;
                  case 11:
                    return 55;
                  case 12:
                    return 60;
                  case 13:
                    return 29;
                  case 14:
                    return 47;
                  case 15:
                    return this.popState(), 44;
                  case 16:
                    return this.popState(), 44;
                  case 17:
                    return 34;
                  case 18:
                    return 39;
                  case 19:
                    return 51;
                  case 20:
                    return 48;
                  case 21:
                    this.unput(b.yytext), this.popState(), this.begin("com");
                    break;
                  case 22:
                    return this.popState(), 14;
                  case 23:
                    return 48;
                  case 24:
                    return 73;
                  case 25:
                    return 72;
                  case 26:
                    return 72;
                  case 27:
                    return 87;
                  case 28:
                    break;
                  case 29:
                    return this.popState(), 54;
                  case 30:
                    return this.popState(), 33;
                  case 31:
                    return (b.yytext = e(1, 2).replace(/\\"/g, '"')), 80;
                  case 32:
                    return (b.yytext = e(1, 2).replace(/\\'/g, "'")), 80;
                  case 33:
                    return 85;
                  case 34:
                    return 82;
                  case 35:
                    return 82;
                  case 36:
                    return 83;
                  case 37:
                    return 84;
                  case 38:
                    return 81;
                  case 39:
                    return 75;
                  case 40:
                    return 77;
                  case 41:
                    return 72;
                  case 42:
                    return (
                      (b.yytext = b.yytext.replace(/\\([\\\]])/g, "$1")), 72
                    );
                  case 43:
                    return "INVALID";
                  case 44:
                    return 5;
                }
              }),
              (a.rules = [
                /^(?:[^\x00]*?(?=(\{\{)))/,
                /^(?:[^\x00]+)/,
                /^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,
                /^(?:\{\{\{\{(?=[^\/]))/,
                /^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,
                /^(?:[^\x00]+?(?=(\{\{\{\{)))/,
                /^(?:[\s\S]*?--(~)?\}\})/,
                /^(?:\()/,
                /^(?:\))/,
                /^(?:\{\{\{\{)/,
                /^(?:\}\}\}\})/,
                /^(?:\{\{(~)?>)/,
                /^(?:\{\{(~)?#>)/,
                /^(?:\{\{(~)?#\*?)/,
                /^(?:\{\{(~)?\/)/,
                /^(?:\{\{(~)?\^\s*(~)?\}\})/,
                /^(?:\{\{(~)?\s*else\s*(~)?\}\})/,
                /^(?:\{\{(~)?\^)/,
                /^(?:\{\{(~)?\s*else\b)/,
                /^(?:\{\{(~)?\{)/,
                /^(?:\{\{(~)?&)/,
                /^(?:\{\{(~)?!--)/,
                /^(?:\{\{(~)?![\s\S]*?\}\})/,
                /^(?:\{\{(~)?\*?)/,
                /^(?:=)/,
                /^(?:\.\.)/,
                /^(?:\.(?=([=~}\s\/.)|])))/,
                /^(?:[\/.])/,
                /^(?:\s+)/,
                /^(?:\}(~)?\}\})/,
                /^(?:(~)?\}\})/,
                /^(?:"(\\["]|[^"])*")/,
                /^(?:'(\\[']|[^'])*')/,
                /^(?:@)/,
                /^(?:true(?=([~}\s)])))/,
                /^(?:false(?=([~}\s)])))/,
                /^(?:undefined(?=([~}\s)])))/,
                /^(?:null(?=([~}\s)])))/,
                /^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,
                /^(?:as\s+\|)/,
                /^(?:\|)/,
                /^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,
                /^(?:\[(\\\]|[^\]])*\])/,
                /^(?:.)/,
                /^(?:$)/,
              ]),
              (a.conditions = {
                mu: {
                  rules: [
                    7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22,
                    23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37,
                    38, 39, 40, 41, 42, 43, 44,
                  ],
                  inclusive: !1,
                },
                emu: { rules: [2], inclusive: !1 },
                com: { rules: [6], inclusive: !1 },
                raw: { rules: [3, 4, 5], inclusive: !1 },
                INITIAL: { rules: [0, 1, 44], inclusive: !0 },
              }),
              a
            );
          })();
        return (b.lexer = c), (a.prototype = b), (b.Parser = a), new a();
      })();
      (b["default"] = c), (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        var a =
          arguments.length <= 0 || void 0 === arguments[0] ? {} : arguments[0];
        this.options = a;
      }
      function e(a, b, c) {
        void 0 === b && (b = a.length);
        var d = a[b - 1],
          e = a[b - 2];
        return d
          ? "ContentStatement" === d.type
            ? (e || !c ? /\r?\n\s*?$/ : /(^|\r?\n)\s*?$/).test(d.original)
            : void 0
          : c;
      }
      function f(a, b, c) {
        void 0 === b && (b = -1);
        var d = a[b + 1],
          e = a[b + 2];
        return d
          ? "ContentStatement" === d.type
            ? (e || !c ? /^\s*?\r?\n/ : /^\s*?(\r?\n|$)/).test(d.original)
            : void 0
          : c;
      }
      function g(a, b, c) {
        var d = a[null == b ? 0 : b + 1];
        if (d && "ContentStatement" === d.type && (c || !d.rightStripped)) {
          var e = d.value;
          (d.value = d.value.replace(c ? /^\s+/ : /^[ \t]*\r?\n?/, "")),
            (d.rightStripped = d.value !== e);
        }
      }
      function h(a, b, c) {
        var d = a[null == b ? a.length - 1 : b - 1];
        if (d && "ContentStatement" === d.type && (c || !d.leftStripped)) {
          var e = d.value;
          return (
            (d.value = d.value.replace(c ? /\s+$/ : /[ \t]+$/, "")),
            (d.leftStripped = d.value !== e),
            d.leftStripped
          );
        }
      }
      var i = c(1)["default"];
      b.__esModule = !0;
      var j = c(49),
        k = i(j);
      (d.prototype = new k["default"]()),
        (d.prototype.Program = function (a) {
          var b = !this.options.ignoreStandalone,
            c = !this.isRootSeen;
          this.isRootSeen = !0;
          for (var d = a.body, i = 0, j = d.length; i < j; i++) {
            var k = d[i],
              l = this.accept(k);
            if (l) {
              var m = e(d, i, c),
                n = f(d, i, c),
                o = l.openStandalone && m,
                p = l.closeStandalone && n,
                q = l.inlineStandalone && m && n;
              l.close && g(d, i, !0),
                l.open && h(d, i, !0),
                b &&
                  q &&
                  (g(d, i),
                  h(d, i) &&
                    "PartialStatement" === k.type &&
                    (k.indent = /([ \t]+$)/.exec(d[i - 1].original)[1])),
                b && o && (g((k.program || k.inverse).body), h(d, i)),
                b && p && (g(d, i), h((k.inverse || k.program).body));
            }
          }
          return a;
        }),
        (d.prototype.BlockStatement =
          d.prototype.DecoratorBlock =
          d.prototype.PartialBlockStatement =
            function (a) {
              this.accept(a.program), this.accept(a.inverse);
              var b = a.program || a.inverse,
                c = a.program && a.inverse,
                d = c,
                i = c;
              if (c && c.chained)
                for (d = c.body[0].program; i.chained; )
                  i = i.body[i.body.length - 1].program;
              var j = {
                open: a.openStrip.open,
                close: a.closeStrip.close,
                openStandalone: f(b.body),
                closeStandalone: e((d || b).body),
              };
              if ((a.openStrip.close && g(b.body, null, !0), c)) {
                var k = a.inverseStrip;
                k.open && h(b.body, null, !0),
                  k.close && g(d.body, null, !0),
                  a.closeStrip.open && h(i.body, null, !0),
                  !this.options.ignoreStandalone &&
                    e(b.body) &&
                    f(d.body) &&
                    (h(b.body), g(d.body));
              } else a.closeStrip.open && h(b.body, null, !0);
              return j;
            }),
        (d.prototype.Decorator = d.prototype.MustacheStatement =
          function (a) {
            return a.strip;
          }),
        (d.prototype.PartialStatement = d.prototype.CommentStatement =
          function (a) {
            var b = a.strip || {};
            return { inlineStandalone: !0, open: b.open, close: b.close };
          }),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d() {
        this.parents = [];
      }
      function e(a) {
        this.acceptRequired(a, "path"),
          this.acceptArray(a.params),
          this.acceptKey(a, "hash");
      }
      function f(a) {
        e.call(this, a),
          this.acceptKey(a, "program"),
          this.acceptKey(a, "inverse");
      }
      function g(a) {
        this.acceptRequired(a, "name"),
          this.acceptArray(a.params),
          this.acceptKey(a, "hash");
      }
      var h = c(1)["default"];
      b.__esModule = !0;
      var i = c(6),
        j = h(i);
      (d.prototype = {
        constructor: d,
        mutating: !1,
        acceptKey: function (a, b) {
          var c = this.accept(a[b]);
          if (this.mutating) {
            if (c && !d.prototype[c.type])
              throw new j["default"](
                'Unexpected node type "' +
                  c.type +
                  '" found when accepting ' +
                  b +
                  " on " +
                  a.type
              );
            a[b] = c;
          }
        },
        acceptRequired: function (a, b) {
          if ((this.acceptKey(a, b), !a[b]))
            throw new j["default"](a.type + " requires " + b);
        },
        acceptArray: function (a) {
          for (var b = 0, c = a.length; b < c; b++)
            this.acceptKey(a, b), a[b] || (a.splice(b, 1), b--, c--);
        },
        accept: function (a) {
          if (a) {
            if (!this[a.type])
              throw new j["default"]("Unknown type: " + a.type, a);
            this.current && this.parents.unshift(this.current),
              (this.current = a);
            var b = this[a.type](a);
            return (
              (this.current = this.parents.shift()),
              !this.mutating || b ? b : b !== !1 ? a : void 0
            );
          }
        },
        Program: function (a) {
          this.acceptArray(a.body);
        },
        MustacheStatement: e,
        Decorator: e,
        BlockStatement: f,
        DecoratorBlock: f,
        PartialStatement: g,
        PartialBlockStatement: function (a) {
          g.call(this, a), this.acceptKey(a, "program");
        },
        ContentStatement: function () {},
        CommentStatement: function () {},
        SubExpression: e,
        PathExpression: function () {},
        StringLiteral: function () {},
        NumberLiteral: function () {},
        BooleanLiteral: function () {},
        UndefinedLiteral: function () {},
        NullLiteral: function () {},
        Hash: function (a) {
          this.acceptArray(a.pairs);
        },
        HashPair: function (a) {
          this.acceptRequired(a, "value");
        },
      }),
        (b["default"] = d),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b) {
        if (((b = b.path ? b.path.original : b), a.path.original !== b)) {
          var c = { loc: a.path.loc };
          throw new q["default"](a.path.original + " doesn't match " + b, c);
        }
      }
      function e(a, b) {
        (this.source = a),
          (this.start = { line: b.first_line, column: b.first_column }),
          (this.end = { line: b.last_line, column: b.last_column });
      }
      function f(a) {
        return /^\[.*\]$/.test(a) ? a.substring(1, a.length - 1) : a;
      }
      function g(a, b) {
        return {
          open: "~" === a.charAt(2),
          close: "~" === b.charAt(b.length - 3),
        };
      }
      function h(a) {
        return a.replace(/^\{\{~?!-?-?/, "").replace(/-?-?~?\}\}$/, "");
      }
      function i(a, b, c) {
        c = this.locInfo(c);
        for (
          var d = a ? "@" : "", e = [], f = 0, g = 0, h = b.length;
          g < h;
          g++
        ) {
          var i = b[g].part,
            j = b[g].original !== i;
          if (
            ((d += (b[g].separator || "") + i),
            j || (".." !== i && "." !== i && "this" !== i))
          )
            e.push(i);
          else {
            if (e.length > 0)
              throw new q["default"]("Invalid path: " + d, { loc: c });
            ".." === i && f++;
          }
        }
        return {
          type: "PathExpression",
          data: a,
          depth: f,
          parts: e,
          original: d,
          loc: c,
        };
      }
      function j(a, b, c, d, e, f) {
        var g = d.charAt(3) || d.charAt(2),
          h = "{" !== g && "&" !== g,
          i = /\*/.test(d);
        return {
          type: i ? "Decorator" : "MustacheStatement",
          path: a,
          params: b,
          hash: c,
          escaped: h,
          strip: e,
          loc: this.locInfo(f),
        };
      }
      function k(a, b, c, e) {
        d(a, c), (e = this.locInfo(e));
        var f = { type: "Program", body: b, strip: {}, loc: e };
        return {
          type: "BlockStatement",
          path: a.path,
          params: a.params,
          hash: a.hash,
          program: f,
          openStrip: {},
          inverseStrip: {},
          closeStrip: {},
          loc: e,
        };
      }
      function l(a, b, c, e, f, g) {
        e && e.path && d(a, e);
        var h = /\*/.test(a.open);
        b.blockParams = a.blockParams;
        var i = void 0,
          j = void 0;
        if (c) {
          if (h)
            throw new q["default"]("Unexpected inverse block on decorator", c);
          c.chain && (c.program.body[0].closeStrip = e.strip),
            (j = c.strip),
            (i = c.program);
        }
        return (
          f && ((f = i), (i = b), (b = f)),
          {
            type: h ? "DecoratorBlock" : "BlockStatement",
            path: a.path,
            params: a.params,
            hash: a.hash,
            program: b,
            inverse: i,
            openStrip: a.strip,
            inverseStrip: j,
            closeStrip: e && e.strip,
            loc: this.locInfo(g),
          }
        );
      }
      function m(a, b) {
        if (!b && a.length) {
          var c = a[0].loc,
            d = a[a.length - 1].loc;
          c &&
            d &&
            (b = {
              source: c.source,
              start: { line: c.start.line, column: c.start.column },
              end: { line: d.end.line, column: d.end.column },
            });
        }
        return { type: "Program", body: a, strip: {}, loc: b };
      }
      function n(a, b, c, e) {
        return (
          d(a, c),
          {
            type: "PartialBlockStatement",
            name: a.path,
            params: a.params,
            hash: a.hash,
            program: b,
            openStrip: a.strip,
            closeStrip: c && c.strip,
            loc: this.locInfo(e),
          }
        );
      }
      var o = c(1)["default"];
      (b.__esModule = !0),
        (b.SourceLocation = e),
        (b.id = f),
        (b.stripFlags = g),
        (b.stripComment = h),
        (b.preparePath = i),
        (b.prepareMustache = j),
        (b.prepareRawBlock = k),
        (b.prepareBlock = l),
        (b.prepareProgram = m),
        (b.preparePartialBlock = n);
      var p = c(6),
        q = o(p);
    },
    function (a, b, c) {
      "use strict";
      function d() {}
      function e(a, b, c) {
        if (null == a || ("string" != typeof a && "Program" !== a.type))
          throw new l["default"](
            "You must pass a string or Handlebars AST to Handlebars.precompile. You passed " +
              a
          );
        (b = b || {}),
          "data" in b || (b.data = !0),
          b.compat && (b.useDepths = !0);
        var d = c.parse(a, b),
          e = new c.Compiler().compile(d, b);
        return new c.JavaScriptCompiler().compile(e, b);
      }
      function f(a, b, c) {
        function d() {
          var d = c.parse(a, b),
            e = new c.Compiler().compile(d, b),
            f = new c.JavaScriptCompiler().compile(e, b, void 0, !0);
          return c.template(f);
        }
        function e(a, b) {
          return f || (f = d()), f.call(this, a, b);
        }
        if (
          (void 0 === b && (b = {}),
          null == a || ("string" != typeof a && "Program" !== a.type))
        )
          throw new l["default"](
            "You must pass a string or Handlebars AST to Handlebars.compile. You passed " +
              a
          );
        (b = m.extend({}, b)),
          "data" in b || (b.data = !0),
          b.compat && (b.useDepths = !0);
        var f = void 0;
        return (
          (e._setup = function (a) {
            return f || (f = d()), f._setup(a);
          }),
          (e._child = function (a, b, c, e) {
            return f || (f = d()), f._child(a, b, c, e);
          }),
          e
        );
      }
      function g(a, b) {
        if (a === b) return !0;
        if (m.isArray(a) && m.isArray(b) && a.length === b.length) {
          for (var c = 0; c < a.length; c++) if (!g(a[c], b[c])) return !1;
          return !0;
        }
      }
      function h(a) {
        if (!a.path.parts) {
          var b = a.path;
          a.path = {
            type: "PathExpression",
            data: !1,
            depth: 0,
            parts: [b.original + ""],
            original: b.original + "",
            loc: b.loc,
          };
        }
      }
      var i = c(34)["default"],
        j = c(1)["default"];
      (b.__esModule = !0),
        (b.Compiler = d),
        (b.precompile = e),
        (b.compile = f);
      var k = c(6),
        l = j(k),
        m = c(5),
        n = c(45),
        o = j(n),
        p = [].slice;
      d.prototype = {
        compiler: d,
        equals: function (a) {
          var b = this.opcodes.length;
          if (a.opcodes.length !== b) return !1;
          for (var c = 0; c < b; c++) {
            var d = this.opcodes[c],
              e = a.opcodes[c];
            if (d.opcode !== e.opcode || !g(d.args, e.args)) return !1;
          }
          b = this.children.length;
          for (var c = 0; c < b; c++)
            if (!this.children[c].equals(a.children[c])) return !1;
          return !0;
        },
        guid: 0,
        compile: function (a, b) {
          return (
            (this.sourceNode = []),
            (this.opcodes = []),
            (this.children = []),
            (this.options = b),
            (this.stringParams = b.stringParams),
            (this.trackIds = b.trackIds),
            (b.blockParams = b.blockParams || []),
            (b.knownHelpers = m.extend(
              i(null),
              {
                helperMissing: !0,
                blockHelperMissing: !0,
                each: !0,
                if: !0,
                unless: !0,
                with: !0,
                log: !0,
                lookup: !0,
              },
              b.knownHelpers
            )),
            this.accept(a)
          );
        },
        compileProgram: function (a) {
          var b = new this.compiler(),
            c = b.compile(a, this.options),
            d = this.guid++;
          return (
            (this.usePartial = this.usePartial || c.usePartial),
            (this.children[d] = c),
            (this.useDepths = this.useDepths || c.useDepths),
            d
          );
        },
        accept: function (a) {
          if (!this[a.type])
            throw new l["default"]("Unknown type: " + a.type, a);
          this.sourceNode.unshift(a);
          var b = this[a.type](a);
          return this.sourceNode.shift(), b;
        },
        Program: function (a) {
          this.options.blockParams.unshift(a.blockParams);
          for (var b = a.body, c = b.length, d = 0; d < c; d++)
            this.accept(b[d]);
          return (
            this.options.blockParams.shift(),
            (this.isSimple = 1 === c),
            (this.blockParams = a.blockParams ? a.blockParams.length : 0),
            this
          );
        },
        BlockStatement: function (a) {
          h(a);
          var b = a.program,
            c = a.inverse;
          (b = b && this.compileProgram(b)), (c = c && this.compileProgram(c));
          var d = this.classifySexpr(a);
          "helper" === d
            ? this.helperSexpr(a, b, c)
            : "simple" === d
            ? (this.simpleSexpr(a),
              this.opcode("pushProgram", b),
              this.opcode("pushProgram", c),
              this.opcode("emptyHash"),
              this.opcode("blockValue", a.path.original))
            : (this.ambiguousSexpr(a, b, c),
              this.opcode("pushProgram", b),
              this.opcode("pushProgram", c),
              this.opcode("emptyHash"),
              this.opcode("ambiguousBlockValue")),
            this.opcode("append");
        },
        DecoratorBlock: function (a) {
          var b = a.program && this.compileProgram(a.program),
            c = this.setupFullMustacheParams(a, b, void 0),
            d = a.path;
          (this.useDecorators = !0),
            this.opcode("registerDecorator", c.length, d.original);
        },
        PartialStatement: function (a) {
          this.usePartial = !0;
          var b = a.program;
          b && (b = this.compileProgram(a.program));
          var c = a.params;
          if (c.length > 1)
            throw new l["default"](
              "Unsupported number of partial arguments: " + c.length,
              a
            );
          c.length ||
            (this.options.explicitPartialContext
              ? this.opcode("pushLiteral", "undefined")
              : c.push({ type: "PathExpression", parts: [], depth: 0 }));
          var d = a.name.original,
            e = "SubExpression" === a.name.type;
          e && this.accept(a.name),
            this.setupFullMustacheParams(a, b, void 0, !0);
          var f = a.indent || "";
          this.options.preventIndent &&
            f &&
            (this.opcode("appendContent", f), (f = "")),
            this.opcode("invokePartial", e, d, f),
            this.opcode("append");
        },
        PartialBlockStatement: function (a) {
          this.PartialStatement(a);
        },
        MustacheStatement: function (a) {
          this.SubExpression(a),
            a.escaped && !this.options.noEscape
              ? this.opcode("appendEscaped")
              : this.opcode("append");
        },
        Decorator: function (a) {
          this.DecoratorBlock(a);
        },
        ContentStatement: function (a) {
          a.value && this.opcode("appendContent", a.value);
        },
        CommentStatement: function () {},
        SubExpression: function (a) {
          h(a);
          var b = this.classifySexpr(a);
          "simple" === b
            ? this.simpleSexpr(a)
            : "helper" === b
            ? this.helperSexpr(a)
            : this.ambiguousSexpr(a);
        },
        ambiguousSexpr: function (a, b, c) {
          var d = a.path,
            e = d.parts[0],
            f = null != b || null != c;
          this.opcode("getContext", d.depth),
            this.opcode("pushProgram", b),
            this.opcode("pushProgram", c),
            (d.strict = !0),
            this.accept(d),
            this.opcode("invokeAmbiguous", e, f);
        },
        simpleSexpr: function (a) {
          var b = a.path;
          (b.strict = !0), this.accept(b), this.opcode("resolvePossibleLambda");
        },
        helperSexpr: function (a, b, c) {
          var d = this.setupFullMustacheParams(a, b, c),
            e = a.path,
            f = e.parts[0];
          if (this.options.knownHelpers[f])
            this.opcode("invokeKnownHelper", d.length, f);
          else {
            if (this.options.knownHelpersOnly)
              throw new l["default"](
                "You specified knownHelpersOnly, but used the unknown helper " +
                  f,
                a
              );
            (e.strict = !0),
              (e.falsy = !0),
              this.accept(e),
              this.opcode(
                "invokeHelper",
                d.length,
                e.original,
                o["default"].helpers.simpleId(e)
              );
          }
        },
        PathExpression: function (a) {
          this.addDepth(a.depth), this.opcode("getContext", a.depth);
          var b = a.parts[0],
            c = o["default"].helpers.scopedId(a),
            d = !a.depth && !c && this.blockParamIndex(b);
          d
            ? this.opcode("lookupBlockParam", d, a.parts)
            : b
            ? a.data
              ? ((this.options.data = !0),
                this.opcode("lookupData", a.depth, a.parts, a.strict))
              : this.opcode("lookupOnContext", a.parts, a.falsy, a.strict, c)
            : this.opcode("pushContext");
        },
        StringLiteral: function (a) {
          this.opcode("pushString", a.value);
        },
        NumberLiteral: function (a) {
          this.opcode("pushLiteral", a.value);
        },
        BooleanLiteral: function (a) {
          this.opcode("pushLiteral", a.value);
        },
        UndefinedLiteral: function () {
          this.opcode("pushLiteral", "undefined");
        },
        NullLiteral: function () {
          this.opcode("pushLiteral", "null");
        },
        Hash: function (a) {
          var b = a.pairs,
            c = 0,
            d = b.length;
          for (this.opcode("pushHash"); c < d; c++) this.pushParam(b[c].value);
          for (; c--; ) this.opcode("assignToHash", b[c].key);
          this.opcode("popHash");
        },
        opcode: function (a) {
          this.opcodes.push({
            opcode: a,
            args: p.call(arguments, 1),
            loc: this.sourceNode[0].loc,
          });
        },
        addDepth: function (a) {
          a && (this.useDepths = !0);
        },
        classifySexpr: function (a) {
          var b = o["default"].helpers.simpleId(a.path),
            c = b && !!this.blockParamIndex(a.path.parts[0]),
            d = !c && o["default"].helpers.helperExpression(a),
            e = !c && (d || b);
          if (e && !d) {
            var f = a.path.parts[0],
              g = this.options;
            g.knownHelpers[f] ? (d = !0) : g.knownHelpersOnly && (e = !1);
          }
          return d ? "helper" : e ? "ambiguous" : "simple";
        },
        pushParams: function (a) {
          for (var b = 0, c = a.length; b < c; b++) this.pushParam(a[b]);
        },
        pushParam: function (a) {
          var b = null != a.value ? a.value : a.original || "";
          if (this.stringParams)
            b.replace &&
              (b = b.replace(/^(\.?\.\/)*/g, "").replace(/\//g, ".")),
              a.depth && this.addDepth(a.depth),
              this.opcode("getContext", a.depth || 0),
              this.opcode("pushStringParam", b, a.type),
              "SubExpression" === a.type && this.accept(a);
          else {
            if (this.trackIds) {
              var c = void 0;
              if (
                (!a.parts ||
                  o["default"].helpers.scopedId(a) ||
                  a.depth ||
                  (c = this.blockParamIndex(a.parts[0])),
                c)
              ) {
                var d = a.parts.slice(1).join(".");
                this.opcode("pushId", "BlockParam", c, d);
              } else
                (b = a.original || b),
                  b.replace &&
                    (b = b
                      .replace(/^this(?:\.|$)/, "")
                      .replace(/^\.\//, "")
                      .replace(/^\.$/, "")),
                  this.opcode("pushId", a.type, b);
            }
            this.accept(a);
          }
        },
        setupFullMustacheParams: function (a, b, c, d) {
          var e = a.params;
          return (
            this.pushParams(e),
            this.opcode("pushProgram", b),
            this.opcode("pushProgram", c),
            a.hash ? this.accept(a.hash) : this.opcode("emptyHash", d),
            e
          );
        },
        blockParamIndex: function (a) {
          for (var b = 0, c = this.options.blockParams.length; b < c; b++) {
            var d = this.options.blockParams[b],
              e = d && m.indexOf(d, a);
            if (d && e >= 0) return [b, e];
          }
        },
      };
    },
    function (a, b, c) {
      "use strict";
      function d(a) {
        this.value = a;
      }
      function e() {}
      function f(a, b, c, d) {
        var e = b.popStack(),
          f = 0,
          g = c.length;
        for (a && g--; f < g; f++) e = b.nameLookup(e, c[f], d);
        return a
          ? [
              b.aliasable("container.strict"),
              "(",
              e,
              ", ",
              b.quotedString(c[f]),
              ", ",
              JSON.stringify(b.source.currentLocation),
              " )",
            ]
          : e;
      }
      var g = c(13)["default"],
        h = c(1)["default"];
      b.__esModule = !0;
      var i = c(4),
        j = c(6),
        k = h(j),
        l = c(5),
        m = c(53),
        n = h(m);
      (e.prototype = {
        nameLookup: function (a, b) {
          return this.internalNameLookup(a, b);
        },
        depthedLookup: function (a) {
          return [this.aliasable("container.lookup"), '(depths, "', a, '")'];
        },
        compilerInfo: function () {
          var a = i.COMPILER_REVISION,
            b = i.REVISION_CHANGES[a];
          return [a, b];
        },
        appendToBuffer: function (a, b, c) {
          return (
            l.isArray(a) || (a = [a]),
            (a = this.source.wrap(a, b)),
            this.environment.isSimple
              ? ["return ", a, ";"]
              : c
              ? ["buffer += ", a, ";"]
              : ((a.appendToBuffer = !0), a)
          );
        },
        initializeBuffer: function () {
          return this.quotedString("");
        },
        internalNameLookup: function (a, b) {
          return (
            (this.lookupPropertyFunctionIsUsed = !0),
            ["lookupProperty(", a, ",", JSON.stringify(b), ")"]
          );
        },
        lookupPropertyFunctionIsUsed: !1,
        compile: function (a, b, c, d) {
          (this.environment = a),
            (this.options = b),
            (this.stringParams = this.options.stringParams),
            (this.trackIds = this.options.trackIds),
            (this.precompile = !d),
            (this.name = this.environment.name),
            (this.isChild = !!c),
            (this.context = c || {
              decorators: [],
              programs: [],
              environments: [],
            }),
            this.preamble(),
            (this.stackSlot = 0),
            (this.stackVars = []),
            (this.aliases = {}),
            (this.registers = { list: [] }),
            (this.hashes = []),
            (this.compileStack = []),
            (this.inlineStack = []),
            (this.blockParams = []),
            this.compileChildren(a, b),
            (this.useDepths =
              this.useDepths ||
              a.useDepths ||
              a.useDecorators ||
              this.options.compat),
            (this.useBlockParams = this.useBlockParams || a.useBlockParams);
          var e = a.opcodes,
            f = void 0,
            g = void 0,
            h = void 0,
            i = void 0;
          for (h = 0, i = e.length; h < i; h++)
            (f = e[h]),
              (this.source.currentLocation = f.loc),
              (g = g || f.loc),
              this[f.opcode].apply(this, f.args);
          if (
            ((this.source.currentLocation = g),
            this.pushSource(""),
            this.stackSlot ||
              this.inlineStack.length ||
              this.compileStack.length)
          )
            throw new k["default"](
              "Compile completed with content left on stack"
            );
          this.decorators.isEmpty()
            ? (this.decorators = void 0)
            : ((this.useDecorators = !0),
              this.decorators.prepend([
                "var decorators = container.decorators, ",
                this.lookupPropertyFunctionVarDeclaration(),
                ";\n",
              ]),
              this.decorators.push("return fn;"),
              d
                ? (this.decorators = Function.apply(this, [
                    "fn",
                    "props",
                    "container",
                    "depth0",
                    "data",
                    "blockParams",
                    "depths",
                    this.decorators.merge(),
                  ]))
                : (this.decorators.prepend(
                    "function(fn, props, container, depth0, data, blockParams, depths) {\n"
                  ),
                  this.decorators.push("}\n"),
                  (this.decorators = this.decorators.merge())));
          var j = this.createFunctionContext(d);
          if (this.isChild) return j;
          var l = { compiler: this.compilerInfo(), main: j };
          this.decorators &&
            ((l.main_d = this.decorators), (l.useDecorators = !0));
          var m = this.context,
            n = m.programs,
            o = m.decorators;
          for (h = 0, i = n.length; h < i; h++)
            n[h] &&
              ((l[h] = n[h]),
              o[h] && ((l[h + "_d"] = o[h]), (l.useDecorators = !0)));
          return (
            this.environment.usePartial && (l.usePartial = !0),
            this.options.data && (l.useData = !0),
            this.useDepths && (l.useDepths = !0),
            this.useBlockParams && (l.useBlockParams = !0),
            this.options.compat && (l.compat = !0),
            d
              ? (l.compilerOptions = this.options)
              : ((l.compiler = JSON.stringify(l.compiler)),
                (this.source.currentLocation = {
                  start: { line: 1, column: 0 },
                }),
                (l = this.objectLiteral(l)),
                b.srcName
                  ? ((l = l.toStringWithSourceMap({ file: b.destName })),
                    (l.map = l.map && l.map.toString()))
                  : (l = l.toString())),
            l
          );
        },
        preamble: function () {
          (this.lastContext = 0),
            (this.source = new n["default"](this.options.srcName)),
            (this.decorators = new n["default"](this.options.srcName));
        },
        createFunctionContext: function (a) {
          var b = this,
            c = "",
            d = this.stackVars.concat(this.registers.list);
          d.length > 0 && (c += ", " + d.join(", "));
          var e = 0;
          g(this.aliases).forEach(function (a) {
            var d = b.aliases[a];
            d.children &&
              d.referenceCount > 1 &&
              ((c += ", alias" + ++e + "=" + a), (d.children[0] = "alias" + e));
          }),
            this.lookupPropertyFunctionIsUsed &&
              (c += ", " + this.lookupPropertyFunctionVarDeclaration());
          var f = ["container", "depth0", "helpers", "partials", "data"];
          (this.useBlockParams || this.useDepths) && f.push("blockParams"),
            this.useDepths && f.push("depths");
          var h = this.mergeSource(c);
          return a
            ? (f.push(h), Function.apply(this, f))
            : this.source.wrap(["function(", f.join(","), ") {\n  ", h, "}"]);
        },
        mergeSource: function (a) {
          var b = this.environment.isSimple,
            c = !this.forceBuffer,
            d = void 0,
            e = void 0,
            f = void 0,
            g = void 0;
          return (
            this.source.each(function (a) {
              a.appendToBuffer
                ? (f ? a.prepend("  + ") : (f = a), (g = a))
                : (f &&
                    (e ? f.prepend("buffer += ") : (d = !0),
                    g.add(";"),
                    (f = g = void 0)),
                  (e = !0),
                  b || (c = !1));
            }),
            c
              ? f
                ? (f.prepend("return "), g.add(";"))
                : e || this.source.push('return "";')
              : ((a += ", buffer = " + (d ? "" : this.initializeBuffer())),
                f
                  ? (f.prepend("return buffer + "), g.add(";"))
                  : this.source.push("return buffer;")),
            a &&
              this.source.prepend("var " + a.substring(2) + (d ? "" : ";\n")),
            this.source.merge()
          );
        },
        lookupPropertyFunctionVarDeclaration: function () {
          return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim();
        },
        blockValue: function (a) {
          var b = this.aliasable("container.hooks.blockHelperMissing"),
            c = [this.contextName(0)];
          this.setupHelperArgs(a, 0, c);
          var d = this.popStack();
          c.splice(1, 0, d), this.push(this.source.functionCall(b, "call", c));
        },
        ambiguousBlockValue: function () {
          var a = this.aliasable("container.hooks.blockHelperMissing"),
            b = [this.contextName(0)];
          this.setupHelperArgs("", 0, b, !0), this.flushInline();
          var c = this.topStack();
          b.splice(1, 0, c),
            this.pushSource([
              "if (!",
              this.lastHelper,
              ") { ",
              c,
              " = ",
              this.source.functionCall(a, "call", b),
              "}",
            ]);
        },
        appendContent: function (a) {
          this.pendingContent
            ? (a = this.pendingContent + a)
            : (this.pendingLocation = this.source.currentLocation),
            (this.pendingContent = a);
        },
        append: function () {
          if (this.isInline())
            this.replaceStack(function (a) {
              return [" != null ? ", a, ' : ""'];
            }),
              this.pushSource(this.appendToBuffer(this.popStack()));
          else {
            var a = this.popStack();
            this.pushSource([
              "if (",
              a,
              " != null) { ",
              this.appendToBuffer(a, void 0, !0),
              " }",
            ]),
              this.environment.isSimple &&
                this.pushSource([
                  "else { ",
                  this.appendToBuffer("''", void 0, !0),
                  " }",
                ]);
          }
        },
        appendEscaped: function () {
          this.pushSource(
            this.appendToBuffer([
              this.aliasable("container.escapeExpression"),
              "(",
              this.popStack(),
              ")",
            ])
          );
        },
        getContext: function (a) {
          this.lastContext = a;
        },
        pushContext: function () {
          this.pushStackLiteral(this.contextName(this.lastContext));
        },
        lookupOnContext: function (a, b, c, d) {
          var e = 0;
          d || !this.options.compat || this.lastContext
            ? this.pushContext()
            : this.push(this.depthedLookup(a[e++])),
            this.resolvePath("context", a, e, b, c);
        },
        lookupBlockParam: function (a, b) {
          (this.useBlockParams = !0),
            this.push(["blockParams[", a[0], "][", a[1], "]"]),
            this.resolvePath("context", b, 1);
        },
        lookupData: function (a, b, c) {
          a
            ? this.pushStackLiteral("container.data(data, " + a + ")")
            : this.pushStackLiteral("data"),
            this.resolvePath("data", b, 0, !0, c);
        },
        resolvePath: function (a, b, c, d, e) {
          var g = this;
          if (this.options.strict || this.options.assumeObjects)
            return void this.push(f(this.options.strict && e, this, b, a));
          for (var h = b.length; c < h; c++)
            this.replaceStack(function (e) {
              var f = g.nameLookup(e, b[c], a);
              return d ? [" && ", f] : [" != null ? ", f, " : ", e];
            });
        },
        resolvePossibleLambda: function () {
          this.push([
            this.aliasable("container.lambda"),
            "(",
            this.popStack(),
            ", ",
            this.contextName(0),
            ")",
          ]);
        },
        pushStringParam: function (a, b) {
          this.pushContext(),
            this.pushString(b),
            "SubExpression" !== b &&
              ("string" == typeof a
                ? this.pushString(a)
                : this.pushStackLiteral(a));
        },
        emptyHash: function (a) {
          this.trackIds && this.push("{}"),
            this.stringParams && (this.push("{}"), this.push("{}")),
            this.pushStackLiteral(a ? "undefined" : "{}");
        },
        pushHash: function () {
          this.hash && this.hashes.push(this.hash),
            (this.hash = { values: {}, types: [], contexts: [], ids: [] });
        },
        popHash: function () {
          var a = this.hash;
          (this.hash = this.hashes.pop()),
            this.trackIds && this.push(this.objectLiteral(a.ids)),
            this.stringParams &&
              (this.push(this.objectLiteral(a.contexts)),
              this.push(this.objectLiteral(a.types))),
            this.push(this.objectLiteral(a.values));
        },
        pushString: function (a) {
          this.pushStackLiteral(this.quotedString(a));
        },
        pushLiteral: function (a) {
          this.pushStackLiteral(a);
        },
        pushProgram: function (a) {
          null != a
            ? this.pushStackLiteral(this.programExpression(a))
            : this.pushStackLiteral(null);
        },
        registerDecorator: function (a, b) {
          var c = this.nameLookup("decorators", b, "decorator"),
            d = this.setupHelperArgs(b, a);
          this.decorators.push([
            "fn = ",
            this.decorators.functionCall(c, "", [
              "fn",
              "props",
              "container",
              d,
            ]),
            " || fn;",
          ]);
        },
        invokeHelper: function (a, b, c) {
          var d = this.popStack(),
            e = this.setupHelper(a, b),
            f = [];
          c && f.push(e.name),
            f.push(d),
            this.options.strict ||
              f.push(this.aliasable("container.hooks.helperMissing"));
          var g = ["(", this.itemsSeparatedBy(f, "||"), ")"],
            h = this.source.functionCall(g, "call", e.callParams);
          this.push(h);
        },
        itemsSeparatedBy: function (a, b) {
          var c = [];
          c.push(a[0]);
          for (var d = 1; d < a.length; d++) c.push(b, a[d]);
          return c;
        },
        invokeKnownHelper: function (a, b) {
          var c = this.setupHelper(a, b);
          this.push(this.source.functionCall(c.name, "call", c.callParams));
        },
        invokeAmbiguous: function (a, b) {
          this.useRegister("helper");
          var c = this.popStack();
          this.emptyHash();
          var d = this.setupHelper(0, a, b),
            e = (this.lastHelper = this.nameLookup("helpers", a, "helper")),
            f = ["(", "(helper = ", e, " || ", c, ")"];
          this.options.strict ||
            ((f[0] = "(helper = "),
            f.push(
              " != null ? helper : ",
              this.aliasable("container.hooks.helperMissing")
            )),
            this.push([
              "(",
              f,
              d.paramsInit ? ["),(", d.paramsInit] : [],
              "),",
              "(typeof helper === ",
              this.aliasable('"function"'),
              " ? ",
              this.source.functionCall("helper", "call", d.callParams),
              " : helper))",
            ]);
        },
        invokePartial: function (a, b, c) {
          var d = [],
            e = this.setupParams(b, 1, d);
          a && ((b = this.popStack()), delete e.name),
            c && (e.indent = JSON.stringify(c)),
            (e.helpers = "helpers"),
            (e.partials = "partials"),
            (e.decorators = "container.decorators"),
            a
              ? d.unshift(b)
              : d.unshift(this.nameLookup("partials", b, "partial")),
            this.options.compat && (e.depths = "depths"),
            (e = this.objectLiteral(e)),
            d.push(e),
            this.push(
              this.source.functionCall("container.invokePartial", "", d)
            );
        },
        assignToHash: function (a) {
          var b = this.popStack(),
            c = void 0,
            d = void 0,
            e = void 0;
          this.trackIds && (e = this.popStack()),
            this.stringParams && ((d = this.popStack()), (c = this.popStack()));
          var f = this.hash;
          c && (f.contexts[a] = c),
            d && (f.types[a] = d),
            e && (f.ids[a] = e),
            (f.values[a] = b);
        },
        pushId: function (a, b, c) {
          "BlockParam" === a
            ? this.pushStackLiteral(
                "blockParams[" +
                  b[0] +
                  "].path[" +
                  b[1] +
                  "]" +
                  (c ? " + " + JSON.stringify("." + c) : "")
              )
            : "PathExpression" === a
            ? this.pushString(b)
            : "SubExpression" === a
            ? this.pushStackLiteral("true")
            : this.pushStackLiteral("null");
        },
        compiler: e,
        compileChildren: function (a, b) {
          for (
            var c = a.children, d = void 0, e = void 0, f = 0, g = c.length;
            f < g;
            f++
          ) {
            (d = c[f]), (e = new this.compiler());
            var h = this.matchExistingProgram(d);
            if (null == h) {
              this.context.programs.push("");
              var i = this.context.programs.length;
              (d.index = i),
                (d.name = "program" + i),
                (this.context.programs[i] = e.compile(
                  d,
                  b,
                  this.context,
                  !this.precompile
                )),
                (this.context.decorators[i] = e.decorators),
                (this.context.environments[i] = d),
                (this.useDepths = this.useDepths || e.useDepths),
                (this.useBlockParams = this.useBlockParams || e.useBlockParams),
                (d.useDepths = this.useDepths),
                (d.useBlockParams = this.useBlockParams);
            } else
              (d.index = h.index),
                (d.name = "program" + h.index),
                (this.useDepths = this.useDepths || h.useDepths),
                (this.useBlockParams = this.useBlockParams || h.useBlockParams);
          }
        },
        matchExistingProgram: function (a) {
          for (var b = 0, c = this.context.environments.length; b < c; b++) {
            var d = this.context.environments[b];
            if (d && d.equals(a)) return d;
          }
        },
        programExpression: function (a) {
          var b = this.environment.children[a],
            c = [b.index, "data", b.blockParams];
          return (
            (this.useBlockParams || this.useDepths) && c.push("blockParams"),
            this.useDepths && c.push("depths"),
            "container.program(" + c.join(", ") + ")"
          );
        },
        useRegister: function (a) {
          this.registers[a] ||
            ((this.registers[a] = !0), this.registers.list.push(a));
        },
        push: function (a) {
          return (
            a instanceof d || (a = this.source.wrap(a)),
            this.inlineStack.push(a),
            a
          );
        },
        pushStackLiteral: function (a) {
          this.push(new d(a));
        },
        pushSource: function (a) {
          this.pendingContent &&
            (this.source.push(
              this.appendToBuffer(
                this.source.quotedString(this.pendingContent),
                this.pendingLocation
              )
            ),
            (this.pendingContent = void 0)),
            a && this.source.push(a);
        },
        replaceStack: function (a) {
          var b = ["("],
            c = void 0,
            e = void 0,
            f = void 0;
          if (!this.isInline())
            throw new k["default"]("replaceStack on non-inline");
          var g = this.popStack(!0);
          if (g instanceof d) (c = [g.value]), (b = ["(", c]), (f = !0);
          else {
            e = !0;
            var h = this.incrStack();
            (b = ["((", this.push(h), " = ", g, ")"]), (c = this.topStack());
          }
          var i = a.call(this, c);
          f || this.popStack(),
            e && this.stackSlot--,
            this.push(b.concat(i, ")"));
        },
        incrStack: function () {
          return (
            this.stackSlot++,
            this.stackSlot > this.stackVars.length &&
              this.stackVars.push("stack" + this.stackSlot),
            this.topStackName()
          );
        },
        topStackName: function () {
          return "stack" + this.stackSlot;
        },
        flushInline: function () {
          var a = this.inlineStack;
          this.inlineStack = [];
          for (var b = 0, c = a.length; b < c; b++) {
            var e = a[b];
            if (e instanceof d) this.compileStack.push(e);
            else {
              var f = this.incrStack();
              this.pushSource([f, " = ", e, ";"]), this.compileStack.push(f);
            }
          }
        },
        isInline: function () {
          return this.inlineStack.length;
        },
        popStack: function (a) {
          var b = this.isInline(),
            c = (b ? this.inlineStack : this.compileStack).pop();
          if (!a && c instanceof d) return c.value;
          if (!b) {
            if (!this.stackSlot) throw new k["default"]("Invalid stack pop");
            this.stackSlot--;
          }
          return c;
        },
        topStack: function () {
          var a = this.isInline() ? this.inlineStack : this.compileStack,
            b = a[a.length - 1];
          return b instanceof d ? b.value : b;
        },
        contextName: function (a) {
          return this.useDepths && a ? "depths[" + a + "]" : "depth" + a;
        },
        quotedString: function (a) {
          return this.source.quotedString(a);
        },
        objectLiteral: function (a) {
          return this.source.objectLiteral(a);
        },
        aliasable: function (a) {
          var b = this.aliases[a];
          return b
            ? (b.referenceCount++, b)
            : ((b = this.aliases[a] = this.source.wrap(a)),
              (b.aliasable = !0),
              (b.referenceCount = 1),
              b);
        },
        setupHelper: function (a, b, c) {
          var d = [],
            e = this.setupHelperArgs(b, a, d, c),
            f = this.nameLookup("helpers", b, "helper"),
            g = this.aliasable(
              this.contextName(0) +
                " != null ? " +
                this.contextName(0) +
                " : (container.nullContext || {})"
            );
          return {
            params: d,
            paramsInit: e,
            name: f,
            callParams: [g].concat(d),
          };
        },
        setupParams: function (a, b, c) {
          var d = {},
            e = [],
            f = [],
            g = [],
            h = !c,
            i = void 0;
          h && (c = []),
            (d.name = this.quotedString(a)),
            (d.hash = this.popStack()),
            this.trackIds && (d.hashIds = this.popStack()),
            this.stringParams &&
              ((d.hashTypes = this.popStack()),
              (d.hashContexts = this.popStack()));
          var j = this.popStack(),
            k = this.popStack();
          (k || j) &&
            ((d.fn = k || "container.noop"),
            (d.inverse = j || "container.noop"));
          for (var l = b; l--; )
            (i = this.popStack()),
              (c[l] = i),
              this.trackIds && (g[l] = this.popStack()),
              this.stringParams &&
                ((f[l] = this.popStack()), (e[l] = this.popStack()));
          return (
            h && (d.args = this.source.generateArray(c)),
            this.trackIds && (d.ids = this.source.generateArray(g)),
            this.stringParams &&
              ((d.types = this.source.generateArray(f)),
              (d.contexts = this.source.generateArray(e))),
            this.options.data && (d.data = "data"),
            this.useBlockParams && (d.blockParams = "blockParams"),
            d
          );
        },
        setupHelperArgs: function (a, b, c, d) {
          var e = this.setupParams(a, b, c);
          return (
            (e.loc = JSON.stringify(this.source.currentLocation)),
            (e = this.objectLiteral(e)),
            d
              ? (this.useRegister("options"),
                c.push("options"),
                ["options=", e])
              : c
              ? (c.push(e), "")
              : e
          );
        },
      }),
        (function () {
          for (
            var a =
                "break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(
                  " "
                ),
              b = (e.RESERVED_WORDS = {}),
              c = 0,
              d = a.length;
            c < d;
            c++
          )
            b[a[c]] = !0;
        })(),
        (e.isValidJavaScriptVariableName = function (a) {
          return !e.RESERVED_WORDS[a] && /^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(a);
        }),
        (b["default"] = e),
        (a.exports = b["default"]);
    },
    function (a, b, c) {
      "use strict";
      function d(a, b, c) {
        if (g.isArray(a)) {
          for (var d = [], e = 0, f = a.length; e < f; e++)
            d.push(b.wrap(a[e], c));
          return d;
        }
        return "boolean" == typeof a || "number" == typeof a ? a + "" : a;
      }
      function e(a) {
        (this.srcFile = a), (this.source = []);
      }
      var f = c(13)["default"];
      b.__esModule = !0;
      var g = c(5),
        h = void 0;
      try {
      } catch (i) {}
      h ||
        ((h = function (a, b, c, d) {
          (this.src = ""), d && this.add(d);
        }),
        (h.prototype = {
          add: function (a) {
            g.isArray(a) && (a = a.join("")), (this.src += a);
          },
          prepend: function (a) {
            g.isArray(a) && (a = a.join("")), (this.src = a + this.src);
          },
          toStringWithSourceMap: function () {
            return { code: this.toString() };
          },
          toString: function () {
            return this.src;
          },
        })),
        (e.prototype = {
          isEmpty: function () {
            return !this.source.length;
          },
          prepend: function (a, b) {
            this.source.unshift(this.wrap(a, b));
          },
          push: function (a, b) {
            this.source.push(this.wrap(a, b));
          },
          merge: function () {
            var a = this.empty();
            return (
              this.each(function (b) {
                a.add(["  ", b, "\n"]);
              }),
              a
            );
          },
          each: function (a) {
            for (var b = 0, c = this.source.length; b < c; b++)
              a(this.source[b]);
          },
          empty: function () {
            var a = this.currentLocation || { start: {} };
            return new h(a.start.line, a.start.column, this.srcFile);
          },
          wrap: function (a) {
            var b =
              arguments.length <= 1 || void 0 === arguments[1]
                ? this.currentLocation || { start: {} }
                : arguments[1];
            return a instanceof h
              ? a
              : ((a = d(a, this, b)),
                new h(b.start.line, b.start.column, this.srcFile, a));
          },
          functionCall: function (a, b, c) {
            return (
              (c = this.generateList(c)),
              this.wrap([a, b ? "." + b + "(" : "(", c, ")"])
            );
          },
          quotedString: function (a) {
            return (
              '"' +
              (a + "")
                .replace(/\\/g, "\\\\")
                .replace(/"/g, '\\"')
                .replace(/\n/g, "\\n")
                .replace(/\r/g, "\\r")
                .replace(/\u2028/g, "\\u2028")
                .replace(/\u2029/g, "\\u2029") +
              '"'
            );
          },
          objectLiteral: function (a) {
            var b = this,
              c = [];
            f(a).forEach(function (e) {
              var f = d(a[e], b);
              "undefined" !== f && c.push([b.quotedString(e), ":", f]);
            });
            var e = this.generateList(c);
            return e.prepend("{"), e.add("}"), e;
          },
          generateList: function (a) {
            for (var b = this.empty(), c = 0, e = a.length; c < e; c++)
              c && b.add(","), b.add(d(a[c], this));
            return b;
          },
          generateArray: function (a) {
            var b = this.generateList(a);
            return b.prepend("["), b.add("]"), b;
          },
        }),
        (b["default"] = e),
        (a.exports = b["default"]);
    },
  ]);
});

/*
 * Uglipop 1.0.0
 * http://flouthoc.github.io/uglipop.js/
 * License MIT
 */
(function (f, a) {
  function g(b, a, c) {
    b.addEventListener
      ? b.addEventListener(a, c)
      : b.attachEvent("on" + a, function () {
          c.call(b);
        });
  }
  function k(b) {
    b &&
      ("string" == typeof b["class"] &&
        b["class"] &&
        a.getElementById("uglipop_popbox").setAttribute("class", b["class"]),
      b.keepLayout &&
        !b["class"] &&
        a
          .getElementById("uglipop_popbox")
          .setAttribute(
            "style",
            "position:relative;height:300px;width:300px;background-color:white;opacity:1;"
          ),
      "string" == typeof b.content &&
        b.content &&
        "html" == b.source &&
        (a.getElementById("uglipop_popbox").innerHTML = b.content),
      "string" == typeof b.content &&
        b.content &&
        "div" == b.source &&
        (a.getElementById("uglipop_popbox").innerHTML = a.getElementById(
          b.content
        ).innerHTML));
    a.getElementById("uglipop_overlay_wrapper").style.display = "";
    a.getElementById("uglipop_overlay").style.display = "";
    a.getElementById("uglipop_content_fixed").style.display = "";
  }
  function h() {
    a.getElementById("uglipop_overlay_wrapper").style.display = "none";
    a.getElementById("uglipop_overlay").style.display = "none";
    a.getElementById("uglipop_content_fixed").style.display = "none";
  }
  g(a, "DOMContentLoaded", function () {
    var b = a.createElement("div"),
      e = a.createElement("div"),
      c = a.createElement("div"),
      d = a.createElement("div");
    e.id = "uglipop_content_fixed";
    e.setAttribute(
      "style",
      "position:fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);-webkit-transform: translate(-50%, -50%);-ms-transform: translate(-50%, -50%);opacity:1;"
    );
    c.id = "uglipop_popbox";
    d.id = "uglipop_overlay_wrapper";
    d.setAttribute("style", "position:absolute;top:0;bottom:0;left:0;right:0;");
    b.id = "uglipop_overlay";
    b.setAttribute(
      "style",
      "position:fixed;top:0;bottom:0;left:0;right:0;opacity:0.3;width:100%;height:100%;background-color:black;"
    );
    d.appendChild(b);
    e.appendChild(c);
    a.body.appendChild(d);
    a.body.appendChild(e);
    a.getElementById("uglipop_overlay_wrapper").style.display = "none";
    a.getElementById("uglipop_overlay").style.display = "none";
    a.getElementById("uglipop_content_fixed").style.display = "none";
    d.addEventListener("click", h);
    g(f, "keydown", function (a) {
      27 == a.keyCode && h();
    });
    f.uglipop = k;
  });
})(window, document);

/*!
 * The Final Countdown for jQuery v2.2.0 (http://hilios.github.io/jQuery.countdown/)
 * Copyright (c) 2016 Edson Hilios
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy of
 * this software and associated documentation files (the "Software"), to deal in
 * the Software without restriction, including without limitation the rights to
 * use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
 * the Software, and to permit persons to whom the Software is furnished to do so,
 * subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
 * FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
 * COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
 * IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
 * CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 */
!(function (a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery);
})(function (a) {
  "use strict";
  function b(a) {
    if (a instanceof Date) return a;
    if (String(a).match(g))
      return (
        String(a).match(/^[0-9]*$/) && (a = Number(a)),
        String(a).match(/\-/) && (a = String(a).replace(/\-/g, "/")),
        new Date(a)
      );
    throw new Error("Couldn't cast `" + a + "` to a date object.");
  }
  function c(a) {
    var b = a.toString().replace(/([.?*+^]\\(){}|-)/g, "\\$1");
    return new RegExp(b);
  }
  function d(a) {
    return function (b) {
      var d = b.match(/%(-|!)?[A-Z]{1}(:[^;]+;)?/gi);
      if (d)
        for (var f = 0, g = d.length; f < g; ++f) {
          var h = d[f].match(/%(-|!)?([a-zA-Z]{1})(:[^;]+;)?/),
            j = c(h[0]),
            k = h[1] || "",
            l = h[3] || "",
            m = null;
          (h = h[2]),
            i.hasOwnProperty(h) && ((m = i[h]), (m = Number(a[m]))),
            null !== m &&
              ("!" === k && (m = e(l, m)),
              "" === k && m < 10 && (m = "0" + m.toString()),
              (b = b.replace(j, m.toString())));
        }
      return (b = b.replace(/%%/, "%"));
    };
  }
  function e(a, b) {
    var c = "s",
      d = "";
    return (
      a &&
        ((a = a.replace(/(:|;|\s)/gi, "").split(/\,/)),
        1 === a.length ? (c = a[0]) : ((d = a[0]), (c = a[1]))),
      Math.abs(b) > 1 ? c : d
    );
  }
  var f = [],
    g = [],
    h = { precision: 100, elapse: !1, defer: !1 };
  g.push(/^[0-9]*$/.source),
    g.push(/([0-9]{1,2}\/){2}[0-9]{4}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    g.push(/[0-9]{4}([\/\-][0-9]{1,2}){2}( [0-9]{1,2}(:[0-9]{2}){2})?/.source),
    (g = new RegExp(g.join("|")));
  var i = {
      Y: "years",
      m: "months",
      n: "daysToMonth",
      d: "daysToWeek",
      w: "weeks",
      W: "weeksToMonth",
      H: "hours",
      M: "minutes",
      S: "seconds",
      D: "totalDays",
      I: "totalHours",
      N: "totalMinutes",
      T: "totalSeconds",
    },
    j = function (b, c, d) {
      (this.el = b),
        (this.$el = a(b)),
        (this.interval = null),
        (this.offset = {}),
        (this.options = a.extend({}, h)),
        (this.instanceNumber = f.length),
        f.push(this),
        this.$el.data("countdown-instance", this.instanceNumber),
        d &&
          ("function" == typeof d
            ? (this.$el.on("update.countdown", d),
              this.$el.on("stoped.countdown", d),
              this.$el.on("finish.countdown", d))
            : (this.options = a.extend({}, h, d))),
        this.setFinalDate(c),
        this.options.defer === !1 && this.start();
    };
  a.extend(j.prototype, {
    start: function () {
      null !== this.interval && clearInterval(this.interval);
      var a = this;
      this.update(),
        (this.interval = setInterval(function () {
          a.update.call(a);
        }, this.options.precision));
    },
    stop: function () {
      clearInterval(this.interval),
        (this.interval = null),
        this.dispatchEvent("stoped");
    },
    toggle: function () {
      this.interval ? this.stop() : this.start();
    },
    pause: function () {
      this.stop();
    },
    resume: function () {
      this.start();
    },
    remove: function () {
      this.stop.call(this),
        (f[this.instanceNumber] = null),
        delete this.$el.data().countdownInstance;
    },
    setFinalDate: function (a) {
      this.finalDate = b(a);
    },
    update: function () {
      if (0 === this.$el.closest("html").length) return void this.remove();
      var b,
        c = void 0 !== a._data(this.el, "events"),
        d = new Date();
      (b = this.finalDate.getTime() - d.getTime()),
        (b = Math.ceil(b / 1e3)),
        (b = !this.options.elapse && b < 0 ? 0 : Math.abs(b)),
        this.totalSecsLeft !== b &&
          c &&
          ((this.totalSecsLeft = b),
          (this.elapsed = d >= this.finalDate),
          (this.offset = {
            seconds: this.totalSecsLeft % 60,
            minutes: Math.floor(this.totalSecsLeft / 60) % 60,
            hours: Math.floor(this.totalSecsLeft / 60 / 60) % 24,
            days: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToWeek: Math.floor(this.totalSecsLeft / 60 / 60 / 24) % 7,
            daysToMonth: Math.floor(
              (this.totalSecsLeft / 60 / 60 / 24) % 30.4368
            ),
            weeks: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7),
            weeksToMonth: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 7) % 4,
            months: Math.floor(this.totalSecsLeft / 60 / 60 / 24 / 30.4368),
            years: Math.abs(this.finalDate.getFullYear() - d.getFullYear()),
            totalDays: Math.floor(this.totalSecsLeft / 60 / 60 / 24),
            totalHours: Math.floor(this.totalSecsLeft / 60 / 60),
            totalMinutes: Math.floor(this.totalSecsLeft / 60),
            totalSeconds: this.totalSecsLeft,
          }),
          this.options.elapse || 0 !== this.totalSecsLeft
            ? this.dispatchEvent("update")
            : (this.stop(), this.dispatchEvent("finish")));
    },
    dispatchEvent: function (b) {
      var c = a.Event(b + ".countdown");
      (c.finalDate = this.finalDate),
        (c.elapsed = this.elapsed),
        (c.offset = a.extend({}, this.offset)),
        (c.strftime = d(this.offset)),
        this.$el.trigger(c);
    },
  }),
    (a.fn.countdown = function () {
      var b = Array.prototype.slice.call(arguments, 0);
      return this.each(function () {
        var c = a(this).data("countdown-instance");
        if (void 0 !== c) {
          var d = f[c],
            e = b[0];
          j.prototype.hasOwnProperty(e)
            ? d[e].apply(d, b.slice(1))
            : null === String(e).match(/^[$A-Z_][0-9A-Z_$]*$/i)
            ? (d.setFinalDate.call(d, e), d.start())
            : a.error(
                "Method %s does not exist on jQuery.countdown".replace(
                  /\%s/gi,
                  e
                )
              );
        } else new j(this, b[0], b[1]);
      });
    });
});

// Cart.js
// version: 0.4.1
// author: Gavin Ballard
// license: MIT
(function () {
  // Public sightglass interface.
  function sightglass(obj, keypath, callback, options) {
    return new Observer(obj, keypath, callback, options);
  }

  // Batteries not included.
  sightglass.adapters = {};

  // Constructs a new keypath observer and kicks things off.
  function Observer(obj, keypath, callback, options) {
    this.options = options || {};
    this.options.adapters = this.options.adapters || {};
    this.obj = obj;
    this.keypath = keypath;
    this.callback = callback;
    this.objectPath = [];
    this.parse();

    if (isObject((this.target = this.realize()))) {
      this.set(true, this.key, this.target, this.callback);
    }
  }

  // Tokenizes the provided keypath string into interface + path tokens for the
  // observer to work with.
  Observer.tokenize = function (keypath, interfaces, root) {
    var tokens = [];
    var current = { i: root, path: "" };
    var index, chr;

    for (index = 0; index < keypath.length; index++) {
      chr = keypath.charAt(index);

      if (!!~interfaces.indexOf(chr)) {
        tokens.push(current);
        current = { i: chr, path: "" };
      } else {
        current.path += chr;
      }
    }

    tokens.push(current);
    return tokens;
  };

  // Parses the keypath using the interfaces defined on the view. Sets variables
  // for the tokenized keypath as well as the end key.
  Observer.prototype.parse = function () {
    var interfaces = this.interfaces();
    var root, path;

    if (!interfaces.length) {
      error("Must define at least one adapter interface.");
    }

    if (!!~interfaces.indexOf(this.keypath[0])) {
      root = this.keypath[0];
      path = this.keypath.substr(1);
    } else {
      if (
        typeof (root = this.options.root || sightglass.root) === "undefined"
      ) {
        error("Must define a default root adapter.");
      }

      path = this.keypath;
    }

    this.tokens = Observer.tokenize(path, interfaces, root);
    this.key = this.tokens.pop();
  };

  // Realizes the full keypath, attaching observers for every key and correcting
  // old observers to any changed objects in the keypath.
  Observer.prototype.realize = function () {
    var current = this.obj;
    var unreached = false;
    var prev;

    this.tokens.forEach(function (token, index) {
      if (isObject(current)) {
        if (typeof this.objectPath[index] !== "undefined") {
          if (current !== (prev = this.objectPath[index])) {
            this.set(false, token, prev, this.update.bind(this));
            this.set(true, token, current, this.update.bind(this));
            this.objectPath[index] = current;
          }
        } else {
          this.set(true, token, current, this.update.bind(this));
          this.objectPath[index] = current;
        }

        current = this.get(token, current);
      } else {
        if (unreached === false) {
          unreached = index;
        }

        if ((prev = this.objectPath[index])) {
          this.set(false, token, prev, this.update.bind(this));
        }
      }
    }, this);

    if (unreached !== false) {
      this.objectPath.splice(unreached);
    }

    return current;
  };

  // Updates the keypath. This is called when any intermediary key is changed.
  Observer.prototype.update = function () {
    var next, oldValue;

    if ((next = this.realize()) !== this.target) {
      if (isObject(this.target)) {
        this.set(false, this.key, this.target, this.callback);
      }

      if (isObject(next)) {
        this.set(true, this.key, next, this.callback);
      }

      oldValue = this.value();
      this.target = next;

      if (this.value() !== oldValue) this.callback();
    }
  };

  // Reads the current end value of the observed keypath. Returns undefined if
  // the full keypath is unreachable.
  Observer.prototype.value = function () {
    if (isObject(this.target)) {
      return this.get(this.key, this.target);
    }
  };

  // Sets the current end value of the observed keypath. Calling setValue when
  // the full keypath is unreachable is a no-op.
  Observer.prototype.setValue = function (value) {
    if (isObject(this.target)) {
      this.adapter(this.key).set(this.target, this.key.path, value);
    }
  };

  // Gets the provided key on an object.
  Observer.prototype.get = function (key, obj) {
    return this.adapter(key).get(obj, key.path);
  };

  // Observes or unobserves a callback on the object using the provided key.
  Observer.prototype.set = function (active, key, obj, callback) {
    var action = active ? "observe" : "unobserve";
    this.adapter(key)[action](obj, key.path, callback);
  };

  // Returns an array of all unique adapter interfaces available.
  Observer.prototype.interfaces = function () {
    var interfaces = Object.keys(this.options.adapters);

    Object.keys(sightglass.adapters).forEach(function (i) {
      if (!~interfaces.indexOf(i)) {
        interfaces.push(i);
      }
    });

    return interfaces;
  };

  // Convenience function to grab the adapter for a specific key.
  Observer.prototype.adapter = function (key) {
    return this.options.adapters[key.i] || sightglass.adapters[key.i];
  };

  // Unobserves the entire keypath.
  Observer.prototype.unobserve = function () {
    var obj;

    this.tokens.forEach(function (token, index) {
      if ((obj = this.objectPath[index])) {
        this.set(false, token, obj, this.update.bind(this));
      }
    }, this);

    if (isObject(this.target)) {
      this.set(false, this.key, this.target, this.callback);
    }
  };

  // Check if a value is an object than can be observed.
  function isObject(obj) {
    return typeof obj === "object" && obj !== null;
  }

  // Error thrower.
  function error(message) {
    throw new Error("[sightglass] " + message);
  }

  // Export module for Node and the browser.
  if (typeof module !== "undefined" && module.exports) {
    module.exports = sightglass;
  } else if (typeof define === "function" && define.amd) {
    define([], function () {
      return (this.sightglass = sightglass);
    });
  } else {
    this.sightglass = sightglass;
  }
}.call(this));

// Rivets.js
// version: 0.8.1
// author: Michael Richards
// license: MIT
(function () {
  var Rivets,
    bindMethod,
    unbindMethod,
    _ref,
    __bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    },
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function (child, parent) {
      for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    __indexOf =
      [].indexOf ||
      function (item) {
        for (var i = 0, l = this.length; i < l; i++) {
          if (i in this && this[i] === item) return i;
        }
        return -1;
      };

  Rivets = {
    options: [
      "prefix",
      "templateDelimiters",
      "rootInterface",
      "preloadData",
      "handler",
    ],
    extensions: ["binders", "formatters", "components", "adapters"],
    public: {
      binders: {},
      components: {},
      formatters: {},
      adapters: {},
      prefix: "rv",
      templateDelimiters: ["{", "}"],
      rootInterface: ".",
      preloadData: true,
      handler: function (context, ev, binding) {
        return this.call(context, ev, binding.view.models);
      },
      configure: function (options) {
        var descriptor, key, option, value;
        if (options == null) {
          options = {};
        }
        for (option in options) {
          value = options[option];
          if (
            option === "binders" ||
            option === "components" ||
            option === "formatters" ||
            option === "adapters"
          ) {
            for (key in value) {
              descriptor = value[key];
              Rivets[option][key] = descriptor;
            }
          } else {
            Rivets["public"][option] = value;
          }
        }
      },
      bind: function (el, models, options) {
        var view;
        if (models == null) {
          models = {};
        }
        if (options == null) {
          options = {};
        }
        view = new Rivets.View(el, models, options);
        view.bind();
        return view;
      },
      init: function (component, el, data) {
        var scope, view;
        if (data == null) {
          data = {};
        }
        if (el == null) {
          el = document.createElement("div");
        }
        component = Rivets["public"].components[component];
        el.innerHTML = component.template.call(this, el);
        scope = component.initialize.call(this, el, data);
        view = new Rivets.View(el, scope);
        view.bind();
        return view;
      },
    },
  };

  if (window["jQuery"] || window["$"]) {
    (_ref = "on" in jQuery.prototype ? ["on", "off"] : ["bind", "unbind"]),
      (bindMethod = _ref[0]),
      (unbindMethod = _ref[1]);
    Rivets.Util = {
      bindEvent: function (el, event, handler) {
        return jQuery(el)[bindMethod](event, handler);
      },
      unbindEvent: function (el, event, handler) {
        return jQuery(el)[unbindMethod](event, handler);
      },
      getInputValue: function (el) {
        var $el;
        $el = jQuery(el);
        if ($el.attr("type") === "checkbox") {
          return $el.is(":checked");
        } else {
          return $el.val();
        }
      },
    };
  } else {
    Rivets.Util = {
      bindEvent: (function () {
        if ("addEventListener" in window) {
          return function (el, event, handler) {
            return el.addEventListener(event, handler, false);
          };
        }
        return function (el, event, handler) {
          return el.attachEvent("on" + event, handler);
        };
      })(),
      unbindEvent: (function () {
        if ("removeEventListener" in window) {
          return function (el, event, handler) {
            return el.removeEventListener(event, handler, false);
          };
        }
        return function (el, event, handler) {
          return el.detachEvent("on" + event, handler);
        };
      })(),
      getInputValue: function (el) {
        var o, _i, _len, _results;
        if (el.type === "checkbox") {
          return el.checked;
        } else if (el.type === "select-multiple") {
          _results = [];
          for (_i = 0, _len = el.length; _i < _len; _i++) {
            o = el[_i];
            if (o.selected) {
              _results.push(o.value);
            }
          }
          return _results;
        } else {
          return el.value;
        }
      },
    };
  }

  Rivets.TypeParser = (function () {
    function TypeParser() {}

    TypeParser.types = {
      primitive: 0,
      keypath: 1,
    };

    TypeParser.parse = function (string) {
      if (/^'.*'$|^".*"$/.test(string)) {
        return {
          type: this.types.primitive,
          value: string.slice(1, -1),
        };
      } else if (string === "true") {
        return {
          type: this.types.primitive,
          value: true,
        };
      } else if (string === "false") {
        return {
          type: this.types.primitive,
          value: false,
        };
      } else if (string === "null") {
        return {
          type: this.types.primitive,
          value: null,
        };
      } else if (string === "undefined") {
        return {
          type: this.types.primitive,
          value: void 0,
        };
      } else if (isNaN(Number(string)) === false) {
        return {
          type: this.types.primitive,
          value: Number(string),
        };
      } else {
        return {
          type: this.types.keypath,
          value: string,
        };
      }
    };

    return TypeParser;
  })();

  Rivets.TextTemplateParser = (function () {
    function TextTemplateParser() {}

    TextTemplateParser.types = {
      text: 0,
      binding: 1,
    };

    TextTemplateParser.parse = function (template, delimiters) {
      var index, lastIndex, lastToken, length, substring, tokens, value;
      tokens = [];
      length = template.length;
      index = 0;
      lastIndex = 0;
      while (lastIndex < length) {
        index = template.indexOf(delimiters[0], lastIndex);
        if (index < 0) {
          tokens.push({
            type: this.types.text,
            value: template.slice(lastIndex),
          });
          break;
        } else {
          if (index > 0 && lastIndex < index) {
            tokens.push({
              type: this.types.text,
              value: template.slice(lastIndex, index),
            });
          }
          lastIndex = index + delimiters[0].length;
          index = template.indexOf(delimiters[1], lastIndex);
          if (index < 0) {
            substring = template.slice(lastIndex - delimiters[1].length);
            lastToken = tokens[tokens.length - 1];
            if (
              (lastToken != null ? lastToken.type : void 0) === this.types.text
            ) {
              lastToken.value += substring;
            } else {
              tokens.push({
                type: this.types.text,
                value: substring,
              });
            }
            break;
          }
          value = template.slice(lastIndex, index).trim();
          tokens.push({
            type: this.types.binding,
            value: value,
          });
          lastIndex = index + delimiters[1].length;
        }
      }
      return tokens;
    };

    return TextTemplateParser;
  })();

  Rivets.View = (function () {
    function View(els, models, options) {
      var k,
        option,
        v,
        _base,
        _i,
        _j,
        _len,
        _len1,
        _ref1,
        _ref2,
        _ref3,
        _ref4,
        _ref5;
      this.els = els;
      this.models = models;
      if (options == null) {
        options = {};
      }
      this.update = __bind(this.update, this);
      this.publish = __bind(this.publish, this);
      this.sync = __bind(this.sync, this);
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.select = __bind(this.select, this);
      this.traverse = __bind(this.traverse, this);
      this.build = __bind(this.build, this);
      this.buildBinding = __bind(this.buildBinding, this);
      this.bindingRegExp = __bind(this.bindingRegExp, this);
      this.options = __bind(this.options, this);
      if (!(this.els.jquery || this.els instanceof Array)) {
        this.els = [this.els];
      }
      _ref1 = Rivets.extensions;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        option = _ref1[_i];
        this[option] = {};
        if (options[option]) {
          _ref2 = options[option];
          for (k in _ref2) {
            v = _ref2[k];
            this[option][k] = v;
          }
        }
        _ref3 = Rivets["public"][option];
        for (k in _ref3) {
          v = _ref3[k];
          if ((_base = this[option])[k] == null) {
            _base[k] = v;
          }
        }
      }
      _ref4 = Rivets.options;
      for (_j = 0, _len1 = _ref4.length; _j < _len1; _j++) {
        option = _ref4[_j];
        this[option] =
          (_ref5 = options[option]) != null ? _ref5 : Rivets["public"][option];
      }
      this.build();
    }

    View.prototype.options = function () {
      var option, options, _i, _len, _ref1;
      options = {};
      _ref1 = Rivets.extensions.concat(Rivets.options);
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        option = _ref1[_i];
        options[option] = this[option];
      }
      return options;
    };

    View.prototype.bindingRegExp = function () {
      return new RegExp("^" + this.prefix + "-");
    };

    View.prototype.buildBinding = function (binding, node, type, declaration) {
      var context, ctx, dependencies, keypath, options, pipe, pipes;
      options = {};
      pipes = (function () {
        var _i, _len, _ref1, _results;
        _ref1 = declaration.split("|");
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          pipe = _ref1[_i];
          _results.push(pipe.trim());
        }
        return _results;
      })();
      context = (function () {
        var _i, _len, _ref1, _results;
        _ref1 = pipes.shift().split("<");
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          ctx = _ref1[_i];
          _results.push(ctx.trim());
        }
        return _results;
      })();
      keypath = context.shift();
      options.formatters = pipes;
      if ((dependencies = context.shift())) {
        options.dependencies = dependencies.split(/\s+/);
      }
      return this.bindings.push(
        new Rivets[binding](this, node, type, keypath, options)
      );
    };

    View.prototype.build = function () {
      var el, parse, _i, _len, _ref1;
      this.bindings = [];
      parse = (function (_this) {
        return function (node) {
          var block,
            childNode,
            delimiters,
            n,
            parser,
            text,
            token,
            tokens,
            _i,
            _j,
            _len,
            _len1,
            _ref1,
            _results;
          if (node.nodeType === 3) {
            parser = Rivets.TextTemplateParser;
            if ((delimiters = _this.templateDelimiters)) {
              if ((tokens = parser.parse(node.data, delimiters)).length) {
                if (
                  !(tokens.length === 1 && tokens[0].type === parser.types.text)
                ) {
                  for (_i = 0, _len = tokens.length; _i < _len; _i++) {
                    token = tokens[_i];
                    text = document.createTextNode(token.value);
                    node.parentNode.insertBefore(text, node);
                    if (token.type === 1) {
                      _this.buildBinding(
                        "TextBinding",
                        text,
                        null,
                        token.value
                      );
                    }
                  }
                  node.parentNode.removeChild(node);
                }
              }
            }
          } else if (node.nodeType === 1) {
            block = _this.traverse(node);
          }
          if (!block) {
            _ref1 = (function () {
              var _k, _len1, _ref1, _results1;
              _ref1 = node.childNodes;
              _results1 = [];
              for (_k = 0, _len1 = _ref1.length; _k < _len1; _k++) {
                n = _ref1[_k];
                _results1.push(n);
              }
              return _results1;
            })();
            _results = [];
            for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
              childNode = _ref1[_j];
              _results.push(parse(childNode));
            }
            return _results;
          }
        };
      })(this);
      _ref1 = this.els;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        el = _ref1[_i];
        parse(el);
      }
      this.bindings.sort(function (a, b) {
        var _ref2, _ref3;
        return (
          (((_ref2 = b.binder) != null ? _ref2.priority : void 0) || 0) -
          (((_ref3 = a.binder) != null ? _ref3.priority : void 0) || 0)
        );
      });
    };

    View.prototype.traverse = function (node) {
      var attribute,
        attributes,
        binder,
        bindingRegExp,
        block,
        identifier,
        regexp,
        type,
        value,
        _i,
        _j,
        _len,
        _len1,
        _ref1,
        _ref2,
        _ref3;
      bindingRegExp = this.bindingRegExp();
      block = node.nodeName === "SCRIPT" || node.nodeName === "STYLE";
      _ref1 = node.attributes;
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        attribute = _ref1[_i];
        if (bindingRegExp.test(attribute.name)) {
          type = attribute.name.replace(bindingRegExp, "");
          if (!(binder = this.binders[type])) {
            _ref2 = this.binders;
            for (identifier in _ref2) {
              value = _ref2[identifier];
              if (identifier !== "*" && identifier.indexOf("*") !== -1) {
                regexp = new RegExp(
                  "^" + identifier.replace(/\*/g, ".+") + "$"
                );
                if (regexp.test(type)) {
                  binder = value;
                }
              }
            }
          }
          binder || (binder = this.binders["*"]);
          if (binder.block) {
            block = true;
            attributes = [attribute];
          }
        }
      }
      _ref3 = attributes || node.attributes;
      for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
        attribute = _ref3[_j];
        if (bindingRegExp.test(attribute.name)) {
          type = attribute.name.replace(bindingRegExp, "");
          this.buildBinding("Binding", node, type, attribute.value);
        }
      }
      if (!block) {
        type = node.nodeName.toLowerCase();
        if (this.components[type] && !node._bound) {
          this.bindings.push(new Rivets.ComponentBinding(this, node, type));
          block = true;
        }
      }
      return block;
    };

    View.prototype.select = function (fn) {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        if (fn(binding)) {
          _results.push(binding);
        }
      }
      return _results;
    };

    View.prototype.bind = function () {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.bind());
      }
      return _results;
    };

    View.prototype.unbind = function () {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.unbind());
      }
      return _results;
    };

    View.prototype.sync = function () {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(
          typeof binding.sync === "function" ? binding.sync() : void 0
        );
      }
      return _results;
    };

    View.prototype.publish = function () {
      var binding, _i, _len, _ref1, _results;
      _ref1 = this.select(function (b) {
        var _ref1;
        return (_ref1 = b.binder) != null ? _ref1.publishes : void 0;
      });
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(binding.publish());
      }
      return _results;
    };

    View.prototype.update = function (models) {
      var binding, key, model, _i, _len, _ref1, _results;
      if (models == null) {
        models = {};
      }
      for (key in models) {
        model = models[key];
        this.models[key] = model;
      }
      _ref1 = this.bindings;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        binding = _ref1[_i];
        _results.push(
          typeof binding.update === "function" ? binding.update(models) : void 0
        );
      }
      return _results;
    };

    return View;
  })();

  Rivets.Binding = (function () {
    function Binding(view, el, type, keypath, options) {
      this.view = view;
      this.el = el;
      this.type = type;
      this.keypath = keypath;
      this.options = options != null ? options : {};
      this.getValue = __bind(this.getValue, this);
      this.update = __bind(this.update, this);
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.publish = __bind(this.publish, this);
      this.sync = __bind(this.sync, this);
      this.set = __bind(this.set, this);
      this.eventHandler = __bind(this.eventHandler, this);
      this.formattedValue = __bind(this.formattedValue, this);
      this.parseTarget = __bind(this.parseTarget, this);
      this.observe = __bind(this.observe, this);
      this.setBinder = __bind(this.setBinder, this);
      this.formatters = this.options.formatters || [];
      this.dependencies = [];
      this.formatterObservers = {};
      this.model = void 0;
      this.setBinder();
    }

    Binding.prototype.setBinder = function () {
      var identifier, regexp, value, _ref1;
      if (!(this.binder = this.view.binders[this.type])) {
        _ref1 = this.view.binders;
        for (identifier in _ref1) {
          value = _ref1[identifier];
          if (identifier !== "*" && identifier.indexOf("*") !== -1) {
            regexp = new RegExp("^" + identifier.replace(/\*/g, ".+") + "$");
            if (regexp.test(this.type)) {
              this.binder = value;
              this.args = new RegExp(
                "^" + identifier.replace(/\*/g, "(.+)") + "$"
              ).exec(this.type);
              this.args.shift();
            }
          }
        }
      }
      this.binder || (this.binder = this.view.binders["*"]);
      if (this.binder instanceof Function) {
        return (this.binder = {
          routine: this.binder,
        });
      }
    };

    Binding.prototype.observe = function (obj, keypath, callback) {
      return Rivets.sightglass(obj, keypath, callback, {
        root: this.view.rootInterface,
        adapters: this.view.adapters,
      });
    };

    Binding.prototype.parseTarget = function () {
      var token;
      token = Rivets.TypeParser.parse(this.keypath);
      if (token.type === 0) {
        return (this.value = token.value);
      } else {
        this.observer = this.observe(this.view.models, this.keypath, this.sync);
        return (this.model = this.observer.target);
      }
    };

    Binding.prototype.formattedValue = function (value) {
      var ai,
        arg,
        args,
        fi,
        formatter,
        id,
        observer,
        processedArgs,
        _base,
        _i,
        _j,
        _len,
        _len1,
        _ref1;
      _ref1 = this.formatters;
      for (fi = _i = 0, _len = _ref1.length; _i < _len; fi = ++_i) {
        formatter = _ref1[fi];
        args = formatter.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g);
        id = args.shift();
        formatter = this.view.formatters[id];
        args = (function () {
          var _j, _len1, _results;
          _results = [];
          for (_j = 0, _len1 = args.length; _j < _len1; _j++) {
            arg = args[_j];
            _results.push(Rivets.TypeParser.parse(arg));
          }
          return _results;
        })();
        processedArgs = [];
        for (ai = _j = 0, _len1 = args.length; _j < _len1; ai = ++_j) {
          arg = args[ai];
          processedArgs.push(
            arg.type === 0
              ? arg.value
              : ((_base = this.formatterObservers)[fi] || (_base[fi] = {}),
                !(observer = this.formatterObservers[fi][ai])
                  ? ((observer = this.observe(
                      this.view.models,
                      arg.value,
                      this.sync
                    )),
                    (this.formatterObservers[fi][ai] = observer))
                  : void 0,
                observer.value())
          );
        }
        if ((formatter != null ? formatter.read : void 0) instanceof Function) {
          value = formatter.read.apply(
            formatter,
            [value].concat(__slice.call(processedArgs))
          );
        } else if (formatter instanceof Function) {
          value = formatter.apply(
            null,
            [value].concat(__slice.call(processedArgs))
          );
        }
      }
      return value;
    };

    Binding.prototype.eventHandler = function (fn) {
      var binding, handler;
      handler = (binding = this).view.handler;
      return function (ev) {
        return handler.call(fn, this, ev, binding);
      };
    };

    Binding.prototype.set = function (value) {
      var _ref1;
      value =
        value instanceof Function && !this.binder["function"]
          ? this.formattedValue(value.call(this.model))
          : this.formattedValue(value);
      return (_ref1 = this.binder.routine) != null
        ? _ref1.call(this, this.el, value)
        : void 0;
    };

    Binding.prototype.sync = function () {
      var dependency, observer;
      return this.set(
        function () {
          var _i, _j, _len, _len1, _ref1, _ref2, _ref3;
          if (this.observer) {
            if (this.model !== this.observer.target) {
              _ref1 = this.dependencies;
              for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                observer = _ref1[_i];
                observer.unobserve();
              }
              this.dependencies = [];
              if (
                (this.model = this.observer.target) != null &&
                ((_ref2 = this.options.dependencies) != null
                  ? _ref2.length
                  : void 0)
              ) {
                _ref3 = this.options.dependencies;
                for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                  dependency = _ref3[_j];
                  observer = this.observe(this.model, dependency, this.sync);
                  this.dependencies.push(observer);
                }
              }
            }
            return this.observer.value();
          } else {
            return this.value;
          }
        }.call(this)
      );
    };

    Binding.prototype.publish = function () {
      var args, formatter, id, value, _i, _len, _ref1, _ref2, _ref3;
      if (this.observer) {
        value = this.getValue(this.el);
        _ref1 = this.formatters.slice(0).reverse();
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          formatter = _ref1[_i];
          args = formatter.split(/\s+/);
          id = args.shift();
          if (
            (_ref2 = this.view.formatters[id]) != null ? _ref2.publish : void 0
          ) {
            value = (_ref3 = this.view.formatters[id]).publish.apply(
              _ref3,
              [value].concat(__slice.call(args))
            );
          }
        }
        return this.observer.setValue(value);
      }
    };

    Binding.prototype.bind = function () {
      var dependency, observer, _i, _len, _ref1, _ref2, _ref3;
      this.parseTarget();
      if ((_ref1 = this.binder.bind) != null) {
        _ref1.call(this, this.el);
      }
      if (
        this.model != null &&
        ((_ref2 = this.options.dependencies) != null ? _ref2.length : void 0)
      ) {
        _ref3 = this.options.dependencies;
        for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
          dependency = _ref3[_i];
          observer = this.observe(this.model, dependency, this.sync);
          this.dependencies.push(observer);
        }
      }
      if (this.view.preloadData) {
        return this.sync();
      }
    };

    Binding.prototype.unbind = function () {
      var ai, args, fi, observer, _i, _len, _ref1, _ref2, _ref3, _ref4;
      if ((_ref1 = this.binder.unbind) != null) {
        _ref1.call(this, this.el);
      }
      if ((_ref2 = this.observer) != null) {
        _ref2.unobserve();
      }
      _ref3 = this.dependencies;
      for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
        observer = _ref3[_i];
        observer.unobserve();
      }
      this.dependencies = [];
      _ref4 = this.formatterObservers;
      for (fi in _ref4) {
        args = _ref4[fi];
        for (ai in args) {
          observer = args[ai];
          observer.unobserve();
        }
      }
      return (this.formatterObservers = {});
    };

    Binding.prototype.update = function (models) {
      var _ref1, _ref2;
      if (models == null) {
        models = {};
      }
      this.model = (_ref1 = this.observer) != null ? _ref1.target : void 0;
      return (_ref2 = this.binder.update) != null
        ? _ref2.call(this, models)
        : void 0;
    };

    Binding.prototype.getValue = function (el) {
      if (this.binder && this.binder.getValue != null) {
        return this.binder.getValue.call(this, el);
      } else {
        return Rivets.Util.getInputValue(el);
      }
    };

    return Binding;
  })();

  Rivets.ComponentBinding = (function (_super) {
    __extends(ComponentBinding, _super);

    function ComponentBinding(view, el, type) {
      var attribute, bindingRegExp, propertyName, _i, _len, _ref1, _ref2;
      this.view = view;
      this.el = el;
      this.type = type;
      this.unbind = __bind(this.unbind, this);
      this.bind = __bind(this.bind, this);
      this.locals = __bind(this.locals, this);
      this.component = this.view.components[this.type];
      this["static"] = {};
      this.observers = {};
      this.upstreamObservers = {};
      bindingRegExp = view.bindingRegExp();
      _ref1 = this.el.attributes || [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        attribute = _ref1[_i];
        if (!bindingRegExp.test(attribute.name)) {
          propertyName = this.camelCase(attribute.name);
          if (
            __indexOf.call(
              (_ref2 = this.component["static"]) != null ? _ref2 : [],
              propertyName
            ) >= 0
          ) {
            this["static"][propertyName] = attribute.value;
          } else {
            this.observers[propertyName] = attribute.value;
          }
        }
      }
    }

    ComponentBinding.prototype.sync = function () {};

    ComponentBinding.prototype.update = function () {};

    ComponentBinding.prototype.publish = function () {};

    ComponentBinding.prototype.locals = function () {
      var key, observer, result, value, _ref1, _ref2;
      result = {};
      _ref1 = this["static"];
      for (key in _ref1) {
        value = _ref1[key];
        result[key] = value;
      }
      _ref2 = this.observers;
      for (key in _ref2) {
        observer = _ref2[key];
        result[key] = observer.value();
      }
      return result;
    };

    ComponentBinding.prototype.camelCase = function (string) {
      return string.replace(/-([a-z])/g, function (grouped) {
        return grouped[1].toUpperCase();
      });
    };

    ComponentBinding.prototype.bind = function () {
      var k,
        key,
        keypath,
        observer,
        option,
        options,
        scope,
        v,
        _base,
        _i,
        _j,
        _len,
        _len1,
        _ref1,
        _ref2,
        _ref3,
        _ref4,
        _ref5,
        _ref6,
        _ref7,
        _results;
      if (!this.bound) {
        _ref1 = this.observers;
        for (key in _ref1) {
          keypath = _ref1[key];
          this.observers[key] = this.observe(
            this.view.models,
            keypath,
            (function (_this) {
              return function (key) {
                return function () {
                  return (_this.componentView.models[key] =
                    _this.observers[key].value());
                };
              };
            })(this).call(this, key)
          );
        }
        this.bound = true;
      }
      if (this.componentView != null) {
        return this.componentView.bind();
      } else {
        this.el.innerHTML = this.component.template.call(this);
        scope = this.component.initialize.call(this, this.el, this.locals());
        this.el._bound = true;
        options = {};
        _ref2 = Rivets.extensions;
        for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
          option = _ref2[_i];
          options[option] = {};
          if (this.component[option]) {
            _ref3 = this.component[option];
            for (k in _ref3) {
              v = _ref3[k];
              options[option][k] = v;
            }
          }
          _ref4 = this.view[option];
          for (k in _ref4) {
            v = _ref4[k];
            if ((_base = options[option])[k] == null) {
              _base[k] = v;
            }
          }
        }
        _ref5 = Rivets.options;
        for (_j = 0, _len1 = _ref5.length; _j < _len1; _j++) {
          option = _ref5[_j];
          options[option] =
            (_ref6 = this.component[option]) != null
              ? _ref6
              : this.view[option];
        }
        this.componentView = new Rivets.View(this.el, scope, options);
        this.componentView.bind();
        _ref7 = this.observers;
        _results = [];
        for (key in _ref7) {
          observer = _ref7[key];
          _results.push(
            (this.upstreamObservers[key] = this.observe(
              this.componentView.models,
              key,
              (function (_this) {
                return function (key, observer) {
                  return function () {
                    return observer.setValue(_this.componentView.models[key]);
                  };
                };
              })(this).call(this, key, observer)
            ))
          );
        }
        return _results;
      }
    };

    ComponentBinding.prototype.unbind = function () {
      var key, observer, _ref1, _ref2, _ref3;
      _ref1 = this.upstreamObservers;
      for (key in _ref1) {
        observer = _ref1[key];
        observer.unobserve();
      }
      _ref2 = this.observers;
      for (key in _ref2) {
        observer = _ref2[key];
        observer.unobserve();
      }
      return (_ref3 = this.componentView) != null
        ? _ref3.unbind.call(this)
        : void 0;
    };

    return ComponentBinding;
  })(Rivets.Binding);

  Rivets.TextBinding = (function (_super) {
    __extends(TextBinding, _super);

    function TextBinding(view, el, type, keypath, options) {
      this.view = view;
      this.el = el;
      this.type = type;
      this.keypath = keypath;
      this.options = options != null ? options : {};
      this.sync = __bind(this.sync, this);
      this.formatters = this.options.formatters || [];
      this.dependencies = [];
      this.formatterObservers = {};
    }

    TextBinding.prototype.binder = {
      routine: function (node, value) {
        return (node.data = value != null ? value : "");
      },
    };

    TextBinding.prototype.sync = function () {
      return TextBinding.__super__.sync.apply(this, arguments);
    };

    return TextBinding;
  })(Rivets.Binding);

  Rivets["public"].binders.text = function (el, value) {
    if (el.textContent != null) {
      return (el.textContent = value != null ? value : "");
    } else {
      return (el.innerText = value != null ? value : "");
    }
  };

  Rivets["public"].binders.html = function (el, value) {
    return (el.innerHTML = value != null ? value : "");
  };

  Rivets["public"].binders.show = function (el, value) {
    return (el.style.display = value ? "" : "none");
  };

  Rivets["public"].binders.hide = function (el, value) {
    return (el.style.display = value ? "none" : "");
  };

  Rivets["public"].binders.enabled = function (el, value) {
    return (el.disabled = !value);
  };

  Rivets["public"].binders.disabled = function (el, value) {
    return (el.disabled = !!value);
  };

  Rivets["public"].binders["style-*"] = function (el, value) {
    el.style.setProperty(this.args[0], value);
  };

  Rivets["public"].binders["background-image"] = function (el, value) {
    el.style.backgroundImage = "url('" + value + "')";
  };

  Rivets["public"].binders.checked = {
    publishes: true,
    priority: 2000,
    bind: function (el) {
      return Rivets.Util.bindEvent(el, "change", this.publish);
    },
    unbind: function (el) {
      return Rivets.Util.unbindEvent(el, "change", this.publish);
    },
    routine: function (el, value) {
      var _ref1;
      if (el.type === "radio") {
        return (el.checked =
          ((_ref1 = el.value) != null ? _ref1.toString() : void 0) ===
          (value != null ? value.toString() : void 0));
      } else {
        return (el.checked = !!value);
      }
    },
  };

  Rivets["public"].binders.unchecked = {
    publishes: true,
    priority: 2000,
    bind: function (el) {
      return Rivets.Util.bindEvent(el, "change", this.publish);
    },
    unbind: function (el) {
      return Rivets.Util.unbindEvent(el, "change", this.publish);
    },
    routine: function (el, value) {
      var _ref1;
      if (el.type === "radio") {
        return (el.checked =
          ((_ref1 = el.value) != null ? _ref1.toString() : void 0) !==
          (value != null ? value.toString() : void 0));
      } else {
        return (el.checked = !value);
      }
    },
  };

  Rivets["public"].binders.value = {
    publishes: true,
    priority: 3000,
    bind: function (el) {
      if (!(el.tagName === "INPUT" && el.type === "radio")) {
        this.event = el.tagName === "SELECT" ? "change" : "input";
        return Rivets.Util.bindEvent(el, this.event, this.publish);
      }
    },
    unbind: function (el) {
      if (!(el.tagName === "INPUT" && el.type === "radio")) {
        return Rivets.Util.unbindEvent(el, this.event, this.publish);
      }
    },
    routine: function (el, value) {
      var o, _i, _len, _ref1, _ref2, _ref3, _results;
      if (el.tagName === "INPUT" && el.type === "radio") {
        return el.setAttribute("value", value);
      } else if (window.jQuery != null) {
        el = jQuery(el);
        if (
          (value != null ? value.toString() : void 0) !==
          ((_ref1 = el.val()) != null ? _ref1.toString() : void 0)
        ) {
          return el.val(value != null ? value : "");
        }
      } else {
        if (el.type === "select-multiple") {
          if (value != null) {
            _results = [];
            for (_i = 0, _len = el.length; _i < _len; _i++) {
              o = el[_i];
              _results.push(
                (o.selected =
                  ((_ref2 = o.value), __indexOf.call(value, _ref2) >= 0))
              );
            }
            return _results;
          }
        } else if (
          (value != null ? value.toString() : void 0) !==
          ((_ref3 = el.value) != null ? _ref3.toString() : void 0)
        ) {
          return (el.value = value != null ? value : "");
        }
      }
    },
  };

  Rivets["public"].binders["if"] = {
    block: true,
    priority: 4000,
    bind: function (el) {
      var attr, declaration;
      if (this.marker == null) {
        attr = [this.view.prefix, this.type].join("-").replace("--", "-");
        declaration = el.getAttribute(attr);
        this.marker = document.createComment(
          " rivets: " + this.type + " " + declaration + " "
        );
        this.bound = false;
        el.removeAttribute(attr);
        el.parentNode.insertBefore(this.marker, el);
        return el.parentNode.removeChild(el);
      }
    },
    unbind: function () {
      var _ref1;
      return (_ref1 = this.nested) != null ? _ref1.unbind() : void 0;
    },
    routine: function (el, value) {
      var key, model, models, _ref1;
      if (!!value === !this.bound) {
        if (value) {
          models = {};
          _ref1 = this.view.models;
          for (key in _ref1) {
            model = _ref1[key];
            models[key] = model;
          }
          (
            this.nested ||
            (this.nested = new Rivets.View(el, models, this.view.options()))
          ).bind();
          this.marker.parentNode.insertBefore(el, this.marker.nextSibling);
          return (this.bound = true);
        } else {
          el.parentNode.removeChild(el);
          this.nested.unbind();
          return (this.bound = false);
        }
      }
    },
    update: function (models) {
      var _ref1;
      return (_ref1 = this.nested) != null ? _ref1.update(models) : void 0;
    },
  };

  Rivets["public"].binders.unless = {
    block: true,
    priority: 4000,
    bind: function (el) {
      return Rivets["public"].binders["if"].bind.call(this, el);
    },
    unbind: function () {
      return Rivets["public"].binders["if"].unbind.call(this);
    },
    routine: function (el, value) {
      return Rivets["public"].binders["if"].routine.call(this, el, !value);
    },
    update: function (models) {
      return Rivets["public"].binders["if"].update.call(this, models);
    },
  };

  Rivets["public"].binders["on-*"] = {
    function: true,
    priority: 1000,
    unbind: function (el) {
      if (this.handler) {
        return Rivets.Util.unbindEvent(el, this.args[0], this.handler);
      }
    },
    routine: function (el, value) {
      if (this.handler) {
        Rivets.Util.unbindEvent(el, this.args[0], this.handler);
      }
      return Rivets.Util.bindEvent(
        el,
        this.args[0],
        (this.handler = this.eventHandler(value))
      );
    },
  };

  Rivets["public"].binders["each-*"] = {
    block: true,
    priority: 4000,
    bind: function (el) {
      var attr, view, _i, _len, _ref1;
      if (this.marker == null) {
        attr = [this.view.prefix, this.type].join("-").replace("--", "-");
        this.marker = document.createComment(" rivets: " + this.type + " ");
        this.iterated = [];
        el.removeAttribute(attr);
        el.parentNode.insertBefore(this.marker, el);
        el.parentNode.removeChild(el);
      } else {
        _ref1 = this.iterated;
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          view = _ref1[_i];
          view.bind();
        }
      }
    },
    unbind: function (el) {
      var view, _i, _len, _ref1, _results;
      if (this.iterated != null) {
        _ref1 = this.iterated;
        _results = [];
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          view = _ref1[_i];
          _results.push(view.unbind());
        }
        return _results;
      }
    },
    routine: function (el, collection) {
      var binding,
        data,
        i,
        index,
        key,
        model,
        modelName,
        options,
        previous,
        template,
        view,
        _i,
        _j,
        _k,
        _len,
        _len1,
        _len2,
        _ref1,
        _ref2,
        _ref3,
        _results;
      modelName = this.args[0];
      collection = collection || [];
      if (this.iterated.length > collection.length) {
        _ref1 = Array(this.iterated.length - collection.length);
        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
          i = _ref1[_i];
          view = this.iterated.pop();
          view.unbind();
          this.marker.parentNode.removeChild(view.els[0]);
        }
      }
      for (
        index = _j = 0, _len1 = collection.length;
        _j < _len1;
        index = ++_j
      ) {
        model = collection[index];
        data = {
          index: index,
        };
        data[modelName] = model;
        if (this.iterated[index] == null) {
          _ref2 = this.view.models;
          for (key in _ref2) {
            model = _ref2[key];
            if (data[key] == null) {
              data[key] = model;
            }
          }
          previous = this.iterated.length
            ? this.iterated[this.iterated.length - 1].els[0]
            : this.marker;
          options = this.view.options();
          options.preloadData = true;
          template = el.cloneNode(true);
          view = new Rivets.View(template, data, options);
          view.bind();
          this.iterated.push(view);
          this.marker.parentNode.insertBefore(template, previous.nextSibling);
        } else if (this.iterated[index].models[modelName] !== model) {
          this.iterated[index].update(data);
        }
      }
      if (el.nodeName === "OPTION") {
        _ref3 = this.view.bindings;
        _results = [];
        for (_k = 0, _len2 = _ref3.length; _k < _len2; _k++) {
          binding = _ref3[_k];
          if (
            binding.el === this.marker.parentNode &&
            binding.type === "value"
          ) {
            _results.push(binding.sync());
          } else {
            _results.push(void 0);
          }
        }
        return _results;
      }
    },
    update: function (models) {
      var data, key, model, view, _i, _len, _ref1, _results;
      data = {};
      for (key in models) {
        model = models[key];
        if (key !== this.args[0]) {
          data[key] = model;
        }
      }
      _ref1 = this.iterated;
      _results = [];
      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
        view = _ref1[_i];
        _results.push(view.update(data));
      }
      return _results;
    },
  };

  Rivets["public"].binders["class-*"] = function (el, value) {
    var elClass;
    elClass = " " + el.className + " ";
    if (!value === (elClass.indexOf(" " + this.args[0] + " ") !== -1)) {
      return (el.className = value
        ? "" + el.className + " " + this.args[0]
        : elClass.replace(" " + this.args[0] + " ", " ").trim());
    }
  };

  Rivets["public"].binders["*"] = function (el, value) {
    if (value != null) {
      return el.setAttribute(this.type, value);
    } else {
      return el.removeAttribute(this.type);
    }
  };

  Rivets["public"].adapters["."] = {
    id: "_rv",
    counter: 0,
    weakmap: {},
    weakReference: function (obj) {
      var id, _base, _name;
      if (!obj.hasOwnProperty(this.id)) {
        id = this.counter++;
        Object.defineProperty(obj, this.id, {
          value: id,
        });
      }
      return (
        (_base = this.weakmap)[(_name = obj[this.id])] ||
        (_base[_name] = {
          callbacks: {},
        })
      );
    },
    cleanupWeakReference: function (ref, id) {
      if (!Object.keys(ref.callbacks).length) {
        if (!(ref.pointers && Object.keys(ref.pointers).length)) {
          return delete this.weakmap[id];
        }
      }
    },
    stubFunction: function (obj, fn) {
      var map, original, weakmap;
      original = obj[fn];
      map = this.weakReference(obj);
      weakmap = this.weakmap;
      return (obj[fn] = function () {
        var callback, k, r, response, _i, _len, _ref1, _ref2, _ref3, _ref4;
        response = original.apply(obj, arguments);
        _ref1 = map.pointers;
        for (r in _ref1) {
          k = _ref1[r];
          _ref4 =
            (_ref2 =
              (_ref3 = weakmap[r]) != null ? _ref3.callbacks[k] : void 0) !=
            null
              ? _ref2
              : [];
          for (_i = 0, _len = _ref4.length; _i < _len; _i++) {
            callback = _ref4[_i];
            callback();
          }
        }
        return response;
      });
    },
    observeMutations: function (obj, ref, keypath) {
      var fn, functions, map, _base, _i, _len;
      if (Array.isArray(obj)) {
        map = this.weakReference(obj);
        if (map.pointers == null) {
          map.pointers = {};
          functions = [
            "push",
            "pop",
            "shift",
            "unshift",
            "sort",
            "reverse",
            "splice",
          ];
          for (_i = 0, _len = functions.length; _i < _len; _i++) {
            fn = functions[_i];
            this.stubFunction(obj, fn);
          }
        }
        if ((_base = map.pointers)[ref] == null) {
          _base[ref] = [];
        }
        if (__indexOf.call(map.pointers[ref], keypath) < 0) {
          return map.pointers[ref].push(keypath);
        }
      }
    },
    unobserveMutations: function (obj, ref, keypath) {
      var idx, map, pointers;
      if (Array.isArray(obj) && obj[this.id] != null) {
        if ((map = this.weakmap[obj[this.id]])) {
          if ((pointers = map.pointers[ref])) {
            if ((idx = pointers.indexOf(keypath)) >= 0) {
              pointers.splice(idx, 1);
            }
            if (!pointers.length) {
              delete map.pointers[ref];
            }
            return this.cleanupWeakReference(map, obj[this.id]);
          }
        }
      }
    },
    observe: function (obj, keypath, callback) {
      var callbacks, desc, value;
      callbacks = this.weakReference(obj).callbacks;
      if (callbacks[keypath] == null) {
        callbacks[keypath] = [];
        desc = Object.getOwnPropertyDescriptor(obj, keypath);
        if (
          !(
            (desc != null ? desc.get : void 0) ||
            (desc != null ? desc.set : void 0)
          )
        ) {
          value = obj[keypath];
          Object.defineProperty(obj, keypath, {
            enumerable: true,
            get: function () {
              return value;
            },
            set: (function (_this) {
              return function (newValue) {
                var map, _i, _len, _ref1;
                if (newValue !== value) {
                  _this.unobserveMutations(value, obj[_this.id], keypath);
                  value = newValue;
                  if ((map = _this.weakmap[obj[_this.id]])) {
                    callbacks = map.callbacks;
                    if (callbacks[keypath]) {
                      _ref1 = callbacks[keypath].slice();
                      for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                        callback = _ref1[_i];
                        if (__indexOf.call(callbacks[keypath], callback) >= 0) {
                          callback();
                        }
                      }
                    }
                    return _this.observeMutations(
                      newValue,
                      obj[_this.id],
                      keypath
                    );
                  }
                }
              };
            })(this),
          });
        }
      }
      if (__indexOf.call(callbacks[keypath], callback) < 0) {
        callbacks[keypath].push(callback);
      }
      return this.observeMutations(obj[keypath], obj[this.id], keypath);
    },
    unobserve: function (obj, keypath, callback) {
      var callbacks, idx, map;
      if ((map = this.weakmap[obj[this.id]])) {
        if ((callbacks = map.callbacks[keypath])) {
          if ((idx = callbacks.indexOf(callback)) >= 0) {
            callbacks.splice(idx, 1);
            if (!callbacks.length) {
              delete map.callbacks[keypath];
            }
          }
          this.unobserveMutations(obj[keypath], obj[this.id], keypath);
          return this.cleanupWeakReference(map, obj[this.id]);
        }
      }
    },
    get: function (obj, keypath) {
      return obj[keypath];
    },
    set: function (obj, keypath, value) {
      return (obj[keypath] = value);
    },
  };

  Rivets.factory = function (sightglass) {
    Rivets.sightglass = sightglass;
    Rivets["public"]._ = Rivets;
    return Rivets["public"];
  };

  if (
    typeof (typeof module !== "undefined" && module !== null
      ? module.exports
      : void 0) === "object"
  ) {
    module.exports = Rivets.factory(require("sightglass"));
  } else if (typeof define === "function" && define.amd) {
    define(["sightglass"], function (sightglass) {
      return (this.rivets = Rivets.factory(sightglass));
    });
  } else {
    this.rivets = Rivets.factory(sightglass);
  }
}.call(this));

(function () {
  var $document,
    Cart,
    CartJS,
    Item,
    processing,
    queue,
    __bind = function (fn, me) {
      return function () {
        return fn.apply(me, arguments);
      };
    };

  Cart = (function () {
    function Cart() {
      this.update = __bind(this.update, this);
    }

    Cart.prototype.update = function (cart) {
      var item, key, value;
      for (key in cart) {
        value = cart[key];
        if (key !== "items") {
          this[key] = value;
        }
      }
      return (this.items = (function () {
        var _i, _len, _ref, _results;
        _ref = cart.items;
        _results = [];
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          item = _ref[_i];
          _results.push(new Item(item));
        }
        return _results;
      })());
    };

    return Cart;
  })();

  Item = (function () {
    function Item(item) {
      this.propertyArray = __bind(this.propertyArray, this);
      this.update = __bind(this.update, this);
      this.update(item);
    }

    Item.prototype.update = function (item) {
      var key, value;
      for (key in item) {
        value = item[key];
        if (key !== "properties") {
          this[key] = value;
        }
      }
      return (this.properties = CartJS.Utils.extend({}, item.properties));
    };

    Item.prototype.propertyArray = function () {
      var name, value, _ref, _results;
      _ref = this.properties;
      _results = [];
      for (name in _ref) {
        value = _ref[name];
        _results.push({
          name: name,
          value: value,
        });
      }
      return _results;
    };

    return Item;
  })();

  CartJS = {
    settings: {
      debug: false,
      dataAPI: true,
      requestBodyClass: null,
      rivetsModels: {},
      currency: null,
      moneyFormat: null,
      moneyWithCurrencyFormat: null,
      weightUnit: "g",
      weightPrecision: 0,
    },
    cart: new Cart(),
  };

  CartJS.init = function (cart, settings) {
    if (settings == null) {
      settings = {};
    }
    CartJS.configure(settings);
    CartJS.Utils.log("Initialising CartJS.");
    CartJS.cart.update(cart);
    if (CartJS.settings.dataAPI) {
      CartJS.Utils.log('"dataAPI" setting is true, initialising Data API.');
      CartJS.Data.init();
    }
    if (CartJS.settings.requestBodyClass) {
      CartJS.Utils.log('"requestBodyClass" set, adding event listeners.');
      jQuery(document).on("cart.requestStarted", function () {
        return jQuery("body").addClass(CartJS.settings.requestBodyClass);
      });
      jQuery(document).on("cart.requestComplete", function () {
        return jQuery("body").removeClass(CartJS.settings.requestBodyClass);
      });
    }
    CartJS.Rivets.init();
    return jQuery(document).trigger("cart.ready", [CartJS.cart]);
  };

  CartJS.configure = function (settings) {
    if (settings == null) {
      settings = {};
    }
    return CartJS.Utils.extend(CartJS.settings, settings);
  };

  if (window.console == null) {
    window.console = {};
    window.console.log = function () {};
  }

  CartJS.Utils = {
    log: function () {
      return CartJS.Utils.console(console.log, arguments);
    },
    error: function () {
      return CartJS.Utils.console(console.error, arguments);
    },
    console: function (method, args) {
      if (
        CartJS.settings.debug &&
        typeof console !== "undefined" &&
        console !== null
      ) {
        args = Array.prototype.slice.call(args);
        args.unshift("[CartJS]:");
        return method.apply(console, args);
      }
    },
    wrapKeys: function (obj, type, override) {
      var key, value, wrapped;
      if (type == null) {
        type = "properties";
      }
      wrapped = {};
      for (key in obj) {
        value = obj[key];
        wrapped["" + type + "[" + key + "]"] =
          override != null ? override : value;
      }
      return wrapped;
    },
    unwrapKeys: function (obj, type, override) {
      var key, unwrapped, unwrappedKey, value;
      if (type == null) {
        type = "properties";
      }
      unwrapped = {};
      for (key in obj) {
        value = obj[key];
        unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
        unwrapped[unwrappedKey] = override != null ? override : value;
      }
      return unwrapped;
    },
    extend: function (object, properties) {
      var key, val;
      for (key in properties) {
        val = properties[key];
        object[key] = val;
      }
      return object;
    },
    clone: function (object) {
      var key, newInstance;
      if (object == null || typeof object !== "object") {
        return object;
      }
      newInstance = new object.constructor();
      for (key in object) {
        newInstance[key] = clone(object[key]);
      }
      return newInstance;
    },
    isArray:
      Array.isArray ||
      function (value) {
        return {}.toString.call(value) === "[object Array]";
      },
    ensureArray: function (value) {
      if (CartJS.Utils.isArray(value)) {
        return value;
      }
      if (value != null) {
        return [value];
      } else {
        return [];
      }
    },
    formatMoney: function (value, format, formatName, currency) {
      var _ref, _ref1;
      if (currency == null) {
        currency = "";
      }
      if (!currency) {
        currency = CartJS.settings.currency;
      }
      if (window.Currency != null && currency !== CartJS.settings.currency) {
        value = Currency.convert(value, CartJS.settings.currency, currency);
        if (
          ((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) !=
            null &&
          currency in window.Currency.moneyFormats
        ) {
          format = window.Currency.moneyFormats[currency][formatName];
        }
      }
      if (
        ((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null
      ) {
        return Shopify.formatMoney(value, format);
      } else {
        return value;
      }
    },
    getSizedImageUrl: function (src, size) {
      var _ref, _ref1;
      if (
        ((_ref = window.Shopify) != null
          ? (_ref1 = _ref.Image) != null
            ? _ref1.getSizedImageUrl
            : void 0
          : void 0) != null
      ) {
        if (src) {
          return Shopify.Image.getSizedImageUrl(src, size);
        } else {
          return Shopify.Image.getSizedImageUrl(
            "https://cdn.shopify.com/s/images/admin/no-image-.gif",
            size
          ).replace("-_", "-");
        }
      } else {
        if (src) {
          return src;
        } else {
          return "https://cdn.shopify.com/s/images/admin/no-image-large.gif";
        }
      }
    },
  };

  queue = [];

  processing = false;

  CartJS.Queue = {
    add: function (url, data, options) {
      var request;
      if (options == null) {
        options = {};
      }
      request = {
        url: url,
        data: data,
        type: options.type || "POST",
        dataType: options.dataType || "json",
        success: CartJS.Utils.ensureArray(options.success),
        error: CartJS.Utils.ensureArray(options.error),
        complete: CartJS.Utils.ensureArray(options.complete),
      };
      if (options.updateCart) {
        request.success.push(CartJS.cart.update);
      }
      queue.push(request);
      if (processing) {
        return;
      }
      jQuery(document).trigger("cart.requestStarted", [CartJS.cart]);
      return CartJS.Queue.process();
    },
    process: function () {
      var params;
      if (!queue.length) {
        processing = false;
        jQuery(document).trigger("cart.requestComplete", [CartJS.cart]);
        return;
      }
      processing = true;
      params = queue.shift();
      params.complete = CartJS.Queue.process;
      return jQuery.ajax(params);
    },
  };

  CartJS.Core = {
    getCart: function (options) {
      if (options == null) {
        options = {};
      }
      options.type = "GET";
      options.updateCart = true;
      return CartJS.Queue.add("/cart.js", {}, options);
    },
    addItem: function (id, quantity, properties, options) {
      var data;
      if (quantity == null) {
        quantity = 1;
      }
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      data.quantity = quantity;
      CartJS.Queue.add("/cart/add.js", data, options);
      return CartJS.Core.getCart();
    },
    updateItem: function (line, quantity, properties, options) {
      var data;
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.line = line;
      if (quantity != null) {
        data.quantity = quantity;
      }
      options.updateCart = true;
      return CartJS.Queue.add("/cart/change.js", data, options);
    },
    removeItem: function (line, options) {
      if (options == null) {
        options = {};
      }
      return CartJS.Core.updateItem(line, 0, {}, options);
    },
    updateItemById: function (id, quantity, properties, options) {
      var data;
      if (properties == null) {
        properties = {};
      }
      if (options == null) {
        options = {};
      }
      data = CartJS.Utils.wrapKeys(properties);
      data.id = id;
      if (quantity != null) {
        data.quantity = quantity;
      }
      options.updateCart = true;
      return CartJS.Queue.add("/cart/change.js", data, options);
    },
    updateItemQuantitiesById: function (updates, options) {
      if (updates == null) {
        updates = {};
      }
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add(
        "/cart/update.js",
        {
          updates: updates,
        },
        options
      );
    },
    removeItemById: function (id, options) {
      var data;
      if (options == null) {
        options = {};
      }
      data = {
        id: id,
        quantity: 0,
      };
      options.updateCart = true;
      return CartJS.Queue.add("/cart/change.js", data, options);
    },
    clear: function (options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add("/cart/clear.js", {}, options);
    },
    getAttribute: function (attributeName, defaultValue) {
      if (attributeName in CartJS.cart.attributes) {
        return CartJS.cart.attributes[attributeName];
      } else {
        return defaultValue;
      }
    },
    setAttribute: function (attributeName, value, options) {
      var attributes;
      if (options == null) {
        options = {};
      }
      attributes = {};
      attributes[attributeName] = value;
      return CartJS.Core.setAttributes(attributes, options);
    },
    getAttributes: function () {
      return CartJS.cart.attributes;
    },
    setAttributes: function (attributes, options) {
      if (attributes == null) {
        attributes = {};
      }
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add(
        "/cart/update.js",
        CartJS.Utils.wrapKeys(attributes, "attributes"),
        options
      );
    },
    clearAttributes: function (options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add(
        "/cart/update.js",
        CartJS.Utils.wrapKeys(CartJS.Core.getAttributes(), "attributes", ""),
        options
      );
    },
    getNote: function () {
      return CartJS.cart.note;
    },
    setNote: function (note, options) {
      if (options == null) {
        options = {};
      }
      options.updateCart = true;
      return CartJS.Queue.add(
        "/cart/update.js",
        {
          note: note,
        },
        options
      );
    },
  };

  $document = null;

  CartJS.Data = {
    init: function () {
      $document = jQuery(document);
      CartJS.Data.setEventListeners("on");
      return CartJS.Data.render(null, CartJS.cart);
    },
    destroy: function () {
      return CartJS.Data.setEventListeners("off");
    },
    setEventListeners: function (method) {
      $document[method]("click", "[data-cart-add]", CartJS.Data.add);
      $document[method]("click", "[data-cart-remove]", CartJS.Data.remove);
      $document[method](
        "click",
        "[data-cart-remove-id]",
        CartJS.Data.removeById
      );
      $document[method]("click", "[data-cart-update]", CartJS.Data.update);
      $document[method](
        "click",
        "[data-cart-update-id]",
        CartJS.Data.updateById
      );
      $document[method]("click", "[data-cart-clear]", CartJS.Data.clear);
      $document[method]("change", "[data-cart-toggle]", CartJS.Data.toggle);
      $document[method](
        "change",
        "[data-cart-toggle-attribute]",
        CartJS.Data.toggleAttribute
      );
      $document[method]("submit", "[data-cart-submit]", CartJS.Data.submit);
      return $document[method]("cart.requestComplete", CartJS.Data.render);
    },
    add: function (e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.addItem(
        $this.attr("data-cart-add"),
        $this.attr("data-cart-quantity")
      );
    },
    remove: function (e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.removeItem($this.attr("data-cart-remove"));
    },
    removeById: function (e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.removeItemById($this.attr("data-cart-remove-id"));
    },
    update: function (e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.updateItem(
        $this.attr("data-cart-update"),
        $this.attr("data-cart-quantity")
      );
    },
    updateById: function (e) {
      var $this;
      e.preventDefault();
      $this = jQuery(this);
      return CartJS.Core.updateItemById(
        $this.attr("data-cart-update-id"),
        $this.attr("data-cart-quantity")
      );
    },
    clear: function (e) {
      e.preventDefault();
      return CartJS.Core.clear();
    },
    toggle: function (e) {
      var $input, id;
      $input = jQuery(this);
      id = $input.attr("data-cart-toggle");
      if ($input.is(":checked")) {
        return CartJS.Core.addItem(id);
      } else {
        return CartJS.Core.removeItemById(id);
      }
    },
    toggleAttribute: function (e) {
      var $input, attribute;
      $input = jQuery(this);
      attribute = $input.attr("data-cart-toggle-attribute");
      return CartJS.Core.setAttribute(
        attribute,
        $input.is(":checked") ? "Yes" : ""
      );
    },
    submit: function (e) {
      var dataArray, id, properties, quantity;
      e.preventDefault();
      dataArray = jQuery(this).serializeArray();
      id = void 0;
      quantity = void 0;
      properties = {};
      jQuery.each(dataArray, function (i, item) {
        if (item.name === "id") {
          return (id = item.value);
        } else if (item.name === "quantity") {
          return (quantity = item.value);
        } else if (item.name.match(/^properties\[\w+\]$/)) {
          return (properties[item.name] = item.value);
        }
      });
      return CartJS.Core.addItem(
        id,
        quantity,
        CartJS.Utils.unwrapKeys(properties)
      );
    },
    render: function (e, cart) {
      var context;
      context = {
        item_count: cart.item_count,
        total_price: cart.total_price,
        total_price_money: CartJS.Utils.formatMoney(
          cart.total_price,
          CartJS.settings.moneyFormat,
          "money_format",
          (typeof Currency !== "undefined" && Currency !== null
            ? Currency.currentCurrency
            : void 0) != null
            ? Currency.currentCurrency
            : void 0
        ),
        total_price_money_with_currency: CartJS.Utils.formatMoney(
          cart.total_price,
          CartJS.settings.moneyWithCurrencyFormat,
          "money_with_currency_format",
          (typeof Currency !== "undefined" && Currency !== null
            ? Currency.currentCurrency
            : void 0) != null
            ? Currency.currentCurrency
            : void 0
        ),
      };
      return jQuery("[data-cart-render]").each(function () {
        var $this;
        $this = jQuery(this);
        return $this.html(context[$this.attr("data-cart-render")]);
      });
    },
  };

  if ("rivets" in window) {
    CartJS.Rivets = {
      model: null,
      boundViews: [],
      init: function () {
        return CartJS.Rivets.bindViews();
      },
      destroy: function () {
        return CartJS.Rivets.unbindViews();
      },
      bindViews: function () {
        CartJS.Utils.log("Rivets.js is present, binding views.");
        CartJS.Rivets.unbindViews();
        CartJS.Rivets.model = CartJS.Utils.extend(
          {
            cart: CartJS.cart,
          },
          CartJS.settings.rivetsModels
        );
        if (window.Currency != null) {
          CartJS.Rivets.model.Currency = window.Currency;
        }
        return jQuery("[data-cart-view]").each(function () {
          var view;
          view = rivets.bind(jQuery(this), CartJS.Rivets.model);
          return CartJS.Rivets.boundViews.push(view);
        });
      },
      unbindViews: function () {
        var view, _i, _len, _ref;
        _ref = CartJS.Rivets.boundViews;
        for (_i = 0, _len = _ref.length; _i < _len; _i++) {
          view = _ref[_i];
          view.unbind();
        }
        return (CartJS.Rivets.boundViews = []);
      },
    };
    rivets.formatters.eq = function (a, b) {
      return a === b;
    };
    rivets.formatters.includes = function (a, b) {
      return a.indexOf(b) >= 0;
    };
    rivets.formatters.match = function (a, regexp, flags) {
      return a.match(new RegExp(regexp, flags));
    };
    rivets.formatters.lt = function (a, b) {
      return a < b;
    };
    rivets.formatters.gt = function (a, b) {
      return a > b;
    };
    rivets.formatters.not = function (a) {
      return !a;
    };
    rivets.formatters.empty = function (a) {
      return !a.length;
    };
    rivets.formatters.plus = function (a, b) {
      return parseInt(a) + parseInt(b);
    };
    rivets.formatters.minus = function (a, b) {
      return parseInt(a) - parseInt(b);
    };
    rivets.formatters.times = function (a, b) {
      return a * b;
    };
    rivets.formatters.divided_by = function (a, b) {
      return a / b;
    };
    rivets.formatters.modulo = function (a, b) {
      return a % b;
    };
    rivets.formatters.prepend = function (a, b) {
      return b + a;
    };
    rivets.formatters.append = function (a, b) {
      return a + b;
    };
    rivets.formatters.slice = function (value, start, end) {
      return value.slice(start, end);
    };
    rivets.formatters.pluralize = function (input, singular, plural) {
      if (plural == null) {
        plural = singular + "s";
      }
      if (CartJS.Utils.isArray(input)) {
        input = input.length;
      }
      if (input === 1) {
        return singular;
      } else {
        return plural;
      }
    };
    rivets.formatters.array_element = function (array, index) {
      return array[index];
    };
    rivets.formatters.array_first = function (array) {
      return array[0];
    };
    rivets.formatters.array_last = function (array) {
      return array[array.length - 1];
    };
    rivets.formatters.money = function (value, currency) {
      return CartJS.Utils.formatMoney(
        value,
        CartJS.settings.moneyFormat,
        "money_format",
        currency
      );
    };
    rivets.formatters.money_with_currency = function (value, currency) {
      return CartJS.Utils.formatMoney(
        value,
        CartJS.settings.moneyWithCurrencyFormat,
        "money_with_currency_format",
        currency
      );
    };
    rivets.formatters.weight = function (grams) {
      switch (CartJS.settings.weightUnit) {
        case "kg":
          return (grams / 1000).toFixed(CartJS.settings.weightPrecision);
        case "oz":
          return (grams * 0.035274).toFixed(CartJS.settings.weightPrecision);
        case "lb":
          return (grams * 0.00220462).toFixed(CartJS.settings.weightPrecision);
        default:
          return grams.toFixed(CartJS.settings.weightPrecision);
      }
    };
    rivets.formatters.weight_with_unit = function (grams) {
      return rivets.formatters.weight(grams) + CartJS.settings.weightUnit;
    };
    rivets.formatters.product_image_size = function (src, size) {
      return CartJS.Utils.getSizedImageUrl(src, size);
    };
    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency;
    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit;
    rivets.formatters.productImageSize = rivets.formatters.product_image_size;
  } else {
    CartJS.Rivets = {
      init: function () {},
      destroy: function () {},
    };
  }

  CartJS.factory = function (exports) {
    exports.init = CartJS.init;
    exports.configure = CartJS.configure;
    exports.cart = CartJS.cart;
    exports.settings = CartJS.settings;
    exports.getCart = CartJS.Core.getCart;
    exports.addItem = CartJS.Core.addItem;
    exports.updateItem = CartJS.Core.updateItem;
    exports.updateItemById = CartJS.Core.updateItemById;
    exports.updateItemQuantitiesById = CartJS.Core.updateItemQuantitiesById;
    exports.removeItem = CartJS.Core.removeItem;
    exports.removeItemById = CartJS.Core.removeItemById;
    exports.clear = CartJS.Core.clear;
    exports.getAttribute = CartJS.Core.getAttribute;
    exports.setAttribute = CartJS.Core.setAttribute;
    exports.getAttributes = CartJS.Core.getAttributes;
    exports.setAttributes = CartJS.Core.setAttributes;
    exports.clearAttributes = CartJS.Core.clearAttributes;
    exports.getNote = CartJS.Core.getNote;
    exports.setNote = CartJS.Core.setNote;
    return (exports.render = CartJS.Data.render);
  };

  if (typeof exports === "object") {
    CartJS.factory(exports);
  } else if (typeof define === "function" && define.amd) {
    define(["exports"], function (exports) {
      CartJS.factory((this.CartJS = exports));
      return exports;
    });
  } else {
    CartJS.factory((this.CartJS = {}));
  }
}.call(this));
("use strict");

/**
 * Copyright:   Matthieu Riolo <advise@ocsource.ch>
 * Website:     http://www.ocsource.ch/
 * License:     <see file /License>
 * Created:     2014-11-05
 * Repository:  https://github.com/matthieuriolo/rivetsjs-stdlib
 */

(function (root, factory) {
  if (typeof exports === "object") {
    // CommonJS
    module.exports = factory(require("rivets"), require("moment"));
  } else if (typeof define === "function" && define.amd) {
    // AMD. Register as an anonymous module.
    define(["rivets", "moment"], factory);
  } else {
    // Browser globals
    factory(root.rivets, root.moment);
  }
})(this, function (rivets, moment) {
  rivets.stdlib = {
    defaultPrecision: 2,
    defaultThousandSeparator: "'",
    defaultDecimalSeparator: ".",

    defaultDateFormat: "YYYY-MM-DD",
    defaultTimeFormat: "HH:mm:ss",
    defaultDatetimeFormat: "YYYY-MM-DD HH:mm:ss",
  };

  rivets.formatters.imageSize = function (src, size) {
    return src.replace(/\.jpg|\.png|\.gif|\.jpeg/gi, function (match) {
      return "_" + size + match;
    });
  };

  /*
   * basic formatters for rivets
   *
   */

  /* general */
  rivets.formatters.log = function (target) {
    return console.log(target);
  };

  rivets.formatters.default = function (target, val) {
    return !rivets.formatters.isEmpty(target) ? target : val;
  };

  rivets.formatters.add = function (target, val) {
    return target + val;
  };

  rivets.formatters.sub = function (target, val) {
    return target - val;
  };

  rivets.formatters.map = function (target, obj, prop) {
    var args = Array.prototype.slice.call(arguments);
    args.splice(1, 2);
    return obj[prop].apply(obj, args);
  };

  /* check JS types */

  rivets.formatters.isBoolean = function (target) {
    return typeof target == "boolean";
  };

  rivets.formatters.isNumeric = function (target) {
    return !isNaN(target);
  };

  rivets.formatters.isNaN = function (target) {
    if (rivets.formatters.isArray(target)) return true;
    return isNaN(target);
  };

  rivets.formatters.isInteger = function (n) {
    /**
     * thanks a lot to Dagg Nabbit
     * http://stackoverflow.com/questions/3885817/how-to-check-if-a-number-is-float-or-integer
     */
    return n === +n && n === (n | 0);
  };

  rivets.formatters.isFloat = function (n) {
    /**
     * thanks a lot to Dagg Nabbit
     * http://stackoverflow.com/questions/3885817/how-to-check-if-a-number-is-float-or-integer
     */
    return Infinity !== n && n === +n && n !== (n | 0);
  };

  rivets.formatters.isNumber = function (target) {
    return (
      rivets.formatters.isFloat(target) || rivets.formatters.isInteger(target)
    );
  };

  rivets.formatters.isObject = function (target) {
    return (
      rivets.formatters.toBoolean(target) &&
      typeof target == "object" &&
      !rivets.formatters.isArray(target)
    );
  };

  rivets.formatters.isFunction = function (target) {
    return typeof target == "function";
  };

  rivets.formatters.isArray = function (target) {
    return rivets.formatters.isFunction(Array.isArray)
      ? Array.isArray(target)
      : target instanceof Array;
  };

  rivets.formatters.isString = function (target) {
    return typeof target == "string" || target instanceof String;
  };

  rivets.formatters.isInfinity = function (target) {
    return target === Infinity;
  };

  /* convert JS types */

  rivets.formatters.toBoolean = function (target) {
    return !!target;
  };

  rivets.formatters.toInteger = function (target) {
    var ret = parseInt(target * 1, 10);
    return isNaN(ret) ? 0 : ret;
  };

  rivets.formatters.toFloat = function (target) {
    var ret = parseFloat(target * 1.0);
    return isNaN(ret) ? 0.0 : ret;
  };

  rivets.formatters.toDecimal = function (target) {
    var retI = rivets.formatters.toInteger(target * 1);
    var retF = rivets.formatters.toFloat(target);
    return retI == retF ? retI : retF;
  };

  rivets.formatters.toArray = function (target) {
    if (rivets.formatters.isArray(target)) {
      return target;
    } else if (rivets.formatters.isObject(target)) {
      return rivets.formatters.values(target);
    }

    return [target];
  };

  rivets.formatters.toString = function (target) {
    return target ? target.toString() : "";
  };

  rivets.formatters.integer = {
    read: function (target) {
      return rivets.formatters.toInteger(target);
    },

    publish: function (target) {
      return rivets.formatters.toInteger(target);
    },
  };

  /* Math functions */
  rivets.formatters.sum = function (target, val) {
    return 1 * target + 1 * val;
  };

  rivets.formatters.substract = function (target, val) {
    return 1 * target - 1 * val;
  };

  rivets.formatters.multiply = function (target, val) {
    return 1 * target * (1 * val);
  };

  /*
    rivets.formaters.crossMultiplication = function(target, base, total) {
        return (target / base) * total
    }

    rivets.formaters.percents = function(target, base, total) {
        return rivets.formaters.crossMultiplication(target, base, total) + "%";
    }
    */

  rivets.formatters.divide = function (target, val) {
    return (1 * target) / (1 * val);
  };

  rivets.formatters.min = function () {
    return Math.min.apply(Math, arguments);
  };

  rivets.formatters.max = function () {
    return Math.max.apply(Math, arguments);
  };

  /* comparisons */

  rivets.formatters.isEqual = function (target, val) {
    return target === val;
  };

  rivets.formatters.isNotEqual = function (target, val) {
    return target !== val;
  };

  rivets.formatters.isLess = function (target, val) {
    return target * 1 < val * 1;
  };

  rivets.formatters.isGreater = function (target, val) {
    return target * 1 > val * 1;
  };

  rivets.formatters.isLessEqual = function (target, val) {
    return target * 1 <= val * 1;
  };

  rivets.formatters.isGreaterEqual = function (target, val) {
    return target * 1 >= val * 1;
  };

  /* logical functions */

  rivets.formatters.or = function () {
    for (var i = 0; i < arguments.length; i++) {
      if (rivets.formatters.toBoolean(arguments[i])) {
        return true;
      }
    }
    return false;
  };

  rivets.formatters.and = function () {
    for (var i = 0; i < arguments.length; i++) {
      if (!rivets.formatters.toBoolean(arguments[i])) {
        return false;
      }
    }

    return true;
  };

  rivets.formatters.negate = function (target) {
    return !rivets.formatters.toBoolean(target);
  };

  rivets.formatters.if = function (target, trueCase, falseCase) {
    return rivets.formatters.toBoolean(target) ? trueCase : falseCase;
  };

  /* number functions */
  rivets.formatters.numberFormat = function (
    target,
    precision,
    decimalSeparator,
    thousandSeparator
  ) {
    target = rivets.formatters.isNumber(target)
      ? target
      : rivets.formatters.toDecimal(target);

    if (!rivets.formatters.isInteger(precision))
      precision = rivets.stdlib.defaultPrecision;
    if (!decimalSeparator)
      decimalSeparator = rivets.stdlib.defaultDecimalSeparator;
    if (!thousandSeparator)
      thousandSeparator = rivets.stdlib.defaultThousandSeparator;

    /*
     *thanks to user2823670
     * http://stackoverflow.com/questions/10015027/javascript-tofixed-not-rounding
     */
    var ret = (+(
      Math.round(+(Math.abs(target) + "e" + precision)) +
      "e" +
      -precision
    )).toFixed(precision);
    if (target < 0) ret = "-" + ret;

    /**
     * thanks to Elias Zamaria
     * http://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
     */
    ret = ret.split(".");
    if (ret.length == 2) {
      return (
        ret[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator) +
        decimalSeparator +
        ret[1]
      );
    }

    return ret[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
  };

  /* date functions */

  rivets.formatters.date = function (target) {
    return moment(target).format(rivets.stdlib.defaultDateFormat);
  };

  rivets.formatters.time = function (target) {
    return moment(target).format(rivets.stdlib.defaultTimeFormat);
  };

  rivets.formatters.datetime = function (target) {
    return moment(target).format(rivets.stdlib.defaultDatetimeFormat);
  };

  rivets.formatters.toTimestamp = function (target) {
    return moment(target).format("X");
  };

  rivets.formatters.toDate = function (target) {
    return moment.unix(target).toDate();
  };

  rivets.formatters.toMoment = function (target) {
    return moment(target);
  };

  /**
   * The date formatter returns a formatted date string according to the moment.js
   * formatting syntax.
   *
   * ```html
   * <span rv-value="model:date | date 'dddd, MMMM Do'"></span>
   * ```
   *
   * @see {@link http://momentjs.com/docs/#/displaying} for format options.
   */
  rivets.formatters.dateFormat = function (target, val) {
    return moment(target).format(val);
  };

  /* object functions */

  rivets.formatters.pairs = function (target) {
    return Object.keys(target).map(function (key) {
      return {
        object: target,
        property: key,
        value: target[key],
      };
    });
  };

  rivets.formatters.keys = function (target) {
    return Object.keys(target);
  };

  rivets.formatters.values = function (target) {
    return Object.keys(target).map(function (key) {
      return target[key];
    });
  };

  /* string functions */

  rivets.formatters.stringFormat = function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var offset = target.indexOf("%s");
      if (offset === -1) {
        break;
      }

      target =
        target.slice(0, offset) + arguments[i] + target.slice(offset + 2);
    }

    return target;
  };

  rivets.formatters.split = function (target, val) {
    return target.split(val);
  };

  rivets.formatters.removeAfterPipe = function (target) {
    return target.substring(0, target.indexOf("|") - 1);
  };

  rivets.formatters.removeBeforePipe = function (target) {
    return target.substring(target.indexOf("|") + 1);
  };

  rivets.formatters.formatCartTitle = function (target) {
    var x = target.substring(0, target.indexOf("|") - 1);
    if (x == "") {
      return target;
    }
    return x;
  };

  rivets.formatters.formatCartColor = function (target) {
    var y = "";

    if (target.includes("|")) {
      var y = target.substring(target.indexOf("|") + 1);
    }

    if (y.trim() == "") {
      return;
    }

    return "Color: " + y;
  };

  rivets.formatters.formatPluralItems = function (target) {
    if (target != null && target > 1) {
      return "You have " + target + " items in your bag";
    }

    return "You have " + target + " item in your bag";
  };

  rivets.formatters.lower = function (target) {
    return target.toLowerCase();
  };

  rivets.formatters.upper = function (target) {
    return target.toUpperCase();
  };

  rivets.formatters.capitalize = function (target) {
    target = rivets.formatters.toString(target);
    return target
      .split(" ")
      .map(function (seq) {
        return seq
          .split("-")
          .map(function (word) {
            return word.charAt(0).toUpperCase() + word.slice(1);
          })
          .join("-");
      })
      .join(" ");
  };

  /* string&array functions */
  rivets.formatters.contains = function (target, val) {
    return target.indexOf(val) !== -1;
  };

  rivets.formatters.doesNotContain = function (target, val) {
    return rivets.formatters.negate(rivets.formatters.contains(target, val));
  };

  rivets.formatters.prettyPrint = function (target) {
    return JSON.stringify(target, null, 2);
  };

  rivets.formatters.isEmpty = function (target) {
    if (!rivets.formatters.toBoolean(target)) return true;
    return rivets.formatters.toArray(target).length === 0;
  };

  /* array formatters */

  rivets.formatters.length = function (target) {
    if (rivets.formatters.isString(target)) return target.length;
    return rivets.formatters.toArray(target).length;
  };

  rivets.formatters.join = function (target, val) {
    return rivets.formatters.toArray(target).join(val);
  };

  /* functions formatters */

  rivets.formatters.wrap = function (target) {
    var args = Array.prototype.slice.call(arguments);
    args.splice(0, 1);

    return function (evt) {
      var cpy = args.slice();
      Array.prototype.push.apply(cpy, Array.prototype.slice.call(arguments));
      return target.apply(this, cpy);
    };
  };

  rivets.formatters.delay = function (target, ts) {
    var self = this;
    return function () {
      setTimeout(function () {
        target.apply(self, arguments);
      }, ts);
    };
  };

  rivets.formatters.preventDefault = function (target) {
    var self = this;
    return function (evt) {
      evt.preventDefault();
      target.call(self, evt);
      return false;
    };
  };

  /*
   * basic bindings for rivets
   *
   */

  rivets.binders.width = function (el, value) {
    el.style.width = value;
  };

  rivets.binders.height = function (el, value) {
    el.style.height = value;
  };

  /* extra bind-type for rivets - we may need a better solution than that one */
  rivets.binders.template = {
    block: true,

    bind: function () {
      this.subviews = [];
    },

    unbind: function (el) {
      this.subviews.forEach(function (el) {
        el.unbind();
      });
    },

    routine: function (el, value) {
      var self = this;

      //kill old data
      this.subviews.forEach(function (el) {
        el.unbind();
      });
      this.subviews = [];

      //set new value
      $(el).html(value);

      //make subhtml binding capable
      var options = {
        binders: this.view.binders,
        formatters: this.view.formatters,
        adapters: this.view.adapters,
        config: this.view.config,
      };

      var models = {};
      for (var k in self.view.models) {
        models[k] = self.view.models[k];
      }

      $(el)
        .children()
        .each(function () {
          var v = new rivets._.View(this, models); ///rivets.bind(this, models)
          v.bind();
          self.subviews.push(v);
        });
    },

    update: function (models) {
      this.subviews.forEach(function (el) {
        el.update(models);
      });
    },
  };

  /* formatter shortcuts */
  rivets.formatters.eq = rivets.formatters.isEqual;
  rivets.formatters.ne = function (target, val) {
    return rivets.formatters.negate(rivets.formatters.isEqual(target, val));
  };

  rivets.formatters.lt = rivets.formatters.isLess;
  rivets.formatters.gt = rivets.formatters.isGreater;

  rivets.formatters.le = rivets.formatters.isLessEqual;
  rivets.formatters.lte = rivets.formatters.isLessEqual;

  rivets.formatters.ge = rivets.formatters.isGreaterEqual;
  rivets.formatters.gte = rivets.formatters.isGreaterEqual;

  rivets.formatters.prv = rivets.formatters.preventDefault;
  rivets.formatters.inject = rivets.formatters.stringFormat;
  rivets.formatters.format = rivets.formatters.dateFormat;
  rivets.formatters.len = rivets.formatters.length;
  rivets.formatters.def = rivets.formatters.default;
  rivets.formatters.neg = rivets.formatters.negate;

  rivets.formatters.date = rivets.formatters.dateFormat;

  rivets.formatters.stringify = rivets.formatters.prettyPrint;
  rivets.formatters.int = rivets.formatters.integer;

  // backwards compatibility
  rivets.formatters.isLower = rivets.formatters.isLess;
  rivets.formatters.isLowerEqual = rivets.formatters.isLessEqual;
});
var Shopify = Shopify || {};

// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// ---------------------------------------------------------------------------
// Image.switchImage
// helps to switch variant images on variant selection
// ---------------------------------------------------------------------------
Shopify.Image = {
  preload: function (images, size) {
    for (var i = 0; i < images.length; i++) {
      var image = images[i];

      this.loadImage(this.getSizedImageUrl(image, size));
    }
  },

  loadImage: function (path) {
    new Image().src = path;
  },

  switchImage: function (image, element, callback) {
    if (!image || !element) {
      return;
    }

    var size = this.imageSize(element.src);
    var imageUrl = this.getSizedImageUrl(image.src, size);

    if (callback) {
      callback(imageUrl, image, element);
    } else {
      element.src = imageUrl;
    }
  },

  imageSize: function (src) {
    var match = src.match(
      /_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./
    );

    if (match != null) {
      return match[1];
    } else {
      return null;
    }
  },

  getSizedImageUrl: function (src, size) {
    if (size == null) {
      return src;
    }

    if (size == "master") {
      return this.removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match != null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + "_" + size + suffix);
    } else {
      return null;
    }
  },

  removeProtocol: function (path) {
    return path.replace(/http(s)?:/, "");
  },
};

(function (undefined) {
  "use strict";
  var id = 0;
  var $ = (window.webshims && webshims.$) || window.jQuery || window.$;

  function RemoteList(element, options) {
    id++;
    this.element = $(element);
    this.options = $.extend({}, RemoteList.defaults, options);
    this.cache = {};
    this.id = "remotelist-" + id;

    if (!this.options.param) {
      this.options.param = this.element.prop("name") || "q";
    }

    this._createDatalist();
    this._bindEvents(this);
  }

  RemoteList.defaults = {
    minLength: 2,
    maxLength: -1,
    source: "",
    param: "",
    select: $.noop,
    renderItem: null,
  };

  RemoteList.createOption = function (option) {
    var ret = $(document.createElement("option"));
    if (!option || typeof option == "string") {
      option = { value: option };
    }
    ret.prop("value", option.value);
    if (option.label) {
      ret.prop("label", option.label);
    }
    ret.data("optionData", option);
    return ret[0];
  };

  RemoteList.prototype = {
    selectedData: function () {
      var elem = this.selectedOption();
      return elem && $(elem).data("optionData");
    },
    selectedOption: function () {
      var selectedOption = null;
      var val = this.val();
      if (val) {
        selectedOption =
          $('[value="' + val + '"]', this.element.prop("list"))[0] || null;
      }
      return selectedOption;
    },
    search: function (val) {
      var dataObj, source, response, reset;
      var that = this;
      var o = this.options;
      var cVal = val;

      if (o.maxLength > -1) {
        cVal = cVal.substr(o, o.maxLength);
      }

      this.doAjax = false;

      if (this.cache[cVal]) {
        this.setList(this.cache[cVal], cVal);
      } else if (!this.currentAjax) {
        this.element.addClass("list-search");
        dataObj = {};
        dataObj[o.param] = val;
        this.currentAjax = true;

        reset = function () {
          if (reset.xhr && reset.xhr.abort) {
            reset.xhr.abort();
          }
          that.currentAjax = false;

          clearTimeout(reset.timer);

          if (that.doAjax) {
            that.search(that.doAjax);
          } else {
            that.element.removeClass("list-search");
          }
        };

        source = $.isFunction(o.source)
          ? o.source
          : function (val, response, fail, dataObj, url) {
              return $.ajax({
                dataType: "json",
                url: url,
                data: dataObj,
                context: this,
                error: fail,
                success: response,
              });
            };

        response = function (data) {
          that.setList(data, cVal);
          reset();
        };

        reset.timer = setTimeout(reset, 999);
        reset.xhr = source(val, response, reset, dataObj, o.source);
      } else {
        this.doAjax = val;
      }
    },
    setList: function (options, val) {
      if (!options) {
        options = [];
      }

      if (this.currentOptions != options && this.currentVal !== val) {
        this.currentOptions = options;
        this.currentVal = val;
        this.cache[val] = options;
        options = $.map(options, RemoteList.createOption);
        this.datalistSelect.html(options);
        if ($.fn.updatePolyfill) {
          this.datalistSelect.updatePolyfill();
        }
      }
    },
    _createDatalist: function () {
      this.datalistSelect = this.element.prop("list");

      if (!this.datalistSelect) {
        this.datalistSelect = $(
          '<datalist id="' + this.id + '"><select /></datalist>'
        );
        this.element.attr("list", this.id);
        this.element.after(this.datalistSelect);
      }

      this.datalistSelect = $("select", this.datalistSelect);
    },
    val: function () {
      return window.webshims && webshims.getDataListVal
        ? webshims.getDataListVal(this.element[0])
        : this.element.prop("value");
    },
    widget: function () {
      return this;
    },
    _bindEvents: function (inst) {
      var searchTimer, selectTimer, character;
      var options = inst.options;

      var detectListselect = (function () {
        var lastValue;
        return function (type) {
          var curValue = inst.val();

          if (curValue === lastValue) {
            return;
          }
          lastValue = curValue;
          if (
            type != "change" &&
            character &&
            character.toLowerCase() ==
              curValue.charAt(curValue.length - 1).toLowerCase()
          ) {
            return;
          }

          if (inst.selectedOption()) {
            clearTimeout(searchTimer);
            if (options.select) {
              options.select.call(inst.element[0], $.Event("listselect"));
            }
            inst.element.trigger("listselect");
            return true;
          }
        };
      })();

      inst.element.on({
        "input focus": (function () {
          var fn = function () {
            var useVal = inst.val();
            if (useVal.length >= options.minLength) {
              inst.search(useVal);
            }
          };
          return function () {
            clearTimeout(searchTimer);
            searchTimer = setTimeout(fn, 99);
          };
        })(),
        /*
                 Actually if an option is selected by a user a change event should be dispatched.
                 Unfortunatley currently no browser got this right, so we use the input event, which isn't 100% a proof solution
                 */
        "input change": function (e) {
          clearTimeout(selectTimer);
          if (e.type == "change") {
            clearTimeout(searchTimer);
            if (inst.element.is(":focus")) {
              detectListselect("change");
            }
          } else {
            selectTimer = setTimeout(detectListselect, 9);
          }
        },
        keypress: (function () {
          var removeChar = function () {
            character = "";
          };
          return function (e) {
            character = String.fromCharCode(e.charCode);
            setTimeout(removeChar, 20);
          };
        })(),
        getoptioncontent: function (e, data) {
          //renderItem
          if (options.renderItem) {
            return options.renderItem(
              '<span class="option-value">' + data.item.value + "</span>",
              data.item.label &&
                '<span class="option-label">' + data.item.label + "</span>",
              $.data(data.item.elem, "optionData")
            );
          }
        },
      });
    },
  };

  $.fn.remoteList = function (opts, args) {
    var fn = opts;
    var ret = this;
    this.each(function () {
      var instRet, markupOpts;
      var inst = $(this).data("remoteList");
      if (typeof inst == "string") {
        markupOpts = { source: inst };
        inst = false;
      }
      if (inst && $.isPlainObject(inst)) {
        markupOpts = inst;
      }
      if (inst && typeof fn == "string" && fn in inst) {
        instRet =
          inst[fn] && inst[fn].apply
            ? inst[fn].apply(inst, args || [])
            : inst[fn];
        if (instRet !== undefined) {
          ret = instRet;
          return false;
        }
      } else {
        $(this).data(
          "remoteList",
          new RemoteList(this, $.extend({}, opts, markupOpts))
        );
      }
    });

    return ret;
  };

  $.fn.remoteList.constructorFn = RemoteList;
})();

/*! jQuery UI - v1.12.1 - 2017-08-10

* http://jqueryui.com

* Includes: effect.js

* Copyright jQuery Foundation and other contributors; Licensed MIT */

(function (t) {
  "function" == typeof define && define.amd ? define(["jquery"], t) : t(jQuery);
})(function (t) {
  (t.ui = t.ui || {}), (t.ui.version = "1.12.1");
  var e = "ui-effects-",
    i = "ui-effects-style",
    s = "ui-effects-animated",
    n = t;
  (t.effects = { effect: {} }),
    (function (t, e) {
      function i(t, e, i) {
        var s = u[e.type] || {};
        return null == t
          ? i || !e.def
            ? null
            : e.def
          : ((t = s.floor ? ~~t : parseFloat(t)),
            isNaN(t)
              ? e.def
              : s.mod
              ? (t + s.mod) % s.mod
              : 0 > t
              ? 0
              : t > s.max
              ? s.max
              : t);
      }
      function s(i) {
        var s = h(),
          n = (s._rgba = []);
        return (
          (i = i.toLowerCase()),
          f(l, function (t, o) {
            var a,
              r = o.re.exec(i),
              l = r && o.parse(r),
              h = o.space || "rgba";
            return l
              ? ((a = s[h](l)),
                (s[c[h].cache] = a[c[h].cache]),
                (n = s._rgba = a._rgba),
                !1)
              : e;
          }),
          n.length
            ? ("0,0,0,0" === n.join() && t.extend(n, o.transparent), s)
            : o[i]
        );
      }
      function n(t, e, i) {
        return (
          (i = (i + 1) % 1),
          1 > 6 * i
            ? t + 6 * (e - t) * i
            : 1 > 2 * i
            ? e
            : 2 > 3 * i
            ? t + 6 * (e - t) * (2 / 3 - i)
            : t
        );
      }
      var o,
        a =
          "backgroundColor borderBottomColor borderLeftColor borderRightColor borderTopColor color columnRuleColor outlineColor textDecorationColor textEmphasisColor",
        r = /^([\-+])=\s*(\d+\.?\d*)/,
        l = [
          {
            re: /rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (t) {
              return [t[1], t[2], t[3], t[4]];
            },
          },
          {
            re: /rgba?\(\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            parse: function (t) {
              return [2.55 * t[1], 2.55 * t[2], 2.55 * t[3], t[4]];
            },
          },
          {
            re: /#([a-f0-9]{2})([a-f0-9]{2})([a-f0-9]{2})/,
            parse: function (t) {
              return [
                parseInt(t[1], 16),
                parseInt(t[2], 16),
                parseInt(t[3], 16),
              ];
            },
          },
          {
            re: /#([a-f0-9])([a-f0-9])([a-f0-9])/,
            parse: function (t) {
              return [
                parseInt(t[1] + t[1], 16),
                parseInt(t[2] + t[2], 16),
                parseInt(t[3] + t[3], 16),
              ];
            },
          },
          {
            re: /hsla?\(\s*(\d+(?:\.\d+)?)\s*,\s*(\d+(?:\.\d+)?)\%\s*,\s*(\d+(?:\.\d+)?)\%\s*(?:,\s*(\d?(?:\.\d+)?)\s*)?\)/,
            space: "hsla",
            parse: function (t) {
              return [t[1], t[2] / 100, t[3] / 100, t[4]];
            },
          },
        ],
        h = (t.Color = function (e, i, s, n) {
          return new t.Color.fn.parse(e, i, s, n);
        }),
        c = {
          rgba: {
            props: {
              red: { idx: 0, type: "byte" },
              green: { idx: 1, type: "byte" },
              blue: { idx: 2, type: "byte" },
            },
          },
          hsla: {
            props: {
              hue: { idx: 0, type: "degrees" },
              saturation: { idx: 1, type: "percent" },
              lightness: { idx: 2, type: "percent" },
            },
          },
        },
        u = {
          byte: { floor: !0, max: 255 },
          percent: { max: 1 },
          degrees: { mod: 360, floor: !0 },
        },
        d = (h.support = {}),
        p = t("<p>")[0],
        f = t.each;
      (p.style.cssText = "background-color:rgba(1,1,1,.5)"),
        (d.rgba = p.style.backgroundColor.indexOf("rgba") > -1),
        f(c, function (t, e) {
          (e.cache = "_" + t),
            (e.props.alpha = { idx: 3, type: "percent", def: 1 });
        }),
        (h.fn = t.extend(h.prototype, {
          parse: function (n, a, r, l) {
            if (n === e) return (this._rgba = [null, null, null, null]), this;
            (n.jquery || n.nodeType) && ((n = t(n).css(a)), (a = e));
            var u = this,
              d = t.type(n),
              p = (this._rgba = []);
            return (
              a !== e && ((n = [n, a, r, l]), (d = "array")),
              "string" === d
                ? this.parse(s(n) || o._default)
                : "array" === d
                ? (f(c.rgba.props, function (t, e) {
                    p[e.idx] = i(n[e.idx], e);
                  }),
                  this)
                : "object" === d
                ? (n instanceof h
                    ? f(c, function (t, e) {
                        n[e.cache] && (u[e.cache] = n[e.cache].slice());
                      })
                    : f(c, function (e, s) {
                        var o = s.cache;
                        f(s.props, function (t, e) {
                          if (!u[o] && s.to) {
                            if ("alpha" === t || null == n[t]) return;
                            u[o] = s.to(u._rgba);
                          }
                          u[o][e.idx] = i(n[t], e, !0);
                        }),
                          u[o] &&
                            0 > t.inArray(null, u[o].slice(0, 3)) &&
                            ((u[o][3] = 1), s.from && (u._rgba = s.from(u[o])));
                      }),
                  this)
                : e
            );
          },
          is: function (t) {
            var i = h(t),
              s = !0,
              n = this;
            return (
              f(c, function (t, o) {
                var a,
                  r = i[o.cache];
                return (
                  r &&
                    ((a = n[o.cache] || (o.to && o.to(n._rgba)) || []),
                    f(o.props, function (t, i) {
                      return null != r[i.idx] ? (s = r[i.idx] === a[i.idx]) : e;
                    })),
                  s
                );
              }),
              s
            );
          },
          _space: function () {
            var t = [],
              e = this;
            return (
              f(c, function (i, s) {
                e[s.cache] && t.push(i);
              }),
              t.pop()
            );
          },
          transition: function (t, e) {
            var s = h(t),
              n = s._space(),
              o = c[n],
              a = 0 === this.alpha() ? h("transparent") : this,
              r = a[o.cache] || o.to(a._rgba),
              l = r.slice();
            return (
              (s = s[o.cache]),
              f(o.props, function (t, n) {
                var o = n.idx,
                  a = r[o],
                  h = s[o],
                  c = u[n.type] || {};
                null !== h &&
                  (null === a
                    ? (l[o] = h)
                    : (c.mod &&
                        (h - a > c.mod / 2
                          ? (a += c.mod)
                          : a - h > c.mod / 2 && (a -= c.mod)),
                      (l[o] = i((h - a) * e + a, n))));
              }),
              this[n](l)
            );
          },
          blend: function (e) {
            if (1 === this._rgba[3]) return this;
            var i = this._rgba.slice(),
              s = i.pop(),
              n = h(e)._rgba;
            return h(
              t.map(i, function (t, e) {
                return (1 - s) * n[e] + s * t;
              })
            );
          },
          toRgbaString: function () {
            var e = "rgba(",
              i = t.map(this._rgba, function (t, e) {
                return null == t ? (e > 2 ? 1 : 0) : t;
              });
            return 1 === i[3] && (i.pop(), (e = "rgb(")), e + i.join() + ")";
          },
          toHslaString: function () {
            var e = "hsla(",
              i = t.map(this.hsla(), function (t, e) {
                return (
                  null == t && (t = e > 2 ? 1 : 0),
                  e && 3 > e && (t = Math.round(100 * t) + "%"),
                  t
                );
              });
            return 1 === i[3] && (i.pop(), (e = "hsl(")), e + i.join() + ")";
          },
          toHexString: function (e) {
            var i = this._rgba.slice(),
              s = i.pop();
            return (
              e && i.push(~~(255 * s)),
              "#" +
                t
                  .map(i, function (t) {
                    return (
                      (t = (t || 0).toString(16)), 1 === t.length ? "0" + t : t
                    );
                  })
                  .join("")
            );
          },
          toString: function () {
            return 0 === this._rgba[3] ? "transparent" : this.toRgbaString();
          },
        })),
        (h.fn.parse.prototype = h.fn),
        (c.hsla.to = function (t) {
          if (null == t[0] || null == t[1] || null == t[2])
            return [null, null, null, t[3]];
          var e,
            i,
            s = t[0] / 255,
            n = t[1] / 255,
            o = t[2] / 255,
            a = t[3],
            r = Math.max(s, n, o),
            l = Math.min(s, n, o),
            h = r - l,
            c = r + l,
            u = 0.5 * c;
          return (
            (e =
              l === r
                ? 0
                : s === r
                ? (60 * (n - o)) / h + 360
                : n === r
                ? (60 * (o - s)) / h + 120
                : (60 * (s - n)) / h + 240),
            (i = 0 === h ? 0 : 0.5 >= u ? h / c : h / (2 - c)),
            [Math.round(e) % 360, i, u, null == a ? 1 : a]
          );
        }),
        (c.hsla.from = function (t) {
          if (null == t[0] || null == t[1] || null == t[2])
            return [null, null, null, t[3]];
          var e = t[0] / 360,
            i = t[1],
            s = t[2],
            o = t[3],
            a = 0.5 >= s ? s * (1 + i) : s + i - s * i,
            r = 2 * s - a;
          return [
            Math.round(255 * n(r, a, e + 1 / 3)),
            Math.round(255 * n(r, a, e)),
            Math.round(255 * n(r, a, e - 1 / 3)),
            o,
          ];
        }),
        f(c, function (s, n) {
          var o = n.props,
            a = n.cache,
            l = n.to,
            c = n.from;
          (h.fn[s] = function (s) {
            if ((l && !this[a] && (this[a] = l(this._rgba)), s === e))
              return this[a].slice();
            var n,
              r = t.type(s),
              u = "array" === r || "object" === r ? s : arguments,
              d = this[a].slice();
            return (
              f(o, function (t, e) {
                var s = u["object" === r ? t : e.idx];
                null == s && (s = d[e.idx]), (d[e.idx] = i(s, e));
              }),
              c ? ((n = h(c(d))), (n[a] = d), n) : h(d)
            );
          }),
            f(o, function (e, i) {
              h.fn[e] ||
                (h.fn[e] = function (n) {
                  var o,
                    a = t.type(n),
                    l = "alpha" === e ? (this._hsla ? "hsla" : "rgba") : s,
                    h = this[l](),
                    c = h[i.idx];
                  return "undefined" === a
                    ? c
                    : ("function" === a &&
                        ((n = n.call(this, c)), (a = t.type(n))),
                      null == n && i.empty
                        ? this
                        : ("string" === a &&
                            ((o = r.exec(n)),
                            o &&
                              (n =
                                c +
                                parseFloat(o[2]) * ("+" === o[1] ? 1 : -1))),
                          (h[i.idx] = n),
                          this[l](h)));
                });
            });
        }),
        (h.hook = function (e) {
          var i = e.split(" ");
          f(i, function (e, i) {
            (t.cssHooks[i] = {
              set: function (e, n) {
                var o,
                  a,
                  r = "";
                if (
                  "transparent" !== n &&
                  ("string" !== t.type(n) || (o = s(n)))
                ) {
                  if (((n = h(o || n)), !d.rgba && 1 !== n._rgba[3])) {
                    for (
                      a = "backgroundColor" === i ? e.parentNode : e;
                      ("" === r || "transparent" === r) && a && a.style;

                    )
                      try {
                        (r = t.css(a, "backgroundColor")), (a = a.parentNode);
                      } catch (l) {}
                    n = n.blend(r && "transparent" !== r ? r : "_default");
                  }
                  n = n.toRgbaString();
                }
                try {
                  e.style[i] = n;
                } catch (l) {}
              },
            }),
              (t.fx.step[i] = function (e) {
                e.colorInit ||
                  ((e.start = h(e.elem, i)),
                  (e.end = h(e.end)),
                  (e.colorInit = !0)),
                  t.cssHooks[i].set(e.elem, e.start.transition(e.end, e.pos));
              });
          });
        }),
        h.hook(a),
        (t.cssHooks.borderColor = {
          expand: function (t) {
            var e = {};
            return (
              f(["Top", "Right", "Bottom", "Left"], function (i, s) {
                e["border" + s + "Color"] = t;
              }),
              e
            );
          },
        }),
        (o = t.Color.names =
          {
            aqua: "#00ffff",
            black: "#000000",
            blue: "#0000ff",
            fuchsia: "#ff00ff",
            gray: "#808080",
            green: "#008000",
            lime: "#00ff00",
            maroon: "#800000",
            navy: "#000080",
            olive: "#808000",
            purple: "#800080",
            red: "#ff0000",
            silver: "#c0c0c0",
            teal: "#008080",
            white: "#ffffff",
            yellow: "#ffff00",
            transparent: [null, null, null, 0],
            _default: "#ffffff",
          });
    })(n),
    (function () {
      function e(e) {
        var i,
          s,
          n = e.ownerDocument.defaultView
            ? e.ownerDocument.defaultView.getComputedStyle(e, null)
            : e.currentStyle,
          o = {};
        if (n && n.length && n[0] && n[n[0]])
          for (s = n.length; s--; )
            (i = n[s]), "string" == typeof n[i] && (o[t.camelCase(i)] = n[i]);
        else for (i in n) "string" == typeof n[i] && (o[i] = n[i]);
        return o;
      }
      function i(e, i) {
        var s,
          n,
          a = {};
        for (s in i)
          (n = i[s]),
            e[s] !== n &&
              (o[s] || ((t.fx.step[s] || !isNaN(parseFloat(n))) && (a[s] = n)));
        return a;
      }
      var s = ["add", "remove", "toggle"],
        o = {
          border: 1,
          borderBottom: 1,
          borderColor: 1,
          borderLeft: 1,
          borderRight: 1,
          borderTop: 1,
          borderWidth: 1,
          margin: 1,
          padding: 1,
        };
      t.each(
        [
          "borderLeftStyle",
          "borderRightStyle",
          "borderBottomStyle",
          "borderTopStyle",
        ],
        function (e, i) {
          t.fx.step[i] = function (t) {
            (("none" !== t.end && !t.setAttr) || (1 === t.pos && !t.setAttr)) &&
              (n.style(t.elem, i, t.end), (t.setAttr = !0));
          };
        }
      ),
        t.fn.addBack ||
          (t.fn.addBack = function (t) {
            return this.add(
              null == t ? this.prevObject : this.prevObject.filter(t)
            );
          }),
        (t.effects.animateClass = function (n, o, a, r) {
          var l = t.speed(o, a, r);
          return this.queue(function () {
            var o,
              a = t(this),
              r = a.attr("class") || "",
              h = l.children ? a.find("*").addBack() : a;
            (h = h.map(function () {
              var i = t(this);
              return { el: i, start: e(this) };
            })),
              (o = function () {
                t.each(s, function (t, e) {
                  n[e] && a[e + "Class"](n[e]);
                });
              }),
              o(),
              (h = h.map(function () {
                return (
                  (this.end = e(this.el[0])),
                  (this.diff = i(this.start, this.end)),
                  this
                );
              })),
              a.attr("class", r),
              (h = h.map(function () {
                var e = this,
                  i = t.Deferred(),
                  s = t.extend({}, l, {
                    queue: !1,
                    complete: function () {
                      i.resolve(e);
                    },
                  });
                return this.el.animate(this.diff, s), i.promise();
              })),
              t.when.apply(t, h.get()).done(function () {
                o(),
                  t.each(arguments, function () {
                    var e = this.el;
                    t.each(this.diff, function (t) {
                      e.css(t, "");
                    });
                  }),
                  l.complete.call(a[0]);
              });
          });
        }),
        t.fn.extend({
          addClass: (function (e) {
            return function (i, s, n, o) {
              return s
                ? t.effects.animateClass.call(this, { add: i }, s, n, o)
                : e.apply(this, arguments);
            };
          })(t.fn.addClass),
          removeClass: (function (e) {
            return function (i, s, n, o) {
              return arguments.length > 1
                ? t.effects.animateClass.call(this, { remove: i }, s, n, o)
                : e.apply(this, arguments);
            };
          })(t.fn.removeClass),
          toggleClass: (function (e) {
            return function (i, s, n, o, a) {
              return "boolean" == typeof s || void 0 === s
                ? n
                  ? t.effects.animateClass.call(
                      this,
                      s ? { add: i } : { remove: i },
                      n,
                      o,
                      a
                    )
                  : e.apply(this, arguments)
                : t.effects.animateClass.call(this, { toggle: i }, s, n, o);
            };
          })(t.fn.toggleClass),
          switchClass: function (e, i, s, n, o) {
            return t.effects.animateClass.call(
              this,
              { add: i, remove: e },
              s,
              n,
              o
            );
          },
        });
    })(),
    (function () {
      function n(e, i, s, n) {
        return (
          t.isPlainObject(e) && ((i = e), (e = e.effect)),
          (e = { effect: e }),
          null == i && (i = {}),
          t.isFunction(i) && ((n = i), (s = null), (i = {})),
          ("number" == typeof i || t.fx.speeds[i]) &&
            ((n = s), (s = i), (i = {})),
          t.isFunction(s) && ((n = s), (s = null)),
          i && t.extend(e, i),
          (s = s || i.duration),
          (e.duration = t.fx.off
            ? 0
            : "number" == typeof s
            ? s
            : s in t.fx.speeds
            ? t.fx.speeds[s]
            : t.fx.speeds._default),
          (e.complete = n || i.complete),
          e
        );
      }
      function o(e) {
        return !e || "number" == typeof e || t.fx.speeds[e]
          ? !0
          : "string" != typeof e || t.effects.effect[e]
          ? t.isFunction(e)
            ? !0
            : "object" != typeof e || e.effect
            ? !1
            : !0
          : !0;
      }
      function a(t, e) {
        var i = e.outerWidth(),
          s = e.outerHeight(),
          n =
            /^rect\((-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto),?\s*(-?\d*\.?\d*px|-?\d+%|auto)\)$/,
          o = n.exec(t) || ["", 0, i, s, 0];
        return {
          top: parseFloat(o[1]) || 0,
          right: "auto" === o[2] ? i : parseFloat(o[2]),
          bottom: "auto" === o[3] ? s : parseFloat(o[3]),
          left: parseFloat(o[4]) || 0,
        };
      }
      t.expr &&
        t.expr.filters &&
        t.expr.filters.animated &&
        (t.expr.filters.animated = (function (e) {
          return function (i) {
            return !!t(i).data(s) || e(i);
          };
        })(t.expr.filters.animated)),
        t.uiBackCompat !== !1 &&
          t.extend(t.effects, {
            save: function (t, i) {
              for (var s = 0, n = i.length; n > s; s++)
                null !== i[s] && t.data(e + i[s], t[0].style[i[s]]);
            },
            restore: function (t, i) {
              for (var s, n = 0, o = i.length; o > n; n++)
                null !== i[n] && ((s = t.data(e + i[n])), t.css(i[n], s));
            },
            setMode: function (t, e) {
              return (
                "toggle" === e && (e = t.is(":hidden") ? "show" : "hide"), e
              );
            },
            createWrapper: function (e) {
              if (e.parent().is(".ui-effects-wrapper")) return e.parent();
              var i = {
                  width: e.outerWidth(!0),
                  height: e.outerHeight(!0),
                  float: e.css("float"),
                },
                s = t("<div></div>").addClass("ui-effects-wrapper").css({
                  fontSize: "100%",
                  background: "transparent",
                  border: "none",
                  margin: 0,
                  padding: 0,
                }),
                n = { width: e.width(), height: e.height() },
                o = document.activeElement;
              try {
                o.id;
              } catch (a) {
                o = document.body;
              }
              return (
                e.wrap(s),
                (e[0] === o || t.contains(e[0], o)) && t(o).trigger("focus"),
                (s = e.parent()),
                "static" === e.css("position")
                  ? (s.css({ position: "relative" }),
                    e.css({ position: "relative" }))
                  : (t.extend(i, {
                      position: e.css("position"),
                      zIndex: e.css("z-index"),
                    }),
                    t.each(["top", "left", "bottom", "right"], function (t, s) {
                      (i[s] = e.css(s)),
                        isNaN(parseInt(i[s], 10)) && (i[s] = "auto");
                    }),
                    e.css({
                      position: "relative",
                      top: 0,
                      left: 0,
                      right: "auto",
                      bottom: "auto",
                    })),
                e.css(n),
                s.css(i).show()
              );
            },
            removeWrapper: function (e) {
              var i = document.activeElement;
              return (
                e.parent().is(".ui-effects-wrapper") &&
                  (e.parent().replaceWith(e),
                  (e[0] === i || t.contains(e[0], i)) && t(i).trigger("focus")),
                e
              );
            },
          }),
        t.extend(t.effects, {
          version: "1.12.1",
          define: function (e, i, s) {
            return (
              s || ((s = i), (i = "effect")),
              (t.effects.effect[e] = s),
              (t.effects.effect[e].mode = i),
              s
            );
          },
          scaledDimensions: function (t, e, i) {
            if (0 === e)
              return { height: 0, width: 0, outerHeight: 0, outerWidth: 0 };
            var s = "horizontal" !== i ? (e || 100) / 100 : 1,
              n = "vertical" !== i ? (e || 100) / 100 : 1;
            return {
              height: t.height() * n,
              width: t.width() * s,
              outerHeight: t.outerHeight() * n,
              outerWidth: t.outerWidth() * s,
            };
          },
          clipToBox: function (t) {
            return {
              width: t.clip.right - t.clip.left,
              height: t.clip.bottom - t.clip.top,
              left: t.clip.left,
              top: t.clip.top,
            };
          },
          unshift: function (t, e, i) {
            var s = t.queue();
            e > 1 && s.splice.apply(s, [1, 0].concat(s.splice(e, i))),
              t.dequeue();
          },
          saveStyle: function (t) {
            t.data(i, t[0].style.cssText);
          },
          restoreStyle: function (t) {
            (t[0].style.cssText = t.data(i) || ""), t.removeData(i);
          },
          mode: function (t, e) {
            var i = t.is(":hidden");
            return (
              "toggle" === e && (e = i ? "show" : "hide"),
              (i ? "hide" === e : "show" === e) && (e = "none"),
              e
            );
          },
          getBaseline: function (t, e) {
            var i, s;
            switch (t[0]) {
              case "top":
                i = 0;
                break;
              case "middle":
                i = 0.5;
                break;
              case "bottom":
                i = 1;
                break;
              default:
                i = t[0] / e.height;
            }
            switch (t[1]) {
              case "left":
                s = 0;
                break;
              case "center":
                s = 0.5;
                break;
              case "right":
                s = 1;
                break;
              default:
                s = t[1] / e.width;
            }
            return { x: s, y: i };
          },
          createPlaceholder: function (i) {
            var s,
              n = i.css("position"),
              o = i.position();
            return (
              i
                .css({
                  marginTop: i.css("marginTop"),
                  marginBottom: i.css("marginBottom"),
                  marginLeft: i.css("marginLeft"),
                  marginRight: i.css("marginRight"),
                })
                .outerWidth(i.outerWidth())
                .outerHeight(i.outerHeight()),
              /^(static|relative)/.test(n) &&
                ((n = "absolute"),
                (s = t("<" + i[0].nodeName + ">")
                  .insertAfter(i)
                  .css({
                    display: /^(inline|ruby)/.test(i.css("display"))
                      ? "inline-block"
                      : "block",
                    visibility: "hidden",
                    marginTop: i.css("marginTop"),
                    marginBottom: i.css("marginBottom"),
                    marginLeft: i.css("marginLeft"),
                    marginRight: i.css("marginRight"),
                    float: i.css("float"),
                  })
                  .outerWidth(i.outerWidth())
                  .outerHeight(i.outerHeight())
                  .addClass("ui-effects-placeholder")),
                i.data(e + "placeholder", s)),
              i.css({ position: n, left: o.left, top: o.top }),
              s
            );
          },
          removePlaceholder: function (t) {
            var i = e + "placeholder",
              s = t.data(i);
            s && (s.remove(), t.removeData(i));
          },
          cleanUp: function (e) {
            t.effects.restoreStyle(e), t.effects.removePlaceholder(e);
          },
          setTransition: function (e, i, s, n) {
            return (
              (n = n || {}),
              t.each(i, function (t, i) {
                var o = e.cssUnit(i);
                o[0] > 0 && (n[i] = o[0] * s + o[1]);
              }),
              n
            );
          },
        }),
        t.fn.extend({
          effect: function () {
            function e(e) {
              function n() {
                l.removeData(s),
                  t.effects.cleanUp(l),
                  "hide" === i.mode && l.hide(),
                  r();
              }
              function r() {
                t.isFunction(h) && h.call(l[0]), t.isFunction(e) && e();
              }
              var l = t(this);
              (i.mode = u.shift()),
                t.uiBackCompat === !1 || a
                  ? "none" === i.mode
                    ? (l[c](), r())
                    : o.call(l[0], i, n)
                  : (l.is(":hidden") ? "hide" === c : "show" === c)
                  ? (l[c](), r())
                  : o.call(l[0], i, r);
            }
            var i = n.apply(this, arguments),
              o = t.effects.effect[i.effect],
              a = o.mode,
              r = i.queue,
              l = r || "fx",
              h = i.complete,
              c = i.mode,
              u = [],
              d = function (e) {
                var i = t(this),
                  n = t.effects.mode(i, c) || a;
                i.data(s, !0),
                  u.push(n),
                  a && ("show" === n || (n === a && "hide" === n)) && i.show(),
                  (a && "none" === n) || t.effects.saveStyle(i),
                  t.isFunction(e) && e();
              };
            return t.fx.off || !o
              ? c
                ? this[c](i.duration, h)
                : this.each(function () {
                    h && h.call(this);
                  })
              : r === !1
              ? this.each(d).each(e)
              : this.queue(l, d).queue(l, e);
          },
          show: (function (t) {
            return function (e) {
              if (o(e)) return t.apply(this, arguments);
              var i = n.apply(this, arguments);
              return (i.mode = "show"), this.effect.call(this, i);
            };
          })(t.fn.show),
          hide: (function (t) {
            return function (e) {
              if (o(e)) return t.apply(this, arguments);
              var i = n.apply(this, arguments);
              return (i.mode = "hide"), this.effect.call(this, i);
            };
          })(t.fn.hide),
          toggle: (function (t) {
            return function (e) {
              if (o(e) || "boolean" == typeof e)
                return t.apply(this, arguments);
              var i = n.apply(this, arguments);
              return (i.mode = "toggle"), this.effect.call(this, i);
            };
          })(t.fn.toggle),
          cssUnit: function (e) {
            var i = this.css(e),
              s = [];
            return (
              t.each(["em", "px", "%", "pt"], function (t, e) {
                i.indexOf(e) > 0 && (s = [parseFloat(i), e]);
              }),
              s
            );
          },
          cssClip: function (t) {
            return t
              ? this.css(
                  "clip",
                  "rect(" +
                    t.top +
                    "px " +
                    t.right +
                    "px " +
                    t.bottom +
                    "px " +
                    t.left +
                    "px)"
                )
              : a(this.css("clip"), this);
          },
          transfer: function (e, i) {
            var s = t(this),
              n = t(e.to),
              o = "fixed" === n.css("position"),
              a = t("body"),
              r = o ? a.scrollTop() : 0,
              l = o ? a.scrollLeft() : 0,
              h = n.offset(),
              c = {
                top: h.top - r,
                left: h.left - l,
                height: n.innerHeight(),
                width: n.innerWidth(),
              },
              u = s.offset(),
              d = t("<div class='ui-effects-transfer'></div>")
                .appendTo("body")
                .addClass(e.className)
                .css({
                  top: u.top - r,
                  left: u.left - l,
                  height: s.innerHeight(),
                  width: s.innerWidth(),
                  position: o ? "fixed" : "absolute",
                })
                .animate(c, e.duration, e.easing, function () {
                  d.remove(), t.isFunction(i) && i();
                });
          },
        }),
        (t.fx.step.clip = function (e) {
          e.clipInit ||
            ((e.start = t(e.elem).cssClip()),
            "string" == typeof e.end && (e.end = a(e.end, e.elem)),
            (e.clipInit = !0)),
            t(e.elem).cssClip({
              top: e.pos * (e.end.top - e.start.top) + e.start.top,
              right: e.pos * (e.end.right - e.start.right) + e.start.right,
              bottom: e.pos * (e.end.bottom - e.start.bottom) + e.start.bottom,
              left: e.pos * (e.end.left - e.start.left) + e.start.left,
            });
        });
    })(),
    (function () {
      var e = {};
      t.each(["Quad", "Cubic", "Quart", "Quint", "Expo"], function (t, i) {
        e[i] = function (e) {
          return Math.pow(e, t + 2);
        };
      }),
        t.extend(e, {
          Sine: function (t) {
            return 1 - Math.cos((t * Math.PI) / 2);
          },
          Circ: function (t) {
            return 1 - Math.sqrt(1 - t * t);
          },
          Elastic: function (t) {
            return 0 === t || 1 === t
              ? t
              : -Math.pow(2, 8 * (t - 1)) *
                  Math.sin(((80 * (t - 1) - 7.5) * Math.PI) / 15);
          },
          Back: function (t) {
            return t * t * (3 * t - 2);
          },
          Bounce: function (t) {
            for (var e, i = 4; ((e = Math.pow(2, --i)) - 1) / 11 > t; );
            return (
              1 / Math.pow(4, 3 - i) -
              7.5625 * Math.pow((3 * e - 2) / 22 - t, 2)
            );
          },
        }),
        t.each(e, function (e, i) {
          (t.easing["easeIn" + e] = i),
            (t.easing["easeOut" + e] = function (t) {
              return 1 - i(1 - t);
            }),
            (t.easing["easeInOut" + e] = function (t) {
              return 0.5 > t ? i(2 * t) / 2 : 1 - i(-2 * t + 2) / 2;
            });
        });
    })(),
    t.effects;
});

// jQuery RoyalSlider plugin. Copyright Dmitry Semenov http://dimsemenov.com
// jquery.royalslider v9.5.8
(function (n) {
  function v(b, f) {
    var c,
      a = this,
      e = window.navigator,
      g = e.userAgent.toLowerCase();
    a.uid = n.rsModules.uid++;
    a.ns = ".rs" + a.uid;
    var d = document.createElement("div").style,
      h = ["webkit", "Moz", "ms", "O"],
      k = "",
      l = 0,
      q;
    for (c = 0; c < h.length; c++)
      (q = h[c]),
        !k && q + "Transform" in d && (k = q),
        (q = q.toLowerCase()),
        window.requestAnimationFrame ||
          ((window.requestAnimationFrame = window[q + "RequestAnimationFrame"]),
          (window.cancelAnimationFrame =
            window[q + "CancelAnimationFrame"] ||
            window[q + "CancelRequestAnimationFrame"]));
    window.requestAnimationFrame ||
      (window.requestAnimationFrame = function (a, b) {
        var c = new Date().getTime(),
          d = Math.max(0, 16 - (c - l)),
          e = window.setTimeout(function () {
            a(c + d);
          }, d);
        l = c + d;
        return e;
      });
    window.cancelAnimationFrame ||
      (window.cancelAnimationFrame = function (a) {
        clearTimeout(a);
      });
    a.isIPAD = g.match(/(ipad)/);
    a.isIOS = a.isIPAD || g.match(/(iphone|ipod)/);
    c = (function (a) {
      a =
        /(chrome)[ \/]([\w.]+)/.exec(a) ||
        /(webkit)[ \/]([\w.]+)/.exec(a) ||
        /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(a) ||
        /(msie) ([\w.]+)/.exec(a) ||
        (0 > a.indexOf("compatible") &&
          /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(a)) ||
        [];
      return { browser: a[1] || "", version: a[2] || "0" };
    })(g);
    h = {};
    c.browser && ((h[c.browser] = !0), (h.version = c.version));
    h.chrome && (h.webkit = !0);
    a._a = h;
    a.isAndroid = -1 < g.indexOf("android");
    a.slider = n(b);
    a.ev = n(a);
    a._b = n(document);
    a.st = n.extend({}, n.fn.royalSlider.defaults, f);
    a._c = a.st.transitionSpeed;
    a._d = 0;
    !a.st.allowCSS3 ||
      (h.webkit && !a.st.allowCSS3OnWebkit) ||
      ((c = k + (k ? "T" : "t")),
      (a._e = c + "ransform" in d && c + "ransition" in d),
      a._e && (a._f = k + (k ? "P" : "p") + "erspective" in d));
    k = k.toLowerCase();
    a._g = "-" + k + "-";
    a._h = "vertical" === a.st.slidesOrientation ? !1 : !0;
    a._i = a._h ? "left" : "top";
    a._j = a._h ? "width" : "height";
    a._k = -1;
    a._l = "fade" === a.st.transitionType ? !1 : !0;
    a._l || ((a.st.sliderDrag = !1), (a._m = 10));
    a._n = "z-index:0; display:none; opacity:0;";
    a._o = 0;
    a._p = 0;
    a._q = 0;
    n.each(n.rsModules, function (b, c) {
      "uid" !== b && c.call(a);
    });
    a.slides = [];
    a._r = 0;
    (a.st.slides ? n(a.st.slides) : a.slider.children().detach()).each(
      function () {
        a._s(this, !0);
      }
    );
    a.st.randomizeSlides &&
      a.slides.sort(function () {
        return 0.5 - Math.random();
      });
    a.numSlides = a.slides.length;
    a._t();
    a.st.startSlideId
      ? a.st.startSlideId > a.numSlides - 1 &&
        (a.st.startSlideId = a.numSlides - 1)
      : (a.st.startSlideId = 0);
    a._o = a.staticSlideId = a.currSlideId = a._u = a.st.startSlideId;
    a.currSlide = a.slides[a.currSlideId];
    a._v = 0;
    a.pointerMultitouch = !1;
    a.slider.addClass((a._h ? "rsHor" : "rsVer") + (a._l ? "" : " rsFade"));
    d = '<div class="rsOverflow"><div class="rsContainer">';
    a.slidesSpacing = a.st.slidesSpacing;
    a._w = (a._h ? a.slider.width() : a.slider.height()) + a.st.slidesSpacing;
    a._x = Boolean(0 < a._y);
    1 >= a.numSlides && (a._z = !1);
    a._a1 = a._z && a._l ? (2 === a.numSlides ? 1 : 2) : 0;
    a._b1 = 6 > a.numSlides ? a.numSlides : 6;
    a._c1 = 0;
    a._d1 = 0;
    a.slidesJQ = [];
    for (c = 0; c < a.numSlides; c++)
      a.slidesJQ.push(
        n(
          '<div style="' +
            (a._l ? "" : c !== a.currSlideId ? a._n : "z-index:0;") +
            '" class="rsSlide "></div>'
        )
      );
    a._e1 = d = n(d + "</div></div>");
    var m = a.ns,
      k = function (b, c, d, e, f) {
        a._j1 = b + c + m;
        a._k1 = b + d + m;
        a._l1 = b + e + m;
        f && (a._m1 = b + f + m);
      };
    c = e.pointerEnabled;
    a.pointerEnabled = c || e.msPointerEnabled;
    a.pointerEnabled
      ? ((a.hasTouch = !1),
        (a._n1 = 0.2),
        (a.pointerMultitouch = Boolean(
          1 < e[(c ? "m" : "msM") + "axTouchPoints"]
        )),
        c
          ? k("pointer", "down", "move", "up", "cancel")
          : k("MSPointer", "Down", "Move", "Up", "Cancel"))
      : (a.isIOS
          ? (a._j1 = a._k1 = a._l1 = a._m1 = "")
          : k("mouse", "down", "move", "up"),
        "ontouchstart" in window || "createTouch" in document
          ? ((a.hasTouch = !0),
            (a._j1 += " touchstart" + m),
            (a._k1 += " touchmove" + m),
            (a._l1 += " touchend" + m),
            (a._m1 += " touchcancel" + m),
            (a._n1 = 0.5),
            a.st.sliderTouch && (a._f1 = !0))
          : ((a.hasTouch = !1), (a._n1 = 0.2)));
    a.st.sliderDrag &&
      ((a._f1 = !0),
      h.msie || h.opera
        ? (a._g1 = a._h1 = "move")
        : h.mozilla
        ? ((a._g1 = "-moz-grab"), (a._h1 = "-moz-grabbing"))
        : h.webkit &&
          -1 != e.platform.indexOf("Mac") &&
          ((a._g1 = "-webkit-grab"), (a._h1 = "-webkit-grabbing")),
      a._i1());
    a.slider.html(d);
    a._o1 = a.st.controlsInside ? a._e1 : a.slider;
    a._p1 = a._e1.children(".rsContainer");
    a.pointerEnabled &&
      a._p1.css((c ? "" : "-ms-") + "touch-action", a._h ? "pan-y" : "pan-x");
    a._q1 = n('<div class="rsPreloader"></div>');
    e = a._p1.children(".rsSlide");
    a._r1 = a.slidesJQ[a.currSlideId];
    a._s1 = 0;
    a._e
      ? ((a._t1 = "transition-property"),
        (a._u1 = "transition-duration"),
        (a._v1 = "transition-timing-function"),
        (a._w1 = a._x1 = a._g + "transform"),
        a._f
          ? (h.webkit && !h.chrome && a.slider.addClass("rsWebkit3d"),
            (a._y1 = "translate3d("),
            (a._z1 = "px, "),
            (a._a2 = "px, 0px)"))
          : ((a._y1 = "translate("), (a._z1 = "px, "), (a._a2 = "px)")),
        a._l
          ? (a._p1[a._g + a._t1] = a._g + "transform")
          : ((h = {}),
            (h[a._g + a._t1] = "opacity"),
            (h[a._g + a._u1] = a.st.transitionSpeed + "ms"),
            (h[a._g + a._v1] = a.st.css3easeInOut),
            e.css(h)))
      : ((a._x1 = "left"), (a._w1 = "top"));
    var p;
    n(window).on("resize" + a.ns, function () {
      p && clearTimeout(p);
      p = setTimeout(function () {
        a.updateSliderSize();
      }, 50);
    });
    a.ev.trigger("rsAfterPropsSetup");
    a.updateSliderSize();
    a.st.keyboardNavEnabled && a._b2();
    a.st.arrowsNavHideOnTouch &&
      (a.hasTouch || a.pointerMultitouch) &&
      (a.st.arrowsNav = !1);
    a.st.arrowsNav &&
      ((e = a._o1),
      n(
        '<div class="rsArrow rsArrowLeft"><div class="rsArrowIcn"></div></div><div class="rsArrow rsArrowRight"><div class="rsArrowIcn"></div></div>'
      ).appendTo(e),
      (a._c2 = e.children(".rsArrowLeft").click(function (b) {
        b.preventDefault();
        a.prev();
      })),
      (a._d2 = e.children(".rsArrowRight").click(function (b) {
        b.preventDefault();
        a.next();
      })),
      a.st.arrowsNavAutoHide &&
        !a.hasTouch &&
        (a._c2.addClass("rsHidden"),
        a._d2.addClass("rsHidden"),
        e.one("mousemove.arrowshover", function () {
          a._c2.removeClass("rsHidden");
          a._d2.removeClass("rsHidden");
        }),
        e.hover(
          function () {
            a._e2 ||
              (a._c2.removeClass("rsHidden"), a._d2.removeClass("rsHidden"));
          },
          function () {
            a._e2 || (a._c2.addClass("rsHidden"), a._d2.addClass("rsHidden"));
          }
        )),
      a.ev.on("rsOnUpdateNav", function () {
        a._f2();
      }),
      a._f2());
    if ((a.hasTouch && a.st.sliderTouch) || (!a.hasTouch && a.st.sliderDrag))
      a._p1.on(a._j1, function (b) {
        a._g2(b);
      });
    else a.dragSuccess = !1;
    var r = [
      "rsPlayBtnIcon",
      "rsPlayBtn",
      "rsCloseVideoBtn",
      "rsCloseVideoIcn",
    ];
    a._p1
      .click(function (b) {
        if (!a.dragSuccess) {
          var c = n(b.target).attr("class");
          if (-1 !== n.inArray(c, r) && a.toggleVideo()) return !1;
          if (a.st.navigateByClick && !a._h2) {
            if (n(b.target).closest(".rsNoDrag", a._r1).length) return !0;
            a._i2(b);
          }
          a.ev.trigger("rsSlideClick", b);
        }
      })
      .on("click.rs", "a", function (b) {
        if (a.dragSuccess) return !1;
        a._h2 = !0;
        setTimeout(function () {
          a._h2 = !1;
        }, 3);
      });
    a.ev.trigger("rsAfterInit");
  }
  n.rsModules || (n.rsModules = { uid: 0 });
  v.prototype = {
    constructor: v,
    _i2: function (b) {
      b = b[this._h ? "pageX" : "pageY"] - this._j2;
      b >= this._q ? this.next() : 0 > b && this.prev();
    },
    _t: function () {
      var b;
      b = this.st.numImagesToPreload;
      if ((this._z = this.st.loop))
        2 === this.numSlides
          ? ((this._z = !1), (this.st.loopRewind = !0))
          : 2 > this.numSlides && (this.st.loopRewind = this._z = !1);
      this._z &&
        0 < b &&
        (4 >= this.numSlides
          ? (b = 1)
          : this.st.numImagesToPreload > (this.numSlides - 1) / 2 &&
            (b = Math.floor((this.numSlides - 1) / 2)));
      this._y = b;
    },
    _s: function (b, f) {
      function c(b, c) {
        c ? g.images.push(b.attr(c)) : g.images.push(b.text());
        if (h) {
          h = !1;
          g.caption = "src" === c ? b.attr("alt") : b.contents();
          g.image = g.images[0];
          g.videoURL = b.attr("data-rsVideo");
          var d = b.attr("data-rsw"),
            e = b.attr("data-rsh");
          "undefined" !== typeof d &&
          !1 !== d &&
          "undefined" !== typeof e &&
          !1 !== e
            ? ((g.iW = parseInt(d, 10)), (g.iH = parseInt(e, 10)))
            : a.st.imgWidth &&
              a.st.imgHeight &&
              ((g.iW = a.st.imgWidth), (g.iH = a.st.imgHeight));
        }
      }
      var a = this,
        e,
        g = {},
        d,
        h = !0;
      b = n(b);
      a._k2 = b;
      a.ev.trigger("rsBeforeParseNode", [b, g]);
      if (!g.stopParsing)
        return (
          (b = a._k2),
          (g.id = a._r),
          (g.contentAdded = !1),
          a._r++,
          (g.images = []),
          (g.isBig = !1),
          g.hasCover ||
            (b.hasClass("rsImg")
              ? ((d = b), (e = !0))
              : ((d = b.find(".rsImg")), d.length && (e = !0)),
            e
              ? ((g.bigImage = d.eq(0).attr("data-rsBigImg")),
                d.each(function () {
                  var a = n(this);
                  a.is("a") ? c(a, "href") : a.is("img") ? c(a, "src") : c(a);
                }))
              : b.is("img") &&
                (b.addClass("rsImg rsMainSlideImage"), c(b, "src"))),
          (d = b.find(".rsCaption")),
          d.length && (g.caption = d.remove()),
          (g.content = b),
          a.ev.trigger("rsAfterParseNode", [b, g]),
          f && a.slides.push(g),
          0 === g.images.length &&
            ((g.isLoaded = !0),
            (g.isRendered = !1),
            (g.isLoading = !1),
            (g.images = null)),
          g
        );
    },
    _b2: function () {
      var b = this,
        f,
        c,
        a = function (a) {
          37 === a ? b.prev() : 39 === a && b.next();
        };
      b._b
        .on("keydown" + b.ns, function (e) {
          if (!b.st.keyboardNavEnabled) return !0;
          if (!(b._l2 || ((c = e.keyCode), (37 !== c && 39 !== c) || f))) {
            if (
              document.activeElement &&
              /(INPUT|SELECT|TEXTAREA)/i.test(document.activeElement.tagName)
            )
              return !0;
            b.isFullscreen && e.preventDefault();
            a(c);
            f = setInterval(function () {
              a(c);
            }, 700);
          }
        })
        .on("keyup" + b.ns, function (a) {
          f && (clearInterval(f), (f = null));
        });
    },
    goTo: function (b, f) {
      b !== this.currSlideId && this._m2(b, this.st.transitionSpeed, !0, !f);
    },
    destroy: function (b) {
      this.ev.trigger("rsBeforeDestroy");
      this._b.off(
        "keydown" +
          this.ns +
          " keyup" +
          this.ns +
          " " +
          this._k1 +
          " " +
          this._l1
      );
      this._p1.off(this._j1 + " click");
      this.slider.data("royalSlider", null);
      n.removeData(this.slider, "royalSlider");
      n(window).off("resize" + this.ns);
      this.loadingTimeout && clearTimeout(this.loadingTimeout);
      b && this.slider.remove();
      this.ev = this.slider = this.slides = null;
    },
    _n2: function (b, f) {
      function c(c, f, g) {
        c.isAdded
          ? (a(f, c), e(f, c))
          : (g || (g = d.slidesJQ[f]),
            c.holder
              ? (g = c.holder)
              : ((g = d.slidesJQ[f] = n(g)), (c.holder = g)),
            (c.appendOnLoaded = !1),
            e(f, c, g),
            a(f, c),
            d._p2(c, g, b),
            (c.isAdded = !0));
      }
      function a(a, c) {
        c.contentAdded || (d.setItemHtml(c, b), b || (c.contentAdded = !0));
      }
      function e(a, b, c) {
        d._l && (c || (c = d.slidesJQ[a]), c.css(d._i, (a + d._d1 + p) * d._w));
      }
      function g(a) {
        if (l) {
          if (a > q - 1) return g(a - q);
          if (0 > a) return g(q + a);
        }
        return a;
      }
      var d = this,
        h,
        k,
        l = d._z,
        q = d.numSlides;
      if (!isNaN(f)) return g(f);
      var m = d.currSlideId,
        p,
        r = b
          ? Math.abs(d._o2 - d.currSlideId) >= d.numSlides - 1
            ? 0
            : 1
          : d._y,
        t = Math.min(2, r),
        w = !1,
        v = !1,
        u;
      for (k = m; k < m + 1 + t; k++)
        if (((u = g(k)), (h = d.slides[u]) && (!h.isAdded || !h.positionSet))) {
          w = !0;
          break;
        }
      for (k = m - 1; k > m - 1 - t; k--)
        if (((u = g(k)), (h = d.slides[u]) && (!h.isAdded || !h.positionSet))) {
          v = !0;
          break;
        }
      if (w)
        for (k = m; k < m + r + 1; k++)
          (u = g(k)),
            (p = Math.floor((d._u - (m - k)) / d.numSlides) * d.numSlides),
            (h = d.slides[u]) && c(h, u);
      if (v)
        for (k = m - 1; k > m - 1 - r; k--)
          (u = g(k)),
            (p = Math.floor((d._u - (m - k)) / q) * q),
            (h = d.slides[u]) && c(h, u);
      if (!b)
        for (t = g(m - r), m = g(m + r), r = t > m ? 0 : t, k = 0; k < q; k++)
          (t > m && k > t - 1) ||
            !(k < r || k > m) ||
            ((h = d.slides[k]) &&
              h.holder &&
              (h.holder.detach(), (h.isAdded = !1)));
    },
    setItemHtml: function (b, f) {
      var c = this,
        a = function () {
          if (!b.images)
            (b.isRendered = !0), (b.isLoaded = !0), (b.isLoading = !1), d(!0);
          else if (!b.isLoading) {
            var a, f;
            b.content.hasClass("rsImg")
              ? ((a = b.content), (f = !0))
              : (a = b.content.find(".rsImg:not(img)"));
            a &&
              !a.is("img") &&
              a.each(function () {
                var a = n(this),
                  c =
                    '<img class="rsImg" src="' +
                    (a.is("a") ? a.attr("href") : a.text()) +
                    '" />';
                f ? (b.content = n(c)) : a.replaceWith(c);
              });
            a = f ? b.content : b.content.find("img.rsImg");
            k();
            a.eq(0).addClass("rsMainSlideImage");
            b.iW && b.iH && (b.isLoaded || c._q2(b), d());
            b.isLoading = !0;
            if (b.isBig)
              n("<img />")
                .on("load.rs error.rs", function (a) {
                  n(this).off("load.rs error.rs");
                  e([this], !0);
                })
                .attr("src", b.image);
            else {
              b.loaded = [];
              b.numStartedLoad = 0;
              a = function (a) {
                n(this).off("load.rs error.rs");
                b.loaded.push(this);
                b.loaded.length === b.numStartedLoad && e(b.loaded, !1);
              };
              for (var g = 0; g < b.images.length; g++) {
                var h = n("<img />");
                b.numStartedLoad++;
                h.on("load.rs error.rs", a).attr("src", b.images[g]);
              }
            }
          }
        },
        e = function (a, c) {
          if (a.length) {
            var d = a[0];
            if (c !== b.isBig) (d = b.holder.children()) && 1 < d.length && l();
            else if (b.iW && b.iH) g();
            else if (((b.iW = d.width), (b.iH = d.height), b.iW && b.iH)) g();
            else {
              var e = new Image();
              e.onload = function () {
                e.width
                  ? ((b.iW = e.width), (b.iH = e.height), g())
                  : setTimeout(function () {
                      e.width && ((b.iW = e.width), (b.iH = e.height));
                      g();
                    }, 1e3);
              };
              e.src = d.src;
            }
          } else g();
        },
        g = function () {
          b.isLoaded = !0;
          b.isLoading = !1;
          d();
          l();
          h();
        },
        d = function () {
          if (!b.isAppended && c.ev) {
            var a = c.st.visibleNearby,
              d = b.id - c._o;
            f ||
              b.appendOnLoaded ||
              !c.st.fadeinLoadedSlide ||
              (0 !== d && (!(a || c._r2 || c._l2) || (-1 !== d && 1 !== d))) ||
              ((a = { visibility: "visible", opacity: 0 }),
              (a[c._g + "transition"] = "opacity 400ms ease-in-out"),
              b.content.css(a),
              setTimeout(function () {
                b.content.css("opacity", 1);
              }, 16));
            b.holder.find(".rsPreloader").length
              ? b.holder.append(b.content)
              : b.holder.html(b.content);
            b.isAppended = !0;
            b.isLoaded && (c._q2(b), h());
            b.sizeReady ||
              ((b.sizeReady = !0),
              setTimeout(function () {
                c.ev.trigger("rsMaybeSizeReady", b);
              }, 100));
          }
        },
        h = function () {
          !b.loadedTriggered &&
            c.ev &&
            ((b.isLoaded = b.loadedTriggered = !0),
            b.holder.trigger("rsAfterContentSet"),
            c.ev.trigger("rsAfterContentSet", b));
        },
        k = function () {
          c.st.usePreloader && b.holder.html(c._q1.clone());
        },
        l = function (a) {
          c.st.usePreloader &&
            ((a = b.holder.find(".rsPreloader")), a.length && a.remove());
        };
      b.isLoaded
        ? d()
        : f
        ? !c._l && b.images && b.iW && b.iH
          ? a()
          : ((b.holder.isWaiting = !0), k(), (b.holder.slideId = -99))
        : a();
    },
    _p2: function (b, f, c) {
      this._p1.append(b.holder);
      b.appendOnLoaded = !1;
    },
    _g2: function (b, f) {
      var c = this,
        a,
        e = "touchstart" === b.type;
      c._s2 = e;
      c.ev.trigger("rsDragStart");
      if (n(b.target).closest(".rsNoDrag", c._r1).length)
        return (c.dragSuccess = !1), !0;
      !f && c._r2 && ((c._t2 = !0), c._u2());
      c.dragSuccess = !1;
      if (c._l2) e && (c._v2 = !0);
      else {
        e && (c._v2 = !1);
        c._w2();
        if (e) {
          var g = b.originalEvent.touches;
          if (g && 0 < g.length) (a = g[0]), 1 < g.length && (c._v2 = !0);
          else return;
        } else
          b.preventDefault(),
            (a = b),
            c.pointerEnabled && (a = a.originalEvent);
        c._l2 = !0;
        c._b
          .on(c._k1, function (a) {
            c._x2(a, f);
          })
          .on(c._l1, function (a) {
            c._y2(a, f);
          });
        c._z2 = "";
        c._a3 = !1;
        c._b3 = a.pageX;
        c._c3 = a.pageY;
        c._d3 = c._v = (f ? c._e3 : c._h) ? a.pageX : a.pageY;
        c._f3 = 0;
        c._g3 = 0;
        c._h3 = f ? c._i3 : c._p;
        c._j3 = new Date().getTime();
        if (e)
          c._e1.on(c._m1, function (a) {
            c._y2(a, f);
          });
      }
    },
    _k3: function (b, f) {
      if (this._l3) {
        var c = this._m3,
          a = b.pageX - this._b3,
          e = b.pageY - this._c3,
          g = this._h3 + a,
          d = this._h3 + e,
          h = f ? this._e3 : this._h,
          g = h ? g : d,
          d = this._z2;
        this._a3 = !0;
        this._b3 = b.pageX;
        this._c3 = b.pageY;
        "x" === d && 0 !== a
          ? (this._f3 = 0 < a ? 1 : -1)
          : "y" === d && 0 !== e && (this._g3 = 0 < e ? 1 : -1);
        d = h ? this._b3 : this._c3;
        a = h ? a : e;
        f
          ? g > this._n3
            ? (g = this._h3 + a * this._n1)
            : g < this._o3 && (g = this._h3 + a * this._n1)
          : this._z ||
            (0 >= this.currSlideId &&
              0 < d - this._d3 &&
              (g = this._h3 + a * this._n1),
            this.currSlideId >= this.numSlides - 1 &&
              0 > d - this._d3 &&
              (g = this._h3 + a * this._n1));
        this._h3 = g;
        200 < c - this._j3 && ((this._j3 = c), (this._v = d));
        f ? this._q3(this._h3) : this._l && this._p3(this._h3);
      }
    },
    _x2: function (b, f) {
      var c = this,
        a,
        e = "touchmove" === b.type;
      if (!c._s2 || e) {
        if (e) {
          if (c._r3) return;
          var g = b.originalEvent.touches;
          if (g) {
            if (1 < g.length) return;
            a = g[0];
          } else return;
        } else (a = b), c.pointerEnabled && (a = a.originalEvent);
        c._a3 ||
          (c._e && (f ? c._s3 : c._p1).css(c._g + c._u1, "0s"),
          (function h() {
            c._l2 &&
              ((c._t3 = requestAnimationFrame(h)), c._u3 && c._k3(c._u3, f));
          })());
        if (c._l3)
          b.preventDefault(), (c._m3 = new Date().getTime()), (c._u3 = a);
        else if (
          ((g = f ? c._e3 : c._h),
          (a =
            Math.abs(a.pageX - c._b3) -
            Math.abs(a.pageY - c._c3) -
            (g ? -7 : 7)),
          7 < a)
        ) {
          if (g) b.preventDefault(), (c._z2 = "x");
          else if (e) {
            c._v3(b);
            return;
          }
          c._l3 = !0;
        } else if (-7 > a) {
          if (!g) b.preventDefault(), (c._z2 = "y");
          else if (e) {
            c._v3(b);
            return;
          }
          c._l3 = !0;
        }
      }
    },
    _v3: function (b, f) {
      this._r3 = !0;
      this._a3 = this._l2 = !1;
      this._y2(b);
    },
    _y2: function (b, f) {
      function c(a) {
        return 100 > a ? 100 : 500 < a ? 500 : a;
      }
      function a(a, b) {
        if (e._l || f)
          (h = (-e._u - e._d1) * e._w),
            (k = Math.abs(e._p - h)),
            (e._c = k / b),
            a && (e._c += 250),
            (e._c = c(e._c)),
            e._x3(h, !1);
      }
      var e = this,
        g,
        d,
        h,
        k;
      g = -1 < b.type.indexOf("touch");
      if (!e._s2 || g)
        if (
          ((e._s2 = !1),
          e.ev.trigger("rsDragRelease"),
          (e._u3 = null),
          (e._l2 = !1),
          (e._r3 = !1),
          (e._l3 = !1),
          (e._m3 = 0),
          cancelAnimationFrame(e._t3),
          e._a3 && (f ? e._q3(e._h3) : e._l && e._p3(e._h3)),
          e._b.off(e._k1).off(e._l1),
          g && e._e1.off(e._m1),
          e._i1(),
          !e._a3 && !e._v2 && f && e._w3)
        ) {
          var l = n(b.target).closest(".rsNavItem");
          l.length && e.goTo(l.index());
        } else {
          d = f ? e._e3 : e._h;
          if (!e._a3 || ("y" === e._z2 && d) || ("x" === e._z2 && !d))
            if (!f && e._t2) {
              e._t2 = !1;
              if (e.st.navigateByClick) {
                e._i2(e.pointerEnabled ? b.originalEvent : b);
                e.dragSuccess = !0;
                return;
              }
              e.dragSuccess = !0;
            } else {
              e._t2 = !1;
              e.dragSuccess = !1;
              return;
            }
          else e.dragSuccess = !0;
          e._t2 = !1;
          e._z2 = "";
          var q = e.st.minSlideOffset;
          g = g
            ? b.originalEvent.changedTouches[0]
            : e.pointerEnabled
            ? b.originalEvent
            : b;
          var m = d ? g.pageX : g.pageY,
            p = e._d3;
          g = e._v;
          var r = e.currSlideId,
            t = e.numSlides,
            w = d ? e._f3 : e._g3,
            v = e._z;
          Math.abs(m - p);
          g = m - g;
          d = new Date().getTime() - e._j3;
          d = Math.abs(g) / d;
          if (0 === w || 1 >= t) a(!0, d);
          else {
            if (!v && !f)
              if (0 >= r) {
                if (0 < w) {
                  a(!0, d);
                  return;
                }
              } else if (r >= t - 1 && 0 > w) {
                a(!0, d);
                return;
              }
            if (f) {
              h = e._i3;
              if (h > e._n3) h = e._n3;
              else if (h < e._o3) h = e._o3;
              else {
                m = (d * d) / 0.006;
                l = -e._i3;
                p = e._y3 - e._z3 + e._i3;
                0 < g && m > l
                  ? ((l += e._z3 / (15 / ((m / d) * 0.003))),
                    (d = (d * l) / m),
                    (m = l))
                  : 0 > g &&
                    m > p &&
                    ((p += e._z3 / (15 / ((m / d) * 0.003))),
                    (d = (d * p) / m),
                    (m = p));
                l = Math.max(Math.round(d / 0.003), 50);
                h += m * (0 > g ? -1 : 1);
                if (h > e._n3) {
                  e._a4(h, l, !0, e._n3, 200);
                  return;
                }
                if (h < e._o3) {
                  e._a4(h, l, !0, e._o3, 200);
                  return;
                }
              }
              e._a4(h, l, !0);
            } else
              (l = function (a) {
                var b = Math.floor(a / e._w);
                a - b * e._w > q && b++;
                return b;
              }),
                p + q < m
                  ? 0 > w
                    ? a(!1, d)
                    : ((l = l(m - p)),
                      e._m2(
                        e.currSlideId - l,
                        c(Math.abs(e._p - (-e._u - e._d1 + l) * e._w) / d),
                        !1,
                        !0,
                        !0
                      ))
                  : p - q > m
                  ? 0 < w
                    ? a(!1, d)
                    : ((l = l(p - m)),
                      e._m2(
                        e.currSlideId + l,
                        c(Math.abs(e._p - (-e._u - e._d1 - l) * e._w) / d),
                        !1,
                        !0,
                        !0
                      ))
                  : a(!1, d);
          }
        }
    },
    _p3: function (b) {
      b = this._p = b;
      this._e
        ? this._p1.css(
            this._x1,
            this._y1 +
              (this._h ? b + this._z1 + 0 : 0 + this._z1 + b) +
              this._a2
          )
        : this._p1.css(this._h ? this._x1 : this._w1, b);
    },
    updateSliderSize: function (b) {
      var f, c;
      if (this.slider) {
        if (this.st.autoScaleSlider) {
          var a = this.st.autoScaleSliderWidth,
            e = this.st.autoScaleSliderHeight;
          this.st.autoScaleHeight
            ? ((f = this.slider.width()),
              f != this.width &&
                (this.slider.css("height", (e / a) * f),
                (f = this.slider.width())),
              (c = this.slider.height()))
            : ((c = this.slider.height()),
              c != this.height &&
                (this.slider.css("width", (a / e) * c),
                (c = this.slider.height())),
              (f = this.slider.width()));
        } else (f = this.slider.width()), (c = this.slider.height());
        if (b || f != this.width || c != this.height) {
          this.width = f;
          this.height = c;
          this._b4 = f;
          this._c4 = c;
          this.ev.trigger("rsBeforeSizeSet");
          this.ev.trigger("rsAfterSizePropSet");
          this._e1.css({ width: this._b4, height: this._c4 });
          this._w = (this._h ? this._b4 : this._c4) + this.st.slidesSpacing;
          this._d4 = this.st.imageScalePadding;
          for (f = 0; f < this.slides.length; f++)
            (b = this.slides[f]),
              (b.positionSet = !1),
              b && b.images && b.isLoaded && ((b.isRendered = !1), this._q2(b));
          if (this._e4)
            for (f = 0; f < this._e4.length; f++)
              (b = this._e4[f]),
                b.holder.css(this._i, (b.id + this._d1) * this._w);
          this._n2();
          this._l &&
            (this._e && this._p1.css(this._g + "transition-duration", "0s"),
            this._p3((-this._u - this._d1) * this._w));
          this.ev.trigger("rsOnUpdateNav");
        }
        this._j2 = this._e1.offset();
        this._j2 = this._j2[this._i];
      }
    },
    appendSlide: function (b, f) {
      var c = this._s(b);
      if (isNaN(f) || f > this.numSlides) f = this.numSlides;
      this.slides.splice(f, 0, c);
      this.slidesJQ.splice(
        f,
        0,
        n(
          '<div style="' +
            (this._l ? "position:absolute;" : this._n) +
            '" class="rsSlide"></div>'
        )
      );
      f <= this.currSlideId && this.currSlideId++;
      this.ev.trigger("rsOnAppendSlide", [c, f]);
      this._f4(f);
      f === this.currSlideId && this.ev.trigger("rsAfterSlideChange");
    },
    removeSlide: function (b) {
      var f = this.slides[b];
      f &&
        (f.holder && f.holder.remove(),
        b < this.currSlideId && this.currSlideId--,
        this.slides.splice(b, 1),
        this.slidesJQ.splice(b, 1),
        this.ev.trigger("rsOnRemoveSlide", [b]),
        this._f4(b),
        b === this.currSlideId && this.ev.trigger("rsAfterSlideChange"));
    },
    _f4: function (b) {
      var f = this;
      b = f.numSlides;
      b = 0 >= f._u ? 0 : Math.floor(f._u / b);
      f.numSlides = f.slides.length;
      0 === f.numSlides
        ? ((f.currSlideId = f._d1 = f._u = 0), (f.currSlide = f._g4 = null))
        : (f._u = b * f.numSlides + f.currSlideId);
      for (b = 0; b < f.numSlides; b++) f.slides[b].id = b;
      f.currSlide = f.slides[f.currSlideId];
      f._r1 = f.slidesJQ[f.currSlideId];
      f.currSlideId >= f.numSlides
        ? f.goTo(f.numSlides - 1)
        : 0 > f.currSlideId && f.goTo(0);
      f._t();
      f._l && f._p1.css(f._g + f._u1, "0ms");
      f._h4 && clearTimeout(f._h4);
      f._h4 = setTimeout(function () {
        f._l && f._p3((-f._u - f._d1) * f._w);
        f._n2();
        f._l || f._r1.css({ display: "block", opacity: 1 });
      }, 14);
      f.ev.trigger("rsOnUpdateNav");
    },
    _i1: function () {
      this._f1 &&
        this._l &&
        (this._g1
          ? this._e1.css("cursor", this._g1)
          : (this._e1.removeClass("grabbing-cursor"),
            this._e1.addClass("grab-cursor")));
    },
    _w2: function () {
      this._f1 &&
        this._l &&
        (this._h1
          ? this._e1.css("cursor", this._h1)
          : (this._e1.removeClass("grab-cursor"),
            this._e1.addClass("grabbing-cursor")));
    },
    next: function (b) {
      this._m2("next", this.st.transitionSpeed, !0, !b);
    },
    prev: function (b) {
      this._m2("prev", this.st.transitionSpeed, !0, !b);
    },
    _m2: function (b, f, c, a, e) {
      var g = this,
        d,
        h,
        k;
      g.ev.trigger("rsBeforeMove", [b, a]);
      k =
        "next" === b
          ? g.currSlideId + 1
          : "prev" === b
          ? g.currSlideId - 1
          : (b = parseInt(b, 10));
      if (!g._z) {
        if (0 > k) {
          g._i4("left", !a);
          return;
        }
        if (k >= g.numSlides) {
          g._i4("right", !a);
          return;
        }
      }
      g._r2 && (g._u2(!0), (c = !1));
      h = k - g.currSlideId;
      k = g._o2 = g.currSlideId;
      var l = g.currSlideId + h;
      a = g._u;
      var n;
      g._z ? ((l = g._n2(!1, l)), (a += h)) : (a = l);
      g._o = l;
      g._g4 = g.slidesJQ[g.currSlideId];
      g._u = a;
      g.currSlideId = g._o;
      g.currSlide = g.slides[g.currSlideId];
      g._r1 = g.slidesJQ[g.currSlideId];
      var l = g.st.slidesDiff,
        m = Boolean(0 < h);
      h = Math.abs(h);
      var p = Math.floor(k / g._y),
        r = Math.floor((k + (m ? l : -l)) / g._y),
        p = (m ? Math.max(p, r) : Math.min(p, r)) * g._y + (m ? g._y - 1 : 0);
      p > g.numSlides - 1 ? (p = g.numSlides - 1) : 0 > p && (p = 0);
      k = m ? p - k : k - p;
      k > g._y && (k = g._y);
      if (h > k + l)
        for (
          g._d1 += (h - (k + l)) * (m ? -1 : 1), f *= 1.4, k = 0;
          k < g.numSlides;
          k++
        )
          g.slides[k].positionSet = !1;
      g._c = f;
      g._n2(!0);
      e || (n = !0);
      d = (-a - g._d1) * g._w;
      n
        ? setTimeout(function () {
            g._j4 = !1;
            g._x3(d, b, !1, c);
            g.ev.trigger("rsOnUpdateNav");
          }, 0)
        : (g._x3(d, b, !1, c), g.ev.trigger("rsOnUpdateNav"));
    },
    _f2: function () {
      this.st.arrowsNav &&
        (1 >= this.numSlides
          ? (this._c2.css("display", "none"), this._d2.css("display", "none"))
          : (this._c2.css("display", "block"),
            this._d2.css("display", "block"),
            this._z ||
              this.st.loopRewind ||
              (0 === this.currSlideId
                ? this._c2.addClass("rsArrowDisabled")
                : this._c2.removeClass("rsArrowDisabled"),
              this.currSlideId === this.numSlides - 1
                ? this._d2.addClass("rsArrowDisabled")
                : this._d2.removeClass("rsArrowDisabled"))));
    },
    _x3: function (b, f, c, a, e) {
      function g() {
        var a;
        h &&
          (a = h.data("rsTimeout")) &&
          (h !== k && h.css({ opacity: 0, display: "none", zIndex: 0 }),
          clearTimeout(a),
          h.data("rsTimeout", ""));
        if ((a = k.data("rsTimeout"))) clearTimeout(a), k.data("rsTimeout", "");
      }
      var d = this,
        h,
        k,
        l = {};
      isNaN(d._c) && (d._c = 400);
      d._p = d._h3 = b;
      d.ev.trigger("rsBeforeAnimStart");
      d._e
        ? d._l
          ? ((d._c = parseInt(d._c, 10)),
            (c = d._g + d._v1),
            (l[d._g + d._u1] = d._c + "ms"),
            (l[c] = a
              ? n.rsCSS3Easing[d.st.easeInOut]
              : n.rsCSS3Easing[d.st.easeOut]),
            d._p1.css(l),
            a || !d.hasTouch
              ? setTimeout(function () {
                  d._p3(b);
                }, 5)
              : d._p3(b))
          : ((d._c = d.st.transitionSpeed),
            (h = d._g4),
            (k = d._r1),
            k.data("rsTimeout") && k.css("opacity", 0),
            g(),
            h &&
              h.data(
                "rsTimeout",
                setTimeout(function () {
                  l[d._g + d._u1] = "0ms";
                  l.zIndex = 0;
                  l.display = "none";
                  h.data("rsTimeout", "");
                  h.css(l);
                  setTimeout(function () {
                    h.css("opacity", 0);
                  }, 16);
                }, d._c + 60)
              ),
            (l.display = "block"),
            (l.zIndex = d._m),
            (l.opacity = 0),
            (l[d._g + d._u1] = "0ms"),
            (l[d._g + d._v1] = n.rsCSS3Easing[d.st.easeInOut]),
            k.css(l),
            k.data(
              "rsTimeout",
              setTimeout(function () {
                k.css(d._g + d._u1, d._c + "ms");
                k.data(
                  "rsTimeout",
                  setTimeout(function () {
                    k.css("opacity", 1);
                    k.data("rsTimeout", "");
                  }, 20)
                );
              }, 20)
            ))
        : d._l
        ? ((l[d._h ? d._x1 : d._w1] = b + "px"),
          d._p1.animate(l, d._c, a ? d.st.easeInOut : d.st.easeOut))
        : ((h = d._g4),
          (k = d._r1),
          k.stop(!0, !0).css({ opacity: 0, display: "block", zIndex: d._m }),
          (d._c = d.st.transitionSpeed),
          k.animate({ opacity: 1 }, d._c, d.st.easeInOut),
          g(),
          h &&
            h.data(
              "rsTimeout",
              setTimeout(function () {
                h.stop(!0, !0).css({ opacity: 0, display: "none", zIndex: 0 });
              }, d._c + 60)
            ));
      d._r2 = !0;
      d.loadingTimeout && clearTimeout(d.loadingTimeout);
      d.loadingTimeout = e
        ? setTimeout(function () {
            d.loadingTimeout = null;
            e.call();
          }, d._c + 60)
        : setTimeout(function () {
            d.loadingTimeout = null;
            d._k4(f);
          }, d._c + 60);
    },
    _u2: function (b) {
      this._r2 = !1;
      clearTimeout(this.loadingTimeout);
      if (this._l)
        if (!this._e)
          this._p1.stop(!0),
            (this._p = parseInt(
              this._p1.css(this._h ? this._x1 : this._w1),
              10
            ));
        else {
          if (!b) {
            b = this._p;
            var f = (this._h3 = this._l4());
            this._p1.css(this._g + this._u1, "0ms");
            b !== f && this._p3(f);
          }
        }
      else 20 < this._m ? (this._m = 10) : this._m++;
    },
    _l4: function () {
      var b = window
          .getComputedStyle(this._p1.get(0), null)
          .getPropertyValue(this._g + "transform")
          .replace(/^matrix\(/i, "")
          .split(/, |\)$/g),
        f = 0 === b[0].indexOf("matrix3d");
      return parseInt(b[this._h ? (f ? 12 : 4) : f ? 13 : 5], 10);
    },
    _m4: function (b, f) {
      return this._e
        ? this._y1 + (f ? b + this._z1 + 0 : 0 + this._z1 + b) + this._a2
        : b;
    },
    _k4: function (b) {
      this._l || (this._r1.css("z-index", 0), (this._m = 10));
      this._r2 = !1;
      this.staticSlideId = this.currSlideId;
      this._n2();
      this._n4 = !1;
      this.ev.trigger("rsAfterSlideChange");
    },
    _i4: function (b, f) {
      var c = this,
        a = (-c._u - c._d1) * c._w;
      if (0 !== c.numSlides && !c._r2)
        if (c.st.loopRewind) c.goTo("left" === b ? c.numSlides - 1 : 0, f);
        else if (c._l) {
          c._c = 200;
          var e = function () {
            c._r2 = !1;
          };
          c._x3(a + ("left" === b ? 30 : -30), "", !1, !0, function () {
            c._r2 = !1;
            c._x3(a, "", !1, !0, e);
          });
        }
    },
    _q2: function (b, f) {
      if (!b.isRendered) {
        var c = b.content,
          a = "rsMainSlideImage",
          e,
          g = n.isFunction(this.st.imageAlignCenter)
            ? this.st.imageAlignCenter(b)
            : this.st.imageAlignCenter,
          d = n.isFunction(this.st.imageScaleMode)
            ? this.st.imageScaleMode(b)
            : this.st.imageScaleMode,
          h;
        b.videoURL &&
          ((a = "rsVideoContainer"),
          "fill" !== d
            ? (e = !0)
            : ((h = c),
              h.hasClass(a) || (h = h.find("." + a)),
              h.css({ width: "100%", height: "100%" }),
              (a = "rsMainSlideImage")));
        c.hasClass(a) || (c = c.find("." + a));
        if (c) {
          var k = b.iW,
            l = b.iH;
          b.isRendered = !0;
          if ("none" !== d || g) {
            a = "fill" !== d ? this._d4 : 0;
            h = this._b4 - 2 * a;
            var q = this._c4 - 2 * a,
              m,
              p,
              r = {};
            "fit-if-smaller" === d && (k > h || l > q) && (d = "fit");
            if ("fill" === d || "fit" === d)
              (m = h / k),
                (p = q / l),
                (m =
                  "fill" == d
                    ? m > p
                      ? m
                      : p
                    : "fit" == d
                    ? m < p
                      ? m
                      : p
                    : 1),
                (k = Math.ceil(k * m, 10)),
                (l = Math.ceil(l * m, 10));
            "none" !== d &&
              ((r.width = k),
              (r.height = l),
              e && c.find(".rsImg").css({ width: "100%", height: "100%" }));
            g &&
              ((r.marginLeft = Math.floor((h - k) / 2) + a),
              (r.marginTop = Math.floor((q - l) / 2) + a));
            c.css(r);
          }
        }
      }
    },
  };
  n.rsProto = v.prototype;
  n.fn.royalSlider = function (b) {
    var f = arguments;
    return this.each(function () {
      var c = n(this);
      if ("object" !== typeof b && b) {
        if ((c = c.data("royalSlider")) && c[b])
          return c[b].apply(c, Array.prototype.slice.call(f, 1));
      } else c.data("royalSlider") || c.data("royalSlider", new v(c, b));
    });
  };
  n.fn.royalSlider.defaults = {
    slidesSpacing: 8,
    startSlideId: 0,
    loop: !1,
    loopRewind: !1,
    numImagesToPreload: 4,
    fadeinLoadedSlide: !0,
    slidesOrientation: "horizontal",
    transitionType: "move",
    transitionSpeed: 600,
    controlNavigation: "bullets",
    controlsInside: !0,
    arrowsNav: !0,
    arrowsNavAutoHide: !0,
    navigateByClick: !0,
    randomizeSlides: !1,
    sliderDrag: !0,
    sliderTouch: !0,
    keyboardNavEnabled: !1,
    fadeInAfterLoaded: !0,
    allowCSS3: !0,
    allowCSS3OnWebkit: !0,
    addActiveClass: !1,
    autoHeight: !1,
    easeOut: "easeOutSine",
    easeInOut: "easeInOutSine",
    minSlideOffset: 10,
    imageScaleMode: "fit-if-smaller",
    imageAlignCenter: !0,
    imageScalePadding: 4,
    usePreloader: !0,
    autoScaleSlider: !1,
    autoScaleSliderWidth: 800,
    autoScaleSliderHeight: 400,
    autoScaleHeight: !0,
    arrowsNavHideOnTouch: !1,
    globalCaption: !1,
    slidesDiff: 2,
  };
  n.rsCSS3Easing = {
    easeOutSine: "cubic-bezier(0.390, 0.575, 0.565, 1.000)",
    easeInOutSine: "cubic-bezier(0.445, 0.050, 0.550, 0.950)",
  };
  n.extend(jQuery.easing, {
    easeInOutSine: function (b, f, c, a, e) {
      return (-a / 2) * (Math.cos((Math.PI * f) / e) - 1) + c;
    },
    easeOutSine: function (b, f, c, a, e) {
      return a * Math.sin((f / e) * (Math.PI / 2)) + c;
    },
    easeOutCubic: function (b, f, c, a, e) {
      return a * ((f = f / e - 1) * f * f + 1) + c;
    },
  });
})(jQuery, window);
// jquery.rs.bullets v1.0.1
(function (c) {
  c.extend(c.rsProto, {
    _i5: function () {
      var a = this;
      "bullets" === a.st.controlNavigation &&
        (a.ev.one("rsAfterPropsSetup", function () {
          a._j5 = !0;
          a.slider.addClass("rsWithBullets");
          for (
            var b = '<div class="rsNav rsBullets">', e = 0;
            e < a.numSlides;
            e++
          )
            b += '<div class="rsNavItem rsBullet"><span></span></div>';
          a._k5 = b = c(b + "</div>");
          a._l5 = b.appendTo(a.slider).children();
          a._k5.on("click.rs", ".rsNavItem", function (b) {
            a._m5 || a.goTo(c(this).index());
          });
        }),
        a.ev.on("rsOnAppendSlide", function (b, c, d) {
          d >= a.numSlides
            ? a._k5.append(
                '<div class="rsNavItem rsBullet"><span></span></div>'
              )
            : a._l5
                .eq(d)
                .before('<div class="rsNavItem rsBullet"><span></span></div>');
          a._l5 = a._k5.children();
        }),
        a.ev.on("rsOnRemoveSlide", function (b, c) {
          var d = a._l5.eq(c);
          d && d.length && (d.remove(), (a._l5 = a._k5.children()));
        }),
        a.ev.on("rsOnUpdateNav", function () {
          var b = a.currSlideId;
          a._n5 && a._n5.removeClass("rsNavSelected");
          b = a._l5.eq(b);
          b.addClass("rsNavSelected");
          a._n5 = b;
        }));
    },
  });
  c.rsModules.bullets = c.rsProto._i5;
})(jQuery);
// jquery.rs.thumbnails v1.0.8
(function (f) {
  f.extend(f.rsProto, {
    _h6: function () {
      var a = this;
      "thumbnails" === a.st.controlNavigation &&
        ((a._i6 = {
          drag: !0,
          touch: !0,
          orientation: "horizontal",
          navigation: !0,
          arrows: !0,
          arrowLeft: null,
          arrowRight: null,
          spacing: 4,
          arrowsAutoHide: !1,
          appendSpan: !1,
          transitionSpeed: 600,
          autoCenter: !0,
          fitInViewport: !0,
          firstMargin: !0,
          paddingTop: 0,
          paddingBottom: 0,
        }),
        (a.st.thumbs = f.extend({}, a._i6, a.st.thumbs)),
        (a._j6 = !0),
        !1 === a.st.thumbs.firstMargin
          ? (a.st.thumbs.firstMargin = 0)
          : !0 === a.st.thumbs.firstMargin &&
            (a.st.thumbs.firstMargin = a.st.thumbs.spacing),
        a.ev.on("rsBeforeParseNode", function (a, b, c) {
          b = f(b);
          c.thumbnail = b.find(".rsTmb").remove();
          c.thumbnail.length
            ? (c.thumbnail = f(document.createElement("div"))
                .append(c.thumbnail)
                .html())
            : ((c.thumbnail = b.attr("data-rsTmb")),
              c.thumbnail ||
                (c.thumbnail = b.find(".rsImg").attr("data-rsTmb")),
              (c.thumbnail = c.thumbnail
                ? '<img src="' + c.thumbnail + '"/>'
                : ""));
        }),
        a.ev.one("rsAfterPropsSetup", function () {
          a._k6();
        }),
        (a._n5 = null),
        a.ev.on("rsOnUpdateNav", function () {
          var e = f(a._l5[a.currSlideId]);
          e !== a._n5 &&
            (a._n5 && (a._n5.removeClass("rsNavSelected"), (a._n5 = null)),
            a._l6 && a._m6(a.currSlideId),
            (a._n5 = e.addClass("rsNavSelected")));
        }),
        a.ev.on("rsOnAppendSlide", function (e, b, c) {
          e =
            "<div" +
            a._n6 +
            ' class="rsNavItem rsThumb">' +
            a._o6 +
            b.thumbnail +
            "</div>";
          a._e && a._s3.css(a._g + "transition-duration", "0ms");
          c >= a.numSlides ? a._s3.append(e) : a._l5.eq(c).before(e);
          a._l5 = a._s3.children();
          a.updateThumbsSize(!0);
        }),
        a.ev.on("rsOnRemoveSlide", function (e, b) {
          var c = a._l5.eq(b);
          c &&
            (a._e && a._s3.css(a._g + "transition-duration", "0ms"),
            c.remove(),
            (a._l5 = a._s3.children()),
            a.updateThumbsSize(!0));
        }));
    },
    _k6: function () {
      var a = this,
        e = "rsThumbs",
        b = a.st.thumbs,
        c = "",
        g,
        d,
        h = b.spacing;
      a._j5 = !0;
      a._e3 = "vertical" === b.orientation ? !1 : !0;
      a._n6 = g = h
        ? ' style="margin-' + (a._e3 ? "right" : "bottom") + ":" + h + 'px;"'
        : "";
      a._i3 = 0;
      a._p6 = !1;
      a._m5 = !1;
      a._l6 = !1;
      a._q6 = b.arrows && b.navigation;
      d = a._e3 ? "Hor" : "Ver";
      a.slider.addClass("rsWithThumbs rsWithThumbs" + d);
      c +=
        '<div class="rsNav rsThumbs rsThumbs' +
        d +
        '"><div class="' +
        e +
        'Container">';
      a._o6 = b.appendSpan ? '<span class="thumbIco"></span>' : "";
      for (var k = 0; k < a.numSlides; k++)
        (d = a.slides[k]),
          (c +=
            "<div" +
            g +
            ' class="rsNavItem rsThumb">' +
            d.thumbnail +
            a._o6 +
            "</div>");
      c = f(c + "</div></div>");
      g = {};
      b.paddingTop && (g[a._e3 ? "paddingTop" : "paddingLeft"] = b.paddingTop);
      b.paddingBottom &&
        (g[a._e3 ? "paddingBottom" : "paddingRight"] = b.paddingBottom);
      c.css(g);
      a._s3 = f(c).find("." + e + "Container");
      a._q6 &&
        ((e += "Arrow"),
        b.arrowLeft
          ? (a._r6 = b.arrowLeft)
          : ((a._r6 = f(
              '<div class="' +
                e +
                " " +
                e +
                'Left"><div class="' +
                e +
                'Icn"></div></div>'
            )),
            c.append(a._r6)),
        b.arrowRight
          ? (a._s6 = b.arrowRight)
          : ((a._s6 = f(
              '<div class="' +
                e +
                " " +
                e +
                'Right"><div class="' +
                e +
                'Icn"></div></div>'
            )),
            c.append(a._s6)),
        a._r6.click(function () {
          var b =
            (Math.floor(a._i3 / a._t6) + a._u6) * a._t6 +
            a.st.thumbs.firstMargin;
          a._a4(b > a._n3 ? a._n3 : b);
        }),
        a._s6.click(function () {
          var b =
            (Math.floor(a._i3 / a._t6) - a._u6) * a._t6 +
            a.st.thumbs.firstMargin;
          a._a4(b < a._o3 ? a._o3 : b);
        }),
        b.arrowsAutoHide &&
          !a.hasTouch &&
          (a._r6.css("opacity", 0),
          a._s6.css("opacity", 0),
          c.one("mousemove.rsarrowshover", function () {
            a._l6 && (a._r6.css("opacity", 1), a._s6.css("opacity", 1));
          }),
          c.hover(
            function () {
              a._l6 && (a._r6.css("opacity", 1), a._s6.css("opacity", 1));
            },
            function () {
              a._l6 && (a._r6.css("opacity", 0), a._s6.css("opacity", 0));
            }
          )));
      a._k5 = c;
      a._l5 = a._s3.children();
      a.msEnabled &&
        a.st.thumbs.navigation &&
        a._s3.css("-ms-touch-action", a._e3 ? "pan-y" : "pan-x");
      a.slider.append(c);
      a._w3 = !0;
      a._v6 = h;
      b.navigation &&
        a._e &&
        a._s3.css(a._g + "transition-property", a._g + "transform");
      a._k5.on("click.rs", ".rsNavItem", function (b) {
        a._m5 || a.goTo(f(this).index());
      });
      a.ev
        .off("rsBeforeSizeSet.thumbs")
        .on("rsBeforeSizeSet.thumbs", function () {
          a._w6 = a._e3 ? a._c4 : a._b4;
          a.updateThumbsSize(!0);
        });
      a.ev
        .off("rsAutoHeightChange.thumbs")
        .on("rsAutoHeightChange.thumbs", function (b, c) {
          a.updateThumbsSize(!0, c);
        });
    },
    updateThumbsSize: function (a, e) {
      var b = this,
        c = b._l5.first(),
        f = {},
        d = b._l5.length;
      b._t6 = (b._e3 ? c.outerWidth() : c.outerHeight()) + b._v6;
      b._y3 = d * b._t6 - b._v6;
      f[b._e3 ? "width" : "height"] = b._y3 + b._v6;
      b._z3 = b._e3 ? b._k5.width() : void 0 !== e ? e : b._k5.height();
      b._w3 &&
        (b.isFullscreen || b.st.thumbs.fitInViewport) &&
        (b._e3
          ? (b._c4 = b._w6 - b._k5.outerHeight())
          : (b._b4 = b._w6 - b._k5.outerWidth()));
      b._z3 &&
        ((b._o3 = -(b._y3 - b._z3) - b.st.thumbs.firstMargin),
        (b._n3 = b.st.thumbs.firstMargin),
        (b._u6 = Math.floor(b._z3 / b._t6)),
        b._y3 < b._z3
          ? (b.st.thumbs.autoCenter ? b._q3((b._z3 - b._y3) / 2) : b._q3(b._n3),
            b.st.thumbs.arrows &&
              b._r6 &&
              (b._r6.addClass("rsThumbsArrowDisabled"),
              b._s6.addClass("rsThumbsArrowDisabled")),
            (b._l6 = !1),
            (b._m5 = !1),
            b._k5.off(b._j1))
          : b.st.thumbs.navigation &&
            !b._l6 &&
            ((b._l6 = !0),
            (!b.hasTouch && b.st.thumbs.drag) ||
              (b.hasTouch && b.st.thumbs.touch)) &&
            ((b._m5 = !0),
            b._k5.on(b._j1, function (a) {
              b._g2(a, !0);
            })),
        b._s3.css(f),
        a && e && b._m6(b.currSlideId, !0));
    },
    setThumbsOrientation: function (a, e) {
      this._w3 &&
        ((this.st.thumbs.orientation = a),
        this._k5.remove(),
        this.slider.removeClass("rsWithThumbsHor rsWithThumbsVer"),
        this._k6(),
        this._k5.off(this._j1),
        e || this.updateSliderSize(!0));
    },
    _q3: function (a) {
      this._i3 = a;
      this._e
        ? this._s3.css(
            this._x1,
            this._y1 +
              (this._e3 ? a + this._z1 + 0 : 0 + this._z1 + a) +
              this._a2
          )
        : this._s3.css(this._e3 ? this._x1 : this._w1, a);
    },
    _a4: function (a, e, b, c, g) {
      var d = this;
      if (d._l6) {
        e || (e = d.st.thumbs.transitionSpeed);
        d._i3 = a;
        d._x6 && clearTimeout(d._x6);
        d._p6 && (d._e || d._s3.stop(), (b = !0));
        var h = {};
        d._p6 = !0;
        d._e
          ? ((h[d._g + "transition-duration"] = e + "ms"),
            (h[d._g + "transition-timing-function"] = b
              ? f.rsCSS3Easing[d.st.easeOut]
              : f.rsCSS3Easing[d.st.easeInOut]),
            d._s3.css(h),
            d._q3(a))
          : ((h[d._e3 ? d._x1 : d._w1] = a + "px"),
            d._s3.animate(h, e, b ? "easeOutCubic" : d.st.easeInOut));
        c && (d._i3 = c);
        d._y6();
        d._x6 = setTimeout(function () {
          d._p6 = !1;
          g && (d._a4(c, g, !0), (g = null));
        }, e);
      }
    },
    _y6: function () {
      this._q6 &&
        (this._i3 === this._n3
          ? this._r6.addClass("rsThumbsArrowDisabled")
          : this._r6.removeClass("rsThumbsArrowDisabled"),
        this._i3 === this._o3
          ? this._s6.addClass("rsThumbsArrowDisabled")
          : this._s6.removeClass("rsThumbsArrowDisabled"));
    },
    _m6: function (a, e) {
      var b = 0,
        c,
        f = a * this._t6 + 2 * this._t6 - this._v6 + this._n3,
        d = Math.floor(this._i3 / this._t6);
      this._l6 &&
        (this._j6 && ((e = !0), (this._j6 = !1)),
        f + this._i3 > this._z3
          ? (a === this.numSlides - 1 && (b = 1),
            (d = -a + this._u6 - 2 + b),
            (c = d * this._t6 + (this._z3 % this._t6) + this._v6 - this._n3))
          : 0 !== a
          ? (a - 1) * this._t6 <= -this._i3 + this._n3 &&
            a - 1 <= this.numSlides - this._u6 &&
            (c = (-a + 1) * this._t6 + this._n3)
          : (c = this._n3),
        c !== this._i3 &&
          ((b = void 0 === c ? this._i3 : c),
          b > this._n3
            ? this._q3(this._n3)
            : b < this._o3
            ? this._q3(this._o3)
            : void 0 !== c && (e ? this._q3(c) : this._a4(c))),
        this._y6());
    },
  });
  f.rsModules.thumbnails = f.rsProto._h6;
})(jQuery);
// jquery.rs.tabs v1.0.2
(function (e) {
  e.extend(e.rsProto, {
    _f6: function () {
      var a = this;
      "tabs" === a.st.controlNavigation &&
        (a.ev.on("rsBeforeParseNode", function (a, d, b) {
          d = e(d);
          b.thumbnail = d.find(".rsTmb").remove();
          b.thumbnail.length
            ? (b.thumbnail = e(document.createElement("div"))
                .append(b.thumbnail)
                .html())
            : ((b.thumbnail = d.attr("data-rsTmb")),
              b.thumbnail ||
                (b.thumbnail = d.find(".rsImg").attr("data-rsTmb")),
              (b.thumbnail = b.thumbnail
                ? '<img src="' + b.thumbnail + '"/>'
                : ""));
        }),
        a.ev.one("rsAfterPropsSetup", function () {
          a._g6();
        }),
        a.ev.on("rsOnAppendSlide", function (c, d, b) {
          b >= a.numSlides
            ? a._k5.append(
                '<div class="rsNavItem rsTab">' + d.thumbnail + "</div>"
              )
            : a._l5
                .eq(b)
                .before(
                  '<div class="rsNavItem rsTab">' + item.thumbnail + "</div>"
                );
          a._l5 = a._k5.children();
        }),
        a.ev.on("rsOnRemoveSlide", function (c, d) {
          var b = a._l5.eq(d);
          b && (b.remove(), (a._l5 = a._k5.children()));
        }),
        a.ev.on("rsOnUpdateNav", function () {
          var c = a.currSlideId;
          a._n5 && a._n5.removeClass("rsNavSelected");
          c = a._l5.eq(c);
          c.addClass("rsNavSelected");
          a._n5 = c;
        }));
    },
    _g6: function () {
      var a = this,
        c;
      a._j5 = !0;
      c = '<div class="rsNav rsTabs">';
      for (var d = 0; d < a.numSlides; d++)
        c += '<div class="rsNavItem rsTab">' + a.slides[d].thumbnail + "</div>";
      c = e(c + "</div>");
      a._k5 = c;
      a._l5 = c.children(".rsNavItem");
      a.slider.append(c);
      a._k5.click(function (b) {
        b = e(b.target).closest(".rsNavItem");
        b.length && a.goTo(b.index());
      });
    },
  });
  e.rsModules.tabs = e.rsProto._f6;
})(jQuery);
// jquery.rs.fullscreen v1.0.6
(function (c) {
  c.extend(c.rsProto, {
    _q5: function () {
      var a = this;
      a._r5 = {
        enabled: !1,
        keyboardNav: !0,
        buttonFS: !0,
        nativeFS: !1,
        doubleTap: !0,
      };
      a.st.fullscreen = c.extend({}, a._r5, a.st.fullscreen);
      if (a.st.fullscreen.enabled)
        a.ev.one("rsBeforeSizeSet", function () {
          a._s5();
        });
    },
    _s5: function () {
      var a = this;
      a._t5 = !a.st.keyboardNavEnabled && a.st.fullscreen.keyboardNav;
      if (a.st.fullscreen.nativeFS) {
        var b = {
            supportsFullScreen: !1,
            isFullScreen: function () {
              return !1;
            },
            requestFullScreen: function () {},
            cancelFullScreen: function () {},
            fullScreenEventName: "",
            prefix: "",
          },
          d = ["webkit", "moz", "o", "ms", "khtml"];
        if ("undefined" != typeof document.cancelFullScreen)
          b.supportsFullScreen = !0;
        else
          for (var e = 0, f = d.length; e < f; e++)
            if (
              ((b.prefix = d[e]),
              "undefined" != typeof document[b.prefix + "CancelFullScreen"])
            ) {
              b.supportsFullScreen = !0;
              break;
            }
        b.supportsFullScreen
          ? ((a.nativeFS = !0),
            (b.fullScreenEventName = b.prefix + "fullscreenchange" + a.ns),
            (b.isFullScreen = function () {
              switch (this.prefix) {
                case "":
                  return document.fullScreen;
                case "webkit":
                  return document.webkitIsFullScreen;
                default:
                  return document[this.prefix + "FullScreen"];
              }
            }),
            (b.requestFullScreen = function (a) {
              return "" === this.prefix
                ? a.requestFullScreen()
                : a[this.prefix + "RequestFullScreen"]();
            }),
            (b.cancelFullScreen = function (a) {
              return "" === this.prefix
                ? document.cancelFullScreen()
                : document[this.prefix + "CancelFullScreen"]();
            }),
            (a._u5 = b))
          : (a._u5 = !1);
      }
      a.st.fullscreen.buttonFS &&
        (a._v5 = c(
          '<div class="rsFullscreenBtn"><div class="rsFullscreenIcn"></div></div>'
        )
          .appendTo(a._o1)
          .on("click.rs", function () {
            a.isFullscreen ? a.exitFullscreen() : a.enterFullscreen();
          }));
    },
    enterFullscreen: function (a) {
      var b = this;
      if (b._u5)
        if (a) b._u5.requestFullScreen(c("html")[0]);
        else {
          b._b.on(b._u5.fullScreenEventName, function (a) {
            b._u5.isFullScreen() ? b.enterFullscreen(!0) : b.exitFullscreen(!0);
          });
          b._u5.requestFullScreen(c("html")[0]);
          return;
        }
      if (!b._w5) {
        b._w5 = !0;
        b._b.on("keyup" + b.ns + "fullscreen", function (a) {
          27 === a.keyCode && b.exitFullscreen();
        });
        b._t5 && b._b2();
        a = c(window);
        b._x5 = a.scrollTop();
        b._y5 = a.scrollLeft();
        b._z5 = c("html").attr("style");
        b._a6 = c("body").attr("style");
        b._b6 = b.slider.attr("style");
        c("body, html").css({
          overflow: "hidden",
          height: "100%",
          width: "100%",
          margin: "0",
          padding: "0",
        });
        b.slider.addClass("rsFullscreen");
        var d;
        for (d = 0; d < b.numSlides; d++)
          (a = b.slides[d]),
            (a.isRendered = !1),
            a.bigImage &&
              ((a.isBig = !0),
              (a.isMedLoaded = a.isLoaded),
              (a.isMedLoading = a.isLoading),
              (a.medImage = a.image),
              (a.medIW = a.iW),
              (a.medIH = a.iH),
              (a.slideId = -99),
              a.bigImage !== a.medImage && (a.sizeType = "big"),
              (a.isLoaded = a.isBigLoaded),
              (a.isLoading = !1),
              (a.image = a.bigImage),
              (a.images[0] = a.bigImage),
              (a.iW = a.bigIW),
              (a.iH = a.bigIH),
              (a.isAppended = a.contentAdded = !1),
              b._c6(a));
        b.isFullscreen = !0;
        b._w5 = !1;
        b.updateSliderSize();
        b.ev.trigger("rsEnterFullscreen");
      }
    },
    exitFullscreen: function (a) {
      var b = this;
      if (b._u5) {
        if (!a) {
          b._u5.cancelFullScreen(c("html")[0]);
          return;
        }
        b._b.off(b._u5.fullScreenEventName);
      }
      if (!b._w5) {
        b._w5 = !0;
        b._b.off("keyup" + b.ns + "fullscreen");
        b._t5 && b._b.off("keydown" + b.ns);
        c("html").attr("style", b._z5 || "");
        c("body").attr("style", b._a6 || "");
        var d;
        for (d = 0; d < b.numSlides; d++)
          (a = b.slides[d]),
            (a.isRendered = !1),
            a.bigImage &&
              ((a.isBig = !1),
              (a.slideId = -99),
              (a.isBigLoaded = a.isLoaded),
              (a.isBigLoading = a.isLoading),
              (a.bigImage = a.image),
              (a.bigIW = a.iW),
              (a.bigIH = a.iH),
              (a.isLoaded = a.isMedLoaded),
              (a.isLoading = !1),
              (a.image = a.medImage),
              (a.images[0] = a.medImage),
              (a.iW = a.medIW),
              (a.iH = a.medIH),
              (a.isAppended = a.contentAdded = !1),
              b._c6(a, !0),
              a.bigImage !== a.medImage && (a.sizeType = "med"));
        b.isFullscreen = !1;
        a = c(window);
        a.scrollTop(b._x5);
        a.scrollLeft(b._y5);
        b._w5 = !1;
        b.slider.removeClass("rsFullscreen");
        b.updateSliderSize();
        setTimeout(function () {
          b.updateSliderSize();
        }, 1);
        b.ev.trigger("rsExitFullscreen");
      }
    },
    _c6: function (a, b) {
      var d =
        a.isLoaded || a.isLoading
          ? '<img class="rsImg rsMainSlideImage" src="' + a.image + '"/>'
          : '<a class="rsImg rsMainSlideImage" href="' + a.image + '"></a>';
      a.content.hasClass("rsImg")
        ? (a.content = c(d))
        : a.content.find(".rsImg").eq(0).replaceWith(d);
      a.isLoaded || a.isLoading || !a.holder || a.holder.html(a.content);
    },
  });
  c.rsModules.fullscreen = c.rsProto._q5;
})(jQuery);
// jquery.rs.autoplay v1.0.5
(function (b) {
  b.extend(b.rsProto, {
    _x4: function () {
      var a = this,
        d;
      a._y4 = { enabled: !1, stopAtAction: !0, pauseOnHover: !0, delay: 2e3 };
      !a.st.autoPlay && a.st.autoplay && (a.st.autoPlay = a.st.autoplay);
      a.st.autoPlay = b.extend({}, a._y4, a.st.autoPlay);
      a.st.autoPlay.enabled &&
        (a.ev.on("rsBeforeParseNode", function (a, c, f) {
          c = b(c);
          if ((d = c.attr("data-rsDelay"))) f.customDelay = parseInt(d, 10);
        }),
        a.ev.one("rsAfterInit", function () {
          a._z4();
        }),
        a.ev.on("rsBeforeDestroy", function () {
          a.stopAutoPlay();
          a.slider.off("mouseenter mouseleave");
          b(window).off("blur" + a.ns + " focus" + a.ns);
        }));
    },
    _z4: function () {
      var a = this;
      a.startAutoPlay();
      a.ev.on("rsAfterContentSet", function (b, e) {
        a._l2 || a._r2 || !a._a5 || e !== a.currSlide || a._b5();
      });
      a.ev.on("rsDragRelease", function () {
        a._a5 && a._c5 && ((a._c5 = !1), a._b5());
      });
      a.ev.on("rsAfterSlideChange", function () {
        a._a5 && a._c5 && ((a._c5 = !1), a.currSlide.isLoaded && a._b5());
      });
      a.ev.on("rsDragStart", function () {
        a._a5 &&
          (a.st.autoPlay.stopAtAction
            ? a.stopAutoPlay()
            : ((a._c5 = !0), a._d5()));
      });
      a.ev.on("rsBeforeMove", function (b, e, c) {
        a._a5 &&
          (c && a.st.autoPlay.stopAtAction
            ? a.stopAutoPlay()
            : ((a._c5 = !0), a._d5()));
      });
      a._e5 = !1;
      a.ev.on("rsVideoStop", function () {
        a._a5 && ((a._e5 = !1), a._b5());
      });
      a.ev.on("rsVideoPlay", function () {
        a._a5 && ((a._c5 = !1), a._d5(), (a._e5 = !0));
      });
      b(window)
        .on("blur" + a.ns, function () {
          a._a5 && ((a._c5 = !0), a._d5());
        })
        .on("focus" + a.ns, function () {
          a._a5 && a._c5 && ((a._c5 = !1), a._b5());
        });
      a.st.autoPlay.pauseOnHover &&
        ((a._f5 = !1),
        a.slider.hover(
          function () {
            a._a5 && ((a._c5 = !1), a._d5(), (a._f5 = !0));
          },
          function () {
            a._a5 && ((a._f5 = !1), a._b5());
          }
        ));
    },
    toggleAutoPlay: function () {
      this._a5 ? this.stopAutoPlay() : this.startAutoPlay();
    },
    startAutoPlay: function () {
      this._a5 = !0;
      this.currSlide.isLoaded && this._b5();
    },
    stopAutoPlay: function () {
      this._e5 = this._f5 = this._c5 = this._a5 = !1;
      this._d5();
    },
    _b5: function () {
      var a = this;
      a._f5 ||
        a._e5 ||
        ((a._g5 = !0),
        a._h5 && clearTimeout(a._h5),
        (a._h5 = setTimeout(
          function () {
            var b;
            a._z || a.st.loopRewind || ((b = !0), (a.st.loopRewind = !0));
            a.next(!0);
            b && (a.st.loopRewind = !1);
          },
          a.currSlide.customDelay
            ? a.currSlide.customDelay
            : a.st.autoPlay.delay
        )));
    },
    _d5: function () {
      this._f5 ||
        this._e5 ||
        ((this._g5 = !1),
        this._h5 && (clearTimeout(this._h5), (this._h5 = null)));
    },
  });
  b.rsModules.autoplay = b.rsProto._x4;
})(jQuery);
// jquery.rs.video v1.1.3
(function (f) {
  f.extend(f.rsProto, {
    _z6: function () {
      var a = this;
      a._a7 = {
        autoHideArrows: !0,
        autoHideControlNav: !1,
        autoHideBlocks: !1,
        autoHideCaption: !1,
        disableCSS3inFF: !0,
        youTubeCode:
          '<iframe src="https://www.youtube.com/embed/%id%?rel=1&showinfo=0&autoplay=1&wmode=transparent" frameborder="no"></iframe>',
        vimeoCode:
          '<iframe src="https://player.vimeo.com/video/%id%?byline=0&portrait=0&autoplay=1" frameborder="no" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>',
      };
      a.st.video = f.extend({}, a._a7, a.st.video);
      a.ev.on("rsBeforeSizeSet", function () {
        a._b7 &&
          setTimeout(function () {
            var b = a._r1,
              b = b.hasClass("rsVideoContainer")
                ? b
                : b.find(".rsVideoContainer");
            a._c7 && a._c7.css({ width: b.width(), height: b.height() });
          }, 32);
      });
      var d = a._a.mozilla;
      a.ev.on("rsAfterParseNode", function (b, c, e) {
        b = f(c);
        if (e.videoURL) {
          a.st.video.disableCSS3inFF && d && (a._e = a._f = !1);
          c = f('<div class="rsVideoContainer"></div>');
          var g = f(
            '<div class="rsBtnCenterer"><div class="rsPlayBtn"><div class="rsPlayBtnIcon"></div></div></div>'
          );
          b.hasClass("rsImg")
            ? (e.content = c.append(b).append(g))
            : e.content.find(".rsImg").wrap(c).after(g);
        }
      });
      a.ev.on("rsAfterSlideChange", function () {
        a.stopVideo();
      });
    },
    toggleVideo: function () {
      return this._b7 ? this.stopVideo() : this.playVideo();
    },
    playVideo: function () {
      var a = this;
      if (!a._b7) {
        var d = a.currSlide;
        if (!d.videoURL) return !1;
        a._d7 = d;
        var b = (a._e7 = d.content),
          d = d.videoURL,
          c,
          e;
        d.match(/youtu\.be/i) || d.match(/youtube\.com/i)
          ? ((e =
              /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/),
            (e = d.match(e)) && 11 == e[2].length && (c = e[2]),
            void 0 !== c && (a._c7 = a.st.video.youTubeCode.replace("%id%", c)))
          : d.match(/vimeo\.com/i) &&
            ((e = /(www\.)?vimeo.com\/(\d+)($|\/)/),
            (e = d.match(e)) && (c = e[2]),
            void 0 !== c && (a._c7 = a.st.video.vimeoCode.replace("%id%", c)));
        a.videoObj = f(a._c7);
        a.ev.trigger("rsOnCreateVideoElement", [d]);
        a.videoObj.length &&
          ((a._c7 = f(
            '<div class="rsVideoFrameHolder"><div class="rsPreloader"></div><div class="rsCloseVideoBtn"><div class="rsCloseVideoIcn"></div></div></div>'
          )),
          a._c7.find(".rsPreloader").after(a.videoObj),
          (b = b.hasClass("rsVideoContainer")
            ? b
            : b.find(".rsVideoContainer")),
          a._c7
            .css({ width: b.width(), height: b.height() })
            .find(".rsCloseVideoBtn")
            .off("click.rsv")
            .on("click.rsv", function (b) {
              a.stopVideo();
              b.preventDefault();
              b.stopPropagation();
              return !1;
            }),
          b.append(a._c7),
          a.isIPAD && b.addClass("rsIOSVideo"),
          a._f7(!1),
          setTimeout(function () {
            a._c7.addClass("rsVideoActive");
          }, 10),
          a.ev.trigger("rsVideoPlay"),
          (a._b7 = !0));
        return !0;
      }
      return !1;
    },
    stopVideo: function () {
      var a = this;
      return a._b7
        ? (a.isIPAD && a.slider.find(".rsCloseVideoBtn").remove(),
          a._f7(!0),
          setTimeout(function () {
            a.ev.trigger("rsOnDestroyVideoElement", [a.videoObj]);
            var d = a._c7.find("iframe");
            if (d.length)
              try {
                d.attr("src", "");
              } catch (b) {}
            a._c7.remove();
            a._c7 = null;
          }, 16),
          a.ev.trigger("rsVideoStop"),
          (a._b7 = !1),
          !0)
        : !1;
    },
    _f7: function (a, d) {
      var b = [],
        c = this.st.video;
      c.autoHideArrows &&
        (this._c2 && (b.push(this._c2, this._d2), (this._e2 = !a)),
        this._v5 && b.push(this._v5));
      c.autoHideControlNav && this._k5 && b.push(this._k5);
      c.autoHideBlocks && this._d7.animBlocks && b.push(this._d7.animBlocks);
      c.autoHideCaption && this.globalCaption && b.push(this.globalCaption);
      this.slider[a ? "removeClass" : "addClass"]("rsVideoPlaying");
      if (b.length)
        for (c = 0; c < b.length; c++)
          a ? b[c].removeClass("rsHidden") : b[c].addClass("rsHidden");
    },
  });
  f.rsModules.video = f.rsProto._z6;
})(jQuery);
// jquery.rs.animated-blocks v1.0.7
(function (l) {
  l.extend(l.rsProto, {
    _p4: function () {
      function m() {
        var g = a.currSlide;
        if (a.currSlide && a.currSlide.isLoaded && a._t4 !== g) {
          if (0 < a._s4.length) {
            for (b = 0; b < a._s4.length; b++) clearTimeout(a._s4[b]);
            a._s4 = [];
          }
          if (0 < a._r4.length) {
            var f;
            for (b = 0; b < a._r4.length; b++)
              if ((f = a._r4[b]))
                a._e
                  ? (f.block.css(a._g + a._u1, "0s"), f.block.css(f.css))
                  : f.block.stop(!0).css(f.css),
                  (a._t4 = null),
                  (g.animBlocksDisplayed = !1);
            a._r4 = [];
          }
          g.animBlocks &&
            ((g.animBlocksDisplayed = !0), (a._t4 = g), a._u4(g.animBlocks));
        }
      }
      var a = this,
        b;
      a._q4 = {
        fadeEffect: !0,
        moveEffect: "top",
        moveOffset: 20,
        speed: 400,
        easing: "easeOutSine",
        delay: 200,
      };
      a.st.block = l.extend({}, a._q4, a.st.block);
      a._r4 = [];
      a._s4 = [];
      a.ev.on("rsAfterInit", function () {
        m();
      });
      a.ev.on("rsBeforeParseNode", function (a, b, d) {
        b = l(b);
        d.animBlocks = b.find(".rsABlock").css("display", "none");
        d.animBlocks.length ||
          (b.hasClass("rsABlock")
            ? (d.animBlocks = b.css("display", "none"))
            : (d.animBlocks = !1));
      });
      a.ev.on("rsAfterContentSet", function (b, f) {
        f.id === a.slides[a.currSlideId].id &&
          setTimeout(
            function () {
              m();
            },
            a.st.fadeinLoadedSlide ? 300 : 0
          );
      });
      a.ev.on("rsAfterSlideChange", function () {
        m();
      });
    },
    _v4: function (l, a) {
      setTimeout(function () {
        l.css(a);
      }, 6);
    },
    _u4: function (m) {
      var a = this,
        b,
        g,
        f,
        d,
        h,
        e,
        n;
      a._s4 = [];
      m.each(function (m) {
        b = l(this);
        g = {};
        f = {};
        d = null;
        var c = b.attr("data-move-offset"),
          c = c ? parseInt(c, 10) : a.st.block.moveOffset;
        if (
          0 < c &&
          ((e = b.data("move-effect"))
            ? ((e = e.toLowerCase()),
              "none" === e
                ? (e = !1)
                : "left" !== e &&
                  "top" !== e &&
                  "bottom" !== e &&
                  "right" !== e &&
                  ((e = a.st.block.moveEffect), "none" === e && (e = !1)))
            : (e = a.st.block.moveEffect),
          e && "none" !== e)
        ) {
          var p;
          p = "right" === e || "left" === e ? !0 : !1;
          var k;
          n = !1;
          a._e
            ? ((k = 0), (h = a._x1))
            : (p
                ? isNaN(parseInt(b.css("right"), 10))
                  ? (h = "left")
                  : ((h = "right"), (n = !0))
                : isNaN(parseInt(b.css("bottom"), 10))
                ? (h = "top")
                : ((h = "bottom"), (n = !0)),
              (h = "margin-" + h),
              n && (c = -c),
              a._e
                ? (k = parseInt(b.css(h), 10))
                : ((k = b.data("rs-start-move-prop")),
                  void 0 === k &&
                    ((k = parseInt(b.css(h), 10)),
                    isNaN(k) && (k = 0),
                    b.data("rs-start-move-prop", k))));
          f[h] = a._m4("top" === e || "left" === e ? k - c : k + c, p);
          g[h] = a._m4(k, p);
        }
        c = b.attr("data-fade-effect");
        if (!c) c = a.st.block.fadeEffect;
        else if ("none" === c.toLowerCase() || "false" === c.toLowerCase())
          c = !1;
        c && ((f.opacity = 0), (g.opacity = 1));
        if (c || e)
          (d = {}),
            (d.hasFade = Boolean(c)),
            Boolean(e) && ((d.moveProp = h), (d.hasMove = !0)),
            (d.speed = b.data("speed")),
            isNaN(d.speed) && (d.speed = a.st.block.speed),
            (d.easing = b.data("easing")),
            d.easing || (d.easing = a.st.block.easing),
            (d.css3Easing = l.rsCSS3Easing[d.easing]),
            (d.delay = b.data("delay")),
            isNaN(d.delay) && (d.delay = a.st.block.delay * m);
        c = {};
        a._e && (c[a._g + a._u1] = "0ms");
        c.moveProp = g.moveProp;
        c.opacity = g.opacity;
        c.display = "none";
        a._r4.push({ block: b, css: c });
        a._v4(b, f);
        a._s4.push(
          setTimeout(
            (function (b, d, c, e) {
              return function () {
                b.css("display", "block");
                if (c) {
                  var g = {};
                  if (a._e) {
                    var f = "";
                    c.hasMove && (f += c.moveProp);
                    c.hasFade && (c.hasMove && (f += ", "), (f += "opacity"));
                    g[a._g + a._t1] = f;
                    g[a._g + a._u1] = c.speed + "ms";
                    g[a._g + a._v1] = c.css3Easing;
                    b.css(g);
                    setTimeout(function () {
                      b.css(d);
                    }, 24);
                  } else
                    setTimeout(function () {
                      b.animate(d, c.speed, c.easing);
                    }, 16);
                }
                delete a._s4[e];
              };
            })(b, g, d, m),
            6 >= d.delay ? 12 : d.delay
          )
        );
      });
    },
  });
  l.rsModules.animatedBlocks = l.rsProto._p4;
})(jQuery);
// jquery.rs.auto-height v1.0.3
(function (b) {
  b.extend(b.rsProto, {
    _w4: function () {
      var a = this;
      if (a.st.autoHeight) {
        var b,
          c,
          e,
          f = !0,
          d = function (d) {
            e = a.slides[a.currSlideId];
            (b = e.holder) &&
              (c = b.height()) &&
              void 0 !== c &&
              c > (a.st.minAutoHeight || 30) &&
              ((a._c4 = c),
              a._e || !d
                ? a._e1.css("height", c)
                : a._e1
                    .stop(!0, !0)
                    .animate({ height: c }, a.st.transitionSpeed),
              a.ev.trigger("rsAutoHeightChange", c),
              f &&
                (a._e &&
                  setTimeout(function () {
                    a._e1.css(
                      a._g + "transition",
                      "height " + a.st.transitionSpeed + "ms ease-in-out"
                    );
                  }, 16),
                (f = !1)));
          };
        a.ev.on("rsMaybeSizeReady.rsAutoHeight", function (a, b) {
          e === b && d();
        });
        a.ev.on("rsAfterContentSet.rsAutoHeight", function (a, b) {
          e === b && d();
        });
        a.slider.addClass("rsAutoHeight");
        a.ev.one("rsAfterInit", function () {
          setTimeout(function () {
            d(!1);
            setTimeout(function () {
              a.slider.append('<div style="clear:both; float: none;"></div>');
            }, 16);
          }, 16);
        });
        a.ev.on("rsBeforeAnimStart", function () {
          d(!0);
        });
        a.ev.on("rsBeforeSizeSet", function () {
          setTimeout(function () {
            d(!1);
          }, 16);
        });
      }
    },
  });
  b.rsModules.autoHeight = b.rsProto._w4;
})(jQuery);
// jquery.rs.global-caption v1.0.1
(function (b) {
  b.extend(b.rsProto, {
    _d6: function () {
      var a = this;
      a.st.globalCaption &&
        (a.ev.on("rsAfterInit", function () {
          a.globalCaption = b('<div class="rsGCaption"></div>').appendTo(
            a.st.globalCaptionInside ? a._e1 : a.slider
          );
          a.globalCaption.html(a.currSlide.caption || "");
        }),
        a.ev.on("rsBeforeAnimStart", function () {
          a.globalCaption.html(a.currSlide.caption || "");
        }));
    },
  });
  b.rsModules.globalCaption = b.rsProto._d6;
})(jQuery);
// jquery.rs.active-class v1.0.1
(function (c) {
  c.rsProto._o4 = function () {
    var b,
      a = this;
    if (a.st.addActiveClass)
      a.ev.on("rsOnUpdateNav", function () {
        b && clearTimeout(b);
        b = setTimeout(function () {
          a._g4 && a._g4.removeClass("rsActiveSlide");
          a._r1 && a._r1.addClass("rsActiveSlide");
          b = null;
        }, 50);
      });
  };
  c.rsModules.activeClass = c.rsProto._o4;
})(jQuery);
// jquery.rs.deeplinking v1.0.6 + jQuery hashchange plugin v1.3 Copyright (c) 2010 Ben Alman
(function (b) {
  b.extend(b.rsProto, {
    _o5: function () {
      var a = this,
        h,
        d,
        f;
      a._p5 = { enabled: !1, change: !1, prefix: "" };
      a.st.deeplinking = b.extend({}, a._p5, a.st.deeplinking);
      if (a.st.deeplinking.enabled) {
        var g = a.st.deeplinking.change,
          e = a.st.deeplinking.prefix,
          c = "#" + e,
          k = function () {
            var a = window.location.hash;
            return a &&
              0 < a.indexOf(e) &&
              ((a = parseInt(a.substring(c.length), 10)), 0 <= a)
              ? a - 1
              : -1;
          },
          p = k();
        -1 !== p && (a.st.startSlideId = p);
        g &&
          (b(window).on("hashchange" + a.ns, function (b) {
            h ||
              ((b = k()),
              0 > b ||
                (b > a.numSlides - 1 && (b = a.numSlides - 1), a.goTo(b)));
          }),
          a.ev.on("rsBeforeAnimStart", function () {
            d && clearTimeout(d);
            f && clearTimeout(f);
          }),
          a.ev.on("rsAfterSlideChange", function () {
            d && clearTimeout(d);
            f && clearTimeout(f);
            f = setTimeout(function () {
              h = !0;
              window.location.replace(
                ("" + window.location).split("#")[0] + c + (a.currSlideId + 1)
              );
              d = setTimeout(function () {
                h = !1;
                d = null;
              }, 60);
            }, 400);
          }));
        a.ev.on("rsBeforeDestroy", function () {
          d = f = null;
          g && b(window).off("hashchange" + a.ns);
        });
      }
    },
  });
  b.rsModules.deeplinking = b.rsProto._o5;
})(jQuery);
(function (b, a, h) {
  function d(a) {
    a = a || location.href;
    return "#" + a.replace(/^[^#]*#?(.*)$/, "$1");
  }
  ("$:nomunge");
  var f = document,
    g,
    e = b.event.special,
    c = f.documentMode,
    k = "onhashchange" in a && (c === h || 7 < c);
  b.fn.hashchange = function (a) {
    return a ? this.bind("hashchange", a) : this.trigger("hashchange");
  };
  b.fn.hashchange.delay = 50;
  e.hashchange = b.extend(e.hashchange, {
    setup: function () {
      if (k) return !1;
      b(g.start);
    },
    teardown: function () {
      if (k) return !1;
      b(g.stop);
    },
  });
  g = (function () {
    function g() {
      var f = d(),
        e = q(l);
      f !== l
        ? (m((l = f), e), b(a).trigger("hashchange"))
        : e !== l && (location.href = location.href.replace(/#.*/, "") + e);
      c = setTimeout(g, b.fn.hashchange.delay);
    }
    var e = {},
      c,
      l = d(),
      n = function (a) {
        return a;
      },
      m = n,
      q = n;
    e.start = function () {
      c || g();
    };
    e.stop = function () {
      c && clearTimeout(c);
      c = h;
    };
    a.attachEvent &&
      !a.addEventListener &&
      !k &&
      (function () {
        var a, c;
        e.start = function () {
          a ||
            ((c = (c = b.fn.hashchange.src) && c + d()),
            (a = b('<iframe tabindex="-1" title="empty"/>')
              .hide()
              .one("load", function () {
                c || m(d());
                g();
              })
              .attr("src", c || "javascript:0")
              .insertAfter("body")[0].contentWindow),
            (f.onpropertychange = function () {
              try {
                "title" === event.propertyName && (a.document.title = f.title);
              } catch (b) {}
            }));
        };
        e.stop = n;
        q = function () {
          return d(a.location.href);
        };
        m = function (c, e) {
          var d = a.document,
            g = b.fn.hashchange.domain;
          c !== e &&
            ((d.title = f.title),
            d.open(),
            g && d.write('<script>document.domain="' + g + '"\x3c/script>'),
            d.close(),
            (a.location.hash = c));
        };
      })();
    return e;
  })();
})(jQuery, this);
// jquery.rs.visible-nearby v1.0.2
(function (d) {
  d.rsProto._g7 = function () {
    var a = this;
    a.st.visibleNearby &&
      a.st.visibleNearby.enabled &&
      ((a._h7 = {
        enabled: !0,
        centerArea: 0.6,
        center: !0,
        breakpoint: 0,
        breakpointCenterArea: 0.8,
        hiddenOverflow: !0,
        navigateByCenterClick: !1,
      }),
      (a.st.visibleNearby = d.extend({}, a._h7, a.st.visibleNearby)),
      a.ev.one("rsAfterPropsSetup", function () {
        a._i7 = a._e1
          .css("overflow", "visible")
          .wrap('<div class="rsVisibleNearbyWrap"></div>')
          .parent();
        a.st.visibleNearby.hiddenOverflow || a._i7.css("overflow", "visible");
        a._o1 = a.st.controlsInside ? a._i7 : a.slider;
      }),
      a.ev.on("rsAfterSizePropSet", function () {
        var b,
          c = a.st.visibleNearby;
        b =
          c.breakpoint && a.width < c.breakpoint
            ? c.breakpointCenterArea
            : c.centerArea;
        a._h
          ? ((a._b4 *= b),
            a._i7.css({ height: a._c4, width: a._b4 / b }),
            (a._d = (a._b4 * (1 - b)) / 2 / b))
          : ((a._c4 *= b),
            a._i7.css({ height: a._c4 / b, width: a._b4 }),
            (a._d = (a._c4 * (1 - b)) / 2 / b));
        c.navigateByCenterClick || (a._q = a._h ? a._b4 : a._c4);
        c.center && a._e1.css("margin-" + (a._h ? "left" : "top"), a._d);
      }));
  };
  d.rsModules.visibleNearby = d.rsProto._g7;
})(jQuery);

/**
 * Owl Carousel v2.2.1
 * Copyright 2013-2017 David Deutsch
 * Licensed under  ()
 */
!(function (a, b, c, d) {
  function e(b, c) {
    (this.settings = null),
      (this.options = a.extend({}, e.Defaults, c)),
      (this.$element = a(b)),
      (this._handlers = {}),
      (this._plugins = {}),
      (this._supress = {}),
      (this._current = null),
      (this._speed = null),
      (this._coordinates = []),
      (this._breakpoint = null),
      (this._width = null),
      (this._items = []),
      (this._clones = []),
      (this._mergers = []),
      (this._widths = []),
      (this._invalidated = {}),
      (this._pipe = []),
      (this._drag = {
        time: null,
        target: null,
        pointer: null,
        stage: { start: null, current: null },
        direction: null,
      }),
      (this._states = {
        current: {},
        tags: {
          initializing: ["busy"],
          animating: ["busy"],
          dragging: ["interacting"],
        },
      }),
      a.each(
        ["onResize", "onThrottledResize"],
        a.proxy(function (b, c) {
          this._handlers[c] = a.proxy(this[c], this);
        }, this)
      ),
      a.each(
        e.Plugins,
        a.proxy(function (a, b) {
          this._plugins[a.charAt(0).toLowerCase() + a.slice(1)] = new b(this);
        }, this)
      ),
      a.each(
        e.Workers,
        a.proxy(function (b, c) {
          this._pipe.push({ filter: c.filter, run: a.proxy(c.run, this) });
        }, this)
      ),
      this.setup(),
      this.initialize();
  }
  (e.Defaults = {
    items: 3,
    loop: !1,
    center: !1,
    rewind: !1,
    mouseDrag: !0,
    touchDrag: !0,
    pullDrag: !0,
    freeDrag: !1,
    margin: 0,
    stagePadding: 0,
    merge: !1,
    mergeFit: !0,
    autoWidth: !1,
    startPosition: 0,
    rtl: !1,
    smartSpeed: 250,
    fluidSpeed: !1,
    dragEndSpeed: !1,
    responsive: {},
    responsiveRefreshRate: 200,
    responsiveBaseElement: b,
    fallbackEasing: "swing",
    info: !1,
    nestedItemSelector: !1,
    itemElement: "div",
    stageElement: "div",
    refreshClass: "owl-refresh",
    loadedClass: "owl-loaded",
    loadingClass: "owl-loading",
    rtlClass: "owl-rtl",
    responsiveClass: "owl-responsive",
    dragClass: "owl-drag",
    itemClass: "owl-item",
    stageClass: "owl-stage",
    stageOuterClass: "owl-stage-outer",
    grabClass: "owl-grab",
  }),
    (e.Width = { Default: "default", Inner: "inner", Outer: "outer" }),
    (e.Type = { Event: "event", State: "state" }),
    (e.Plugins = {}),
    (e.Workers = [
      {
        filter: ["width", "settings"],
        run: function () {
          this._width = this.$element.width();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          a.current = this._items && this._items[this.relative(this._current)];
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          this.$stage.children(".cloned").remove();
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this.settings.margin || "",
            c = !this.settings.autoWidth,
            d = this.settings.rtl,
            e = {
              width: "auto",
              "margin-left": d ? b : "",
              "margin-right": d ? "" : b,
            };
          !c && this.$stage.children().css(e), (a.css = e);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b =
              (this.width() / this.settings.items).toFixed(3) -
              this.settings.margin,
            c = null,
            d = this._items.length,
            e = !this.settings.autoWidth,
            f = [];
          for (a.items = { merge: !1, width: b }; d--; )
            (c = this._mergers[d]),
              (c =
                (this.settings.mergeFit && Math.min(c, this.settings.items)) ||
                c),
              (a.items.merge = c > 1 || a.items.merge),
              (f[d] = e ? b * c : this._items[d].width());
          this._widths = f;
        },
      },
      {
        filter: ["items", "settings"],
        run: function () {
          var b = [],
            c = this._items,
            d = this.settings,
            e = Math.max(2 * d.items, 4),
            f = 2 * Math.ceil(c.length / 2),
            g = d.loop && c.length ? (d.rewind ? e : Math.max(e, f)) : 0,
            h = "",
            i = "";
          for (g /= 2; g--; )
            b.push(this.normalize(b.length / 2, !0)),
              (h += c[b[b.length - 1]][0].outerHTML),
              b.push(this.normalize(c.length - 1 - (b.length - 1) / 2, !0)),
              (i = c[b[b.length - 1]][0].outerHTML + i);
          (this._clones = b),
            a(h).addClass("cloned").appendTo(this.$stage),
            a(i).addClass("cloned").prependTo(this.$stage);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          for (
            var a = this.settings.rtl ? 1 : -1,
              b = this._clones.length + this._items.length,
              c = -1,
              d = 0,
              e = 0,
              f = [];
            ++c < b;

          )
            (d = f[c - 1] || 0),
              (e = this._widths[this.relative(c)] + this.settings.margin),
              f.push(d + e * a);
          this._coordinates = f;
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function () {
          var a = this.settings.stagePadding,
            b = this._coordinates,
            c = {
              width: Math.ceil(Math.abs(b[b.length - 1])) + 2 * a,
              "padding-left": a || "",
              "padding-right": a || "",
            };
          this.$stage.css(c);
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          var b = this._coordinates.length,
            c = !this.settings.autoWidth,
            d = this.$stage.children();
          if (c && a.items.merge)
            for (; b--; )
              (a.css.width = this._widths[this.relative(b)]),
                d.eq(b).css(a.css);
          else c && ((a.css.width = a.items.width), d.css(a.css));
        },
      },
      {
        filter: ["items"],
        run: function () {
          this._coordinates.length < 1 && this.$stage.removeAttr("style");
        },
      },
      {
        filter: ["width", "items", "settings"],
        run: function (a) {
          (a.current = a.current ? this.$stage.children().index(a.current) : 0),
            (a.current = Math.max(
              this.minimum(),
              Math.min(this.maximum(), a.current)
            )),
            this.reset(a.current);
        },
      },
      {
        filter: ["position"],
        run: function () {
          this.animate(this.coordinates(this._current));
        },
      },
      {
        filter: ["width", "position", "items", "settings"],
        run: function () {
          var a,
            b,
            c,
            d,
            e = this.settings.rtl ? 1 : -1,
            f = 2 * this.settings.stagePadding,
            g = this.coordinates(this.current()) + f,
            h = g + this.width() * e,
            i = [];
          for (c = 0, d = this._coordinates.length; c < d; c++)
            (a = this._coordinates[c - 1] || 0),
              (b = Math.abs(this._coordinates[c]) + f * e),
              ((this.op(a, "<=", g) && this.op(a, ">", h)) ||
                (this.op(b, "<", g) && this.op(b, ">", h))) &&
                i.push(c);
          this.$stage.children(".active").removeClass("active"),
            this.$stage
              .children(":eq(" + i.join("), :eq(") + ")")
              .addClass("active"),
            this.settings.center &&
              (this.$stage.children(".center").removeClass("center"),
              this.$stage.children().eq(this.current()).addClass("center"));
        },
      },
    ]),
    (e.prototype.initialize = function () {
      if (
        (this.enter("initializing"),
        this.trigger("initialize"),
        this.$element.toggleClass(this.settings.rtlClass, this.settings.rtl),
        this.settings.autoWidth && !this.is("pre-loading"))
      ) {
        var b, c, e;
        (b = this.$element.find("img")),
          (c = this.settings.nestedItemSelector
            ? "." + this.settings.nestedItemSelector
            : d),
          (e = this.$element.children(c).width()),
          b.length && e <= 0 && this.preloadAutoWidthImages(b);
      }
      this.$element.addClass(this.options.loadingClass),
        (this.$stage = a(
          "<" +
            this.settings.stageElement +
            ' class="' +
            this.settings.stageClass +
            '"/>'
        ).wrap('<div class="' + this.settings.stageOuterClass + '"/>')),
        this.$element.append(this.$stage.parent()),
        this.replace(this.$element.children().not(this.$stage.parent())),
        this.$element.is(":visible")
          ? this.refresh()
          : this.invalidate("width"),
        this.$element
          .removeClass(this.options.loadingClass)
          .addClass(this.options.loadedClass),
        this.registerEventHandlers(),
        this.leave("initializing"),
        this.trigger("initialized");
    }),
    (e.prototype.setup = function () {
      var b = this.viewport(),
        c = this.options.responsive,
        d = -1,
        e = null;
      c
        ? (a.each(c, function (a) {
            a <= b && a > d && (d = Number(a));
          }),
          (e = a.extend({}, this.options, c[d])),
          "function" == typeof e.stagePadding &&
            (e.stagePadding = e.stagePadding()),
          delete e.responsive,
          e.responsiveClass &&
            this.$element.attr(
              "class",
              this.$element
                .attr("class")
                .replace(
                  new RegExp(
                    "(" + this.options.responsiveClass + "-)\\S+\\s",
                    "g"
                  ),
                  "$1" + d
                )
            ))
        : (e = a.extend({}, this.options)),
        this.trigger("change", { property: { name: "settings", value: e } }),
        (this._breakpoint = d),
        (this.settings = e),
        this.invalidate("settings"),
        this.trigger("changed", {
          property: { name: "settings", value: this.settings },
        });
    }),
    (e.prototype.optionsLogic = function () {
      this.settings.autoWidth &&
        ((this.settings.stagePadding = !1), (this.settings.merge = !1));
    }),
    (e.prototype.prepare = function (b) {
      var c = this.trigger("prepare", { content: b });
      return (
        c.data ||
          (c.data = a("<" + this.settings.itemElement + "/>")
            .addClass(this.options.itemClass)
            .append(b)),
        this.trigger("prepared", { content: c.data }),
        c.data
      );
    }),
    (e.prototype.update = function () {
      for (
        var b = 0,
          c = this._pipe.length,
          d = a.proxy(function (a) {
            return this[a];
          }, this._invalidated),
          e = {};
        b < c;

      )
        (this._invalidated.all || a.grep(this._pipe[b].filter, d).length > 0) &&
          this._pipe[b].run(e),
          b++;
      (this._invalidated = {}), !this.is("valid") && this.enter("valid");
    }),
    (e.prototype.width = function (a) {
      switch ((a = a || e.Width.Default)) {
        case e.Width.Inner:
        case e.Width.Outer:
          return this._width;
        default:
          return (
            this._width - 2 * this.settings.stagePadding + this.settings.margin
          );
      }
    }),
    (e.prototype.refresh = function () {
      this.enter("refreshing"),
        this.trigger("refresh"),
        this.setup(),
        this.optionsLogic(),
        this.$element.addClass(this.options.refreshClass),
        this.update(),
        this.$element.removeClass(this.options.refreshClass),
        this.leave("refreshing"),
        this.trigger("refreshed");
    }),
    (e.prototype.onThrottledResize = function () {
      b.clearTimeout(this.resizeTimer),
        (this.resizeTimer = b.setTimeout(
          this._handlers.onResize,
          this.settings.responsiveRefreshRate
        ));
    }),
    (e.prototype.onResize = function () {
      return (
        !!this._items.length &&
        this._width !== this.$element.width() &&
        !!this.$element.is(":visible") &&
        (this.enter("resizing"),
        this.trigger("resize").isDefaultPrevented()
          ? (this.leave("resizing"), !1)
          : (this.invalidate("width"),
            this.refresh(),
            this.leave("resizing"),
            void this.trigger("resized")))
      );
    }),
    (e.prototype.registerEventHandlers = function () {
      a.support.transition &&
        this.$stage.on(
          a.support.transition.end + ".owl.core",
          a.proxy(this.onTransitionEnd, this)
        ),
        this.settings.responsive !== !1 &&
          this.on(b, "resize", this._handlers.onThrottledResize),
        this.settings.mouseDrag &&
          (this.$element.addClass(this.options.dragClass),
          this.$stage.on("mousedown.owl.core", a.proxy(this.onDragStart, this)),
          this.$stage.on(
            "dragstart.owl.core selectstart.owl.core",
            function () {
              return !1;
            }
          )),
        this.settings.touchDrag &&
          (this.$stage.on(
            "touchstart.owl.core",
            a.proxy(this.onDragStart, this)
          ),
          this.$stage.on(
            "touchcancel.owl.core",
            a.proxy(this.onDragEnd, this)
          ));
    }),
    (e.prototype.onDragStart = function (b) {
      var d = null;
      3 !== b.which &&
        (a.support.transform
          ? ((d = this.$stage
              .css("transform")
              .replace(/.*\(|\)| /g, "")
              .split(",")),
            (d = {
              x: d[16 === d.length ? 12 : 4],
              y: d[16 === d.length ? 13 : 5],
            }))
          : ((d = this.$stage.position()),
            (d = {
              x: this.settings.rtl
                ? d.left +
                  this.$stage.width() -
                  this.width() +
                  this.settings.margin
                : d.left,
              y: d.top,
            })),
        this.is("animating") &&
          (a.support.transform ? this.animate(d.x) : this.$stage.stop(),
          this.invalidate("position")),
        this.$element.toggleClass(
          this.options.grabClass,
          "mousedown" === b.type
        ),
        this.speed(0),
        (this._drag.time = new Date().getTime()),
        (this._drag.target = a(b.target)),
        (this._drag.stage.start = d),
        (this._drag.stage.current = d),
        (this._drag.pointer = this.pointer(b)),
        a(c).on(
          "mouseup.owl.core touchend.owl.core",
          a.proxy(this.onDragEnd, this)
        ),
        a(c).one(
          "mousemove.owl.core touchmove.owl.core",
          a.proxy(function (b) {
            var d = this.difference(this._drag.pointer, this.pointer(b));
            a(c).on(
              "mousemove.owl.core touchmove.owl.core",
              a.proxy(this.onDragMove, this)
            ),
              (Math.abs(d.x) < Math.abs(d.y) && this.is("valid")) ||
                (b.preventDefault(),
                this.enter("dragging"),
                this.trigger("drag"));
          }, this)
        ));
    }),
    (e.prototype.onDragMove = function (a) {
      var b = null,
        c = null,
        d = null,
        e = this.difference(this._drag.pointer, this.pointer(a)),
        f = this.difference(this._drag.stage.start, e);
      this.is("dragging") &&
        (a.preventDefault(),
        this.settings.loop
          ? ((b = this.coordinates(this.minimum())),
            (c = this.coordinates(this.maximum() + 1) - b),
            (f.x = ((((f.x - b) % c) + c) % c) + b))
          : ((b = this.settings.rtl
              ? this.coordinates(this.maximum())
              : this.coordinates(this.minimum())),
            (c = this.settings.rtl
              ? this.coordinates(this.minimum())
              : this.coordinates(this.maximum())),
            (d = this.settings.pullDrag ? (-1 * e.x) / 5 : 0),
            (f.x = Math.max(Math.min(f.x, b + d), c + d))),
        (this._drag.stage.current = f),
        this.animate(f.x));
    }),
    (e.prototype.onDragEnd = function (b) {
      var d = this.difference(this._drag.pointer, this.pointer(b)),
        e = this._drag.stage.current,
        f = (d.x > 0) ^ this.settings.rtl ? "left" : "right";
      a(c).off(".owl.core"),
        this.$element.removeClass(this.options.grabClass),
        ((0 !== d.x && this.is("dragging")) || !this.is("valid")) &&
          (this.speed(this.settings.dragEndSpeed || this.settings.smartSpeed),
          this.current(this.closest(e.x, 0 !== d.x ? f : this._drag.direction)),
          this.invalidate("position"),
          this.update(),
          (this._drag.direction = f),
          (Math.abs(d.x) > 3 || new Date().getTime() - this._drag.time > 300) &&
            this._drag.target.one("click.owl.core", function () {
              return !1;
            })),
        this.is("dragging") &&
          (this.leave("dragging"), this.trigger("dragged"));
    }),
    (e.prototype.closest = function (b, c) {
      var d = -1,
        e = 30,
        f = this.width(),
        g = this.coordinates();
      return (
        this.settings.freeDrag ||
          a.each(
            g,
            a.proxy(function (a, h) {
              return (
                "left" === c && b > h - e && b < h + e
                  ? (d = a)
                  : "right" === c && b > h - f - e && b < h - f + e
                  ? (d = a + 1)
                  : this.op(b, "<", h) &&
                    this.op(b, ">", g[a + 1] || h - f) &&
                    (d = "left" === c ? a + 1 : a),
                d === -1
              );
            }, this)
          ),
        this.settings.loop ||
          (this.op(b, ">", g[this.minimum()])
            ? (d = b = this.minimum())
            : this.op(b, "<", g[this.maximum()]) && (d = b = this.maximum())),
        d
      );
    }),
    (e.prototype.animate = function (b) {
      var c = this.speed() > 0;
      this.is("animating") && this.onTransitionEnd(),
        c && (this.enter("animating"), this.trigger("translate")),
        a.support.transform3d && a.support.transition
          ? this.$stage.css({
              transform: "translate3d(" + b + "px,0px,0px)",
              transition: this.speed() / 1e3 + "s",
            })
          : c
          ? this.$stage.animate(
              { left: b + "px" },
              this.speed(),
              this.settings.fallbackEasing,
              a.proxy(this.onTransitionEnd, this)
            )
          : this.$stage.css({ left: b + "px" });
    }),
    (e.prototype.is = function (a) {
      return this._states.current[a] && this._states.current[a] > 0;
    }),
    (e.prototype.current = function (a) {
      if (a === d) return this._current;
      if (0 === this._items.length) return d;
      if (((a = this.normalize(a)), this._current !== a)) {
        var b = this.trigger("change", {
          property: { name: "position", value: a },
        });
        b.data !== d && (a = this.normalize(b.data)),
          (this._current = a),
          this.invalidate("position"),
          this.trigger("changed", {
            property: { name: "position", value: this._current },
          });
      }
      return this._current;
    }),
    (e.prototype.invalidate = function (b) {
      return (
        "string" === a.type(b) &&
          ((this._invalidated[b] = !0),
          this.is("valid") && this.leave("valid")),
        a.map(this._invalidated, function (a, b) {
          return b;
        })
      );
    }),
    (e.prototype.reset = function (a) {
      (a = this.normalize(a)),
        a !== d &&
          ((this._speed = 0),
          (this._current = a),
          this.suppress(["translate", "translated"]),
          this.animate(this.coordinates(a)),
          this.release(["translate", "translated"]));
    }),
    (e.prototype.normalize = function (a, b) {
      var c = this._items.length,
        e = b ? 0 : this._clones.length;
      return (
        !this.isNumeric(a) || c < 1
          ? (a = d)
          : (a < 0 || a >= c + e) &&
            (a = ((((a - e / 2) % c) + c) % c) + e / 2),
        a
      );
    }),
    (e.prototype.relative = function (a) {
      return (a -= this._clones.length / 2), this.normalize(a, !0);
    }),
    (e.prototype.maximum = function (a) {
      var b,
        c,
        d,
        e = this.settings,
        f = this._coordinates.length;
      if (e.loop) f = this._clones.length / 2 + this._items.length - 1;
      else if (e.autoWidth || e.merge) {
        for (
          b = this._items.length,
            c = this._items[--b].width(),
            d = this.$element.width();
          b-- &&
          ((c += this._items[b].width() + this.settings.margin), !(c > d));

        );
        f = b + 1;
      } else
        f = e.center ? this._items.length - 1 : this._items.length - e.items;
      return a && (f -= this._clones.length / 2), Math.max(f, 0);
    }),
    (e.prototype.minimum = function (a) {
      return a ? 0 : this._clones.length / 2;
    }),
    (e.prototype.items = function (a) {
      return a === d
        ? this._items.slice()
        : ((a = this.normalize(a, !0)), this._items[a]);
    }),
    (e.prototype.mergers = function (a) {
      return a === d
        ? this._mergers.slice()
        : ((a = this.normalize(a, !0)), this._mergers[a]);
    }),
    (e.prototype.clones = function (b) {
      var c = this._clones.length / 2,
        e = c + this._items.length,
        f = function (a) {
          return a % 2 === 0 ? e + a / 2 : c - (a + 1) / 2;
        };
      return b === d
        ? a.map(this._clones, function (a, b) {
            return f(b);
          })
        : a.map(this._clones, function (a, c) {
            return a === b ? f(c) : null;
          });
    }),
    (e.prototype.speed = function (a) {
      return a !== d && (this._speed = a), this._speed;
    }),
    (e.prototype.coordinates = function (b) {
      var c,
        e = 1,
        f = b - 1;
      return b === d
        ? a.map(
            this._coordinates,
            a.proxy(function (a, b) {
              return this.coordinates(b);
            }, this)
          )
        : (this.settings.center
            ? (this.settings.rtl && ((e = -1), (f = b + 1)),
              (c = this._coordinates[b]),
              (c += ((this.width() - c + (this._coordinates[f] || 0)) / 2) * e))
            : (c = this._coordinates[f] || 0),
          (c = Math.ceil(c)));
    }),
    (e.prototype.duration = function (a, b, c) {
      return 0 === c
        ? 0
        : Math.min(Math.max(Math.abs(b - a), 1), 6) *
            Math.abs(c || this.settings.smartSpeed);
    }),
    (e.prototype.to = function (a, b) {
      var c = this.current(),
        d = null,
        e = a - this.relative(c),
        f = (e > 0) - (e < 0),
        g = this._items.length,
        h = this.minimum(),
        i = this.maximum();
      this.settings.loop
        ? (!this.settings.rewind && Math.abs(e) > g / 2 && (e += f * -1 * g),
          (a = c + e),
          (d = ((((a - h) % g) + g) % g) + h),
          d !== a &&
            d - e <= i &&
            d - e > 0 &&
            ((c = d - e), (a = d), this.reset(c)))
        : this.settings.rewind
        ? ((i += 1), (a = ((a % i) + i) % i))
        : (a = Math.max(h, Math.min(i, a))),
        this.speed(this.duration(c, a, b)),
        this.current(a),
        this.$element.is(":visible") && this.update();
    }),
    (e.prototype.next = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) + 1, a);
    }),
    (e.prototype.prev = function (a) {
      (a = a || !1), this.to(this.relative(this.current()) - 1, a);
    }),
    (e.prototype.onTransitionEnd = function (a) {
      if (
        a !== d &&
        (a.stopPropagation(),
        (a.target || a.srcElement || a.originalTarget) !== this.$stage.get(0))
      )
        return !1;
      this.leave("animating"), this.trigger("translated");
    }),
    (e.prototype.viewport = function () {
      var d;
      return (
        this.options.responsiveBaseElement !== b
          ? (d = a(this.options.responsiveBaseElement).width())
          : b.innerWidth
          ? (d = b.innerWidth)
          : c.documentElement && c.documentElement.clientWidth
          ? (d = c.documentElement.clientWidth)
          : console.warn("Can not detect viewport width."),
        d
      );
    }),
    (e.prototype.replace = function (b) {
      this.$stage.empty(),
        (this._items = []),
        b && (b = b instanceof jQuery ? b : a(b)),
        this.settings.nestedItemSelector &&
          (b = b.find("." + this.settings.nestedItemSelector)),
        b
          .filter(function () {
            return 1 === this.nodeType;
          })
          .each(
            a.proxy(function (a, b) {
              (b = this.prepare(b)),
                this.$stage.append(b),
                this._items.push(b),
                this._mergers.push(
                  1 *
                    b
                      .find("[data-merge]")
                      .addBack("[data-merge]")
                      .attr("data-merge") || 1
                );
            }, this)
          ),
        this.reset(
          this.isNumeric(this.settings.startPosition)
            ? this.settings.startPosition
            : 0
        ),
        this.invalidate("items");
    }),
    (e.prototype.add = function (b, c) {
      var e = this.relative(this._current);
      (c = c === d ? this._items.length : this.normalize(c, !0)),
        (b = b instanceof jQuery ? b : a(b)),
        this.trigger("add", { content: b, position: c }),
        (b = this.prepare(b)),
        0 === this._items.length || c === this._items.length
          ? (0 === this._items.length && this.$stage.append(b),
            0 !== this._items.length && this._items[c - 1].after(b),
            this._items.push(b),
            this._mergers.push(
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            ))
          : (this._items[c].before(b),
            this._items.splice(c, 0, b),
            this._mergers.splice(
              c,
              0,
              1 *
                b
                  .find("[data-merge]")
                  .addBack("[data-merge]")
                  .attr("data-merge") || 1
            )),
        this._items[e] && this.reset(this._items[e].index()),
        this.invalidate("items"),
        this.trigger("added", { content: b, position: c });
    }),
    (e.prototype.remove = function (a) {
      (a = this.normalize(a, !0)),
        a !== d &&
          (this.trigger("remove", { content: this._items[a], position: a }),
          this._items[a].remove(),
          this._items.splice(a, 1),
          this._mergers.splice(a, 1),
          this.invalidate("items"),
          this.trigger("removed", { content: null, position: a }));
    }),
    (e.prototype.preloadAutoWidthImages = function (b) {
      b.each(
        a.proxy(function (b, c) {
          this.enter("pre-loading"),
            (c = a(c)),
            a(new Image())
              .one(
                "load",
                a.proxy(function (a) {
                  c.attr("src", a.target.src),
                    c.css("opacity", 1),
                    this.leave("pre-loading"),
                    !this.is("pre-loading") &&
                      !this.is("initializing") &&
                      this.refresh();
                }, this)
              )
              .attr(
                "src",
                c.attr("src") || c.attr("data-src") || c.attr("data-src-retina")
              );
        }, this)
      );
    }),
    (e.prototype.destroy = function () {
      this.$element.off(".owl.core"),
        this.$stage.off(".owl.core"),
        a(c).off(".owl.core"),
        this.settings.responsive !== !1 &&
          (b.clearTimeout(this.resizeTimer),
          this.off(b, "resize", this._handlers.onThrottledResize));
      for (var d in this._plugins) this._plugins[d].destroy();
      this.$stage.children(".cloned").remove(),
        this.$stage.unwrap(),
        this.$stage.children().contents().unwrap(),
        this.$stage.children().unwrap(),
        this.$element
          .removeClass(this.options.refreshClass)
          .removeClass(this.options.loadingClass)
          .removeClass(this.options.loadedClass)
          .removeClass(this.options.rtlClass)
          .removeClass(this.options.dragClass)
          .removeClass(this.options.grabClass)
          .attr(
            "class",
            this.$element
              .attr("class")
              .replace(
                new RegExp(this.options.responsiveClass + "-\\S+\\s", "g"),
                ""
              )
          )
          .removeData("owl.carousel");
    }),
    (e.prototype.op = function (a, b, c) {
      var d = this.settings.rtl;
      switch (b) {
        case "<":
          return d ? a > c : a < c;
        case ">":
          return d ? a < c : a > c;
        case ">=":
          return d ? a <= c : a >= c;
        case "<=":
          return d ? a >= c : a <= c;
      }
    }),
    (e.prototype.on = function (a, b, c, d) {
      a.addEventListener
        ? a.addEventListener(b, c, d)
        : a.attachEvent && a.attachEvent("on" + b, c);
    }),
    (e.prototype.off = function (a, b, c, d) {
      a.removeEventListener
        ? a.removeEventListener(b, c, d)
        : a.detachEvent && a.detachEvent("on" + b, c);
    }),
    (e.prototype.trigger = function (b, c, d, f, g) {
      var h = { item: { count: this._items.length, index: this.current() } },
        i = a.camelCase(
          a
            .grep(["on", b, d], function (a) {
              return a;
            })
            .join("-")
            .toLowerCase()
        ),
        j = a.Event(
          [b, "owl", d || "carousel"].join(".").toLowerCase(),
          a.extend({ relatedTarget: this }, h, c)
        );
      return (
        this._supress[b] ||
          (a.each(this._plugins, function (a, b) {
            b.onTrigger && b.onTrigger(j);
          }),
          this.register({ type: e.Type.Event, name: b }),
          this.$element.trigger(j),
          this.settings &&
            "function" == typeof this.settings[i] &&
            this.settings[i].call(this, j)),
        j
      );
    }),
    (e.prototype.enter = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b] === d && (this._states.current[b] = 0),
            this._states.current[b]++;
        }, this)
      );
    }),
    (e.prototype.leave = function (b) {
      a.each(
        [b].concat(this._states.tags[b] || []),
        a.proxy(function (a, b) {
          this._states.current[b]--;
        }, this)
      );
    }),
    (e.prototype.register = function (b) {
      if (b.type === e.Type.Event) {
        if (
          (a.event.special[b.name] || (a.event.special[b.name] = {}),
          !a.event.special[b.name].owl)
        ) {
          var c = a.event.special[b.name]._default;
          (a.event.special[b.name]._default = function (a) {
            return !c ||
              !c.apply ||
              (a.namespace && a.namespace.indexOf("owl") !== -1)
              ? a.namespace && a.namespace.indexOf("owl") > -1
              : c.apply(this, arguments);
          }),
            (a.event.special[b.name].owl = !0);
        }
      } else
        b.type === e.Type.State &&
          (this._states.tags[b.name]
            ? (this._states.tags[b.name] = this._states.tags[b.name].concat(
                b.tags
              ))
            : (this._states.tags[b.name] = b.tags),
          (this._states.tags[b.name] = a.grep(
            this._states.tags[b.name],
            a.proxy(function (c, d) {
              return a.inArray(c, this._states.tags[b.name]) === d;
            }, this)
          )));
    }),
    (e.prototype.suppress = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          this._supress[b] = !0;
        }, this)
      );
    }),
    (e.prototype.release = function (b) {
      a.each(
        b,
        a.proxy(function (a, b) {
          delete this._supress[b];
        }, this)
      );
    }),
    (e.prototype.pointer = function (a) {
      var c = { x: null, y: null };
      return (
        (a = a.originalEvent || a || b.event),
        (a =
          a.touches && a.touches.length
            ? a.touches[0]
            : a.changedTouches && a.changedTouches.length
            ? a.changedTouches[0]
            : a),
        a.pageX
          ? ((c.x = a.pageX), (c.y = a.pageY))
          : ((c.x = a.clientX), (c.y = a.clientY)),
        c
      );
    }),
    (e.prototype.isNumeric = function (a) {
      return !isNaN(parseFloat(a));
    }),
    (e.prototype.difference = function (a, b) {
      return { x: a.x - b.x, y: a.y - b.y };
    }),
    (a.fn.owlCarousel = function (b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each(function () {
        var d = a(this),
          f = d.data("owl.carousel");
        f ||
          ((f = new e(this, "object" == typeof b && b)),
          d.data("owl.carousel", f),
          a.each(
            [
              "next",
              "prev",
              "to",
              "destroy",
              "refresh",
              "replace",
              "add",
              "remove",
            ],
            function (b, c) {
              f.register({ type: e.Type.Event, name: c }),
                f.$element.on(
                  c + ".owl.carousel.core",
                  a.proxy(function (a) {
                    a.namespace &&
                      a.relatedTarget !== this &&
                      (this.suppress([c]),
                      f[c].apply(this, [].slice.call(arguments, 1)),
                      this.release([c]));
                  }, f)
                );
            }
          )),
          "string" == typeof b && "_" !== b.charAt(0) && f[b].apply(f, c);
      });
    }),
    (a.fn.owlCarousel.Constructor = e);
})(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._interval = null),
        (this._visible = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoRefresh && this.watch();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoRefresh: !0, autoRefreshInterval: 500 }),
      (e.prototype.watch = function () {
        this._interval ||
          ((this._visible = this._core.$element.is(":visible")),
          (this._interval = b.setInterval(
            a.proxy(this.refresh, this),
            this._core.settings.autoRefreshInterval
          )));
      }),
      (e.prototype.refresh = function () {
        this._core.$element.is(":visible") !== this._visible &&
          ((this._visible = !this._visible),
          this._core.$element.toggleClass("owl-hidden", !this._visible),
          this._visible &&
            this._core.invalidate("width") &&
            this._core.refresh());
      }),
      (e.prototype.destroy = function () {
        var a, c;
        b.clearInterval(this._interval);
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoRefresh = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._loaded = []),
        (this._handlers = {
          "initialized.owl.carousel change.owl.carousel resized.owl.carousel":
            a.proxy(function (b) {
              if (
                b.namespace &&
                this._core.settings &&
                this._core.settings.lazyLoad &&
                ((b.property && "position" == b.property.name) ||
                  "initialized" == b.type)
              )
                for (
                  var c = this._core.settings,
                    e = (c.center && Math.ceil(c.items / 2)) || c.items,
                    f = (c.center && e * -1) || 0,
                    g =
                      (b.property && b.property.value !== d
                        ? b.property.value
                        : this._core.current()) + f,
                    h = this._core.clones().length,
                    i = a.proxy(function (a, b) {
                      this.load(b);
                    }, this);
                  f++ < e;

                )
                  this.load(h / 2 + this._core.relative(g)),
                    h && a.each(this._core.clones(this._core.relative(g)), i),
                    g++;
            }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { lazyLoad: !1 }),
      (e.prototype.load = function (c) {
        var d = this._core.$stage.children().eq(c),
          e = d && d.find(".owl-lazy");
        !e ||
          a.inArray(d.get(0), this._loaded) > -1 ||
          (e.each(
            a.proxy(function (c, d) {
              var e,
                f = a(d),
                g =
                  (b.devicePixelRatio > 1 && f.attr("data-src-retina")) ||
                  f.attr("data-src");
              this._core.trigger("load", { element: f, url: g }, "lazy"),
                f.is("img")
                  ? f
                      .one(
                        "load.owl.lazy",
                        a.proxy(function () {
                          f.css("opacity", 1),
                            this._core.trigger(
                              "loaded",
                              { element: f, url: g },
                              "lazy"
                            );
                        }, this)
                      )
                      .attr("src", g)
                  : ((e = new Image()),
                    (e.onload = a.proxy(function () {
                      f.css({
                        "background-image": 'url("' + g + '")',
                        opacity: "1",
                      }),
                        this._core.trigger(
                          "loaded",
                          { element: f, url: g },
                          "lazy"
                        );
                    }, this)),
                    (e.src = g));
            }, this)
          ),
          this._loaded.push(d.get(0)));
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this._core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Lazy = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._handlers = {
          "initialized.owl.carousel refreshed.owl.carousel": a.proxy(function (
            a
          ) {
            a.namespace && this._core.settings.autoHeight && this.update();
          },
          this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              "position" == a.property.name &&
              this.update();
          }, this),
          "loaded.owl.lazy": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.autoHeight &&
              a.element.closest("." + this._core.settings.itemClass).index() ===
                this._core.current() &&
              this.update();
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers);
    };
    (e.Defaults = { autoHeight: !1, autoHeightClass: "owl-height" }),
      (e.prototype.update = function () {
        var b = this._core._current,
          c = b + this._core.settings.items,
          d = this._core.$stage.children().toArray().slice(b, c),
          e = [],
          f = 0;
        a.each(d, function (b, c) {
          e.push(a(c).height());
        }),
          (f = Math.max.apply(null, e)),
          this._core.$stage
            .parent()
            .height(f)
            .addClass(this._core.settings.autoHeightClass);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.AutoHeight = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._videos = {}),
        (this._playing = null),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.register({
                type: "state",
                name: "playing",
                tags: ["interacting"],
              });
          }, this),
          "resize.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.video &&
              this.isInFullScreen() &&
              a.preventDefault();
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.is("resizing") &&
              this._core.$stage.find(".cloned .owl-video-frame").remove();
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" === a.property.name &&
              this._playing &&
              this.stop();
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content).find(".owl-video");
              c.length &&
                (c.css("display", "none"), this.fetch(c, a(b.content)));
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this._core.$element.on(this._handlers),
        this._core.$element.on(
          "click.owl.video",
          ".owl-video-play-icon",
          a.proxy(function (a) {
            this.play(a);
          }, this)
        );
    };
    (e.Defaults = { video: !1, videoHeight: !1, videoWidth: !1 }),
      (e.prototype.fetch = function (a, b) {
        var c = (function () {
            return a.attr("data-vimeo-id")
              ? "vimeo"
              : a.attr("data-vzaar-id")
              ? "vzaar"
              : "youtube";
          })(),
          d =
            a.attr("data-vimeo-id") ||
            a.attr("data-youtube-id") ||
            a.attr("data-vzaar-id"),
          e = a.attr("data-width") || this._core.settings.videoWidth,
          f = a.attr("data-height") || this._core.settings.videoHeight,
          g = a.attr("href");
        if (!g) throw new Error("Missing video URL.");
        if (
          ((d = g.match(
            /(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/
          )),
          d[3].indexOf("youtu") > -1)
        )
          c = "youtube";
        else if (d[3].indexOf("vimeo") > -1) c = "vimeo";
        else {
          if (!(d[3].indexOf("vzaar") > -1))
            throw new Error("Video URL not supported.");
          c = "vzaar";
        }
        (d = d[6]),
          (this._videos[g] = { type: c, id: d, width: e, height: f }),
          b.attr("data-video", g),
          this.thumbnail(a, this._videos[g]);
      }),
      (e.prototype.thumbnail = function (b, c) {
        var d,
          e,
          f,
          g =
            c.width && c.height
              ? 'style="width:' + c.width + "px;height:" + c.height + 'px;"'
              : "",
          h = b.find("img"),
          i = "src",
          j = "",
          k = this._core.settings,
          l = function (a) {
            (e = '<div class="owl-video-play-icon"></div>'),
              (d = k.lazyLoad
                ? '<div class="owl-video-tn ' +
                  j +
                  '" ' +
                  i +
                  '="' +
                  a +
                  '"></div>'
                : '<div class="owl-video-tn" style="opacity:1;background-image:url(' +
                  a +
                  ')"></div>'),
              b.after(d),
              b.after(e);
          };
        if (
          (b.wrap('<div class="owl-video-wrapper"' + g + "></div>"),
          this._core.settings.lazyLoad && ((i = "data-src"), (j = "owl-lazy")),
          h.length)
        )
          return l(h.attr(i)), h.remove(), !1;
        "youtube" === c.type
          ? ((f = "//img.youtube.com/vi/" + c.id + "/hqdefault.jpg"), l(f))
          : "vimeo" === c.type
          ? a.ajax({
              type: "GET",
              url: "//vimeo.com/api/v2/video/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a[0].thumbnail_large), l(f);
              },
            })
          : "vzaar" === c.type &&
            a.ajax({
              type: "GET",
              url: "//vzaar.com/api/videos/" + c.id + ".json",
              jsonp: "callback",
              dataType: "jsonp",
              success: function (a) {
                (f = a.framegrab_url), l(f);
              },
            });
      }),
      (e.prototype.stop = function () {
        this._core.trigger("stop", null, "video"),
          this._playing.find(".owl-video-frame").remove(),
          this._playing.removeClass("owl-video-playing"),
          (this._playing = null),
          this._core.leave("playing"),
          this._core.trigger("stopped", null, "video");
      }),
      (e.prototype.play = function (b) {
        var c,
          d = a(b.target),
          e = d.closest("." + this._core.settings.itemClass),
          f = this._videos[e.attr("data-video")],
          g = f.width || "100%",
          h = f.height || this._core.$stage.height();
        this._playing ||
          (this._core.enter("playing"),
          this._core.trigger("play", null, "video"),
          (e = this._core.items(this._core.relative(e.index()))),
          this._core.reset(e.index()),
          "youtube" === f.type
            ? (c =
                '<iframe width="' +
                g +
                '" height="' +
                h +
                '" src="//www.youtube.com/embed/' +
                f.id +
                "?autoplay=1&rel=0&v=" +
                f.id +
                '" frameborder="0" allowfullscreen></iframe>')
            : "vimeo" === f.type
            ? (c =
                '<iframe src="//player.vimeo.com/video/' +
                f.id +
                '?autoplay=1" width="' +
                g +
                '" height="' +
                h +
                '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>')
            : "vzaar" === f.type &&
              (c =
                '<iframe frameborder="0"height="' +
                h +
                '"width="' +
                g +
                '" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/' +
                f.id +
                '/player?autoplay=true"></iframe>'),
          a('<div class="owl-video-frame">' + c + "</div>").insertAfter(
            e.find(".owl-video")
          ),
          (this._playing = e.addClass("owl-video-playing")));
      }),
      (e.prototype.isInFullScreen = function () {
        var b =
          c.fullscreenElement ||
          c.mozFullScreenElement ||
          c.webkitFullscreenElement;
        return b && a(b).parent().hasClass("owl-video-frame");
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this._core.$element.off("click.owl.video");
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Video = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this.core = b),
        (this.core.options = a.extend({}, e.Defaults, this.core.options)),
        (this.swapping = !0),
        (this.previous = d),
        (this.next = d),
        (this.handlers = {
          "change.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              "position" == a.property.name &&
              ((this.previous = this.core.current()),
              (this.next = a.property.value));
          }, this),
          "drag.owl.carousel dragged.owl.carousel translated.owl.carousel":
            a.proxy(function (a) {
              a.namespace && (this.swapping = "translated" == a.type);
            }, this),
          "translate.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this.swapping &&
              (this.core.options.animateOut || this.core.options.animateIn) &&
              this.swap();
          }, this),
        }),
        this.core.$element.on(this.handlers);
    };
    (e.Defaults = { animateOut: !1, animateIn: !1 }),
      (e.prototype.swap = function () {
        if (
          1 === this.core.settings.items &&
          a.support.animation &&
          a.support.transition
        ) {
          this.core.speed(0);
          var b,
            c = a.proxy(this.clear, this),
            d = this.core.$stage.children().eq(this.previous),
            e = this.core.$stage.children().eq(this.next),
            f = this.core.settings.animateIn,
            g = this.core.settings.animateOut;
          this.core.current() !== this.previous &&
            (g &&
              ((b =
                this.core.coordinates(this.previous) -
                this.core.coordinates(this.next)),
              d
                .one(a.support.animation.end, c)
                .css({ left: b + "px" })
                .addClass("animated owl-animated-out")
                .addClass(g)),
            f &&
              e
                .one(a.support.animation.end, c)
                .addClass("animated owl-animated-in")
                .addClass(f));
        }
      }),
      (e.prototype.clear = function (b) {
        a(b.target)
          .css({ left: "" })
          .removeClass("animated owl-animated-out owl-animated-in")
          .removeClass(this.core.settings.animateIn)
          .removeClass(this.core.settings.animateOut),
          this.core.onTransitionEnd();
      }),
      (e.prototype.destroy = function () {
        var a, b;
        for (a in this.handlers) this.core.$element.off(a, this.handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Animate = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    var e = function (b) {
      (this._core = b),
        (this._timeout = null),
        (this._paused = !1),
        (this._handlers = {
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "settings" === a.property.name
              ? this._core.settings.autoplay
                ? this.play()
                : this.stop()
              : a.namespace &&
                "position" === a.property.name &&
                this._core.settings.autoplay &&
                this._setAutoPlayInterval();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace && this._core.settings.autoplay && this.play();
          }, this),
          "play.owl.autoplay": a.proxy(function (a, b, c) {
            a.namespace && this.play(b, c);
          }, this),
          "stop.owl.autoplay": a.proxy(function (a) {
            a.namespace && this.stop();
          }, this),
          "mouseover.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "mouseleave.owl.autoplay": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.play();
          }, this),
          "touchstart.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause &&
              this._core.is("rotating") &&
              this.pause();
          }, this),
          "touchend.owl.core": a.proxy(function () {
            this._core.settings.autoplayHoverPause && this.play();
          }, this),
        }),
        this._core.$element.on(this._handlers),
        (this._core.options = a.extend({}, e.Defaults, this._core.options));
    };
    (e.Defaults = {
      autoplay: !1,
      autoplayTimeout: 5e3,
      autoplayHoverPause: !1,
      autoplaySpeed: !1,
    }),
      (e.prototype.play = function (a, b) {
        (this._paused = !1),
          this._core.is("rotating") ||
            (this._core.enter("rotating"), this._setAutoPlayInterval());
      }),
      (e.prototype._getNextTimeout = function (d, e) {
        return (
          this._timeout && b.clearTimeout(this._timeout),
          b.setTimeout(
            a.proxy(function () {
              this._paused ||
                this._core.is("busy") ||
                this._core.is("interacting") ||
                c.hidden ||
                this._core.next(e || this._core.settings.autoplaySpeed);
            }, this),
            d || this._core.settings.autoplayTimeout
          )
        );
      }),
      (e.prototype._setAutoPlayInterval = function () {
        this._timeout = this._getNextTimeout();
      }),
      (e.prototype.stop = function () {
        this._core.is("rotating") &&
          (b.clearTimeout(this._timeout), this._core.leave("rotating"));
      }),
      (e.prototype.pause = function () {
        this._core.is("rotating") && (this._paused = !0);
      }),
      (e.prototype.destroy = function () {
        var a, b;
        this.stop();
        for (a in this._handlers) this._core.$element.off(a, this._handlers[a]);
        for (b in Object.getOwnPropertyNames(this))
          "function" != typeof this[b] && (this[b] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.autoplay = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (b) {
      (this._core = b),
        (this._initialized = !1),
        (this._pages = []),
        (this._controls = {}),
        (this._templates = []),
        (this.$element = this._core.$element),
        (this._overrides = {
          next: this._core.next,
          prev: this._core.prev,
          to: this._core.to,
        }),
        (this._handlers = {
          "prepared.owl.carousel": a.proxy(function (b) {
            b.namespace &&
              this._core.settings.dotsData &&
              this._templates.push(
                '<div class="' +
                  this._core.settings.dotClass +
                  '">' +
                  a(b.content)
                    .find("[data-dot]")
                    .addBack("[data-dot]")
                    .attr("data-dot") +
                  "</div>"
              );
          }, this),
          "added.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 0, this._templates.pop());
          }, this),
          "remove.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._core.settings.dotsData &&
              this._templates.splice(a.position, 1);
          }, this),
          "changed.owl.carousel": a.proxy(function (a) {
            a.namespace && "position" == a.property.name && this.draw();
          }, this),
          "initialized.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              !this._initialized &&
              (this._core.trigger("initialize", null, "navigation"),
              this.initialize(),
              this.update(),
              this.draw(),
              (this._initialized = !0),
              this._core.trigger("initialized", null, "navigation"));
          }, this),
          "refreshed.owl.carousel": a.proxy(function (a) {
            a.namespace &&
              this._initialized &&
              (this._core.trigger("refresh", null, "navigation"),
              this.update(),
              this.draw(),
              this._core.trigger("refreshed", null, "navigation"));
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers);
    };
    (e.Defaults = {
      nav: !1,
      navText: ["prev", "next"],
      navSpeed: !1,
      navElement: "div",
      navContainer: !1,
      navContainerClass: "owl-nav",
      navClass: ["owl-prev", "owl-next"],
      slideBy: 1,
      dotClass: "owl-dot",
      dotsClass: "owl-dots",
      dots: !0,
      dotsEach: !1,
      dotsData: !1,
      dotsSpeed: !1,
      dotsContainer: !1,
    }),
      (e.prototype.initialize = function () {
        var b,
          c = this._core.settings;
        (this._controls.$relative = (
          c.navContainer
            ? a(c.navContainer)
            : a("<div>").addClass(c.navContainerClass).appendTo(this.$element)
        ).addClass("disabled")),
          (this._controls.$previous = a("<" + c.navElement + ">")
            .addClass(c.navClass[0])
            .html(c.navText[0])
            .prependTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.prev(c.navSpeed);
              }, this)
            )),
          (this._controls.$next = a("<" + c.navElement + ">")
            .addClass(c.navClass[1])
            .html(c.navText[1])
            .appendTo(this._controls.$relative)
            .on(
              "click",
              a.proxy(function (a) {
                this.next(c.navSpeed);
              }, this)
            )),
          c.dotsData ||
            (this._templates = [
              a("<div>")
                .addClass(c.dotClass)
                .append(a("<span>"))
                .prop("outerHTML"),
            ]),
          (this._controls.$absolute = (
            c.dotsContainer
              ? a(c.dotsContainer)
              : a("<div>").addClass(c.dotsClass).appendTo(this.$element)
          ).addClass("disabled")),
          this._controls.$absolute.on(
            "click",
            "div",
            a.proxy(function (b) {
              var d = a(b.target).parent().is(this._controls.$absolute)
                ? a(b.target).index()
                : a(b.target).parent().index();
              b.preventDefault(), this.to(d, c.dotsSpeed);
            }, this)
          );
        for (b in this._overrides) this._core[b] = a.proxy(this[b], this);
      }),
      (e.prototype.destroy = function () {
        var a, b, c, d;
        for (a in this._handlers) this.$element.off(a, this._handlers[a]);
        for (b in this._controls) this._controls[b].remove();
        for (d in this.overides) this._core[d] = this._overrides[d];
        for (c in Object.getOwnPropertyNames(this))
          "function" != typeof this[c] && (this[c] = null);
      }),
      (e.prototype.update = function () {
        var a,
          b,
          c,
          d = this._core.clones().length / 2,
          e = d + this._core.items().length,
          f = this._core.maximum(!0),
          g = this._core.settings,
          h = g.center || g.autoWidth || g.dotsData ? 1 : g.dotsEach || g.items;
        if (
          ("page" !== g.slideBy && (g.slideBy = Math.min(g.slideBy, g.items)),
          g.dots || "page" == g.slideBy)
        )
          for (this._pages = [], a = d, b = 0, c = 0; a < e; a++) {
            if (b >= h || 0 === b) {
              if (
                (this._pages.push({
                  start: Math.min(f, a - d),
                  end: a - d + h - 1,
                }),
                Math.min(f, a - d) === f)
              )
                break;
              (b = 0), ++c;
            }
            b += this._core.mergers(this._core.relative(a));
          }
      }),
      (e.prototype.draw = function () {
        var b,
          c = this._core.settings,
          d = this._core.items().length <= c.items,
          e = this._core.relative(this._core.current()),
          f = c.loop || c.rewind;
        this._controls.$relative.toggleClass("disabled", !c.nav || d),
          c.nav &&
            (this._controls.$previous.toggleClass(
              "disabled",
              !f && e <= this._core.minimum(!0)
            ),
            this._controls.$next.toggleClass(
              "disabled",
              !f && e >= this._core.maximum(!0)
            )),
          this._controls.$absolute.toggleClass("disabled", !c.dots || d),
          c.dots &&
            ((b =
              this._pages.length - this._controls.$absolute.children().length),
            c.dotsData && 0 !== b
              ? this._controls.$absolute.html(this._templates.join(""))
              : b > 0
              ? this._controls.$absolute.append(
                  new Array(b + 1).join(this._templates[0])
                )
              : b < 0 && this._controls.$absolute.children().slice(b).remove(),
            this._controls.$absolute.find(".active").removeClass("active"),
            this._controls.$absolute
              .children()
              .eq(a.inArray(this.current(), this._pages))
              .addClass("active"));
      }),
      (e.prototype.onTrigger = function (b) {
        var c = this._core.settings;
        b.page = {
          index: a.inArray(this.current(), this._pages),
          count: this._pages.length,
          size:
            c &&
            (c.center || c.autoWidth || c.dotsData ? 1 : c.dotsEach || c.items),
        };
      }),
      (e.prototype.current = function () {
        var b = this._core.relative(this._core.current());
        return a
          .grep(
            this._pages,
            a.proxy(function (a, c) {
              return a.start <= b && a.end >= b;
            }, this)
          )
          .pop();
      }),
      (e.prototype.getPosition = function (b) {
        var c,
          d,
          e = this._core.settings;
        return (
          "page" == e.slideBy
            ? ((c = a.inArray(this.current(), this._pages)),
              (d = this._pages.length),
              b ? ++c : --c,
              (c = this._pages[((c % d) + d) % d].start))
            : ((c = this._core.relative(this._core.current())),
              (d = this._core.items().length),
              b ? (c += e.slideBy) : (c -= e.slideBy)),
          c
        );
      }),
      (e.prototype.next = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!0), b);
      }),
      (e.prototype.prev = function (b) {
        a.proxy(this._overrides.to, this._core)(this.getPosition(!1), b);
      }),
      (e.prototype.to = function (b, c, d) {
        var e;
        !d && this._pages.length
          ? ((e = this._pages.length),
            a.proxy(this._overrides.to, this._core)(
              this._pages[((b % e) + e) % e].start,
              c
            ))
          : a.proxy(this._overrides.to, this._core)(b, c);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Navigation = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    "use strict";
    var e = function (c) {
      (this._core = c),
        (this._hashes = {}),
        (this.$element = this._core.$element),
        (this._handlers = {
          "initialized.owl.carousel": a.proxy(function (c) {
            c.namespace &&
              "URLHash" === this._core.settings.startPosition &&
              a(b).trigger("hashchange.owl.navigation");
          }, this),
          "prepared.owl.carousel": a.proxy(function (b) {
            if (b.namespace) {
              var c = a(b.content)
                .find("[data-hash]")
                .addBack("[data-hash]")
                .attr("data-hash");
              if (!c) return;
              this._hashes[c] = b.content;
            }
          }, this),
          "changed.owl.carousel": a.proxy(function (c) {
            if (c.namespace && "position" === c.property.name) {
              var d = this._core.items(
                  this._core.relative(this._core.current())
                ),
                e = a
                  .map(this._hashes, function (a, b) {
                    return a === d ? b : null;
                  })
                  .join();
              if (!e || b.location.hash.slice(1) === e) return;
              b.location.hash = e;
            }
          }, this),
        }),
        (this._core.options = a.extend({}, e.Defaults, this._core.options)),
        this.$element.on(this._handlers),
        a(b).on(
          "hashchange.owl.navigation",
          a.proxy(function (a) {
            var c = b.location.hash.substring(1),
              e = this._core.$stage.children(),
              f = this._hashes[c] && e.index(this._hashes[c]);
            f !== d &&
              f !== this._core.current() &&
              this._core.to(this._core.relative(f), !1, !0);
          }, this)
        );
    };
    (e.Defaults = { URLhashListener: !1 }),
      (e.prototype.destroy = function () {
        var c, d;
        a(b).off("hashchange.owl.navigation");
        for (c in this._handlers) this._core.$element.off(c, this._handlers[c]);
        for (d in Object.getOwnPropertyNames(this))
          "function" != typeof this[d] && (this[d] = null);
      }),
      (a.fn.owlCarousel.Constructor.Plugins.Hash = e);
  })(window.Zepto || window.jQuery, window, document),
  (function (a, b, c, d) {
    function e(b, c) {
      var e = !1,
        f = b.charAt(0).toUpperCase() + b.slice(1);
      return (
        a.each((b + " " + h.join(f + " ") + f).split(" "), function (a, b) {
          if (g[b] !== d) return (e = !c || b), !1;
        }),
        e
      );
    }
    function f(a) {
      return e(a, !0);
    }
    var g = a("<support>").get(0).style,
      h = "Webkit Moz O ms".split(" "),
      i = {
        transition: {
          end: {
            WebkitTransition: "webkitTransitionEnd",
            MozTransition: "transitionend",
            OTransition: "oTransitionEnd",
            transition: "transitionend",
          },
        },
        animation: {
          end: {
            WebkitAnimation: "webkitAnimationEnd",
            MozAnimation: "animationend",
            OAnimation: "oAnimationEnd",
            animation: "animationend",
          },
        },
      },
      j = {
        csstransforms: function () {
          return !!e("transform");
        },
        csstransforms3d: function () {
          return !!e("perspective");
        },
        csstransitions: function () {
          return !!e("transition");
        },
        cssanimations: function () {
          return !!e("animation");
        },
      };
    j.csstransitions() &&
      ((a.support.transition = new String(f("transition"))),
      (a.support.transition.end = i.transition.end[a.support.transition])),
      j.cssanimations() &&
        ((a.support.animation = new String(f("animation"))),
        (a.support.animation.end = i.animation.end[a.support.animation])),
      j.csstransforms() &&
        ((a.support.transform = new String(f("transform"))),
        (a.support.transform3d = j.csstransforms3d()));
  })(window.Zepto || window.jQuery, window, document);
/**
 * @license
 * Lodash (Custom Build) lodash.com/license | Underscore.js 1.8.3 underscorejs.org/LICENSE
 * Build: `lodash include="debounce,throttle"`
 */
(function () {
  function t() {}
  function e(t) {
    return null == t ? (t === l ? d : y) : I && I in Object(t) ? n(t) : r(t);
  }
  function n(t) {
    var e = $.call(t, I),
      n = t[I];
    try {
      t[I] = l;
      var r = true;
    } catch (t) {}
    var o = _.call(t);
    return r && (e ? (t[I] = n) : delete t[I]), o;
  }
  function r(t) {
    return _.call(t);
  }
  function o(t, e, n) {
    function r(e) {
      var n = d,
        r = g;
      return (d = g = l), (x = e), (v = t.apply(r, n));
    }
    function o(t) {
      return (x = t), (O = setTimeout(c, e)), T ? r(t) : v;
    }
    function i(t) {
      var n = t - h,
        r = t - x,
        o = e - n;
      return w ? k(o, j - r) : o;
    }
    function f(t) {
      var n = t - h,
        r = t - x;
      return h === l || n >= e || n < 0 || (w && r >= j);
    }
    function c() {
      var t = D();
      return f(t) ? p(t) : ((O = setTimeout(c, i(t))), l);
    }
    function p(t) {
      return (O = l), S && d ? r(t) : ((d = g = l), v);
    }
    function s() {
      O !== l && clearTimeout(O), (x = 0), (d = h = g = O = l);
    }
    function y() {
      return O === l ? v : p(D());
    }
    function m() {
      var t = D(),
        n = f(t);
      if (((d = arguments), (g = this), (h = t), n)) {
        if (O === l) return o(h);
        if (w) return (O = setTimeout(c, e)), r(h);
      }
      return O === l && (O = setTimeout(c, e)), v;
    }
    var d,
      g,
      j,
      v,
      O,
      h,
      x = 0,
      T = false,
      w = false,
      S = true;
    if (typeof t != "function") throw new TypeError(b);
    return (
      (e = a(e) || 0),
      u(n) &&
        ((T = !!n.leading),
        (w = "maxWait" in n),
        (j = w ? M(a(n.maxWait) || 0, e) : j),
        (S = "trailing" in n ? !!n.trailing : S)),
      (m.cancel = s),
      (m.flush = y),
      m
    );
  }
  function i(t, e, n) {
    var r = true,
      i = true;
    if (typeof t != "function") throw new TypeError(b);
    return (
      u(n) &&
        ((r = "leading" in n ? !!n.leading : r),
        (i = "trailing" in n ? !!n.trailing : i)),
      o(t, e, { leading: r, maxWait: e, trailing: i })
    );
  }
  function u(t) {
    var e = typeof t;
    return null != t && ("object" == e || "function" == e);
  }
  function f(t) {
    return null != t && typeof t == "object";
  }
  function c(t) {
    return typeof t == "symbol" || (f(t) && e(t) == m);
  }
  function a(t) {
    if (typeof t == "number") return t;
    if (c(t)) return s;
    if (u(t)) {
      var e = typeof t.valueOf == "function" ? t.valueOf() : t;
      t = u(e) ? e + "" : e;
    }
    if (typeof t != "string") return 0 === t ? t : +t;
    t = t.replace(g, "");
    var n = v.test(t);
    return n || O.test(t) ? h(t.slice(2), n ? 2 : 8) : j.test(t) ? s : +t;
  }
  var l,
    p = "4.17.4",
    b = "Expected a function",
    s = NaN,
    y = "[object Null]",
    m = "[object Symbol]",
    d = "[object Undefined]",
    g = /^\s+|\s+$/g,
    j = /^[-+]0x[0-9a-f]+$/i,
    v = /^0b[01]+$/i,
    O = /^0o[0-7]+$/i,
    h = parseInt,
    x =
      typeof global == "object" && global && global.Object === Object && global,
    T = typeof self == "object" && self && self.Object === Object && self,
    w = x || T || Function("return this")(),
    S = typeof exports == "object" && exports && !exports.nodeType && exports,
    N = S && typeof module == "object" && module && !module.nodeType && module,
    E = Object.prototype,
    $ = E.hasOwnProperty,
    _ = E.toString,
    W = w.Symbol,
    I = W ? W.toStringTag : l,
    M = Math.max,
    k = Math.min,
    D = function () {
      return w.Date.now();
    };
  (t.debounce = o),
    (t.throttle = i),
    (t.isObject = u),
    (t.isObjectLike = f),
    (t.isSymbol = c),
    (t.now = D),
    (t.toNumber = a),
    (t.VERSION = p),
    typeof define == "function" && typeof define.amd == "object" && define.amd
      ? ((w._ = t),
        define(function () {
          return t;
        }))
      : N
      ? (((N.exports = t)._ = t), (S._ = t))
      : (w._ = t);
}.call(this));
/*!
 * JavaScript Cookie v2.1.4
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function (factory) {
  var registeredInModuleLoader = false;
  if (typeof define === "function" && define.amd) {
    define(factory);
    registeredInModuleLoader = true;
  }
  if (typeof exports === "object") {
    module.exports = factory();
    registeredInModuleLoader = true;
  }
  if (!registeredInModuleLoader) {
    var OldCookies = window.Cookies;
    var api = (window.Cookies = factory());
    api.noConflict = function () {
      window.Cookies = OldCookies;
      return api;
    };
  }
})(function () {
  function extend() {
    var i = 0;
    var result = {};
    for (; i < arguments.length; i++) {
      var attributes = arguments[i];
      for (var key in attributes) {
        result[key] = attributes[key];
      }
    }
    return result;
  }

  function init(converter) {
    function api(key, value, attributes) {
      var result;
      if (typeof document === "undefined") {
        return;
      }

      // Write

      if (arguments.length > 1) {
        attributes = extend(
          {
            path: "/",
          },
          api.defaults,
          attributes
        );

        if (typeof attributes.expires === "number") {
          var expires = new Date();
          expires.setMilliseconds(
            expires.getMilliseconds() + attributes.expires * 864e5
          );
          attributes.expires = expires;
        }

        // We're using "expires" because "max-age" is not supported by IE
        attributes.expires = attributes.expires
          ? attributes.expires.toUTCString()
          : "";

        try {
          result = JSON.stringify(value);
          if (/^[\{\[]/.test(result)) {
            value = result;
          }
        } catch (e) {}

        if (!converter.write) {
          value = encodeURIComponent(String(value)).replace(
            /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
            decodeURIComponent
          );
        } else {
          value = converter.write(value, key);
        }

        key = encodeURIComponent(String(key));
        key = key.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent);
        key = key.replace(/[\(\)]/g, escape);

        var stringifiedAttributes = "";

        for (var attributeName in attributes) {
          if (!attributes[attributeName]) {
            continue;
          }
          stringifiedAttributes += "; " + attributeName;
          if (attributes[attributeName] === true) {
            continue;
          }
          stringifiedAttributes += "=" + attributes[attributeName];
        }
        return (document.cookie = key + "=" + value + stringifiedAttributes);
      }

      // Read

      if (!key) {
        result = {};
      }

      // To prevent the for loop in the first place assign an empty array
      // in case there are no cookies at all. Also prevents odd result when
      // calling "get()"
      var cookies = document.cookie ? document.cookie.split("; ") : [];
      var rdecode = /(%[0-9A-Z]{2})+/g;
      var i = 0;

      for (; i < cookies.length; i++) {
        var parts = cookies[i].split("=");
        var cookie = parts.slice(1).join("=");

        if (cookie.charAt(0) === '"') {
          cookie = cookie.slice(1, -1);
        }

        try {
          var name = parts[0].replace(rdecode, decodeURIComponent);
          cookie = converter.read
            ? converter.read(cookie, name)
            : converter(cookie, name) ||
              cookie.replace(rdecode, decodeURIComponent);

          if (this.json) {
            try {
              cookie = JSON.parse(cookie);
            } catch (e) {}
          }

          if (key === name) {
            result = cookie;
            break;
          }

          if (!key) {
            result[name] = cookie;
          }
        } catch (e) {}
      }

      return result;
    }

    api.set = api;
    api.get = function (key) {
      return api.call(api, key);
    };
    api.getJSON = function () {
      return api.apply(
        {
          json: true,
        },
        [].slice.call(arguments)
      );
    };
    api.defaults = {};

    api.remove = function (key, attributes) {
      api(
        key,
        "",
        extend(attributes, {
          expires: -1,
        })
      );
    };

    api.withConverter = init;

    return api;
  }

  return init(function () {});
});

/*
 Sticky-kit v1.1.3 | MIT | Leaf Corcoran 2015 | http://leafo.net
*/
(function () {
  var c, f;
  c = window.jQuery;
  f = c(window);
  c.fn.stick_in_parent = function (b) {
    var A, w, J, n, B, K, p, q, L, k, E, t;
    null == b && (b = {});
    t = b.sticky_class;
    B = b.inner_scrolling;
    E = b.recalc_every;
    k = b.parent;
    q = b.offset_top;
    p = b.spacer;
    w = b.bottoming;
    null == q && (q = 0);
    null == k && (k = void 0);
    null == B && (B = !0);
    null == t && (t = "is_stuck");
    A = c(document);
    null == w && (w = !0);
    L = function (a) {
      var b;
      return window.getComputedStyle
        ? ((a = window.getComputedStyle(a[0])),
          (b =
            parseFloat(a.getPropertyValue("width")) +
            parseFloat(a.getPropertyValue("margin-left")) +
            parseFloat(a.getPropertyValue("margin-right"))),
          "border-box" !== a.getPropertyValue("box-sizing") &&
            (b +=
              parseFloat(a.getPropertyValue("border-left-width")) +
              parseFloat(a.getPropertyValue("border-right-width")) +
              parseFloat(a.getPropertyValue("padding-left")) +
              parseFloat(a.getPropertyValue("padding-right"))),
          b)
        : a.outerWidth(!0);
    };
    J = function (a, b, n, C, F, u, r, G) {
      var v, H, m, D, I, d, g, x, y, z, h, l;
      if (!a.data("sticky_kit")) {
        a.data("sticky_kit", !0);
        I = A.height();
        g = a.parent();
        null != k && (g = g.closest(k));
        if (!g.length) throw "failed to find stick parent";
        v = m = !1;
        (h = null != p ? p && a.closest(p) : c("<div />")) &&
          h.css("position", a.css("position"));
        x = function () {
          var d, f, e;
          if (
            !G &&
            ((I = A.height()),
            (d = parseInt(g.css("border-top-width"), 10)),
            (f = parseInt(g.css("padding-top"), 10)),
            (b = parseInt(g.css("padding-bottom"), 10)),
            (n = g.offset().top + d + f),
            (C = g.height()),
            m &&
              ((v = m = !1),
              null == p && (a.insertAfter(h), h.detach()),
              a
                .css({ position: "", top: "", width: "", bottom: "" })
                .removeClass(t),
              (e = !0)),
            (F = a.offset().top - (parseInt(a.css("margin-top"), 10) || 0) - q),
            (u = a.outerHeight(!0)),
            (r = a.css("float")),
            h &&
              h.css({
                width: L(a),
                height: u,
                display: a.css("display"),
                "vertical-align": a.css("vertical-align"),
                float: r,
              }),
            e)
          )
            return l();
        };
        x();
        if (u !== C)
          return (
            (D = void 0),
            (d = q),
            (z = E),
            (l = function () {
              var c, l, e, k;
              if (
                !G &&
                ((e = !1),
                null != z && (--z, 0 >= z && ((z = E), x(), (e = !0))),
                e || A.height() === I || x(),
                (e = f.scrollTop()),
                null != D && (l = e - D),
                (D = e),
                m
                  ? (w &&
                      ((k = e + u + d > C + n),
                      v &&
                        !k &&
                        ((v = !1),
                        a
                          .css({ position: "fixed", bottom: "", top: d })
                          .trigger("sticky_kit:unbottom"))),
                    e < F &&
                      ((m = !1),
                      (d = q),
                      null == p &&
                        (("left" !== r && "right" !== r) || a.insertAfter(h),
                        h.detach()),
                      (c = { position: "", width: "", top: "" }),
                      a.css(c).removeClass(t).trigger("sticky_kit:unstick")),
                    B &&
                      ((c = f.height()),
                      u + q > c &&
                        !v &&
                        ((d -= l),
                        (d = Math.max(c - u, d)),
                        (d = Math.min(q, d)),
                        m && a.css({ top: d + "px" }))))
                  : e > F &&
                    ((m = !0),
                    (c = { position: "fixed", top: d }),
                    (c.width =
                      "border-box" === a.css("box-sizing")
                        ? a.outerWidth() + "px"
                        : a.width() + "px"),
                    a.css(c).addClass(t),
                    null == p &&
                      (a.after(h),
                      ("left" !== r && "right" !== r) || h.append(a)),
                    a.trigger("sticky_kit:stick")),
                m && w && (null == k && (k = e + u + d > C + n), !v && k))
              )
                return (
                  (v = !0),
                  "static" === g.css("position") &&
                    g.css({ position: "relative" }),
                  a
                    .css({ position: "absolute", bottom: b, top: "auto" })
                    .trigger("sticky_kit:bottom")
                );
            }),
            (y = function () {
              x();
              return l();
            }),
            (H = function () {
              G = !0;
              f.off("touchmove", l);
              f.off("scroll", l);
              f.off("resize", y);
              c(document.body).off("sticky_kit:recalc", y);
              a.off("sticky_kit:detach", H);
              a.removeData("sticky_kit");
              a.css({ position: "", bottom: "", top: "", width: "" });
              g.position("position", "");
              if (m)
                return (
                  null == p &&
                    (("left" !== r && "right" !== r) || a.insertAfter(h),
                    h.remove()),
                  a.removeClass(t)
                );
            }),
            f.on("touchmove", l),
            f.on("scroll", l),
            f.on("resize", y),
            c(document.body).on("sticky_kit:recalc", y),
            a.on("sticky_kit:detach", H),
            setTimeout(l, 0)
          );
      }
    };
    n = 0;
    for (K = this.length; n < K; n++) (b = this[n]), J(c(b));
    return this;
  };
}.call(this));
/*!
	Zoom 1.7.21
	license: MIT
	http://www.jacklmoore.com/zoom
*/
(function ($) {
  var defaults = {
    url: false,
    callback: false,
    target: false,
    duration: 120,
    on: "mouseover", // other options: grab, click, toggle
    touch: true, // enables a touch fallback
    onZoomIn: false,
    onZoomOut: false,
    magnify: 1,
  };

  // Core Zoom Logic, independent of event listeners.
  $.zoom = function (target, source, img, magnify) {
    var targetHeight,
      targetWidth,
      sourceHeight,
      sourceWidth,
      xRatio,
      yRatio,
      offset,
      $target = $(target),
      position = $target.css("position"),
      $source = $(source);

    // The parent element needs positioning so that the zoomed element can be correctly positioned within.
    target.style.position = /(absolute|fixed)/.test(position)
      ? position
      : "relative";
    target.style.overflow = "hidden";
    img.style.width = img.style.height = "";

    $(img)
      .addClass("zoomImg")
      .css({
        position: "absolute",
        top: 0,
        left: 0,
        opacity: 0,
        width: img.width * magnify,
        height: img.height * magnify,
        border: "none",
        maxWidth: "none",
        maxHeight: "none",
      })
      .appendTo(target);

    return {
      init: function () {
        targetWidth = $target.outerWidth();
        targetHeight = $target.outerHeight();

        if (source === target) {
          sourceWidth = targetWidth;
          sourceHeight = targetHeight;
        } else {
          sourceWidth = $source.outerWidth();
          sourceHeight = $source.outerHeight();
        }

        xRatio = (img.width - targetWidth) / sourceWidth;
        yRatio = (img.height - targetHeight) / sourceHeight;

        offset = $source.offset();
      },
      move: function (e) {
        var left = e.pageX - offset.left,
          top = e.pageY - offset.top;

        top = Math.max(Math.min(top, sourceHeight), 0);
        left = Math.max(Math.min(left, sourceWidth), 0);

        img.style.left = left * -xRatio + "px";
        img.style.top = top * -yRatio + "px";
      },
    };
  };

  $.fn.zoom = function (options) {
    return this.each(function () {
      var settings = $.extend({}, defaults, options || {}),
        //target will display the zoomed image
        target = (settings.target && $(settings.target)[0]) || this,
        //source will provide zoom location info (thumbnail)
        source = this,
        $source = $(source),
        img = document.createElement("img"),
        $img = $(img),
        mousemove = "mousemove.zoom",
        clicked = false,
        touched = false;

      // If a url wasn't specified, look for an image element.
      if (!settings.url) {
        var srcElement = source.querySelector("img");
        if (srcElement) {
          settings.url =
            srcElement.getAttribute("data-src") ||
            srcElement.currentSrc ||
            srcElement.src;
        }
        if (!settings.url) {
          return;
        }
      }

      $source.one(
        "zoom.destroy",
        function (position, overflow) {
          $source.off(".zoom");
          target.style.position = position;
          target.style.overflow = overflow;
          img.onload = null;
          $img.remove();
        }.bind(this, target.style.position, target.style.overflow)
      );

      img.onload = function () {
        var zoom = $.zoom(target, source, img, settings.magnify);

        function start(e) {
          zoom.init();
          zoom.move(e);

          // Skip the fade-in for IE8 and lower since it chokes on fading-in
          // and changing position based on mousemovement at the same time.
          $img
            .stop()
            .fadeTo(
              $.support.opacity ? settings.duration : 0,
              1,
              $.isFunction(settings.onZoomIn)
                ? settings.onZoomIn.call(img)
                : false
            );
        }

        function stop() {
          $img
            .stop()
            .fadeTo(
              settings.duration,
              0,
              $.isFunction(settings.onZoomOut)
                ? settings.onZoomOut.call(img)
                : false
            );
        }

        // Mouse events
        if (settings.on === "grab") {
          $source.on("mousedown.zoom", function (e) {
            if (e.which === 1) {
              $(document).one("mouseup.zoom", function () {
                stop();

                $(document).off(mousemove, zoom.move);
              });

              start(e);

              $(document).on(mousemove, zoom.move);

              e.preventDefault();
            }
          });
        } else if (settings.on === "click") {
          $source.on("mouseleave.zoom", stop).on("click.zoom", function (e) {
            if (clicked) {
              // bubble the event up to the document to trigger the unbind.
              return;
            } else {
              clicked = true;
              start(e);
              $(document).on(mousemove, zoom.move);
              $(document).one("click.zoom", function () {
                stop();
                clicked = false;
                $(document).off(mousemove, zoom.move);
              });
              return false;
            }
          });
        } else if (settings.on === "toggle") {
          $source.on("click.zoom", function (e) {
            if (clicked) {
              stop();
            } else {
              start(e);
            }
            clicked = !clicked;
          });
        } else if (settings.on === "mouseover") {
          zoom.init(); // Preemptively call init because IE7 will fire the mousemove handler before the hover handler.

          $source
            .on("mouseenter.zoom", start)
            .on("mouseleave.zoom", stop)
            .on(mousemove, zoom.move);
        }

        // Touch fallback
        if (settings.touch) {
          $source
            .on("touchstart.zoom", function (e) {
              e.preventDefault();
              if (touched) {
                touched = false;
                stop();
              } else {
                touched = true;
                start(
                  e.originalEvent.touches[0] ||
                    e.originalEvent.changedTouches[0]
                );
              }
            })
            .on("touchmove.zoom", function (e) {
              e.preventDefault();
              zoom.move(
                e.originalEvent.touches[0] || e.originalEvent.changedTouches[0]
              );
            })
            .on("touchend.zoom", function (e) {
              e.preventDefault();
              if (touched) {
                touched = false;
                stop();
              }
            });
        }

        if ($.isFunction(settings.callback)) {
          settings.callback.call(img);
        }
      };

      img.setAttribute("role", "presentation");
      img.alt = "";
      img.src = settings.url;
    });
  };

  $.fn.zoom.defaults = defaults;
})(window.jQuery);

("use strict");
(function (a, b) {
  "function" == typeof define && define.amd
    ? define("tinysort", function () {
        return b;
      })
    : (a.tinysort = b);
})(
  window || module || {},
  (function (a) {
    function c(a, b) {
      for (var c = a.length, d = c, e = void 0; d--; )
        (e = c - d - 1), b(a[e], e);
    }
    function b(a, b, c) {
      for (var d in b) (c || a[d] === e) && (a[d] = b[d]);
      return a;
    }
    function d(a, b, c) {
      l.push({ prepare: a, sort: b, sortBy: c });
    }
    var e = a,
      f = null,
      g = window,
      h = g.document,
      i = parseFloat,
      j = /(-?\d+\.?\d*)\s*$/g,
      k = /(\d+\.?\d*)\s*$/g,
      l = [],
      m = {
        selector: f,
        order: "asc",
        attr: f,
        data: f,
        useVal: !1,
        place: "org",
        returns: !1,
        cases: !1,
        natural: !1,
        forceStrings: !1,
        ignoreDashes: !1,
        sortFunction: f,
        useFlex: !1,
        emptyEnd: !1,
        console: console,
      },
      n = 0,
      o = 0;
    return (
      g.Element &&
        (function (a) {
          return (a.matches = a.matches || a.msMatchesSelector);
        })(Element.prototype),
      b(d, { loop: c }),
      b(
        function (a, d) {
          function g(a) {
            var c = !!a.selector,
              d = c && ":" === a.selector[0],
              e = b(a || {}, m);
            G.push(
              b(
                {
                  hasSelector: c,
                  hasAttr: e.attr !== f && "" !== e.attr,
                  hasData: e.data !== f,
                  hasFilter: d,
                  sortReturnNumber: "asc" === e.order ? 1 : -1,
                },
                e
              )
            );
          }
          function p() {
            c(a, function (a, b) {
              H ? H !== a.parentNode && (I = !1) : (H = a.parentNode);
              var c = G[0],
                d = c.hasFilter,
                e = c.selector,
                f = !e || (d && a.matches(e)) || (e && a.querySelector(e)),
                g = f ? D : E,
                h = { elm: a, pos: b, posn: g.length };
              C.push(h), g.push(h);
            }),
              F.splice.apply(F, [0, Number.MAX_SAFE_INTEGER].concat(D));
          }
          function q(e, a, b) {
            for (
              var f = b(e.toString()), g = b(a.toString()), h = 0;
              f[h] && g[h];
              h++
            )
              if (f[h] !== g[h]) {
                var i = +f[h],
                  c = +g[h];
                return i == f[h] && c == g[h] ? i - c : f[h] > g[h] ? 1 : -1;
              }
            return f.length - g.length;
          }
          function r(a) {
            for (
              var b, c = [], d = 0, e = -1, f = 0, g = void 0, h = void 0;
              (g = (h = a.charAt(d++)).charCodeAt(0));

            )
              (b = 46 === g || (48 <= g && 57 >= g)),
                b !== f && ((c[++e] = ""), (f = b)),
                (c[e] += h);
            return c;
          }
          function s(d, a) {
            var b = 0;
            0 !== o && (o = 0);
            for (
              var f = function () {
                var f = G[o],
                  g = f.ignoreDashes ? k : j;
                c(l, function (a) {
                  return a.prepare && a.prepare(f);
                });
                var h = !1,
                  m = x(d, f),
                  n = x(a, f);
                if (f.sortFunction) b = f.sortFunction(d, a);
                else if ("rand" === f.order) b = 0.5 > Math.random() ? 1 : -1;
                else {
                  var p = "" === m || m === e,
                    s = "" === n || n === e;
                  if (m === n) b = 0;
                  else if (f.emptyEnd && (p || s)) b = p && s ? 0 : p ? 1 : -1;
                  else {
                    if (!f.forceStrings) {
                      var t = !!y(m) && m && m.match(g),
                        u = !!y(n) && n && n.match(g);
                      if (t && u) {
                        var v = m.substr(0, m.length - t[0].length),
                          w = n.substr(0, n.length - u[0].length);
                        v == w && ((h = !0), (m = i(t[0])), (n = i(u[0])));
                      }
                    }
                    b =
                      m === e || n === e
                        ? 0
                        : f.natural && (isNaN(m) || isNaN(n))
                        ? q(m, n, r)
                        : m < n
                        ? -1
                        : m > n
                        ? 1
                        : 0;
                  }
                }
                c(l, function (a) {
                  var c = a.sort;
                  return c && (b = c(f, h, m, n, b));
                }),
                  (b *= f.sortReturnNumber),
                  0 === b && o++;
              };
              0 === b && o < n;

            )
              f();
            return 0 === b && (b = d.pos > a.pos ? 1 : -1), b;
          }
          function t() {
            var a = D.length === C.length,
              b = G[0],
              c = b.place,
              d = b.console;
            if (I && a)
              L
                ? D.forEach(function (a, b) {
                    return (a.elm.style.order = b);
                  })
                : H
                ? H.appendChild(u())
                : d && d.warn && d.warn("parentNode has been removed");
            else {
              var e = "start" === c,
                f = "end" === c,
                g = "first" === c;
              if ("org" === c)
                D.forEach(v),
                  D.forEach(function (a, b) {
                    return w(F[b], a.elm);
                  });
              else if (e || f) {
                var h = F[e ? 0 : F.length - 1],
                  i = h && h.elm.parentNode,
                  j = i && ((e && i.firstChild) || i.lastChild);
                j &&
                  (j !== h.elm && (h = { elm: j }),
                  v(h),
                  f && i.appendChild(h.ghost),
                  w(h, u()));
              } else if (g || "last" === c) {
                var k = F[g ? 0 : F.length - 1];
                w(v(k), u());
              }
            }
          }
          function u() {
            return (
              D.forEach(function (a) {
                return B.appendChild(a.elm);
              }),
              B
            );
          }
          function v(a) {
            var b = a.elm,
              c = h.createElement("div");
            return (a.ghost = c), b.parentNode.insertBefore(c, b), a;
          }
          function w(a, b) {
            var c = a.ghost,
              d = c.parentNode;
            d.insertBefore(b, c), d.removeChild(c), delete a.ghost;
          }
          function x(a, b) {
            var c,
              d = a.elm,
              e = b.selector;
            return (
              e &&
                (b.hasFilter
                  ? !d.matches(e) && (d = f)
                  : (d = d.querySelector(e))),
              b.hasAttr
                ? (c = d.getAttribute(b.attr))
                : b.useVal
                ? (c = d.value || d.getAttribute("value"))
                : b.hasData
                ? (c = d.getAttribute("data-" + b.data))
                : d && (c = d.textContent),
              y(c) &&
                (!b.cases && (c = c.toLowerCase()),
                (c = c.replace(/\s+/g, " "))),
              null === c && (c = "\u0FFF"),
              c
            );
          }
          function y(a) {
            return "string" == typeof a;
          }
          y(a) && (a = h.querySelectorAll(a));
          var z = Object.assign({}, m, d || {}),
            A = z.console;
          0 === a.length && A && A.warn && A.warn("No elements to sort");
          var B = h.createDocumentFragment(),
            C = [],
            D = [],
            E = [],
            F = [],
            G = [],
            H = void 0,
            I = !0,
            J = a.length && a[0].parentNode,
            K = J.rootNode !== document,
            L =
              a.length &&
              (d === e || !1 !== d.useFlex) &&
              !K &&
              -1 !== getComputedStyle(J, null).display.indexOf("flex");
          return (
            function () {
              0 === arguments.length
                ? g({})
                : c(arguments, function (a) {
                    return g(y(a) ? { selector: a } : a);
                  }),
                (n = G.length);
            }.apply(f, Array.prototype.slice.call(arguments, 1)),
            p(),
            D.sort((d && d.sortFunction) || s),
            t(),
            D.map(function (a) {
              return a.elm;
            })
          );
        },
        { plugin: d, defaults: m }
      )
    );
  })()
);

!(function () {
  "use strict";
  function e(n) {
    return "undefined" == typeof this ||
      Object.getPrototypeOf(this) !== e.prototype
      ? new e(n)
      : ((O = this),
        (O.version = "3.4.0"),
        (O.tools = new E()),
        O.isSupported()
          ? (O.tools.extend(O.defaults, n || {}),
            (O.defaults.container = t(O.defaults)),
            (O.store = { elements: {}, containers: [] }),
            (O.sequences = {}),
            (O.history = []),
            (O.uid = 0),
            (O.initialized = !1))
          : "undefined" != typeof console && null !== console,
        O);
  }
  function t(e) {
    if (e && e.container) {
      if ("string" == typeof e.container)
        return window.document.documentElement.querySelector(e.container);
      if (O.tools.isNode(e.container)) return e.container;
    }
    return O.defaults.container;
  }
  function n(e, t) {
    return "string" == typeof e
      ? Array.prototype.slice.call(t.querySelectorAll(e))
      : O.tools.isNode(e)
      ? [e]
      : O.tools.isNodeList(e)
      ? Array.prototype.slice.call(e)
      : Array.isArray(e)
      ? e.filter(O.tools.isNode)
      : [];
  }
  function i() {
    return ++O.uid;
  }
  function o(e, t, n) {
    t.container && (t.container = n),
      e.config
        ? (e.config = O.tools.extendClone(e.config, t))
        : (e.config = O.tools.extendClone(O.defaults, t)),
      "top" === e.config.origin || "bottom" === e.config.origin
        ? (e.config.axis = "Y")
        : (e.config.axis = "X");
  }
  function r(e) {
    var t = window.getComputedStyle(e.domEl);
    e.styles ||
      ((e.styles = { transition: {}, transform: {}, computed: {} }),
      (e.styles.inline = e.domEl.getAttribute("style") || ""),
      (e.styles.inline += "; visibility: visible; "),
      (e.styles.computed.opacity = t.opacity),
      t.transition && "all 0s ease 0s" !== t.transition
        ? (e.styles.computed.transition = t.transition + ", ")
        : (e.styles.computed.transition = "")),
      (e.styles.transition.instant = s(e, 0)),
      (e.styles.transition.delayed = s(e, e.config.delay)),
      (e.styles.transform.initial = " -webkit-transform:"),
      (e.styles.transform.target = " -webkit-transform:"),
      a(e),
      (e.styles.transform.initial += "transform:"),
      (e.styles.transform.target += "transform:"),
      a(e);
  }
  function s(e, t) {
    var n = e.config;
    return (
      "-webkit-transition: " +
      e.styles.computed.transition +
      "-webkit-transform " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s, opacity " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s; transition: " +
      e.styles.computed.transition +
      "transform " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s, opacity " +
      n.duration / 1e3 +
      "s " +
      n.easing +
      " " +
      t / 1e3 +
      "s; "
    );
  }
  function a(e) {
    var t,
      n = e.config,
      i = e.styles.transform;
    (t =
      "top" === n.origin || "left" === n.origin
        ? /^-/.test(n.distance)
          ? n.distance.substr(1)
          : "-" + n.distance
        : n.distance),
      parseInt(n.distance) &&
        ((i.initial += " translate" + n.axis + "(" + t + ")"),
        (i.target += " translate" + n.axis + "(0)")),
      n.scale &&
        ((i.initial += " scale(" + n.scale + ")"), (i.target += " scale(1)")),
      n.rotate.x &&
        ((i.initial += " rotateX(" + n.rotate.x + "deg)"),
        (i.target += " rotateX(0)")),
      n.rotate.y &&
        ((i.initial += " rotateY(" + n.rotate.y + "deg)"),
        (i.target += " rotateY(0)")),
      n.rotate.z &&
        ((i.initial += " rotateZ(" + n.rotate.z + "deg)"),
        (i.target += " rotateZ(0)")),
      (i.initial += "; opacity: " + n.opacity + ";"),
      (i.target += "; opacity: " + e.styles.computed.opacity + ";");
  }
  function l(e) {
    var t = e.config.container;
    t &&
      O.store.containers.indexOf(t) === -1 &&
      O.store.containers.push(e.config.container),
      (O.store.elements[e.id] = e);
  }
  function c(e, t, n) {
    var i = { target: e, config: t, interval: n };
    O.history.push(i);
  }
  function f() {
    if (O.isSupported()) {
      y();
      for (var e = 0; e < O.store.containers.length; e++)
        O.store.containers[e].addEventListener("scroll", d),
          O.store.containers[e].addEventListener("resize", d);
      O.initialized ||
        (window.addEventListener("scroll", d),
        window.addEventListener("resize", d),
        (O.initialized = !0));
    }
    return O;
  }
  function d() {
    A(y);
  }
  function u() {
    var e, t, n, i;
    O.tools.forOwn(O.sequences, function (o) {
      (i = O.sequences[o]), (e = !1);
      for (var r = 0; r < i.elemIds.length; r++)
        (n = i.elemIds[r]), (t = O.store.elements[n]), q(t) && !e && (e = !0);
      i.active = e;
    });
  }
  function y() {
    var e, t;
    u(),
      O.tools.forOwn(O.store.elements, function (n) {
        (t = O.store.elements[n]),
          (e = w(t)),
          g(t)
            ? (t.config.beforeReveal(t.domEl),
              e
                ? t.domEl.setAttribute(
                    "style",
                    t.styles.inline +
                      t.styles.transform.target +
                      t.styles.transition.delayed
                  )
                : t.domEl.setAttribute(
                    "style",
                    t.styles.inline +
                      t.styles.transform.target +
                      t.styles.transition.instant
                  ),
              p("reveal", t, e),
              (t.revealing = !0),
              (t.seen = !0),
              t.sequence && m(t, e))
            : v(t) &&
              (t.config.beforeReset(t.domEl),
              t.domEl.setAttribute(
                "style",
                t.styles.inline +
                  t.styles.transform.initial +
                  t.styles.transition.instant
              ),
              p("reset", t),
              (t.revealing = !1));
      });
  }
  function m(e, t) {
    var n = 0,
      i = 0,
      o = O.sequences[e.sequence.id];
    (o.blocked = !0),
      t && "onload" === e.config.useDelay && (i = e.config.delay),
      e.sequence.timer &&
        ((n = Math.abs(e.sequence.timer.started - new Date())),
        window.clearTimeout(e.sequence.timer)),
      (e.sequence.timer = { started: new Date() }),
      (e.sequence.timer.clock = window.setTimeout(function () {
        (o.blocked = !1), (e.sequence.timer = null), d();
      }, Math.abs(o.interval) + i - n));
  }
  function p(e, t, n) {
    var i = 0,
      o = 0,
      r = "after";
    switch (e) {
      case "reveal":
        (o = t.config.duration), n && (o += t.config.delay), (r += "Reveal");
        break;
      case "reset":
        (o = t.config.duration), (r += "Reset");
    }
    t.timer &&
      ((i = Math.abs(t.timer.started - new Date())),
      window.clearTimeout(t.timer.clock)),
      (t.timer = { started: new Date() }),
      (t.timer.clock = window.setTimeout(function () {
        t.config[r](t.domEl), (t.timer = null);
      }, o - i));
  }
  function g(e) {
    if (e.sequence) {
      var t = O.sequences[e.sequence.id];
      return t.active && !t.blocked && !e.revealing && !e.disabled;
    }
    return q(e) && !e.revealing && !e.disabled;
  }
  function w(e) {
    var t = e.config.useDelay;
    return (
      "always" === t ||
      ("onload" === t && !O.initialized) ||
      ("once" === t && !e.seen)
    );
  }
  function v(e) {
    if (e.sequence) {
      var t = O.sequences[e.sequence.id];
      return !t.active && e.config.reset && e.revealing && !e.disabled;
    }
    return !q(e) && e.config.reset && e.revealing && !e.disabled;
  }
  function b(e) {
    return { width: e.clientWidth, height: e.clientHeight };
  }
  function h(e) {
    if (e && e !== window.document.documentElement) {
      var t = x(e);
      return { x: e.scrollLeft + t.left, y: e.scrollTop + t.top };
    }
    return { x: window.pageXOffset, y: window.pageYOffset };
  }
  function x(e) {
    var t = 0,
      n = 0,
      i = e.offsetHeight,
      o = e.offsetWidth;
    do
      isNaN(e.offsetTop) || (t += e.offsetTop),
        isNaN(e.offsetLeft) || (n += e.offsetLeft),
        (e = e.offsetParent);
    while (e);
    return { top: t, left: n, height: i, width: o };
  }
  function q(e) {
    function t() {
      var t = c + a * s,
        n = f + l * s,
        i = d - a * s,
        y = u - l * s,
        m = r.y + e.config.viewOffset.top,
        p = r.x + e.config.viewOffset.left,
        g = r.y - e.config.viewOffset.bottom + o.height,
        w = r.x - e.config.viewOffset.right + o.width;
      return t < g && i > m && n < w && y > p;
    }
    function n() {
      return "fixed" === window.getComputedStyle(e.domEl).position;
    }
    var i = x(e.domEl),
      o = b(e.config.container),
      r = h(e.config.container),
      s = e.config.viewFactor,
      a = i.height,
      l = i.width,
      c = i.top,
      f = i.left,
      d = c + a,
      u = f + l;
    return t() || n();
  }
  function E() {}
  var O, A;
  (e.prototype.defaults = {
    origin: "bottom",
    distance: "20px",
    duration: 500,
    delay: 0,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 0.9,
    easing: "cubic-bezier(0.6, 0.2, 0.1, 1)",
    container: window.document.documentElement,
    mobile: !0,
    reset: !1,
    useDelay: "always",
    viewFactor: 0.2,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
    beforeReveal: function (e) {},
    beforeReset: function (e) {},
    afterReveal: function (e) {},
    afterReset: function (e) {},
  }),
    (e.prototype.isSupported = function () {
      var e = document.documentElement.style;
      return (
        ("WebkitTransition" in e && "WebkitTransform" in e) ||
        ("transition" in e && "transform" in e)
      );
    }),
    (e.prototype.reveal = function (e, s, a, d) {
      var u, y, m, p, g, w;
      if (
        (void 0 !== s && "number" == typeof s
          ? ((a = s), (s = {}))
          : (void 0 !== s && null !== s) || (s = {}),
        (u = t(s)),
        (y = n(e, u)),
        !y.length)
      )
        return O;
      a &&
        "number" == typeof a &&
        ((w = i()),
        (g = O.sequences[w] = { id: w, interval: a, elemIds: [], active: !1 }));
      for (var v = 0; v < y.length; v++)
        (p = y[v].getAttribute("data-sr-id")),
          p
            ? (m = O.store.elements[p])
            : ((m = { id: i(), domEl: y[v], seen: !1, revealing: !1 }),
              m.domEl.setAttribute("data-sr-id", m.id)),
          g &&
            ((m.sequence = { id: g.id, index: g.elemIds.length }),
            g.elemIds.push(m.id)),
          o(m, s, u),
          r(m),
          l(m),
          (O.tools.isMobile() && !m.config.mobile) || !O.isSupported()
            ? (m.domEl.setAttribute("style", m.styles.inline),
              (m.disabled = !0))
            : m.revealing ||
              m.domEl.setAttribute(
                "style",
                m.styles.inline + m.styles.transform.initial
              );
      return (
        !d &&
          O.isSupported() &&
          (c(e, s, a),
          O.initTimeout && window.clearTimeout(O.initTimeout),
          (O.initTimeout = window.setTimeout(f, 0))),
        O
      );
    }),
    (e.prototype.sync = function () {
      if (O.history.length && O.isSupported()) {
        for (var e = 0; e < O.history.length; e++) {
          var t = O.history[e];
          O.reveal(t.target, t.config, t.interval, !0);
        }
        f();
      }
      return O;
    }),
    (E.prototype.isObject = function (e) {
      return null !== e && "object" == typeof e && e.constructor === Object;
    }),
    (E.prototype.isNode = function (e) {
      return "object" == typeof window.Node
        ? e instanceof window.Node
        : e &&
            "object" == typeof e &&
            "number" == typeof e.nodeType &&
            "string" == typeof e.nodeName;
    }),
    (E.prototype.isNodeList = function (e) {
      var t = Object.prototype.toString.call(e),
        n = /^\[object (HTMLCollection|NodeList|Object)\]$/;
      return "object" == typeof window.NodeList
        ? e instanceof window.NodeList
        : e &&
            "object" == typeof e &&
            n.test(t) &&
            "number" == typeof e.length &&
            (0 === e.length || this.isNode(e[0]));
    }),
    (E.prototype.forOwn = function (e, t) {
      if (!this.isObject(e))
        throw new TypeError(
          'Expected "object", but received "' + typeof e + '".'
        );
      for (var n in e) e.hasOwnProperty(n) && t(n);
    }),
    (E.prototype.extend = function (e, t) {
      return (
        this.forOwn(
          t,
          function (n) {
            this.isObject(t[n])
              ? ((e[n] && this.isObject(e[n])) || (e[n] = {}),
                this.extend(e[n], t[n]))
              : (e[n] = t[n]);
          }.bind(this)
        ),
        e
      );
    }),
    (E.prototype.extendClone = function (e, t) {
      return this.extend(this.extend({}, e), t);
    }),
    (E.prototype.isMobile = function () {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    }),
    (A =
      window.requestAnimationFrame ||
      window.webkitRequestAnimationFrame ||
      window.mozRequestAnimationFrame ||
      function (e) {
        window.setTimeout(e, 1e3 / 60);
      }),
    "function" == typeof define && "object" == typeof define.amd && define.amd
      ? define(function () {
          return e;
        })
      : "undefined" != typeof module && module.exports
      ? (module.exports = e)
      : (window.ScrollReveal = e);
})();
/*jshint browser:true */
/*!
 * FitVids 1.1
 *
 * Copyright 2013, Chris Coyier - http://css-tricks.com + Dave Rupert - http://daverupert.com
 * Credit to Thierry Koblentz - http://www.alistapart.com/articles/creating-intrinsic-ratios-for-video/
 * Released under the WTFPL license - http://sam.zoy.org/wtfpl/
 *
 */

(function ($) {
  "use strict";

  $.fn.fitVids = function (options) {
    var settings = {
      customSelector: null,
      ignore: null,
    };

    if (!document.getElementById("fit-vids-style")) {
      // appendStyles: https://github.com/toddmotto/fluidvids/blob/master/dist/fluidvids.js
      var head = document.head || document.getElementsByTagName("head")[0];
      var css =
        ".fluid-width-video-wrapper{width:100%;position:relative;padding:0;}.fluid-width-video-wrapper iframe,.fluid-width-video-wrapper object,.fluid-width-video-wrapper embed {position:absolute;top:0;left:0;width:100%;height:100%;}";
      var div = document.createElement("div");
      div.innerHTML = '<p>x</p><style id="fit-vids-style">' + css + "</style>";
      head.appendChild(div.childNodes[1]);
    }

    if (options) {
      $.extend(settings, options);
    }

    return this.each(function () {
      var selectors = [
        'iframe[src*="player.vimeo.com"]',
        'iframe[src*="youtube.com"]',
        'iframe[src*="youtube-nocookie.com"]',
        'iframe[src*="kickstarter.com"][src*="video.html"]',
        "object",
        "embed",
      ];

      if (settings.customSelector) {
        selectors.push(settings.customSelector);
      }

      var ignoreList = ".fitvidsignore";

      if (settings.ignore) {
        ignoreList = ignoreList + ", " + settings.ignore;
      }

      var $allVideos = $(this).find(selectors.join(","));
      $allVideos = $allVideos.not("object object"); // SwfObj conflict patch
      $allVideos = $allVideos.not(ignoreList); // Disable FitVids on this video.

      $allVideos.each(function (count) {
        var $this = $(this);
        if ($this.parents(ignoreList).length > 0) {
          return; // Disable FitVids on this video.
        }
        if (
          (this.tagName.toLowerCase() === "embed" &&
            $this.parent("object").length) ||
          $this.parent(".fluid-width-video-wrapper").length
        ) {
          return;
        }
        if (
          !$this.css("height") &&
          !$this.css("width") &&
          (isNaN($this.attr("height")) || isNaN($this.attr("width")))
        ) {
          $this.attr("height", 9);
          $this.attr("width", 16);
        }
        var height =
            this.tagName.toLowerCase() === "object" ||
            ($this.attr("height") && !isNaN(parseInt($this.attr("height"), 10)))
              ? parseInt($this.attr("height"), 10)
              : $this.height(),
          width = !isNaN(parseInt($this.attr("width"), 10))
            ? parseInt($this.attr("width"), 10)
            : $this.width(),
          aspectRatio = height / width;
        if (!$this.attr("id")) {
          var videoID = "fitvid" + count;
          $this.attr("id", videoID);
        }
        $this
          .wrap('<div class="fluid-width-video-wrapper"></div>')
          .parent(".fluid-width-video-wrapper")
          .css("padding-top", aspectRatio * 100 + "%");
        $this.removeAttr("height").removeAttr("width");
      });
    });
  };
  // Works with either jQuery or Zepto
})(window.jQuery || window.Zepto);

$(function() {
  //begin document ready
  if (parseInt($.fn.jquery) != 3) {
    $.noConflict();
  }
  

  $(".data-slick").slick();
  $(".fitvids").fitVids();

  /* =========================================================================
    Related Show Selected
========================================================================= */

  $("#show-related").on("click", function () {
    $(".related-ymal").removeClass("visible");
    $(".related-picks").addClass("visible");
    $("#show-ymal").removeClass("selected");
    $(this).addClass("selected");
  });

  $("#show-ymal").on("click", function () {
    $(".related-picks").removeClass("visible");
    $(".related-ymal").addClass("visible");
    $("#show-related").removeClass("selected");
    $(this).addClass("selected");
  });

  /* =========================================================================
    Custom Search
========================================================================= */

  var $input = $(".js-product-input");
  var doneTypingInterval = 200;
  var minLength = 3;
  var typingTimer;

  $input.on("keyup", function () {
    $(".product-search__no-results").removeClass("visible");

    var val = $(this).val().toLowerCase();
    var len = val.length;

    if (len >= minLength) {
      clearTimeout(typingTimer);

      typingTimer = setTimeout(function () {
        filterProducts(val);
      }, doneTypingInterval);
    } else {
      clearProducts();
    }
  });

  function clearProducts() {
    $(".js-product-term").removeClass("visible");
  }

  function filterProducts(searchedTerm) {
    var $term = $(".js-product-term");

    var $matches = $term.filter(
      "[data-product-keywords*='" + searchedTerm + "']"
    );

    if ($matches.length) {
      $(".product-search__no-results").removeClass("visible");

      $matches.addClass("visible");
    } else {
      $(".product-search__no-results").addClass("visible");
      clearProducts();
    }
  }

  $(".js-close-clear-search").on("click", function () {
    clearProducts();
    $(".product-search__no-results").removeClass("visible");
    $input.val("");
  });

  /* =========================================================================
    Mobile Safari
========================================================================= */

  Modernizr.addTest("mobile-safari", function () {
    return /iP(ad|hone|od).+Version\/[\d\.]+.*Safari/i.test(
      navigator.userAgent
    );
  });

  /* =========================================================================
    Get Url Parameter
========================================================================= */

  $.urlParam = function (name) {
    var results = new RegExp("[?&]" + name + "=([^&#]*)").exec(
      window.location.href
    );
    return results || 0;
  };

  /* =========================================================================
    Browser Scrolled Detect
========================================================================= */

  // Nav color on hover

  function navColors() {
    if ($(".browser-scrolled").length == 0) {
      $(".desktop-navbar")
        .mouseover(function () {
          var cutomHoverColor = $(this).attr("data-js-hover-color");
          var customTextColor = $(this).attr("data-js-hover-text-color");
          $(this).css("background-color", cutomHoverColor);
          $(this)
            .find(".desktop-navbar-nav-logo svg path")
            .css("fill", customTextColor);
          $(this)
            .find(".desktop-navbar-nav-list-center")
            .css("color", customTextColor);
          $(this)
            .find(".desktop-navbar-nav-list-right")
            .css("color", customTextColor);
          $(this).find(".desktop-navbar-banner").css("color", customTextColor);
        })
        .mouseout(function () {
          $(this).css("background-color", "transparent");
          if ($(".template-index").length) {
            var slideColor = $(".rsSlide.rsActiveSlide div").attr(
              "data-navbar-main-color"
            );
            $(this)
              .find(".desktop-navbar-nav-logo svg path")
              .css("fill", slideColor);
            $(this)
              .find(".desktop-navbar-nav-list-center")
              .css("color", slideColor);
            $(this)
              .find(".desktop-navbar-nav-list-right")
              .css("color", slideColor);
            $(this).find(".desktop-navbar-banner").css("color", slideColor);
          } else {
            $(this)
              .find(".desktop-navbar-nav-logo svg path")
              .css("fill", "#000");
            $(this)
              .find(".desktop-navbar-nav-list-center")
              .css("color", "#000");
            $(this).find(".desktop-navbar-nav-list-right").css("color", "#000");
            $(this).find(".desktop-navbar-banner").css("color", "#000");
          }
        });
    }
  }

  navColors();

  function scrolledCheck() {
    var desktopOffset = $(window).width() > 1400 ? 105 : 85;
    var mobileOffset = 97;
    var scrollTrigger = $(window).width() > 768 ? desktopOffset : mobileOffset;
    var bannerHeight = $(".desktop-navbar-banner").length ? scrollTrigger : 0;

    if ($(window).scrollTop() > bannerHeight) {
      $("body").addClass("browser-scrolled");

      $('.fk-desktop-mini').addClass('scrolled');

      // Hide elements on scroll
      $("body").removeClass("crt-popup-open");
      if ($("html.mod-no-mobile").length) {
        $("body").removeClass("search-overlay-open");
      }

      $(".desktop-navbar")
        .find(".condensed-nav-logo svg path")
        .css("fill", "#fff");
      $(".desktop-navbar")
        .find(".desktop-navbar-nav-list-center")
        .css("color", "#fff");
      $(".desktop-navbar")
        .find(".desktop-navbar-nav-list-right")
        .css("color", "#fff");
      $(".desktop-navbar").find(".desktop-navbar-banner").css("color", "#fff");

      $(".desktop-navbar")
        .mouseover(function () {
          $(this).find(".desktop-navbar-nav-list-center").css("color", "#fff");
          $(this).find(".desktop-navbar-nav-list-right").css("color", "#fff");
        })
        .mouseout(function () {
          $(this).find(".desktop-navbar-nav-list-center").css("color", "#fff");
          $(this).find(".desktop-navbar-nav-list-right").css("color", "#fff");
        });
    } else {
      var slideColor = $(".rsSlide.rsActiveSlide div").attr(
        "data-navbar-main-color"
      );
      var customTextColor = $(".desktop-navbar").attr(
        "data-js-hover-text-color"
      );

      $('.fk-desktop-mini').removeClass('scrolled');

      if ($(".template-index").length) {
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-logo svg path")
          .css("fill", slideColor);
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-list-center")
          .css("color", slideColor);
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-list-right")
          .css("color", slideColor);
        $(".desktop-navbar")
          .find(".desktop-navbar-banner")
          .css("color", slideColor);
      } else {
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-logo svg path")
          .css("fill", "#000");
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-list-center")
          .css("color", "#000");
        $(".desktop-navbar")
          .find(".desktop-navbar-nav-list-right")
          .css("color", "#000");
        $(".desktop-navbar")
          .find(".desktop-navbar-banner")
          .css("color", "#000");
      }

      $(".desktop-navbar")
        .mouseover(function () {
          $(this)
            .find(".desktop-navbar-nav-logo svg path")
            .css("fill", customTextColor);
          $(this).find(".desktop-navbar-banner").css("color", customTextColor);
          $(this)
            .find(".desktop-navbar-nav-list-center")
            .css("color", customTextColor);
          $(this)
            .find(".desktop-navbar-nav-list-right")
            .css("color", customTextColor);
        })
        .mouseout(function () {
          if ($(".template-index").length) {
            $(this)
              .find(".desktop-navbar-nav-list-center")
              .css("color", slideColor);
            $(this)
              .find(".desktop-navbar-nav-list-right")
              .css("color", slideColor);
            $(this)
              .find(".desktop-navbar-nav-logo svg path")
              .css("fill", slideColor);
            $(this).find(".desktop-navbar-banner").css("color", slideColor);
          } else {
            $(this)
              .find(".desktop-navbar-nav-logo svg path")
              .css("fill", "#000");
            $(this).find(".desktop-navbar-banner").css("color", "#000");
            $(this)
              .find(".desktop-navbar-nav-list-center")
              .css("color", "#000");
            $(this).find(".desktop-navbar-nav-list-right").css("color", "#000");
          }
        });
    }

    if ($(window).scrollTop() > $(".desktop-navbar").outerHeight()) {
      $("body").addClass("navbar-condensed");
    } else {
      $("body").removeClass("navbar-condensed");
    }
  }

  scrolledCheck();

  var scrollTimer = null;
  $(window).on("scroll", function () {
    if (scrollTimer) {
      clearTimeout(scrollTimer);
    }

    // NOTE: needs to happen fast (outside throttled scrolledCheck) for smooth trasition between floating header
    if ($(window).scrollTop() <= 25) {
      $("body").removeClass("browser-scrolled");
    }

    scrollTimer = setTimeout(scrolledCheck, 100);
  });

  /* =========================================================================
    Browser Scroller
========================================================================= */

  $(document).on("click", ".js-browser-back-to-top", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600,
      "easeOutExpo"
    );
  });

  $(document).on("click", ".js-browser-snap-to-top", function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      0,
      "linear"
    );
  });

  /* =========================================================================
    Sroll Down Window Height
========================================================================= */

  $(document).on("click", ".js-scroll-down-window-height", function () {
    $("html, body").animate(
      {
        scrollTop: $(window).height() - $(".desktop-navbar").height(),
      },
      600,
      "easeOutExpo"
    );
  });

  /* =========================================================================
    Scroll To Element
========================================================================= */

  $(document).on("click", ".js-body-scroll-to-element", function (event) {
    var elementSelector = $(this).data("element-selector");
    var scrollOffset =
      $(".desktop-navbar-nav").height() + $(".page-breadcrumb").height();

    $("html, body").animate(
      {
        scrollTop: $(elementSelector).offset().top - scrollOffset,
      },
      600,
      "easeOutExpo"
    );
  });

  /* =========================================================================
    100vh Backup
========================================================================= */

  function setHeight100vh() {
    $(".height-100vh").height($(window).height());
  }

  if (!Modernizr.cssvhunit) {
    setHeight100vh();

    deferDebounce(function() {
      $(window).on(
        "resize",
        _.debounce(setHeight100vh, 250, { leading: false, trailing: true })
      );
    });
  }

  /* =========================================================================
    Search
========================================================================= */

  $(".desktop-navbar-search").hover(
    function () {
      $(this).addClass("open");
    },
    function () {
      $(this).removeClass("open");
    }
  );

  /* =========================================================================
    Nav
========================================================================= */
  if ("ontouchstart" in window) {
    $(".desktop-navbar-nav-dropdown-toggle").click(function (event) {
      event.preventDefault();
      var $this = $(this);
      var $dropdown = $(this).parents(".dropdown");
      $dropdown.toggleClass("open").siblings().removeClass("open");
    });

    $(".fk-desktop-has-mini").click(function(e) {
      $(this).addClass('active');
      $(this).attr('aria-expanded', true);

      if ( $(this).hasClass('account') ) {
        if ( !$('.fk-desktop-mini.account').hasClass('active') ) {
          $('.fk-desktop-mini.account').addClass('active');
        }
      } else if ( $(this).hasClass('wishlist') ) {
        if ( !$('.fk-desktop-mini.wishlist').hasClass('active') ) {
          $('.fk-desktop-mini.wishlist').addClass('active');
        }
      }
    });
  } else {
    $(".desktop-navbar-nav-dropdown-toggle").mouseenter(function (event) {
      var $this = $(this);
      var $dropdown = $(this).parents(".dropdown");
      $dropdown.addClass("open").siblings().removeClass("open");
    });

    $(".fk-desktop-has-mini").mouseenter(function(e) {
      $(this).addClass('active');
      $(this).attr('aria-expanded', true);

      if ( $(this).hasClass('account') ) {
        if ( !$('.fk-desktop-mini.account').hasClass('active') ) {
          $('.fk-desktop-mini.account').addClass('active');
        }
      } else if ( $(this).hasClass('wishlist') ) {
        if ( !$('.fk-desktop-mini.wishlist').hasClass('active') ) {
          $('.fk-desktop-mini.wishlist').addClass('active');
        }
      }
    });
  }

  $(".desktop-navbar-nav-dropdown").mouseleave(function (event) {
    var $this = $(this);
    var $toElement = $(event.relatedTarget);

    if ($toElement.is(".desktop-navbar-nav-dropdown")) {
      $this.addClass("mouse-to-sibling");
      $toElement.addClass("mouse-from-sibling");
    } else {
      $this.removeClass("open");
      $(".desktop-navbar-nav-dropdown").removeClass(
        "mouse-to-sibling mouse-from-sibling"
      );
    }
  });

    $('.fk-desktop-mini').mouseleave(function(e) {
      if ( !document.activeElement.classList.contains('fk-desktop-mini--input') ) {
        $(this).removeClass('active');
        $('.fk-desktop-has-mini').removeClass('active');
        $('.fk-desktop-has-mini').attr('aria-expanded', false);
      }
    });

    $('.fk-desktop-has-mini').mouseleave(function(e) {
      if ( !document.activeElement.classList.contains('fk-desktop-mini--input') ) {
        if( $(e.toElement).hasClass('fk-desktop-mini') || $(e.toElement).hasClass('fk-desktop-mini--title') ) {
        } else {
          $('.fk-desktop-mini').removeClass('active');
          $(this).removeClass('active');
        }
      }
    });

  $(".desktop-search-trigger").mouseenter(function () {
    $(".desktop-navbar-nav-dropdown").removeClass("open");
  });

  $(document).on("click", ".mobile-nav-trigger", function () {
    $(".mobile-navbar-nav-dropdown").removeClass("open");
    $(".mobile-navbar-nav-close").addClass("open");
    $(".mobile-nav-right, .mobile-navbar-nav-logo").hide();
  });

  $(document).on("click", ".js-mob-nav-toggle", function () {
    $(this).parent().find(".mobile-navbar-nav-dropdown-menu").addClass("top");
    $(".mobile-navbar-nav-list").addClass("open");
  });

  $(document).on("click", ".js-mob-nav-toggle-back", function (e) {
    $(".mobile-navbar-nav-list").removeClass("open");
    $(this).parent().removeClass("top");
  });

  $(document).on("click", ".js-nav-close", function () {
    $(".mobile-navbar-nav-list").removeClass("open");
    $(".mobile-navbar-nav-dropdown-menu").removeClass("top");
  });

  $(document).on(
    "click",
    ".mobile-navbar-nav-close, .mini-cart-close",
    function () {
      $(".mobile-navbar-nav-list").removeClass("open");
      $(".mobile-navbar-nav-dropdown-menu").removeClass("top");
      $(".mobile-navbar-nav-close").removeClass("open");
      $("body").removeClass("mobile-nav-open");
      $(this).removeClass("open");
      $(".mobile-nav-right, .mobile-navbar-nav-logo").show();
    }
  );

  $(document).on(
    "click",
    ".mobile-nav-overlay, .mini-cart-overlay",
    function () {
      $(".mobile-mini-cart-close").removeClass("open");
      $(".mobile-nav-right, .mobile-navbar-nav-logo").show();
    }
  );

  $(document).on("click", ".mobile-mini-cart-trigger", function () {
    // $(".mobile-mini-cart-close").addClass("open");
    // $(".mobile-nav-right, .mobile-navbar-nav-logo").hide();
  });

  /* =========================================================================
    Dropdown
========================================================================= */
  var resetting = false;
  var mobFilterOpen = false;

  if ($("html.mod-no-mobile").length) {
    $(".js-dropdown-hover").hover(
      function () {
        $(this).addClass("open");
      },
      function () {
        $(this).removeClass("open");
      }
    );
  }

  function handleToggleDropdown(e, toggle) {
    if (toggle === undefined) {
      var $dropdown = $(this).parent();
    } else {
      var $dropdown = $(toggle).parent();
    }

    $dropdown.toggleClass("open").siblings().removeClass("open");

    if ($(".dropdown").hasClass("open")) {
      $(".menu-bg").addClass("menu-visible");
    } else {
      $(".menu-bg").removeClass("menu-visible");
    }

    if ($dropdown.hasClass("collection-sort")) {
      $(".mob-filters").removeClass("open");
      $(".mob-filters").find(".dropdown").removeClass("open");
    }
  }

  $(document).on("click", ".js-dropdown-toggle", handleToggleDropdown);
  $(document).on("mouseup", function (e) {
    var container = $(".collection-sort-desktop .collection-sort.dropdown");
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      if (container.hasClass("open")) {
        handleToggleDropdown(null, container.find(".js-dropdown-toggle"));
      }
    }
  });

  $(document).on("click", ".js-dropdown-toggle-update", function () {
    var $this = $(this);

    $this.parents(".dropdown").find(".dropdown-toggle").html($this.html());
  });

  $(".js-mob_filters-dropdown-toggle, .close-mobile-filters").on(
    "click",
    function () {
      var $dropdown = $(this).parents(".mob-filters");

      $("body").toggleClass("filter-open");

      $dropdown.toggleClass("open").siblings().removeClass("open");

      $dropdown.find(".dropdown").removeClass("open");

      $(".collection-sort").removeClass("open");

      // if (mobFilterOpen == true) {
      // 	mobFilterOpen = false;
      // 	$('body').css({'overflow': 'inherit'});

      // } else {
      // 	mobFilterOpen = true;
      // 	$('body').css({'overflow': 'hidden'});
      // }
    }
  );

  $(".mob_filter__close").on("click", function () {
    var $dropdown = $(this).closest(".dropdown");

    $dropdown.removeClass("open");
  });

  $(".reset-mobile-filters").on("click", function () {
    var emptyProducts = [];
    getFilterProducts(emptyProducts, {});
    $('.mob_filter__options input[type="checkbox"]').prop("checked", false);
  });

  $(".js-filters-dropdown-toggle").on("click", function () {
    $(this).parents(".dropdown").toggleClass("open");
  });

  /* =========================================================================
    Body Class
========================================================================= */

  $(document).on("click", ".js-body-add-class", function () {
    $("body").addClass($(this).data("body-class"));
  });

  $(document).on("click", ".js-body-remove-class", function () {
    $("body").removeClass($(this).data("body-class"));
  });

  $(document).on("click", ".js-body-toggle-class", function () {
    $("body").toggleClass($(this).data("body-class"));
  });

  /* =========================================================================
    Element Fadein Fadeout
========================================================================= */

  $(document).on("click", ".js-element-fadein", function () {
    $($(this).data("element-selector")).fadeIn(400);
  });

  $(document).on("click", ".js-element-fadeout", function () {
    $($(this).data("element-selector")).fadeOut(400);
  });

  $(document).on("click", ".js-element-toggle", function () {
    $($(this).data("element-selector")).fadeToggle(400);
  });

  $(document).on("click", ".js-element-fadeinout", function () {
    var $this = $(this);

    $($this.data("in-element-selector")).show();

    $($this.data("out-element-selector")).hide();
  });

  $(document).on("click", ".js-element-slideupdown", function () {
    var $this = $(this);
    var index = $this.index();

    var $switchTargets = $($this.data("element-selector"));
    var $activeTarget = $switchTargets.filter(":visible");

    $this.addClass("active").siblings().removeClass("active");

    if ($activeTarget.length) {
      $activeTarget.slideUp(300, function () {
        $switchTargets.eq(index).slideDown(300);
      });
    } else {
      $switchTargets.eq(index).slideDown(300);
    }
  });

  /* =========================================================================
    Stop Propagation
========================================================================= */

  $(document).on("click", ".js-stop-propagation", function (event) {
    event.stopPropagation();
  });

  /* =========================================================================
    Tab
========================================================================= */

  $(document).on("click", ".tab-label", function (event) {
    event.preventDefault();

    var $this = $(this);

    $this.parents(".tabs-container").find(".tab-label").removeClass("active");
    $this.addClass("active").siblings().removeClass("active");

    // $('.tab__content').hide();
    // $('#' + $this.attr('aria-controls')).show();
  });

  /* =========================================================================
TABS
========================================================================= */

  var toggleTabs = function () {
    var s = {
      $summary: $(".tab__summary"),
      $content: $(".tab__content"),
    };

    var bindUI = function () {
      s.$summary.on("click", function (e) {
        var $self = $(this);

        var data = {
          controls: $self.attr("aria-controls"),
        };

        // If clicked tab is already active, hide it, otherwise proceed to toggle.
        if ($self.attr("aria-selected") == "true") {
          hideTab(data.controls);
        } else {
          toggleTab(data.controls);
        }
      });
    };

    var toggleTab = function (controls) {
      if (tabIsHidden(controls) == "true") {
        hideTab(); // Hide all
        showTab(controls); // Show specific
      }
    };

    var tabIsHidden = function (controls) {
      return s.$content.filter("[id='" + controls + "']").attr("aria-hidden");
    };

    var hideTab = function (controls) {
      // console.log("hide tab");
      if (controls) {
        s.$summary
          .filter("[aria-controls='" + controls + "']")
          .attr("aria-selected", "false");

        s.$content
          .filter("[id='" + controls + "']")
          .attr("aria-hidden", "true")
          .hide();
      } else {
        s.$summary.attr("aria-selected", "false");
        s.$content.attr("aria-hidden", "true").hide();
      }

      $(".option-set-col").removeClass("active");
    };

    var showTab = function (controls) {
      // console.log("show tab");
      if (controls) {
        s.$summary
          .filter("[aria-controls='" + controls + "']")
          .attr("aria-selected", "true");

        s.$content
          .filter("[id='" + controls + "']")
          .attr("aria-hidden", "false")
          .show();
      } else {
        s.$summary.attr("aria-selected", "true");
        s.$content.attr("aria-hidden", "false").show();
      }

      s.$content
        .filter("[id='" + controls + "']")
        .parent(".option-set-col")
        .addClass("active");
    };

    var init = function () {
      bindUI();
      hideTab();
      showTab($($(".tab__summary")[0]).attr("aria-controls"));
      $($(".tab__summary")[0]).addClass("active");
    };

    init();
  };

  toggleTabs();

  /* =========================================================================
    Pagination Load More Ajax
========================================================================= */

  if ($(".template-blog").length) {
    window.sr = ScrollReveal();
    sr.reveal(".reveal-col", {
      opacity: 0,

      scale: 0.95,

      duration: 400,
    });
  }

  /* =========================================================================
    Remove Class
========================================================================= */

  function removeClassWithPrefix(element, classPrefix) {
    var regex = new RegExp("(^|\\s)" + classPrefix + "\\S+", "g");

    element.removeClass(function (index, css) {
      return (css.match(regex) || []).join(" ");
    });
  }

  /* =========================================================================
    Product Image Fullscreen
========================================================================= */

  $(document).on("click", ".js-product-image-fullscreen", function () {
    $(".product-image-popup")
      .fadeIn()
      .find("img")
      .prop("src", $(this).find("img").prop("src"));
  });

  /* =========================================================================
    Email Subscribe Popup
========================================================================= */
  // function to check if cookie exists
  function checkCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  // function to set cookie
  function createCookie(name, value, days) {
    var date, expires;
    if (days) {
        date = new Date();
        date.setTime(date.getTime()+(days*24*60*60*1000));
        expires = "; expires="+date.toUTCString();
    } else {
        expires = "";
    }
    document.cookie = name+"="+value+expires+"; path=/";
  }

  let y_pos;
  // initialize email pop-up sequence
  function initEmailPopup() {

    // check if cookie exists
    var site_cookie = checkCookie("visited");

    // if cookie is not undefined (or the days are set to 0 for testing), start counting clicks and idle seconds
    if (site_cookie == undefined || _themeSettings.popup_expiry_days == 0) {

      // set # of clicks to 0 in local storage
      var documentClicks = localStorage.getItem("popup_clicks")
        ? localStorage.getItem("popup_clicks")
        : 0;

      // count clicks for each click, and update local storage value
      $(document).on("click", function () {
        documentClicks++;
        localStorage.setItem("popup_clicks", documentClicks);
      });

      // set idle time to 0
      var idleTime = 0;
      //Increment the idle time counter every 1 second
      var idleInterval = setInterval(timerIncrement, 1000);

      //Zero the idle timer on clicks & keypresses
      $(document).click(function (e) {
        idleTime = 0;
      });
      $(document).keypress(function (e) {
        idleTime = 0;
      });

      // every second, check if click + idle conditions meet theme settings
      function timerIncrement() {
        idleTime = idleTime + 1;
        tryOpenPopup();
      }

      function tryOpenPopup() {
        // if clicks + idle time equal theme settings, open the pop-up
        if ( documentClicks >= _themeSettings.popup_click_max && idleTime >= _themeSettings.popup_idle_max ) {
          // Delay a bit to make sure popup doesn't occur on a page transition
          setTimeout(function () {
            // stop timer
            clearInterval(idleInterval);

            // get y_pos (checked on exit)
            y_pos = $(window).scrollTop();

            // hide pop-up to ensure elements aren't still active
            $('.fullscreen-overlay-subscribe-popup').show();

            // show pop-up
            $("body").addClass("subscribe-footer-popup-open");

            // enable the input, which starts disabled to avoid required message interfering when pop-up isn't visible
            $('.subscribe-popup-email').prop("disabled", false);

            // set a cookie (expiry set in theme settings)
            if (!_themeSettings.popup_expiry_days == 0) {
              createCookie("visited", true, _themeSettings.popup_expiry_days);
            }

            // reset doc clicks to 0
            localStorage.setItem("popup_clicks", 0);
          }, 500);
        }
      }
    }
  }

  if ( _themeSettings.popup_enable ) {
    initEmailPopup();
  }

  // on email input focus, try disabling 'focusin focus' event, where iOS scrolls down to auto center - ends up scrolling down below pop-up
  $('input.subscribe-popup-email').bind('focusin focus', function(e){
    e.preventDefault();
  });

  // close pop-up
  $(document).on("click", ".js-subscribe-popup-close", function () {
    // disable the input on close to avoid required message popping up
    $('.subscribe-popup-email').prop("disabled", true);

    // remove class from body & pop-up transitions out
    $("body").removeClass("subscribe-footer-popup-open");

    // hide pop-up to ensure elements aren't still active
    setTimeout(function(){ $('.fullscreen-overlay-subscribe-popup').hide(); }, 700);
  });

  $(window).scroll(function () {
    var subscribeFooterPopup = $(".subscribe-footer-popup-on-scroll");
    var subscribeFooterPopupOpen = subscribeFooterPopup.data("init");
    if (typeof subscribeFooterPopupOpen === "undefined") {
      if ($(window).scrollTop() > $(document).height() / 2) {
        subscribeFooterPopup.show().attr("data-init", "1");
      }
    }
  });


  $("#emailSubscribe").submit(function(e) {
    e.preventDefault();

    const listID = $('#emailSubscribe').attr('data-list');
    const emailInput = $('.subscribe-popup-email').val();
    const settings = {
      "async": true,
      "crossDomain": true,
      "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
      "method": "POST",
      "headers": {
        "content-type": "application/x-www-form-urlencoded",
        "cache-control": "no-cache"
      },
      "data": {
        "g": listID,
        "email": emailInput
      }
    }

    $.ajax(settings).done(function (response) {
      $('.main-form').removeClass('active')
      $('.success-form').addClass('active');
    });

  });

  /* =========================================================================
    Mailchimp Email Subscribe
========================================================================= */
  var handleNewsletterForm = function () {
    // NOTE: The code below was designed only for mailchimp. If you use another email client, please add the code below this.
    var $form = $(".js-newsletter-form"),
      $msg,
      msg;

    $form.on("submit", function (e) {
      e.preventDefault();

      $form = $(this);
      $email = $form.find("input[type='email']");
      $msg = $(".js-newsletter-message");
      $email.on("click", function () {
        $(this).val("");
      });

      var ajaxParams = {
        url: $form.attr("action"),
        method: $form.attr("method"),
        data: $form.serialize(),
        dataType: "jsonp",
        jsonp: "c",
        contentType: "application/json; charset=utf-8",
        error: function (err) {
          $email.val("Sorry, we had an error");
        },
        success: function (data) {
          if (data.result == "error") {
            var msg = data.msg;

            if (msg.indexOf("already") >= 0) {
              msg = "This email is already subscribed";
            } else {
              msg = "Please enter a valid email.";
              $form.addClass("phx-email-error");
            }

            $form.find('input[type="email"]').val(msg);
          } else {
            $form.find('input[type="email"]').val("Thank you!");
          }

          //
          // $msg.text(msg);
          $form.addClass("newsletter-form--success");
        },
      };

      $.ajax(ajaxParams);
    });

    $form.find('input[type="email"]').focus(function () {
      $form.removeClass("phx-email-error");
    });
  };

  handleNewsletterForm();

  /* =========================================================================
    Customer
========================================================================= */

  $(document).on("click", ".js-reset-password-fadein", function () {
    $(".recover-password-form").fadeIn(0);
    $(".customer-login-form").fadeOut(0);
  });

  $(document).on("click", ".js-rest-password-fadeout", function () {
    $(".recover-password-form").fadeOut(0);
    $(".customer-login-form").fadeIn(0);
  });

  if ($(".template-directory-customers").length) {
    // Initialize observers on address selectors, defined in shopify_common.js

    if ($(".template-customers-addresses").length) {
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew",
        }
      );

      // Initialize each edit form's country/province selector

      $(document).on("click", ".address-country-option", function () {
        var formId = $(this).data("form-id");
        var countrySelector = "AddressCountry_" + formId;
        var provinceSelector = "AddressProvince_" + formId;
        var containerSelector = "AddressProvinceContainer_" + formId;

        new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
          hideElement: containerSelector,
        });
      });

      $(document).on("click", ".address-delete", function () {
        var $el = $(this);
        var formId = $el.data("form-id");
        var confirmMessage = $el.data("confirm-message");
        if (
          confirm(
            confirmMessage || "Are you sure you wish to delete this address?"
          )
        ) {
          Shopify.postLink("/account/addresses/" + formId, {
            parameters: { _method: "delete" },
          });
        }
      });
    }
  }

  /* =========================================================================
    Royal Slider
========================================================================= */

  function initialArrowsSlider($slider, slidesHtml) {
    if ($(window).width() > 800) {
      var transspeed = 600;
    } else {
      var transspeed = 400;
    }

    $slider.royalSlider({
      controlNavigation: "bullets",
      navigateByClick: false,
      arrowsNav: false,
      arrowsNavAutoHide: false,
      sliderDrag: true,
      sliderTouch: true,
      slidesSpacing: 0,
      loop: true,
      transitionType: "fade",
      transitionSpeed: transspeed,
      addActiveClass: true,
      autoHeight: true,
      slides: slidesHtml,
      autoPlay: {
        enabled: true,
        stopAtAction: true,
        pauseOnHover: false,
        delay: 5000,
      },
    });

    var fkSlider = $slider.data("royalSlider");
    fkSlider.ev.on("rsBeforeAnimStart", function (event) {
      var fkSliderIndex = event.target.currSlideId;
      var fkNavColor = $("#fk-slide-block-" + fkSliderIndex).data(
        "fk-nav-color"
      );
      if (fkNavColor == "#000000") {
        $(".fk-header").addClass("fk-header--black");
        $(".mobile-navbar").addClass("mobile-navbar--black");
      } else {
        $(".fk-header").removeClass("fk-header--black");
        $(".mobile-navbar").removeClass("mobile-navbar--black");
      }
    });

    var fkNavColor = $("#fk-slide-block-0").data("fk-nav-color");
    if (fkNavColor == "#000000") {
      $(".fk-header").addClass("fk-header--black");
      $(".mobile-navbar").addClass("mobile-navbar--black");
    } else {
      $(".fk-header").removeClass("fk-header--black");
      $(".mobile-navbar").removeClass("mobile-navbar--black");
    }
  }

  function initialBulletsSlider($slider, slidesHtml) {
    $slider.royalSlider({
      controlNavigation: "bullets",
      arrowsNav: false,
      arrowsNavAutoHide: false,
      loop: true,
      transitionType: "fade",
      transitionSpeed: 300,
      addActiveClass: true,
      autoHeight: true,
      sliderDrag: false,
      sliderTouch: false,
      allowCSS3: false,
      slides: slidesHtml,
    });
  }

  function initialAutoMoveSlider($slider, slidesHtml) {
    $slider.royalSlider({
      controlNavigation: "none",
      arrowsNav: false,
      arrowsNavAutoHide: false,
      loop: true,
      transitionType: "fade",
      transitionSpeed: 800,
      addActiveClass: true,
      autoHeight: true,
      sliderDrag: false,
      sliderTouch: false,
      allowCSS3: false,
      slides: slidesHtml,
      autoPlay: {
        enabled: true,
        stopAtAction: true,
        pauseOnHover: true,
        delay: 3500,
      },
    });
  }

  function initialAutoFadeSlider($slider, slidesHtml) {
    $slider.royalSlider({
      controlNavigation: "none",
      arrowsNav: false,
      arrowsNavAutoHide: false,
      loop: true,
      transitionType: "fade",
      transitionSpeed: 1000,
      navigateByClick: false,
      sliderDrag: false,
      sliderTouch: false,
      addActiveClass: true,
      autoHeight: true,
      allowCSS3: false,
      slides: slidesHtml,
      autoPlay: {
        enabled: true,
        stopAtAction: false,
        pauseOnHover: false,
        delay: 900,
      },
    });
  }

  $(".royalSlider").each(function (index) {
    var $this = $(this);

    if ($this.children().length) {
      if ($this.is(".js-arrows-slider")) {
        initialArrowsSlider($this, null);
      } else if ($this.is(".js-bullets-slider")) {
        initialBulletsSlider($this, null);
      } else if ($this.is(".js-auto-move-slider")) {
        initialAutoMoveSlider($this, null);
      } else if ($this.is(".js-auto-fade-slider")) {
        initialAutoFadeSlider($this, null);
      }

      if ($this.data("royalSlider").numSlides === 1) {
        $this.find(".rsNav").hide();
      }
    }
  });

  $("#content-slider-1").royalSlider({
    autoHeight: true,
    arrowsNav: false,
    fadeinLoadedSlide: false,
    controlNavigationSpacing: 0,
    controlNavigation: "tabs",
    imageScaleMode: "none",
    imageAlignCenter: false,
    loop: false,
    loopRewind: true,
    numImagesToPreload: 6,
    keyboardNavEnabled: true,
    usePreloader: false,
  });

  if ($("html.mod-no-mobile").length) {
    $(document).on("mouseenter", ".js-auto-fade-slider", function () {
      var sliderData = $(this).data("royalSlider");
      sliderData.startAutoPlay();
    });

    $(document).on("mouseleave", ".js-auto-fade-slider", function () {
      var sliderData = $(this).data("royalSlider");
      sliderData.stopAutoPlay();
      sliderData.goTo(0);
    });
  }

  /* =========================================================================
    Owl Carousel Nav
========================================================================= */

  $(".owl-carousel-nav-prev").click(function () {
    $(this)
      .parents(".owl-carousel-wrapper")
      .find(".owl-carousel")
      .trigger("prev.owl.carousel");
  });
  $(".owl-carousel-nav-next").click(function () {
    $(this)
      .parents(".owl-carousel-wrapper")
      .find(".owl-carousel")
      .trigger("next.owl.carousel");
  });

  $(".js-carrot-trigger").click(function () {
    $("body").addClass("crt-popup-open");
  });


  /* =========================================================================
    Collection Random
========================================================================= */

  (function ($) {
    $.fn.pick = function (how_many) {
      var how_many = how_many || 4;

      // Picking random numbers without repeating.
      var index_array = [];
      var original_obj_size = this.length;
      for (var i = 0; i < original_obj_size; i++) {
        index_array.push(i);
      }
      //+ Jonas Raoni Soares Silva
      //@ http://jsfromhell.com/array/shuffle [rev. #1]
      var shuffle = function (v) {
        for (
          var j, x, i = v.length;
          i;
          j = parseInt(Math.random() * i), x = v[--i], v[i] = v[j], v[j] = x
        );
        return v;
      };
      var new_index_array = shuffle(index_array).slice(0, how_many);

      // Ditching unpicked elements and removing those from the returned set.
      return this.each(function (i) {
        if ($.inArray(i, new_index_array) === -1) {
          $(this).remove();
        }
      }).filter(function () {
        if (this.parentNode === null) {
          return false;
        } else {
          return true;
        }
      });
    };
  })(jQuery);

  if ($(".template-name-product").length) {
    jQuery(".related-products-grid .related-products-grid-item").pick(4);
  }

  /* =========================================================================
    General
========================================================================= */

  var vhFix = function () {
    $(".hp-pillar").css("max-height", $(window).height());
  };

  vhFix();

  /* =========================================================================
    Info Page
========================================================================= */

  if (window.location.href.indexOf("pages") > -1) {
    var page = window.location.href.split("pages/").slice(1);
    if ($(".info-nav-bar").length) {
      $(".info-nav-bar")
        .find("#" + page)
        .addClass("active-tab");
    }
  }

  /* =========================================================================
    DESIGNERS PAGE
========================================================================= */
  if ($(".template-page-designers").length) {
    $(".js-designer-category").on("click", function () {
      var $this = $(this);
      $selectedCategory = $this.data("designer-category");

      $vendorGroupWrap = $this.parents(".designers").find(".vendor-group-wrap");
      $vendorGroupWrap
        .removeClass("active")
        .filter($selectedCategory)
        .addClass("active");
      $this.addClass("selected").siblings().removeClass("selected");
    });
  }

  // CAPSULE COLLECTION

  if ($(".template-page-capsule-collection").length) {
    $(".video")
      .parent()
      .click(function () {
        if ($(this).children(".video").get(0).paused) {
          $(this).children(".video").get(0).play();
          $(this).children(".playpause").fadeOut();
        } else {
          $(this).children(".video").get(0).pause();
          $(this).children(".playpause").fadeIn();
        }
      });
  }

  /* =========================================================================
    Homepage Page
========================================================================= */

  if ($(".template-index").length) {
    $(".shopify-section:nth-child(-n+3)").removeClass("will-fade-in");

    var $lazy = $(".will-fade-in");
    var activeClass = "will-fade-in--active";
    var threshold = 1000;

    $(window).scroll(function () {
      $lazy.each(function (index, item) {
        var pos = $(item).offset().top;
        var scrollTop = $(window).scrollTop();

        if (scrollTop + threshold >= pos && !$(item).hasClass(activeClass)) {
          $(item).addClass(activeClass);
        }
      });
    });

    // NAV COLOR

    var navColorsCheck = function () {
      if ($("body").hasClass("browser-scrolled")) {
        $(".js-color-change").css("color", "#000");
      } else {
        var slider = $(".royalSlider").data("royalSlider");
        $navColor = $("[data-navbar-main-color]")
          .first()
          .data("navbar-main-color");
        var currSlideColor = slider.currSlide.content.attr(
          "data-navbar-main-color"
        );

        $(".js-color-change").css("color", currSlideColor);

        slider.ev.on("rsBeforeAnimStart", function (event) {
          var currSlideColor = slider.currSlide.content.attr(
            "data-navbar-main-color"
          );
          $(".js-color-change").css("color", currSlideColor);

          $(".desktop-navbar")
            .find(".desktop-navbar-nav-logo svg path")
            .css("fill", currSlideColor);
          $(".desktop-navbar")
            .find(".desktop-navbar-nav-list-center")
            .css("color", currSlideColor);
          $(".desktop-navbar")
            .find(".desktop-navbar-nav-list-right")
            .css("color", currSlideColor);
          $(".desktop-navbar")
            .find(".desktop-navbar-banner")
            .css("color", currSlideColor);
        });
      }
    };

    navColorsCheck();

    $(window).on("scroll", function () {
      navColorsCheck();
    });

    $(".homepage_product_slick").slick({
      dots: false,
      infinite: true,
      speed: 800,
      slidesToShow: 5,
      slidesToScroll: 5,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: true,
            dots: false,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
      ],
    });
  }

  /* =========================================================================
    Collection Page
========================================================================= */

  if ($(".template-name-collection").length) {
    $(".load-ajax-btn").click(function () {
      console.log("HI");
      jQuery.ajax({
        type: "GET",
        url: "/products.json",
        success: function (response) {
          console.log("Product Object: ", response);
        },
        error: function (error) {
          console.log("test" + JSON.stringify(error));
          console.log("This Error: " + error);
        },
      });
    });
  }

  /* =========================================================================
    Designer Story
========================================================================= */

  if ($(".ds-article__mid-gallery").length) {
    $(".design-story-slider").slick({
      dots: true,
      infinite: true,
      arrows: false,
      speed: 800,
      swipe: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  if ($(".fk-si-header-slick").length) {
    $(".fk-si-header-slick").slick({
      dots: true,
      fade: true,
      infinite: true,
      arrows: false,
      speed: 800,
      swipe: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 3000,
      centerMode: true,
      centerPadding: "0px",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  }

  /* =========================================================================
    Contact Page
========================================================================= */

  if ($(".template-page-contact").length) {
    if (window.location.href.includes("contact_posted=true")) {
      $(".contact-form-fields").hide();
      $(".form-text-general").hide();
    }
  }

  /* =========================================================================
    Product Page
========================================================================= */

  if ($(".product-container").length) {
    $(".js-slick-slider").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev" title="Back"></button>',
      nextArrow:
        '<button type="button" class="slick-next" title="Next"></button>',
      dots: true,
      fade: true,
      speed: 100,
      asNavFor: ".js-slick-slider-thumbs",
      responsive: [
        {
          breakpoint: 768,
          settings: {
            fade: false,
          },
        },
      ],
    });

    $(".js-slick-slider-thumbs").slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      arrows: false,
      asNavFor: ".js-slick-slider",
      infinite: true,
      verticalSwiping: true,
      vertical: true,
      focusOnSelect: true,
      centerMode: false,
    });
    $(window).on("resize orientationchange", function () {
      $(".template-product .js-slick-slider-thumbs").slick("setPosition");
      $(".template-product .js-slick-slider").slick("setPosition");
    });

    $(".image-zoom")
      .wrap('<span style="display:block"></span>')
      .css("display", "block")
      .parent()
      .zoom({
        url: $(this).find("img").attr("data-zoom"),
        on: "click",
      });
  }

  /* =========================================================================
    Pages
========================================================================= */

  /* =========================================================================
    Product Card Color Swatch
========================================================================= */

  $(document).on("click", ".js-product-card-color-swatch", function (e) {
    var $this = $(this);

    $this.addClass("selected").siblings().removeClass("selected");

    // data

    var productHandle = $this.data("product-handle");

    var productID = $this.data("product-id");

    var variantID = $this.data("variant-id");

    var productUrl = $this.data("product-url");

    var productTitle = $this.data("product-title");

    var productPrice = $this.data("product-price-html");

    // end of data

    // element

    var $productCard = $this.parents(".product-card");

    var $productCardAlbum = $productCard.find(".product-card-album");

    var $productCardLink = $productCard.find(".product-card-link");

    var $productCardTitle = $productCard.find(".product-card-title");

    var $productCardPrice = $productCard.find(".product-card-price");

    // end of element

    $productCardAlbum
      .removeClass("active")
      .filter('[data-product-handle="' + productHandle + '"]')
      .addClass("active");

    $productCardLink.attr("href", productUrl);

    $productCardTitle.html(productTitle);
    $productCardPrice.html(productPrice);
  });

  /* =========================================================================
    Product Shop Color Swatch
========================================================================= */

  $(document).on("click", ".js-product-shop-color-swatch", function () {
    var $this = $(this);

    $this.addClass("selected").siblings().removeClass("selected");

    // data

    var productHandle = $this.data("product-handle");

    var productID = $this.attr("data-product-id");

    var colorVariantID = parseInt($(this).attr("data-variant-id"));

    var productUrl = $this.data("product-url");

    var productTitle = $this.data("product-title");

    var productDescription = $this.data("product-description-html");

    var productDetails = $this.data("product-details");

    var productBtnText = $this.attr("data-product-btn-text");

    var productBtnJSClass = $this.data("product-btn-js-class");

    var variantPrice = $this.data("variant-price-html");

    var variantInventoryQTY = $this.data("variant-inventory-quantity");

    var variantIncomingDate = $this.data("variant-incoming-date");

    var variantIsLowInStock = $this.data("variant-is-low-in-stock");

    var variantIsBackOrder = $this.data("variant-is-back-order");
    var variantIsMadeToOrder = $this.data("variant-is-made-to-order");
    var productHasShipNoticeTag = $this.data("has-ship-notice-tag");

    var variantIsSoldOut = $this.data("variant-is-sold-out");
    var variantIsGiftCard = $this.data("variant-is-gift-card") === "true";
    var variantName = $this.data("variant-title") + ""; // IMPORTANT: always convert to string

    // end of data

    // element

    var $productShop = $this.parents(".product-shop");

    var $productShopAlbum = $productShop.find(".product-shop-album");

    var $productShopSelector = $productShop.find(".product-shop-selector");

    var $productShopVariants = $productShopSelector.find(
      ".product-shop-variants"
    );

    var $productShopVariant = $productShopVariants.find(
      ".product-shop-variant"
    );

    var $productShopOptions = $productShopSelector.find(
      ".product-shop-options"
    );

    var $productShopOptionValue = $productShopOptions.find(
      ".product-shop-option-value"
    );

    var $productShopTitle = $productShop.find(".product-shop-title");

    var $productShopPrice = $productShop.find(".product-shop-price");

    var $productShopDescription = $productShop.find(".product-shop-description");

    var $productShopDetails = $productShop.find(".product-shop-meta-details");

    var $inventoryNotice = $productShop.find(".product-shop-inventory-notice");

    var $incomingNotice = $productShop.find(".product-shop-incoming-notice");

    var $madeToOrder = $productShop.find(".product-tag-made-to-order");

    var $backInStock = $productShop.find(".product-back-in-stock");

    var $addToCartBtn = $productShop.find(".product-add-to-cart");

    // update swym data attributes on color swatch change only (indicates product switching)
    // attributes called in API call -- window._swat.addToWishList
    $('.wishlist-color-swatch-btn').attr('data-product-id', productID);
    $('.wishlist-color-swatch-btn').attr('data-variant-id', colorVariantID);
    $('.wishlist-color-swatch-btn').attr('data-product-url', 'https://fashionkind.com' + productUrl);

    window._swat.fetch( function(prods) {
      // check if there are wishlist products - add classes if matching variants exist
      if ( prods.length != 0 ) {
        
        var isWishlisted = false;
        prods.forEach(function (item, i) {
          var wishlistVarID= item.epi;
          colorVariantID == wishlistVarID ? isWishlisted = true : null;
        });

        if (isWishlisted) {
          $('.wishlist-color-swatch-btn').addClass('swym-added');
          $('.wishlist-color-swatch-btn').html('Added to wishlist');
        } else {
          $('.wishlist-color-swatch-btn').removeClass('swym-added');
          $('.wishlist-color-swatch-btn').html('Add to wishlist');
        }

      }
    });

    // end of element

    // update album

    $productShopAlbum
      .removeClass("active")
      .filter('[data-product-handle="' + productHandle + '"]')
      .addClass("active");

    // update selector

    $productShopSelector
      .removeClass("active")
      .filter('[data-product-handle="' + productHandle + '"]')
      .addClass("active");

    // reset variant

    $productShopVariant
      .removeClass("selected")
      .filter(".default")
      .addClass("selected");

    // reset option

    $productShopOptionValue
      .removeClass("selected")
      .filter(".default")
      .addClass("selected");

    if ($('.product-shop-option-value.selected').hasClass('.unavailable-value')) {
      $('#productAddToCart').removeClass('active');
      $('#bisTrigger').addClass('active');
    } else {
      $('#productAddToCart').addClass('active');
      $('#bisTrigger').removeClass('active');
    }

    // update color name
    $productShopTitle.html(productTitle);

    // update description
    $productShopDescription.html(productDescription);

    // update details panel
    $productShopDetails.html(productDetails);

    // update price
    $productShopPrice.html(variantPrice);

    var discountVendors = [
      "taylor-thomas",
      "mola-sasa",
      "hunting-season",
      "eleven-six",
      "patbo",
    ];
    var productVendor = $(".product-shop-price").eq(1).data("vendor");

    if (discountVendors.includes(productVendor)) {
      $productShopPrice.append(
        '<span class="product-sale-notification">25% off with code 25OFF</span>'
      );
    }

    // update url
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set("variant", colorVariantID);
    var pathNameSplit = window.location.pathname.split("/products/");
    var replacedUrl = pathNameSplit[0] + productUrl;
    // set the url based on the product name and variant
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      replacedUrl +
      "?" +
      urlParams.toString();
    window.history.replaceState({ path: newurl }, "", newurl);

    // update add to cart variant id
    $addToCartBtn.attr("data-product-id", $(this).data("product-id"));
    $addToCartBtn.attr("data-variant-id", colorVariantID);

    // update add to cart button text, class
    removeClassWithPrefix($addToCartBtn, "js-");

    $addToCartBtn.addClass(productBtnJSClass);
    if (productBtnText == "Sold Out") {
      $("#productAddToCart").removeClass("active");
      $("#bisTrigger").addClass("active");
    } else {
      $("#productAddToCart").addClass("active");
      $("#bisTrigger").removeClass("active");
      if (!variantIsGiftCard) {
        $addToCartBtn.text(productBtnText);
      }
    }
    var variantOptionName = $('.js-product-shop-option-value.selected').first().data('option-value');
    $(".dropdown-selected-value").each(function (i, el) {
      $(el).html(variantOptionName);
    });

    $(".product-shop-option-name").removeClass("opened");

    // update inventory
    if (variantInventoryQTY > 0 && variantInventoryQTY <= 3) {
      $inventoryNotice
        .find(".inventory-wrap")
        .show()
        .find("span")
        .text(variantInventoryQTY);
    } else {
      $inventoryNotice.find(".inventory-wrap").hide();
    }

    if (variantIsLowInStock) {
      $inventoryNotice.addClass("active");
    } else {
      $inventoryNotice.removeClass("active");
    }

    $incomingNotice.find("span").text(variantIncomingDate);

    var renderMadeToOrder = (variantIsMadeToOrder && variantIsBackOrder) ||
      (variantIsMadeToOrder && variantIsSoldOut);
    if (productHasShipNoticeTag || renderMadeToOrder) {
      $incomingNotice.addClass("active");
      if (renderMadeToOrder) {
        $madeToOrder.addClass("active");
      }
    } else {
      $incomingNotice.removeClass("active");
      $madeToOrder.removeClass("active");
    }

    // update back in stock 
    var addToCartForm = document.getElementById("productAddToCart");
    var bisTrigger = document.getElementById("bisTrigger");
    addToCartForm.classList.remove("active");
    bisTrigger.classList.remove("active");
    if (variantIsSoldOut) {
      bisTrigger.classList.add("active");
    } else {
      addToCartForm.classList.add("active");
      $addToCartBtn.attr("disabled", false);
    }

  });

  /* =========================================================================
    Product Shop Variant
========================================================================= */

  $(document).on("sync click", ".js-product-shop-variant", function () {
    var $this = $(this);

    $this.addClass("selected").siblings().removeClass("selected");

    // data
    var productID = $this.data("product-id");
    var productBtnText = $this.data("product-btn-text");
    var productBtnJSClass = $this.data("product-btn-js-class");
    var variantID = $this.data("variant-id");
    var variantPrice = $this.data("variant-price-html");
    var variantInventoryQTY = $this.data("variant-inventory-quantity");
    var variantIncomingDate = $this.data("variant-incoming-date");
    var variantIsLowInStock = $this.data("variant-is-low-in-stock");
    var variantIsBackOrder = $this.data("variant-is-back-order");
    var variantIsMadeToOrder = $this.data("variant-is-made-to-order");
    var productHasShipNoticeTag = $this.data("has-ship-notice-tag");
    var variantIsSoldOut = $this.data("variant-is-sold-out");
    var variantIsGiftCard = $this.data("variant-is-gift-card");
    var variantName = $this.data("variant-title") + ""; // IMPORTANT: always convert to string

    // end of data

    // element

    var $productShop = $this.parents(".product-shop");

    var $productShopPrice = $productShop.find(".product-shop-price");

    var $inventoryNotice = $productShop.find(".product-shop-inventory-notice");

    var $incomingNotice = $productShop.find(".product-shop-incoming-notice");

    var $madeToOrder = $productShop.find(".product-tag-made-to-order");

    var $backInStock = $productShop.find(".product-back-in-stock");

    var $addToCartBtn = $productShop.find(".product-add-to-cart");

    // end of element

    // update price
    $productShopPrice.html(variantPrice);

    // update url
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set("variant", variantID);
    var newurl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?" +
      urlParams.toString();
    window.history.replaceState({ path: newurl }, "", newurl);

    // update add to cart variant id

    $addToCartBtn.attr("data-product-id", productID);
    $addToCartBtn.attr("data-variant-id", variantID);

    // update add to cart button text, class

    removeClassWithPrefix($addToCartBtn, "js-");

    $addToCartBtn.addClass(productBtnJSClass);
    if (!variantIsGiftCard) {
      $addToCartBtn.text(productBtnText);
    }
    var variantOptionNames = variantName.split(" / ");
    $(".dropdown-selected-value").each(function (i, el) {
      $(el).html(variantOptionNames[i]);
    });
    $(".product-shop-option-name").removeClass("opened");

    // update inventory
    if (variantInventoryQTY > 0 && variantInventoryQTY <= 3) {
      $inventoryNotice
        .find(".inventory-wrap")
        .show()
        .find("span")
        .text(variantInventoryQTY);
    } else {
      $inventoryNotice.find(".inventory-wrap").hide();
    }

    if (variantIsLowInStock) {
      $inventoryNotice.addClass("active");
    } else {
      $inventoryNotice.removeClass("active");
    }

    $incomingNotice.find("span").text(variantIncomingDate);

    var renderMadeToOrder = (variantIsMadeToOrder && variantIsBackOrder) ||
      (variantIsMadeToOrder && variantIsSoldOut);
    if (productHasShipNoticeTag  || renderMadeToOrder) {
      $incomingNotice.addClass("active");
      if (renderMadeToOrder) {
        $madeToOrder.addClass("active");
      }
    } else {
      $incomingNotice.removeClass("active");
      $madeToOrder.removeClass("active");
    }

    // update back in stock 
    var addToCartForm = document.getElementById("productAddToCart");
    var bisTrigger = document.getElementById("bisTrigger");
    addToCartForm.classList.remove("active");
    bisTrigger.classList.remove("active");
    if (variantIsSoldOut) {
      bisTrigger.classList.add("active");
    } else {
      addToCartForm.classList.add("active");
      $addToCartBtn.attr("disabled", false);
    }

    // update wishlist btn with new variant
    $('.wishlist-color-swatch-btn').attr('data-variant-id', variantID);

    if(!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(getSwymVariantInfo);
    function getSwymVariantInfo(swat) {
      window._swat.fetch( function(prods) {
        // check if there are wishlist products - add classes if matching variants exist
        if ( prods.length != 0 ) {

          var isWishlisted = false;
          prods.forEach(function (item, i) {
            var wishlistVarID= item.epi;
            variantID == wishlistVarID ? isWishlisted = true : null;
          });

          if (isWishlisted) {
            $('.wishlist-color-swatch-btn').addClass('swym-added');
            $('.wishlist-color-swatch-btn').html('Added to wishlist');
          } else {
            $('.wishlist-color-swatch-btn').removeClass('swym-added');
            $('.wishlist-color-swatch-btn').html('Add to wishlist');
          }
        } else {
          $('.wishlist-color-swatch-btn').html('Add to wishlist');
        }
      });
    }

    var $productShopSelector = $this.parents(".product-shop-selector");
    var activeProductHandleJson = $productShopSelector.attr(
      "data-product-handle-json"
    );
    var activeProductHandle = $productShopSelector.attr("data-product-handle");
  });

  /* =========================================================================
    Product Shop Shipping Module
========================================================================= */
  if ($(".product-shipping-module").length > 0) {
    $(".product-shipping-module .countdown").each(function () {
      $(this).countdown($(this).html().replaceAll("-", "/"), function (event) {
        $(this).text(event.strftime("%Dd %Hh %Mm"));
      });
    });
    //   $(".product-shipping-module .readable-date").each(function() {
    //     console.log($(this).html());
    //     $(this).html($(this).html()).toLocaleDateString(undefined, {month: 'long', day: 'numeric', year: 'numeric'});
    //   });
  }

  /* =========================================================================
    Product Shop Option Value
========================================================================= */

  $(document).on("click", ".js-product-shop-option-value", function () {
    var $this = $(this);

    $this.addClass("selected").siblings().removeClass("selected");

    // if other colors exist, update the 'default' option so the size remains selected when switching colors
    $('.product-option-value')
      .removeClass('default')
      .filter(function() {
        return $(this).data('option-value') == $this.data('option-value');
      })
      .addClass('default');

    $('.js-product-shop-color-swatch').attr('data-variant-title', $this.data('option-value'));

    // data
    var optionValue = $this.data("option-value");    

    // update span.dropdown-selected-value with current variant value
    $this
      .parent(".product-option-values")
      .siblings(".product-option-name")
      .find(".dropdown-selected-value")
      .text(optionValue);

    // element

    var $productShopSelector = $this.parents(".product-shop-selector");

    var $productShopVariants = $productShopSelector.find(
      ".product-shop-variants"
    );

    var $productShopVariant = $productShopVariants.find(
      ".product-shop-variant"
    );

    var $productShopOptions = $productShopSelector.find(
      ".product-shop-options"
    );

    var $productShopOptionValue = $productShopOptions.find(
      ".product-shop-option-value"
    );

    var productShopSelectedOption1 =
      $productShopOptionValue
        .filter('.selected[data-option-position="1"]')
        .data("option-value") || "";

    var productShopSelectedOption2 =
      $productShopOptionValue
        .filter('.selected[data-option-position="2"]')
        .data("option-value") || "";

    var productShopSelectedOption3 =
      $productShopOptionValue
        .filter('.selected[data-option-position="3"]')
        .data("option-value") || "";

    // adjust each color swatch to new variant
    var allSelectors = $(".product-shop-selector");
    allSelectors.each(function() {
      var variantContainer = $(this).find('.product-shop-variants');
      var variantContainerHandle = $(this).attr('data-product-handle');

      var filteredVariant = variantContainer.children('.js-product-shop-variant').filter(function () {
        var option1 = $(this).attr('data-variant-option1');
        var option2 = $(this).attr('data-variant-option2');
        var option3 = $(this).attr('data-variant-option3');
  
        return (
          option1 == productShopSelectedOption1 &&
          option2 == productShopSelectedOption2 &&
          option3 == productShopSelectedOption3
        );
        
      });
            
      var updatedColorVariantID = filteredVariant.attr('data-variant-id');
      var matchingColorSwatch = $(`.js-product-shop-color-swatch[data-product-handle="${variantContainerHandle}"]`);

      matchingColorSwatch.attr('data-variant-title', productShopSelectedOption1)
      matchingColorSwatch.attr('data-variant-id', updatedColorVariantID);
      matchingColorSwatch.attr('data-product-btn-text', filteredVariant.attr('data-product-btn-text'));
    });

    var $productShopSelectedVariant = $productShopVariant.filter(function (index) {
      var option1 = $(this).data("variant-option1");
      var option2 = $(this).data("variant-option2");
      var option3 = $(this).data("variant-option3");

      return (
        option1 == productShopSelectedOption1 &&
        option2 == productShopSelectedOption2 &&
        option3 == productShopSelectedOption3
      );
    });

    const measurementsProp = document.querySelector('[data-measurements-confirmed-prop]');
    
    // if this is for custom measurements, open a popup
    if ((optionValue == 'Made to Measure')) {
      const customModal = new tingle.modal({
        footer: false,
        stickyFooter: false,
        closeMethods: ['overlay', 'escape'],
        cssClass: ['modal--custom'],
        beforeClose: function() {
          return true; // close the modal
        }
      });

      customModal.setContent(document.querySelector('[data-custom-modal]').innerHTML);

      if (measurementsProp != null) {
        const measurementsPropValue = measurementsProp.dataset.measurementsConfirmedProp;
        console.log(measurementsPropValue);
        measurementsProp.value = measurementsPropValue;
        measurementsProp.disabled = false;
        
        if (measurementsPropValue != 'Measurements Confirmed') {
          customModal.open();
        }
      }

      $('[data-custom-modal-trigger]').click(function() {
        customModal.open();
      })

      $('[data-custom-modal-close]').click(function() {
        customModal.close();
      });

      // todo add event listener on submit measurements btn to set cookie
      $('[data-custom-modal-submit]').click(function() {
        localStorage.setItem('measurementBreadcrumb', 
          window.location.href.split('variant=')[1] + ' | ' + window.location.href);
      });
    } else if (optionValue != 'Made to Measure' && measurementsProp != null) {
      measurementsProp.removeAttribute('value');
      measurementsProp.disabled = true;
    }

    // for multi-date calendar charm product - show corresponding number of date/stone inputs when number of dates selected
    if (
      $productShopOptions.attr('data-product-handle') == 'multiple-date-1960s-calendar-charm' 
      && typeof optionValue == 'number'
      && optionValue <= 10) {
        $('[data-multi-date-counter]').hide();
        for (let i = 1; i < (optionValue + 1); i++) {
          $(`[data-multi-date-counter="${i}"]`).show();
        }
    }

    // sync variant selector with option selector

    $productShopSelectedVariant.trigger("sync");

    // var discountVendors = ['taylor-thomas','mola-sasa','hunting-season','eleven-six','patbo'];
    // var productVendor = $('.product-shop-price').eq(1).data('vendor');

    //    if (discountVendors.includes(productVendor)) {
    // 	console.log('included');
    //    	$('.product-shop-price').eq(1).append('<span class="product-sale-notification">20% off with code 25OFF</span>');
    //    	$('.product-shop-price').eq(0).append('<span class="product-sale-notification">20% off with code 25OFF</span>');
    //    }
  });

  /* =========================================================================
      Product Shop Properties - single date and multi date product templates
  ========================================================================= */

  $(document).on("change", ".js-product-prop-option__date-input", function () {
    const dateOutput = $(this).siblings('.product-prop-option__date-toggle').find('.product-prop-option__selected-value')
    dateOutput.text(': ' + $(this).val());
  });

  $(document).on("click", ".js-product-prop-option__value", function () {
    $(this).addClass("selected").siblings().removeClass("selected");
    $(".product-prop-option__name").removeClass("opened");

    $(this)
      .parent(".product-prop-option__values")
      .siblings(".product-prop-option__name")
      .find(".product-prop-option__selected-value")
      .text(": " + $(this).attr("data-option-value").toUpperCase());

    // if it is an engraving option, show the engraving box
    if ($(this).attr("data-option-type") == "engraving") {
      const engravingText = $(this).parent(".product-prop-option__values").siblings(".product-prop-option__text-input");

      if ($(this).attr("data-option-value") == "yes") {
        engravingText.show();
      } else {
        // if engraving is set to 'no', reset the input to blank
        engravingText.hide();
        engravingText.val('');
      }
    }

    // if it is a stone option, fill out the hidden text input (line item property input)
    if ($(this).attr("data-option-type") == "stone") {
      $(this)
        .parent(".product-prop-option__values")
        .siblings(".product-prop-option__text-input")
        .val($(this).attr("data-option-value"))
    }
  });
  
  // toggle variant option dropdown values / property value dropdown values
  $(".product-options-container .product-option-name.product-shop-option-name").on("click", function () {
    $(this).toggleClass("opened");
  });
  
  $(".product-props-container .product-prop-option .product-prop-option__name").on("click", function () {
    $(this).toggleClass("opened");
  });

  // On-load trigger click for selected option
  // NOTE: this ensures the above logic runs (which shows incoming and inventory notices when needed)
  $(".product-selector.active .js-product-shop-option-value.selected").trigger(
    "click"
  );

  /* =========================================================================
    Product Add to Cart
========================================================================= */

  $(document).on("click", ".js-product-add-to-cart", function () {
    var variantID = $(this).attr("data-variant-id");

    var variantProperties = {};

    if ($(".product-shop-inventory-notice").is(".active")) {
      variantProperties = {
        inventory_notice: $(".product-shop-inventory-notice").text(),
      };
    }

    if ($(".product-shop-incoming-notice").is(".active")) {
      variantProperties = {
        incoming_notice: $(".product-shop-incoming-notice").text(),
      };
    }

    // if custom measurement order / clear associated cookie
    if ($('.dropdown-selected-value').text() == 'Made to Measure') {
      if (localStorage.getItem('measurementBreadcrumb') != null && localStorage.getItem('measurementBreadcrumb').includes(window.location.href)) {
        localStorage.removeItem('measurementBreadcrumb');
      } 
    }

    $("input[name^=properties]").each(function () {
      if ($(this).val() != "") {
        var propertyName = $(this)
          .attr("name")
          .replace("properties[", "")
          .replace("]", "");
        variantProperties[propertyName] = $(this).val();
      }
    });

    $("textarea[name^=properties]").each(function () {
      if ($(this).val() != "") {
        var propertyName = $(this)
          .attr("name")
          .replace("properties[", "")
          .replace("]", "");
        variantProperties[propertyName] = $(this).val();
      }
    });

    let calendarTemplate = $(this).attr('data-template') == 'multi-date' || $(this).attr('data-template') == 'single-date' ? true : false;
    if (calendarTemplate && 'Engraving' in variantProperties) {
      CartJS.addItem(42367910969603, 1);
    } 

    CartJS.addItem(variantID, 1, variantProperties, {
      success: function (data, textStatus, jqXHR) {
        //Open Mini Cart
        setTimeout(function () {
          $("body").addClass("mini-cart-open");

          if (affirm) {
            affirm.ui.refresh();
          }
        }, 800);

        if (data.properties !== null) {
          if (
            data.properties.hasOwnProperty("Engraving") ||
            data.properties.hasOwnProperty("Monogramming")
          ) {
            if (data.properties.hasOwnProperty("Engraving")) {
              CartJS.setNote("Engraving: " + data.properties["Engraving"]);
            }
            if (data.properties.hasOwnProperty("Monogramming")) {
              CartJS.setNote(
                "Monogramming: " + data.properties["Monogramming"]
              );
            }
          }
        }
      },

      error: function (jqXHR, textStatus, errorThrown) {},
    });
  });

  /* =========================================================================
    Cart Quantity Input
========================================================================= */

  $(document).on("click", ".js-line-item-quantity-input", function () {
    $(this).select();
  });

  deferDebounce(function() {
    $(document).on(
      "keyup",
      ".js-line-item-quantity-input",
      _.debounce(function () {
        var lineQuantity = parseInt($(this).val());
        var lineNumber = parseInt($(this).data("line-number"));

        CartJS.updateItem(lineNumber, lineQuantity);
      }, 300)
    );
  });

  /* =========================================================================

========================================================================= */

  $(document).on("cart.requestComplete", function (event, data) {
    affirm.ui.refresh();
  });

  /* =========================================================================
    Back in Stock App
========================================================================= */

  $(document).on("click", ".js-product-back-in-stock-submit", function () {
    var $this = $(this);

    if ($this.parents(".product-shop-function-bar").hasClass("is_stuck")) {
      $("html, body").animate(
        {
          scrollTop: 0,
        },
        600,
        "easeOutExpo"
      );
    } else {
      var $emailInput = $(".product-shop-back-in-stock-email");

      var email = $emailInput.val();

      var productID = $this.attr("data-product-id");

      var variantID = $this.attr("data-variant-id");

      BIS.create(email, variantID, productID).then(function (data) {
        var msg = "";

        if (data.status == "OK") {
          msg = "Thank you!";
        } else {
          //console.log(data.errors);

          var error = "";

          for (var k in data.errors) {
            error += k + " " + data.errors[k].join();
          }

          if (error.indexOf("already") >= 0) {
            msg = "Thank you!";
          } else if (error.indexOf("invalid") >= 0) {
            msg = "invalid email";
          } else {
            msg = "error";
          }
        }

        $this.text(msg);
      });
    }
  });

  $(document).on("click", ".product-shop-back-in-stock-submit", function () {
    var $emailInput = $(".product-shop-back-in-stock-email");

    var $addToCartBtn = $(".product-add-to-cart");

    var email = $emailInput.val();

    var productID = $addToCartBtn.attr("data-product-id");

    var variantID = $addToCartBtn.attr("data-variant-id");

    BIS.create(email, variantID, productID).then(function (data) {
      var msg = "";

      if (data.status == "OK") {
        msg = "Thank you!";
      } else {
        //console.log(data.errors);

        var error = "";

        for (var k in data.errors) {
          error += k + " " + data.errors[k].join();
        }

        if (error.indexOf("already") >= 0) {
          msg = "Thank you!";
        } else if (error.indexOf("invalid") >= 0) {
          msg = "invalid email";
        } else {
          msg = "error";
        }
      }
      $addToCartBtn.text(msg);
    });
  });

  function updateVariantImage(
    pId,
    vId,
    activeProductHandleJson,
    activeProductHandle
  ) {
    //console.log('updateVariantImage');
    var productVariant = "productVariants_" + activeProductHandleJson;
    productVariants = product[productVariant];
    if (typeof productVariants !== "undefined" && productVariants != null) {
      //console.log(productVariants);
      $.each(productVariants, function (key, value) {
        if (vId == value.id) {
          if (
            typeof value.featured_image !== "undefined" &&
            value.featured_image != null
          ) {
            var featureImage = value.featured_image;
            featureImage = featureImage.src;
            featureImage = featureImage.replace(/(^\w+:|^)\/\//, "");

            var galleryContainer = $(
              '.product-shop-album[data-product-handle="' +
                activeProductHandle +
                '"]'
            );

            //Desktop
            var deskTopGallery = galleryContainer.find(
              ".product-shop-image-list-item"
            );
            deskTopGallery.each(function () {
              var list = $(this);
              var listimageUrl = list.find("img").attr("data-src");
              var listimageUrl = listimageUrl.replace(/(^\w+:|^)\/\//, "");
              if (listimageUrl == featureImage) {
                list.trigger("click");
              }
            });

            //Mobile
            var mobileGallery = galleryContainer.find(
              ".product-shop-slider-mobile .rsSlide"
            );
            mobileGallery.each(function (index) {
              var list = $(this);
              var listimageUrl = list
                .find(".product-shop-slide-image")
                .attr("data-src-img");
              var listimageUrl = listimageUrl.replace(/(^\w+:|^)\/\//, "");
              if (listimageUrl == featureImage) {
                var bullet = galleryContainer
                  .find(".product-shop-slider-mobile .rsBullets .rsNavItem")
                  .eq(index);
                bullet.trigger("click");
              }
            });
          }
        }
      });
    }
  }

  var quickBuy = function () {
    var addToCart = function (variantID, quantity, $option) {
      if (!variantID) {
        console.error("No variantID!");
        return false;
      }

      if (typeof quantity === "undefined") {
        quantity = 1;
      }

      var properties = {};
      var timeout;

      CartJS.addItem(variantID, quantity, properties, {
        success: function (data, textStatus, jqXHR) {
          $("body").addClass("mini-cart-open");
        },
        error: function (jqXHR, textStatus, errorThrown) {
          var response = jqXHR;

          console.log(response);

          // 422 is a cart error, assume this error is that all avail products are in your cart already. Mark clicked option as sold out.
          if (response.responseJSON.status === 422 && $option) {
            $option.attr("data-available", "false");
          }
        },
      });
    };

    $(".js-quick-add-option").on("click", function () {
      var btnText = $(this).data("product-btn-text");
      $(this)
        .parent()
        .find(".js-quick-add-btn")
        .html("<span class='animated-underline'>" + btnText + "</span>");

      var $self = $(this);
      $self.addClass("selected-value").siblings().removeClass("selected-value");
    });

    $(".js-quick-add-btn").on("click", function () {
      var selectedVar = $(this)
        .parent()
        .find(".selected-value")
        .attr("data-variant-id");
      var varProperties = {};

      addToCart(selectedVar, 1, varProperties);
    });
  };

  quickBuy();

  // Disable search unless field is set
  $(".product-search__submit").prop("disabled", true);
  $(".product-search__in").keyup(function () {
    if ($(this).val() == "") {
      $(".product-search__submit").prop("disabled", true);
    } else {
      $(".product-search__submit").prop("disabled", false);
    }
  });
  $("form.search").on("submit", function () {
    $("form.search input[type=submit]").addClass("active");
  });
}); // end document ready

// Match Height
var equalize_options = {
  byRow: true,
  property: "height",
  target: null,
  remove: false,
};
$(".equal").matchHeight(equalize_options);

// About Pg Slider
function aboutQuoteSlider() {
  if ($("body").hasClass("template-page-about-new")) {
    $(".about-pg__quote-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
    });
  }
}

aboutQuoteSlider();

var fkMenuOpen = false;
var fkMenuState = {
  new: false,
  shop: false,
  impact: false,
  designers: false,
  "si-collective": false,
  search: false,
};

function fkNavMenu() {
  $(".desktop-navbar-banner").on("click", function (e) {
    if (!$(e.target).is("a")) {
      e.preventDefault();
      $(".fk-nav-menu__close").click();
    }
  });
  $(".desktop-navbar-banner + .fk-nav-wrapper").on("click", function (e) {
    if (!$(e.target).is("a") && !$(e.target).parents().is("a")) {
      e.preventDefault();
      $(".fk-nav-menu__close").click();
    }
  });

  $(".fk-has-menu").click(function (e) {
    e.stopPropagation();

    var section = $(this).data("menu");
    section = section.toLowerCase();

    if (!fkMenuOpen) {
      $(".fk-nav-menu").addClass("fk-nav-menu--active");
      $(".fk-header").addClass("fk-header--fill");
      $(
        ".fk-nav-menu__inner:not(.fk-nav-menu__inner--" + section + ")"
      ).removeClass("visible");
      $(".fk-nav-menu__inner--" + section).addClass("visible");
      fkMenuOpen = true;
      fkMenuState[section] = true;
      fkMenuActiveState(this, fkMenuState);
      $(".header-underlay").addClass("header-underlay--show");
    } else if (fkMenuState[section] == true) {
      for (var prop in fkMenuState) {
        fkMenuState[prop] = false;
      }
      fkMenuOpen = false;

      $(".fk-nav-menu").removeClass("fk-nav-menu--active");
      $(".fk-nav-left li, .fk-nav-right li").removeClass("fk-has-menu--active");
      if ($(window).scrollTop() <= 5) {
        $(".fk-header").removeClass("fk-header--fill");
      }
      $(".header-underlay").removeClass("header-underlay--show");

      setTimeout(function () {
        if (!$(".header-underlay").hasClass("header-underlay--show")) {
          $(".fk-nav-menu__inner").removeClass("visible");
        }
      }, 500);
    } else {
      var active = isNavSectionActive(fkMenuState);
      if (active) {
        for (var prop in fkMenuState) {
          fkMenuState[prop] = false;
        }

        $(".fk-nav-menu__inner").removeClass("visible");

        fkMenuState[section] = true;
        $(".fk-nav-menu__inner--" + section).addClass("visible");

        fkMenuActiveState(this, fkMenuState);
      } else {
        for (var prop in fkMenuState) {
          fkMenuState[prop] = false;
        }
        fkMenuOpen = false;
        $(".fk-nav-menu__inner").removeClass("visible");
        $(".fk-nav-menu").removeClass("fk-nav-menu--active");
        $(".fk-nav-left li, .fk-nav-right li").removeClass(
          "fk-has-menu--active"
        );
        if ($(window).scrollTop() <= 5) {
          $(".fk-header").removeClass("fk-header--fill");
        }
        $(".header-underlay").removeClass("header-underlay--show");
      }
    }
  });
}

fkNavMenu();

function isNavSectionActive(obj) {
  for (var prop in obj) {
    if (obj[prop] == true) {
      return true;
    }
  }
  return false;
}

function fkMenuActiveState(elem, obj) {
  $(".fk-nav-left li, .fk-nav-right li").removeClass("fk-has-menu--active");
  $(elem).addClass("fk-has-menu--active");
}

function fkMenuUnderlayClick() {
  $(".header-underlay, .fk-nav-menu__close, .desktop-cart-link").click(
    function () {
      for (var prop in fkMenuState) {
        fkMenuState[prop] = false;
      }
      fkMenuOpen = false;
      $(".fk-nav-menu").removeClass("fk-nav-menu--active");
      if ($(window).scrollTop() <= 5) {
        $(".fk-header").removeClass("fk-header--fill");
      }
      $(".fk-nav-left li, .fk-nav-right li").removeClass("fk-has-menu--active");
      $(".header-underlay").removeClass("header-underlay--show");

      setTimeout(function () {
        if (!$(".header-underlay").hasClass("header-underlay--show")) {
          // incase the user has trigger this but clicks a menu item before the timer ends,
          // otherwise they will get a blank menu.
          $(".fk-nav-menu__inner").removeClass("visible");
        }
      }, 500);
    }
  );
}

fkMenuUnderlayClick();

function fkNavFill() {
  if ($("body").hasClass("template-index") ||
    document.querySelector('.dynamic-media--absolute') != null) {
    $(window).scroll(function () {
      if ($(window).scrollTop() > 5) {
        $(".fk-header").addClass("fk-header--fill");
        $(".mobile-navbar").addClass("mobile-navbar--fill");
      } else {
        if (!$(".fk-nav-menu").hasClass("fk-nav-menu--active")) {
          $(".fk-header").removeClass("fk-header--fill");
          $(".mobile-navbar").removeClass("mobile-navbar--fill");
        }
      }
    });
  }
}

fkNavFill();

var collectionTemplateLastScrollPosition = window.pageYOffset;
function handleCollectionTemplateScroll() {
  var body = $("body");
  if (!body.hasClass("template-collection")) {
    return;
  }

  body.toggleClass(
    "scrolled-up",
    window.pageYOffset < collectionTemplateLastScrollPosition
  );
  collectionTemplateLastScrollPosition = window.pageYOffset;
}

$(window).on("scroll", handleCollectionTemplateScroll);

// 2.25 password protect page
function passwordParam(submitURL) {
  let passwordValue = document.getElementById('passwordInput').value;
  console.log(submitURL + '?password=' + passwordValue);
  window.location.href =  submitURL + '?password=' + passwordValue;
}

/**
 * Build the wishlist item, reused in the minilist and the grid
 * @param {object} item
 * @param {string} itemPrice
 * @returns wishlist item
 */
function buildWishlistItem(item, itemPrice, classes = '') {
  const productHandle = (item.du).replace('https://fashionkind.com/products/', '');
  let productAvailable = false;
  let showAddToCart = false;
  jQuery.getJSON(`/products/${productHandle}.js`, function(product) {
    product.available == true ? productAvailable = true : null;
  }).done(function() {
    if (productAvailable) {
      let showAddToCart = true;
    }
  })

  let itemTitle = (item.dt).split(' | ')[0];
  let wishListItem = `<div class="wishlist-item ${classes}" id="miniWishlist--${item.epi}">
        <button class="wishlist-remove" onclick="removeWishListItem(${item.epi})">Remove from wishlist</button>
        <a href="${item.du}?variant=${item.epi}">
          <img src="${item.iu}" alt="${item.dt}" height="213" width="160" loading="lazy" class="wishlist-item--image" />
        </a>
        <div class="wishlist-item__info">
          <button class="grid-item-add-to-cart" onclick="addWishlistItemtoCart(${item.epi})">Add to Bag</button>
          <a href="${item.du}?variant=${item.epi}">
            <span class="wishlist-item--vendor">${item.bt}</span>
            <span class="wishlist-item--title">${itemTitle}</span>
            <span class="wishlist-item--price">${itemPrice}</span>
          </a>
          <button class="wishlist-add-to-cart" onclick="addWishlistItemtoCart(${item.epi})">Add to Bag</button>
        </div>
      </div>`;

  return wishListItem;

}

//Remove items from list on 'pages/wishlist'
function removeWishListItem(item) {
  window._swat.removeFromWishList(
    {
      "epi": item
    },
    swymCallbackFn
  );
}

/**
 * BIS Modal for the PDP
 */
function bisModal(){
  const bisModalContent = document.querySelector('[data-bis-content]');
  const modalTrigger = document.querySelector('[data-bis-modal-trigger]');
  const modalCloseTrigger = document.querySelector('[data-bis-modal-close]');
  // Bail if there is no modal content or modal trigger
  if(!bisModalContent || !modalTrigger){
    return;
  }

  const bisModal = new tingle.modal({
      footer: false,
      stickyFooter: false,
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: ['modal--bis'],
      onOpen: function() {

      },
      onClose: function() {

      },
      beforeClose: function() {
          // here's goes some logic
          // e.g. save content before closing the modal
          return true; // close the modal
          return false; // nothing happens
      }
  });

  // Add the form to the modal
  bisModal.setContent(bisModalContent);

  // Open the modal when clicking the 'bis' trigger
  modalTrigger.addEventListener('click', function(){
    bisModal.open();
  });

  modalCloseTrigger.addEventListener('click', function(){
    bisModal.close();
  })
}

bisModal();

//Share list on 'pages/wishlist'
function sharedList(){
  const shareModal= document.getElementById('share-list-modal');
  const closeModal = document.getElementById('share-list-modal__close');

  shareModal.classList.add("active");

  closeModal.addEventListener('click', function(){
    shareModal.classList.remove("active");
  })

  window._swat.generateSharedListURL(
    null,
    function(data) {
      console.log("URL", data);
      const btnCopy = document.getElementById('share-list-modal__copy');
      btnCopy.addEventListener('click', function(){
        navigator.clipboard.writeText(data);
        btnCopy.innerHTML = 'Link copied';
      })
    },
    function(data) { console.log("Err when sharing list", data); }
  );
}



//Email list
function emailWishlist(){
  window._swat.generateSharedListURL(
    null,
    function(data) {
      const btnEmail = document.getElementById('email-list');
      btnEmail.href = `mailto:user@example.com?subject=My%20Fashionkind%20Wishlist&body=${data}`;
    },
  );
}


// swym Wishlist Plus - custom functionality to add product to wishlist from PDP
function addProductToWishlist() {
  var prodID = parseInt($('.wishlist-color-swatch-btn').attr('data-product-id'));
  var varID = parseInt($('.wishlist-color-swatch-btn').attr('data-variant-id'));
  var prodURL = $('.wishlist-color-swatch-btn').attr('data-product-url');

  if ($('.wishlist-color-swatch-btn').hasClass('swym-added')) {
    window._swat.removeFromWishList(
      {
        "epi": varID,
        "du": prodURL,
        "empi": prodID
      },
      function(r) {
        $('.wishlist-color-swatch-btn').removeClass('swym-added');
        $('.wishlist-color-swatch-btn').html('Add to wishlist');
        
        if (prods.length == 0) {
          $('.header-desktop-menu-wishlist.solid').removeClass('active');
          $('.header-desktop-menu-wishlist.outline').addClass('active');
        }
        window._swat.fetch( function(prods) {
          const miniWishlist = document.getElementById('miniWishlist');
          if ( prods.length != 0 && document.body.contains(miniWishlist) ) {
            miniWishlist.innerHTML = '';
            prods.slice(0, 3).forEach(function (item, i) {
              let itemPrice = new Intl.NumberFormat('en-US',
                { style: 'currency', currency: 'USD' }
              ).format(item.pr).replace('.00', '');
              let miniWishlistItem = buildWishlistItem(item, itemPrice, 'fk-desktop-mini--wishlist-item');
              miniWishlist.innerHTML += miniWishlistItem;
            });
          }
        });
      }
    );

  } else {
    window._swat.addToWishList(
      {
        "epi": varID,
        "du": prodURL,
        "empi": prodID
      },
      function(r) {
        $('.wishlist-color-swatch-btn').addClass('swym-added');
        $('.wishlist-color-swatch-btn').html('Added to wishlist');

        $('.header-desktop-menu-wishlist.outline').removeClass('active');
        $('.header-desktop-menu-wishlist.solid').addClass('active');

        window._swat.fetch( function(prods) {
          const miniWishlist = document.getElementById('miniWishlist');
          if ( prods.length != 0 && document.body.contains(miniWishlist) ) {
            miniWishlist.innerHTML = '';
            prods.slice(0, 3).forEach(function (item, i) {
              let itemPrice = new Intl.NumberFormat('en-US',
                { style: 'currency', currency: 'USD' }
              ).format(item.pr).replace('.00', '');
              let miniWishlistItem = buildWishlistItem(item, itemPrice, 'fk-desktop-mini--wishlist-item');
              miniWishlist.innerHTML += miniWishlistItem;
            });
          }
        });
      }
    );
  }
}

function openWishlistLogin() {
  if ($(window).width() > 991) {
    $(".fk-desktop-has-mini.wishlist").addClass('active');
    $('.fk-desktop-mini.wishlist').addClass('active');
  } else {
    window.location.href= '/account/login'
  }
}

// swym Wishlist Plus - custom functionality to add product from collection pages
function wishlistPLP(varID, prodID, prodHandle) {
  const wishlistBtn = document.getElementById('wishlistBtn--' + varID);
  const prodURL = 'https://fashionkind.com/products/' + prodHandle;

  // if the user is not logged in, open the wishlist Modal (showing the login form) and bail
  const wishlistModal = document.getElementById('mini-wishlist');
  if ( !wishlistModal.classList.contains('customer') ) {
    openWishlistLogin();
    return;
  }

  if ( wishlistBtn.classList.contains('swym-added') ) {
    window._swat.removeFromWishList(
      {
        "epi": varID,
        "du": prodURL,
        "empi": prodID
      },
      function(r) {
        wishlistBtn.classList.remove('swym-added');
        window._swat.fetch( function(prods) {
          if (prods.length == 0) {
            $('.header-desktop-menu-wishlist.solid').removeClass('active');
            $('.header-desktop-menu-wishlist.outline').addClass('active');
          }
          const miniWishlist = document.getElementById('miniWishlist');
          if ( prods.length != 0 && document.body.contains(miniWishlist) ) {
            miniWishlist.innerHTML = '';
            prods.slice(0, 3).forEach(function (item, i) {
              let itemPrice = new Intl.NumberFormat('en-US',
                { style: 'currency', currency: 'USD' }
              ).format(item.pr).replace('.00', '');
              let miniWishlistItem = buildWishlistItem(item, itemPrice, 'fk-desktop-mini--wishlist-item');
              miniWishlist.innerHTML += miniWishlistItem;
            });
          }
        });
      }
    );
  } else {
    window._swat.addToWishList(
      {
        "epi": varID,
        "du": prodURL,
        "empi": prodID
      },
      function(r) {
        openWishlistLogin();
        $('.header-desktop-menu-wishlist.outline').removeClass('active');
        $('.header-desktop-menu-wishlist.solid').addClass('active');

        wishlistBtn.classList.add('swym-added');
        window._swat.fetch( function(prods) {
          const miniWishlist = document.getElementById('miniWishlist');
          if ( prods.length != 0 && document.body.contains(miniWishlist) ) {
            miniWishlist.innerHTML = '';
            prods.slice(0, 3).forEach(function (item, i) {
              let itemPrice = new Intl.NumberFormat('en-US',
                { style: 'currency', currency: 'USD' }
              ).format(item.pr).replace('.00', '');
              let miniWishlistItem = buildWishlistItem(item, itemPrice, 'fk-desktop-mini--wishlist-item');
              miniWishlist.innerHTML += miniWishlistItem;
            });
          }
        });
      }
    );
  }
};

// callback function to ensure API calls are made once Swym has loaded: https://api-docs.swym.it/v3/index.html#changes-from-v2
function swymCallbackFn(swat) {
  // check if items are already added to wishlist -- get wishlist items first
  window._swat.fetch( function(prods) {
    // When swat loads it calls this function, it also calls as a callback of removing
    // so that we have to make sure the list and grid is on the page to not have a null exception
    const miniWishlist = document.getElementById('miniWishlist');
    const wishlistGrid = document.getElementById('wishlistGrid');
    const wishlistCountInHeader = document.getElementsByClassName('wishlist-count');

    if (miniWishlist){ miniWishlist.innerHTML = '<div class="wishlist-empty">You have no items in your wishlist</div>';}
    if (wishlistGrid){ wishlistGrid.innerHTML = '';}
    if (wishlistCountInHeader){
      while(wishlistCountInHeader.length > 0){
        wishlistCountInHeader[0].parentNode.removeChild(wishlistCountInHeader[0]);
      }
    }
    if (prods.length > 0) {
      $('.header-desktop-menu-wishlist.outline').removeClass('active');
      $('.header-desktop-menu-wishlist.solid').addClass('active');
    }

    if(prods.length == 0 && window.location.href.indexOf('/pages/wishlist') > -1){
      const emptyWishlist = document.getElementById('emptyWishlist');
      emptyWishlist.style.display = 'flex';
      emptyWishlist.innerHTML += "<div class='empty-wishlist-text'>You don’t currently have any items in your wishlist. <br> Browse our collections and click the heart icon to add something to your wishlist.<div>";
      emptyWishlist.innerHTML += "<a href='/collections/new-arrivals' class='btn btn-solid new-arrivals-btn'>SHOP NEW ARRIVALS</a>";
    }

    if (prods.length != 0 && document.body.contains(miniWishlist) ) {
      prods.slice(0, 5).forEach(function (item, i) {
        miniWishlist.innerHTML = '';
        let itemPrice = new Intl.NumberFormat('en-US',
          { style: 'currency', currency: 'USD' }
        ).format(item.pr).replace('.00', '');

        let miniWishlistItem = buildWishlistItem(item, itemPrice, 'fk-desktop-mini--wishlist-item');
        miniWishlist.innerHTML += miniWishlistItem;
      });

      if ( window.location.href.indexOf('/pages/wishlist') > -1) {
        const wishlistHeader = document.getElementById('wishlistHeader');
        wishlistHeader.innerHTML += `<div class='wishlist-count'>${prods.length} items</div>`;
        document.getElementById('wishlistShare').style.display = 'flex';
        document.getElementById('wishlistFooter').style.display = 'flex';

        prods.forEach(function (item, i) {
          let itemPrice = new Intl.NumberFormat('en-US',
            { style: 'currency', currency: 'USD' }
          ).format(item.pr).replace('.00', '');
          let wishListItem = buildWishlistItem(item, itemPrice, 'wishlist-item--grid');
          wishlistGrid.innerHTML += wishListItem;
        });
      }

      // check if there are wishlist products and if we're on PDP or PLP - add classes if matching variants exist
      if ( window.location.href.indexOf('/products') > -1 ) {
        prods.forEach(function (item, i) {
          let variantID = item.epi;
          // all PDP appended with ?variant=<variantID> - check if this page matches any wishlist variants
          if ( window.location.href.indexOf(variantID) > -1 ) {
            $('.wishlist-color-swatch-btn').addClass('swym-added');
            $('.wishlist-color-swatch-btn').html('Added to wishlist');
          }
        });
      } else if ( window.location.href.indexOf('/collections/') ) {
        prods.forEach(function (item, i) {
          let variantID = item.epi;
          let variantIcon = document.getElementById('wishlistBtn--' + variantID);
          document.body.contains(variantIcon) ? variantIcon.classList.add('swym-added') : null;
        });
      }
    }
  })
}
if(!window.SwymCallbacks) {
window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);

function removeWishlistItem(variant, product) {
  window._swat.removeFromWishList(
    {
      "epi": variant,
      "empi": product
    },
    function(r) {
      location.reload();
    }
  );
}

function addWishlistItemtoCart(variantID) {
  let variantProperties = '';

  CartJS.addItem(variantID, 1, variantProperties, {
    success: function (data, textStatus, jqXHR) {
      //Open Mini Cart
      setTimeout(function () {
        $("body").addClass("mini-cart-open");

        if (affirm) {
          affirm.ui.refresh();
        }
      }, 800);
    },

    error: function (jqXHR, textStatus, errorThrown) {},
  });

}

// Custom implementation for Back in Stock flow
function BIS(e) {
  e.preventDefault();
  let email = document.getElementById('BackInStock').value;
  const $addToCartBtn = $('.product-shop').find(".product-add-to-cart");
  let prodID = $addToCartBtn.attr("data-product-id");
  let varID = $addToCartBtn.attr("data-variant-id");

  fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
    "headers": {
      "accept": "application/json, text/plain, */*",
      "content-type": "application/x-www-form-urlencoded;charset=UTF-8",
    },
    "body": new URLSearchParams({
        "a": "LkU2VU",
        "email": email,
        "platform": "shopify",
        "variant": varID,
        "product": prodID,
    }),
    "method": "POST",
  })
  .then(response => {
    document.getElementById('BackInStockForm').classList.remove('active');
    document.getElementById('BackInStockTitle').innerHTML = 'We will notify you when the item is available again.'
    document.getElementById('BackInStockContinue').classList.remove('hide');
  })
  .catch(err => {
      console.error(err);
  });
}

// Custom form validation for account and registration forms using Vanilla Validator
var registerConfig = {
  container: '#create_customer',
  validationBy: 'onclick',
  validateOnFieldChanges: true,
  selectors: {
    required: 'vv-required'
  },
  messages: { // can also be set by html attribute 'data-message-error'
    required: 'This field is required'
  }
};
var registerValidator = new VanillaValidator(registerConfig);

var loginConfig = {
  container: '#customer_login',
  validationBy: 'onclick',
  validateOnFieldChanges: true,
  selectors: {
    required: 'vv-required'
  },
  messages: { // can also be set by html attribute 'data-message-error'
    required: 'This field is required'
  }
};
var loginValidator = new VanillaValidator(loginConfig);

var addAddressConfig = {
  container: '#address_form_new',
  validationBy: 'onclick',
  validateOnFieldChanges: true,
  selectors: {
    required: 'vv-required'
  },
  messages: { // can also be set by html attribute 'data-message-error'
    required: 'This field is required'
  }
};
var addAddressValidator = new VanillaValidator(addAddressConfig);

// measurement page 
if (window.location.href.includes('/pages/measurements')) {
  const measurementBreadcrumb = localStorage.getItem('measurementBreadcrumb');
  const measurementBreadcrumbBtn = document.querySelector('[data-measurement-breadcrumb]');
  if (measurementBreadcrumb != null && measurementBreadcrumbBtn.getAttribute('data-measurement-breadcrumb') == 'true') {
    addMeasurementBreadcrumb(measurementBreadcrumb)
  }
}

function addMeasurementBreadcrumb(breadcrumb) {
  const crumbArray = breadcrumb.split(' | ');
  $('[data-measurement-breadcrumb]').html(`<a href="${crumbArray[1]}" class="btn">Return to product</a>`);
};

if (window.location.href.includes('/pages/measurements?edit')) {
  $('.measurements-container__left').addClass('edit-mode');
}

// redirec to page handle on login - use parameter ?goto=<page-handle>
if (window.location.href.includes('/account/login?goto=')) {
  const redirectValue = window.location.href.split('?goto=')[1];
  const redirectInput = document.querySelector('[data-redirect-url]');
  redirectInput.value = '/pages/' + redirectValue;
}